import "core-js/modules/es6.string.anchor";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.string.link";
import "core-js/modules/es6.string.fixed";
import "core-js/modules/es6.array.fill";
import "core-js/modules/es6.array.some";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.entries";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.date.now";
import "core-js/modules/es7.object.values";
import "core-js/modules/es6.reflect.construct";
import _assertThisInitialized from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.map";
import "core-js/modules/es6.set";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.string.small";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es6.object.freeze";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.weak-map";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.object.create";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { createContext, forwardRef, createElement, Component, Fragment, useState, useContext, useEffect, useRef, useCallback, useImperativeHandle, useMemo, useLayoutEffect } from 'react';
import ReactDOM, { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var inheritsLoose = _inheritsLoose;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe

function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();

function stylis_min(W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {}

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
}; // https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler


var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};

var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};

var removeLabel = function removeLabel(context, content) {
  if (context === 1 && // charcode for l
  content.charCodeAt(0) === 108 && // charcode for b
  content.charCodeAt(2) === 98 // this ignores label
  ) {
      return '';
    }
};

var isBrowser = typeof document !== 'undefined';
var rootServerStylisCache = {};
var getServerStylisCache = isBrowser ? undefined : weakMemoize(function () {
  var getCache = weakMemoize(function () {
    return {};
  });
  var prefixTrueCache = {};
  var prefixFalseCache = {};
  return function (prefix) {
    if (prefix === undefined || prefix === true) {
      return prefixTrueCache;
    }

    if (prefix === false) {
      return prefixFalseCache;
    }

    return getCache(prefix);
  };
});

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new stylis_min(stylisOptions);

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;

  if (isBrowser) {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  if (isBrowser) {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        var map = serialized.map;
        Sheet.current = {
          insert: function insert(rule) {
            sheet.insert(rule + map);
          }
        };
      }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  } else {
    stylis.use(removeLabel);
    var serverStylisCache = rootServerStylisCache;

    if (options.stylisPlugins || options.prefix !== undefined) {
      stylis.use(options.stylisPlugins); // $FlowFixMe

      serverStylisCache = getServerStylisCache(options.stylisPlugins || rootServerStylisCache)(options.prefix);
    }

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = stylis(selector, serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        if ( // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
          return rules + serialized.map;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  if (process.env.NODE_ENV !== 'production') {
    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
    var commentStart = /\/\*/g;
    var commentEnd = /\*\//g;
    stylis.use(function (context, content) {
      switch (context) {
        case -1:
          {
            while (commentStart.test(content)) {
              commentEnd.lastIndex = commentStart.lastIndex;

              if (commentEnd.test(content)) {
                commentStart.lastIndex = commentEnd.lastIndex;
                continue;
              }

              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            }

            commentStart.lastIndex = 0;
            break;
          }
      }
    });
    stylis.use(function (context, content, selectors) {
      switch (context) {
        case -1:
          {
            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);

            if (unsafePseudoClasses && cache.compat !== true) {
              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
                var ignore = ignoreRegExp.test(content);

                if (unsafePseudoClass && !ignore) {
                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
                }
              });
            }

            break;
          }
      }
    });
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

var isBrowser$1 = typeof document !== 'undefined';

function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}

var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$1 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      if (!isBrowser$1 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$1 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};
/* eslint-disable */
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js


function murmurhash2_32_gc(str) {
  var l = str.length,
      h = l ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;
  return (h >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];

  if (process.env.NODE_ENV !== 'production' && couldBeSelectorInterpolation && shouldWarnAboutInterpolatingClassNameFromCss && cached !== undefined) {
    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
    shouldWarnAboutInterpolatingClassNameFromCss = false;
  }

  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;

var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmurhash2_32_gc(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles(args);
}

var isBrowser$2 = typeof document !== 'undefined';
var EmotionCacheContext = createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? createCache() : null);
var ThemeContext = createContext({});
var CacheProvider = EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  var render = function render(props, ref) {
    return createElement(EmotionCacheContext.Consumer, null, function (cache) {
      return func(props, cache, ref);
    });
  }; // $FlowFixMe


  return forwardRef(render);
};

if (!isBrowser$2) {
  var BasicProvider = /*#__PURE__*/function (_React$Component) {
    inheritsLoose(BasicProvider, _React$Component);

    function BasicProvider(props, context, updater) {
      var _this;

      _this = _React$Component.call(this, props, context, updater) || this;
      _this.state = {
        value: createCache()
      };
      return _this;
    }

    var _proto = BasicProvider.prototype;

    _proto.render = function render() {
      return createElement(EmotionCacheContext.Provider, this.state, this.props.children(this.state.value));
    };

    return BasicProvider;
  }(Component);

  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      return createElement(EmotionCacheContext.Consumer, null, function (context) {
        if (context === null) {
          return createElement(BasicProvider, null, function (newContext) {
            return func(props, newContext);
          });
        } else {
          return func(props, context);
        }
      });
    };
  };
} // thus we only need to replace what is a valid character for JS, but not for CSS


var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var hasOwnProperty = Object.prototype.hasOwnProperty;

var render = function render(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles);

  if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  var rules = insertStyles(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = createElement(type, newProps);

  if (!isBrowser$2 && rules !== undefined) {
    var _ref;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    return createElement(Fragment, null, createElement("style", (_ref = {}, _ref["data-emotion-" + cache.key] = serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref)), ele);
  }

  return ele;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  // use Context.read for the theme when it's stable
  if (typeof props.css === 'function') {
    return createElement(ThemeContext.Consumer, null, function (theme) {
      return render(cache, props, theme, ref);
    });
  }

  return render(cache, props, null, ref);
});

if (process.env.NODE_ENV !== 'production') {
  Emotion.displayName = 'EmotionCssPropInternal';
} // $FlowFixMe


var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !hasOwnProperty.call(props, 'css')) {
    // $FlowFixMe
    return createElement.apply(undefined, args);
  }

  if (process.env.NODE_ENV !== 'production' && typeof props.css === 'string' && // check if there is a css declaration
  props.css.indexOf(':') !== -1) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type;

  if (process.env.NODE_ENV !== 'production') {
    var error = new Error();

    if (error.stack) {
      // chrome
      var match = error.stack.match(/at (?:Object\.|)jsx.*\n\s+at ([A-Z][A-Za-z$]+) /);

      if (!match) {
        // safari and firefox
        match = error.stack.match(/^.*\n([A-Z][A-Za-z$]+)@/);
      }

      if (match) {
        newProps[labelPropName] = sanitizeIdentifier(match[1]);
      }
    }
  }

  createElementArgArray[1] = newProps;

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false;
var Global = /* #__PURE__ */withEmotionCache(function (props, cache) {
  if (process.env.NODE_ENV !== 'production' && !warnedAboutCssPropForGlobal && ( // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  props.className || props.css)) {
    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
    warnedAboutCssPropForGlobal = true;
  }

  var styles = props.styles;

  if (typeof styles === 'function') {
    return createElement(ThemeContext.Consumer, null, function (theme) {
      var serialized = serializeStyles([styles(theme)]);
      return createElement(InnerGlobal, {
        serialized: serialized,
        cache: cache
      });
    });
  }

  var serialized = serializeStyles([styles]);
  return createElement(InnerGlobal, {
    serialized: serialized,
    cache: cache
  });
}); // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var InnerGlobal = /*#__PURE__*/function (_React$Component) {
  inheritsLoose(InnerGlobal, _React$Component);

  function InnerGlobal(props, context, updater) {
    return _React$Component.call(this, props, context, updater) || this;
  }

  var _proto = InnerGlobal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.sheet = new StyleSheet({
      key: this.props.cache.key + "-global",
      nonce: this.props.cache.sheet.nonce,
      container: this.props.cache.sheet.container
    }); // $FlowFixMe

    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");

    if (node !== null) {
      this.sheet.tags.push(node);
    }

    if (this.props.cache.sheet.tags.length) {
      this.sheet.before = this.props.cache.sheet.tags[0];
    }

    this.insertStyles();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.serialized.name !== this.props.serialized.name) {
      this.insertStyles();
    }
  };

  _proto.insertStyles = function insertStyles$1() {
    if (this.props.serialized.next !== undefined) {
      // insert keyframes
      insertStyles(this.props.cache, this.props.serialized.next, true);
    }

    if (this.sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
      this.sheet.before = element;
      this.sheet.flush();
    }

    this.props.cache.insert("", this.props.serialized, this.sheet, false);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.sheet.flush();
  };

  _proto.render = function render() {
    if (!isBrowser$2) {
      var serialized = this.props.serialized;
      var serializedNames = serialized.name;
      var serializedStyles = serialized.styles;
      var next = serialized.next;

      while (next !== undefined) {
        serializedNames += ' ' + next.name;
        serializedStyles += next.styles;
        next = next.next;
      }

      var shouldCache = this.props.cache.compat === true;
      var rules = this.props.cache.insert("", {
        name: serializedNames,
        styles: serializedStyles
      }, this.sheet, shouldCache);

      if (!shouldCache) {
        var _ref;

        return createElement("style", (_ref = {}, _ref["data-emotion-" + this.props.cache.key] = serializedNames, _ref.dangerouslySetInnerHTML = {
          __html: rules
        }, _ref.nonce = this.props.cache.sheet.nonce, _ref));
      }
    }

    return null;
  };

  return InnerGlobal;
}(Component);

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css$$1, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css$$1(registeredStyles);
}

var ClassNames = withEmotionCache(function (props, context) {
  return createElement(ThemeContext.Consumer, null, function (theme) {
    var rules = '';
    var serializedHashes = '';
    var hasRendered = false;

    var css$$1 = function css$$1() {
      if (hasRendered && process.env.NODE_ENV !== 'production') {
        throw new Error('css can only be used during render');
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = serializeStyles(args, context.registered);

      if (isBrowser$2) {
        insertStyles(context, serialized, false);
      } else {
        var res = insertStyles(context, serialized, false);

        if (res !== undefined) {
          rules += res;
        }
      }

      if (!isBrowser$2) {
        serializedHashes += " " + serialized.name;
      }

      return context.key + "-" + serialized.name;
    };

    var cx = function cx() {
      if (hasRendered && process.env.NODE_ENV !== 'production') {
        throw new Error('cx can only be used during render');
      }

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return merge(context.registered, css$$1, classnames(args));
    };

    var content = {
      css: css$$1,
      cx: cx,
      theme: theme
    };
    var ele = props.children(content);
    hasRendered = true;

    if (!isBrowser$2 && rules.length !== 0) {
      var _ref;

      return createElement(Fragment, null, createElement("style", (_ref = {}, _ref["data-emotion-" + context.key] = serializedHashes.substring(1), _ref.dangerouslySetInnerHTML = {
        __html: rules
      }, _ref.nonce = context.sheet.nonce, _ref)), ele);
    }

    return ele;
  });
});

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var tinycolor = createCommonjsModule(function (module) {
  // TinyColor v1.4.1
  // https://github.com/bgrins/TinyColor
  // Brian Grinstead, MIT License
  (function (Math) {
    var trimLeft = /^\s+/,
        trimRight = /\s+$/,
        tinyCounter = 0,
        mathRound = Math.round,
        mathMin = Math.min,
        mathMax = Math.max,
        mathRandom = Math.random;

    function tinycolor(color, opts) {
      color = color ? color : '';
      opts = opts || {}; // If input is already a tinycolor, return itself

      if (color instanceof tinycolor) {
        return color;
      } // If we are called as a function, call using new instead


      if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
      }

      var rgb = inputToRGB(color);
      this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = mathRound(100 * this._a) / 100, this._format = opts.format || rgb.format;
      this._gradientType = opts.gradientType; // Don't let the range of [0,255] come back in [0,1].
      // Potentially lose a little bit of precision here, but will fix issues where
      // .5 gets interpreted as half of the total, instead of half of 1
      // If it was supposed to be 128, this was already taken care of by `inputToRgb`

      if (this._r < 1) {
        this._r = mathRound(this._r);
      }

      if (this._g < 1) {
        this._g = mathRound(this._g);
      }

      if (this._b < 1) {
        this._b = mathRound(this._b);
      }

      this._ok = rgb.ok;
      this._tc_id = tinyCounter++;
    }

    tinycolor.prototype = {
      isDark: function isDark() {
        return this.getBrightness() < 128;
      },
      isLight: function isLight() {
        return !this.isDark();
      },
      isValid: function isValid() {
        return this._ok;
      },
      getOriginalInput: function getOriginalInput() {
        return this._originalInput;
      },
      getFormat: function getFormat() {
        return this._format;
      },
      getAlpha: function getAlpha() {
        return this._a;
      },
      getBrightness: function getBrightness() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
      },
      getLuminance: function getLuminance() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r / 255;
        GsRGB = rgb.g / 255;
        BsRGB = rgb.b / 255;

        if (RsRGB <= 0.03928) {
          R = RsRGB / 12.92;
        } else {
          R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        }

        if (GsRGB <= 0.03928) {
          G = GsRGB / 12.92;
        } else {
          G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        }

        if (BsRGB <= 0.03928) {
          B = BsRGB / 12.92;
        } else {
          B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        }

        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
      },
      setAlpha: function setAlpha(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(100 * this._a) / 100;
        return this;
      },
      toHsv: function toHsv() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return {
          h: hsv.h * 360,
          s: hsv.s,
          v: hsv.v,
          a: this._a
        };
      },
      toHsvString: function toHsvString() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360),
            s = mathRound(hsv.s * 100),
            v = mathRound(hsv.v * 100);
        return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
      },
      toHsl: function toHsl() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return {
          h: hsl.h * 360,
          s: hsl.s,
          l: hsl.l,
          a: this._a
        };
      },
      toHslString: function toHslString() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360),
            s = mathRound(hsl.s * 100),
            l = mathRound(hsl.l * 100);
        return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
      },
      toHex: function toHex(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
      },
      toHexString: function toHexString(allow3Char) {
        return '#' + this.toHex(allow3Char);
      },
      toHex8: function toHex8(allow4Char) {
        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
      },
      toHex8String: function toHex8String(allow4Char) {
        return '#' + this.toHex8(allow4Char);
      },
      toRgb: function toRgb() {
        return {
          r: mathRound(this._r),
          g: mathRound(this._g),
          b: mathRound(this._b),
          a: this._a
        };
      },
      toRgbString: function toRgbString() {
        return this._a == 1 ? "rgb(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" : "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
      },
      toPercentageRgb: function toPercentageRgb() {
        return {
          r: mathRound(bound01(this._r, 255) * 100) + "%",
          g: mathRound(bound01(this._g, 255) * 100) + "%",
          b: mathRound(bound01(this._b, 255) * 100) + "%",
          a: this._a
        };
      },
      toPercentageRgbString: function toPercentageRgbString() {
        return this._a == 1 ? "rgb(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" : "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
      },
      toName: function toName() {
        if (this._a === 0) {
          return "transparent";
        }

        if (this._a < 1) {
          return false;
        }

        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
      },
      toFilter: function toFilter(secondColor) {
        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";

        if (secondColor) {
          var s = tinycolor(secondColor);
          secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }

        return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
      },
      toString: function toString(format) {
        var formatSet = !!format;
        format = format || this._format;
        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

        if (needsAlphaFormat) {
          // Special case for "transparent", all other non-alpha formats
          // will return rgba when there is transparency.
          if (format === "name" && this._a === 0) {
            return this.toName();
          }

          return this.toRgbString();
        }

        if (format === "rgb") {
          formattedString = this.toRgbString();
        }

        if (format === "prgb") {
          formattedString = this.toPercentageRgbString();
        }

        if (format === "hex" || format === "hex6") {
          formattedString = this.toHexString();
        }

        if (format === "hex3") {
          formattedString = this.toHexString(true);
        }

        if (format === "hex4") {
          formattedString = this.toHex8String(true);
        }

        if (format === "hex8") {
          formattedString = this.toHex8String();
        }

        if (format === "name") {
          formattedString = this.toName();
        }

        if (format === "hsl") {
          formattedString = this.toHslString();
        }

        if (format === "hsv") {
          formattedString = this.toHsvString();
        }

        return formattedString || this.toHexString();
      },
      clone: function clone() {
        return tinycolor(this.toString());
      },
      _applyModification: function _applyModification(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
      },
      lighten: function lighten() {
        return this._applyModification(_lighten, arguments);
      },
      brighten: function brighten() {
        return this._applyModification(_brighten, arguments);
      },
      darken: function darken() {
        return this._applyModification(_darken, arguments);
      },
      desaturate: function desaturate() {
        return this._applyModification(_desaturate, arguments);
      },
      saturate: function saturate() {
        return this._applyModification(_saturate, arguments);
      },
      greyscale: function greyscale() {
        return this._applyModification(_greyscale, arguments);
      },
      spin: function spin() {
        return this._applyModification(_spin, arguments);
      },
      _applyCombination: function _applyCombination(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
      },
      analogous: function analogous() {
        return this._applyCombination(_analogous, arguments);
      },
      complement: function complement() {
        return this._applyCombination(_complement, arguments);
      },
      monochromatic: function monochromatic() {
        return this._applyCombination(_monochromatic, arguments);
      },
      splitcomplement: function splitcomplement() {
        return this._applyCombination(_splitcomplement, arguments);
      },
      triad: function triad() {
        return this._applyCombination(_triad, arguments);
      },
      tetrad: function tetrad() {
        return this._applyCombination(_tetrad, arguments);
      }
    }; // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1

    tinycolor.fromRatio = function (color, opts) {
      if (typeof color == "object") {
        var newColor = {};

        for (var i in color) {
          if (color.hasOwnProperty(i)) {
            if (i === "a") {
              newColor[i] = color[i];
            } else {
              newColor[i] = convertToPercentage(color[i]);
            }
          }
        }

        color = newColor;
      }

      return tinycolor(color, opts);
    }; // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //


    function inputToRGB(color) {
      var rgb = {
        r: 0,
        g: 0,
        b: 0
      };
      var a = 1;
      var s = null;
      var v = null;
      var l = null;
      var ok = false;
      var format = false;

      if (typeof color == "string") {
        color = stringInputToObject(color);
      }

      if (typeof color == "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
          rgb = rgbToRgb(color.r, color.g, color.b);
          ok = true;
          format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
          s = convertToPercentage(color.s);
          v = convertToPercentage(color.v);
          rgb = hsvToRgb(color.h, s, v);
          ok = true;
          format = "hsv";
        } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
          s = convertToPercentage(color.s);
          l = convertToPercentage(color.l);
          rgb = hslToRgb(color.h, s, l);
          ok = true;
          format = "hsl";
        }

        if (color.hasOwnProperty("a")) {
          a = color.a;
        }
      }

      a = boundAlpha(a);
      return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
      };
    } // Conversion Functions
    // --------------------
    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]


    function rgbToRgb(r, g, b) {
      return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
      };
    } // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]


    function rgbToHsl(r, g, b) {
      r = bound01(r, 255);
      g = bound01(g, 255);
      b = bound01(b, 255);
      var max = mathMax(r, g, b),
          min = mathMin(r, g, b);
      var h,
          s,
          l = (max + min) / 2;

      if (max == min) {
        h = s = 0; // achromatic
      } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

        switch (max) {
          case r:
            h = (g - b) / d + (g < b ? 6 : 0);
            break;

          case g:
            h = (b - r) / d + 2;
            break;

          case b:
            h = (r - g) / d + 4;
            break;
        }

        h /= 6;
      }

      return {
        h: h,
        s: s,
        l: l
      };
    } // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]


    function hslToRgb(h, s, l) {
      var r, g, b;
      h = bound01(h, 360);
      s = bound01(s, 100);
      l = bound01(l, 100);

      function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
      }

      if (s === 0) {
        r = g = b = l; // achromatic
      } else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
      }

      return {
        r: r * 255,
        g: g * 255,
        b: b * 255
      };
    } // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]


    function rgbToHsv(r, g, b) {
      r = bound01(r, 255);
      g = bound01(g, 255);
      b = bound01(b, 255);
      var max = mathMax(r, g, b),
          min = mathMin(r, g, b);
      var h,
          s,
          v = max;
      var d = max - min;
      s = max === 0 ? 0 : d / max;

      if (max == min) {
        h = 0; // achromatic
      } else {
        switch (max) {
          case r:
            h = (g - b) / d + (g < b ? 6 : 0);
            break;

          case g:
            h = (b - r) / d + 2;
            break;

          case b:
            h = (r - g) / d + 4;
            break;
        }

        h /= 6;
      }

      return {
        h: h,
        s: s,
        v: v
      };
    } // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]


    function hsvToRgb(h, s, v) {
      h = bound01(h, 360) * 6;
      s = bound01(s, 100);
      v = bound01(v, 100);
      var i = Math.floor(h),
          f = h - i,
          p = v * (1 - s),
          q = v * (1 - f * s),
          t = v * (1 - (1 - f) * s),
          mod = i % 6,
          r = [v, q, p, p, t, v][mod],
          g = [t, v, v, q, p, p][mod],
          b = [p, p, t, v, v, q][mod];
      return {
        r: r * 255,
        g: g * 255,
        b: b * 255
      };
    } // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex


    function rgbToHex(r, g, b, allow3Char) {
      var hex = [pad2(mathRound(r).toString(16)), pad2(mathRound(g).toString(16)), pad2(mathRound(b).toString(16))]; // Return a 3 character hex if possible

      if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
      }

      return hex.join("");
    } // `rgbaToHex`
    // Converts an RGBA color plus alpha transparency to hex
    // Assumes r, g, b are contained in the set [0, 255] and
    // a in [0, 1]. Returns a 4 or 8 character rgba hex


    function rgbaToHex(r, g, b, a, allow4Char) {
      var hex = [pad2(mathRound(r).toString(16)), pad2(mathRound(g).toString(16)), pad2(mathRound(b).toString(16)), pad2(convertDecimalToHex(a))]; // Return a 4 character hex if possible

      if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
      }

      return hex.join("");
    } // `rgbaToArgbHex`
    // Converts an RGBA color to an ARGB Hex8 string
    // Rarely used, but required for "toFilter()"


    function rgbaToArgbHex(r, g, b, a) {
      var hex = [pad2(convertDecimalToHex(a)), pad2(mathRound(r).toString(16)), pad2(mathRound(g).toString(16)), pad2(mathRound(b).toString(16))];
      return hex.join("");
    } // `equals`
    // Can be called with any tinycolor input


    tinycolor.equals = function (color1, color2) {
      if (!color1 || !color2) {
        return false;
      }

      return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };

    tinycolor.random = function () {
      return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
      });
    }; // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>


    function _desaturate(color, amount) {
      amount = amount === 0 ? 0 : amount || 10;
      var hsl = tinycolor(color).toHsl();
      hsl.s -= amount / 100;
      hsl.s = clamp01(hsl.s);
      return tinycolor(hsl);
    }

    function _saturate(color, amount) {
      amount = amount === 0 ? 0 : amount || 10;
      var hsl = tinycolor(color).toHsl();
      hsl.s += amount / 100;
      hsl.s = clamp01(hsl.s);
      return tinycolor(hsl);
    }

    function _greyscale(color) {
      return tinycolor(color).desaturate(100);
    }

    function _lighten(color, amount) {
      amount = amount === 0 ? 0 : amount || 10;
      var hsl = tinycolor(color).toHsl();
      hsl.l += amount / 100;
      hsl.l = clamp01(hsl.l);
      return tinycolor(hsl);
    }

    function _brighten(color, amount) {
      amount = amount === 0 ? 0 : amount || 10;
      var rgb = tinycolor(color).toRgb();
      rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * -(amount / 100))));
      rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * -(amount / 100))));
      rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * -(amount / 100))));
      return tinycolor(rgb);
    }

    function _darken(color, amount) {
      amount = amount === 0 ? 0 : amount || 10;
      var hsl = tinycolor(color).toHsl();
      hsl.l -= amount / 100;
      hsl.l = clamp01(hsl.l);
      return tinycolor(hsl);
    } // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.


    function _spin(color, amount) {
      var hsl = tinycolor(color).toHsl();
      var hue = (hsl.h + amount) % 360;
      hsl.h = hue < 0 ? 360 + hue : hue;
      return tinycolor(hsl);
    } // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>


    function _complement(color) {
      var hsl = tinycolor(color).toHsl();
      hsl.h = (hsl.h + 180) % 360;
      return tinycolor(hsl);
    }

    function _triad(color) {
      var hsl = tinycolor(color).toHsl();
      var h = hsl.h;
      return [tinycolor(color), tinycolor({
        h: (h + 120) % 360,
        s: hsl.s,
        l: hsl.l
      }), tinycolor({
        h: (h + 240) % 360,
        s: hsl.s,
        l: hsl.l
      })];
    }

    function _tetrad(color) {
      var hsl = tinycolor(color).toHsl();
      var h = hsl.h;
      return [tinycolor(color), tinycolor({
        h: (h + 90) % 360,
        s: hsl.s,
        l: hsl.l
      }), tinycolor({
        h: (h + 180) % 360,
        s: hsl.s,
        l: hsl.l
      }), tinycolor({
        h: (h + 270) % 360,
        s: hsl.s,
        l: hsl.l
      })];
    }

    function _splitcomplement(color) {
      var hsl = tinycolor(color).toHsl();
      var h = hsl.h;
      return [tinycolor(color), tinycolor({
        h: (h + 72) % 360,
        s: hsl.s,
        l: hsl.l
      }), tinycolor({
        h: (h + 216) % 360,
        s: hsl.s,
        l: hsl.l
      })];
    }

    function _analogous(color, results, slices) {
      results = results || 6;
      slices = slices || 30;
      var hsl = tinycolor(color).toHsl();
      var part = 360 / slices;
      var ret = [tinycolor(color)];

      for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
      }

      return ret;
    }

    function _monochromatic(color, results) {
      results = results || 6;
      var hsv = tinycolor(color).toHsv();
      var h = hsv.h,
          s = hsv.s,
          v = hsv.v;
      var ret = [];
      var modification = 1 / results;

      while (results--) {
        ret.push(tinycolor({
          h: h,
          s: s,
          v: v
        }));
        v = (v + modification) % 1;
      }

      return ret;
    } // Utility Functions
    // ---------------------


    tinycolor.mix = function (color1, color2, amount) {
      amount = amount === 0 ? 0 : amount || 50;
      var rgb1 = tinycolor(color1).toRgb();
      var rgb2 = tinycolor(color2).toRgb();
      var p = amount / 100;
      var rgba = {
        r: (rgb2.r - rgb1.r) * p + rgb1.r,
        g: (rgb2.g - rgb1.g) * p + rgb1.g,
        b: (rgb2.b - rgb1.b) * p + rgb1.b,
        a: (rgb2.a - rgb1.a) * p + rgb1.a
      };
      return tinycolor(rgba);
    }; // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
    // `contrast`
    // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)


    tinycolor.readability = function (color1, color2) {
      var c1 = tinycolor(color1);
      var c2 = tinycolor(color2);
      return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
    }; // `isReadable`
    // Ensure that foreground and background color combinations meet WCAG2 guidelines.
    // The third argument is an optional Object.
    //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
    //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
    // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false


    tinycolor.isReadable = function (color1, color2, wcag2) {
      var readability = tinycolor.readability(color1, color2);
      var wcag2Parms, out;
      out = false;
      wcag2Parms = validateWCAG2Parms(wcag2);

      switch (wcag2Parms.level + wcag2Parms.size) {
        case "AAsmall":
        case "AAAlarge":
          out = readability >= 4.5;
          break;

        case "AAlarge":
          out = readability >= 3;
          break;

        case "AAAsmall":
          out = readability >= 7;
          break;
      }

      return out;
    }; // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // Optionally returns Black or White if the most readable color is unreadable.
    // *Example*
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"


    tinycolor.mostReadable = function (baseColor, colorList, args) {
      var bestColor = null;
      var bestScore = 0;
      var readability;
      var includeFallbackColors, level, size;
      args = args || {};
      includeFallbackColors = args.includeFallbackColors;
      level = args.level;
      size = args.size;

      for (var i = 0; i < colorList.length; i++) {
        readability = tinycolor.readability(baseColor, colorList[i]);

        if (readability > bestScore) {
          bestScore = readability;
          bestColor = tinycolor(colorList[i]);
        }
      }

      if (tinycolor.isReadable(baseColor, bestColor, {
        "level": level,
        "size": size
      }) || !includeFallbackColors) {
        return bestColor;
      } else {
        args.includeFallbackColors = false;
        return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
      }
    }; // Big List of Colors
    // ------------------
    // <http://www.w3.org/TR/css3-color/#svg-color>


    var names = tinycolor.names = {
      aliceblue: "f0f8ff",
      antiquewhite: "faebd7",
      aqua: "0ff",
      aquamarine: "7fffd4",
      azure: "f0ffff",
      beige: "f5f5dc",
      bisque: "ffe4c4",
      black: "000",
      blanchedalmond: "ffebcd",
      blue: "00f",
      blueviolet: "8a2be2",
      brown: "a52a2a",
      burlywood: "deb887",
      burntsienna: "ea7e5d",
      cadetblue: "5f9ea0",
      chartreuse: "7fff00",
      chocolate: "d2691e",
      coral: "ff7f50",
      cornflowerblue: "6495ed",
      cornsilk: "fff8dc",
      crimson: "dc143c",
      cyan: "0ff",
      darkblue: "00008b",
      darkcyan: "008b8b",
      darkgoldenrod: "b8860b",
      darkgray: "a9a9a9",
      darkgreen: "006400",
      darkgrey: "a9a9a9",
      darkkhaki: "bdb76b",
      darkmagenta: "8b008b",
      darkolivegreen: "556b2f",
      darkorange: "ff8c00",
      darkorchid: "9932cc",
      darkred: "8b0000",
      darksalmon: "e9967a",
      darkseagreen: "8fbc8f",
      darkslateblue: "483d8b",
      darkslategray: "2f4f4f",
      darkslategrey: "2f4f4f",
      darkturquoise: "00ced1",
      darkviolet: "9400d3",
      deeppink: "ff1493",
      deepskyblue: "00bfff",
      dimgray: "696969",
      dimgrey: "696969",
      dodgerblue: "1e90ff",
      firebrick: "b22222",
      floralwhite: "fffaf0",
      forestgreen: "228b22",
      fuchsia: "f0f",
      gainsboro: "dcdcdc",
      ghostwhite: "f8f8ff",
      gold: "ffd700",
      goldenrod: "daa520",
      gray: "808080",
      green: "008000",
      greenyellow: "adff2f",
      grey: "808080",
      honeydew: "f0fff0",
      hotpink: "ff69b4",
      indianred: "cd5c5c",
      indigo: "4b0082",
      ivory: "fffff0",
      khaki: "f0e68c",
      lavender: "e6e6fa",
      lavenderblush: "fff0f5",
      lawngreen: "7cfc00",
      lemonchiffon: "fffacd",
      lightblue: "add8e6",
      lightcoral: "f08080",
      lightcyan: "e0ffff",
      lightgoldenrodyellow: "fafad2",
      lightgray: "d3d3d3",
      lightgreen: "90ee90",
      lightgrey: "d3d3d3",
      lightpink: "ffb6c1",
      lightsalmon: "ffa07a",
      lightseagreen: "20b2aa",
      lightskyblue: "87cefa",
      lightslategray: "789",
      lightslategrey: "789",
      lightsteelblue: "b0c4de",
      lightyellow: "ffffe0",
      lime: "0f0",
      limegreen: "32cd32",
      linen: "faf0e6",
      magenta: "f0f",
      maroon: "800000",
      mediumaquamarine: "66cdaa",
      mediumblue: "0000cd",
      mediumorchid: "ba55d3",
      mediumpurple: "9370db",
      mediumseagreen: "3cb371",
      mediumslateblue: "7b68ee",
      mediumspringgreen: "00fa9a",
      mediumturquoise: "48d1cc",
      mediumvioletred: "c71585",
      midnightblue: "191970",
      mintcream: "f5fffa",
      mistyrose: "ffe4e1",
      moccasin: "ffe4b5",
      navajowhite: "ffdead",
      navy: "000080",
      oldlace: "fdf5e6",
      olive: "808000",
      olivedrab: "6b8e23",
      orange: "ffa500",
      orangered: "ff4500",
      orchid: "da70d6",
      palegoldenrod: "eee8aa",
      palegreen: "98fb98",
      paleturquoise: "afeeee",
      palevioletred: "db7093",
      papayawhip: "ffefd5",
      peachpuff: "ffdab9",
      peru: "cd853f",
      pink: "ffc0cb",
      plum: "dda0dd",
      powderblue: "b0e0e6",
      purple: "800080",
      rebeccapurple: "663399",
      red: "f00",
      rosybrown: "bc8f8f",
      royalblue: "4169e1",
      saddlebrown: "8b4513",
      salmon: "fa8072",
      sandybrown: "f4a460",
      seagreen: "2e8b57",
      seashell: "fff5ee",
      sienna: "a0522d",
      silver: "c0c0c0",
      skyblue: "87ceeb",
      slateblue: "6a5acd",
      slategray: "708090",
      slategrey: "708090",
      snow: "fffafa",
      springgreen: "00ff7f",
      steelblue: "4682b4",
      tan: "d2b48c",
      teal: "008080",
      thistle: "d8bfd8",
      tomato: "ff6347",
      turquoise: "40e0d0",
      violet: "ee82ee",
      wheat: "f5deb3",
      white: "fff",
      whitesmoke: "f5f5f5",
      yellow: "ff0",
      yellowgreen: "9acd32"
    }; // Make it easy to access colors via `hexNames[hex]`

    var hexNames = tinycolor.hexNames = flip(names); // Utilities
    // ---------
    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`

    function flip(o) {
      var flipped = {};

      for (var i in o) {
        if (o.hasOwnProperty(i)) {
          flipped[o[i]] = i;
        }
      }

      return flipped;
    } // Return a valid alpha value [0,1] with all invalid values being set to 1


    function boundAlpha(a) {
      a = parseFloat(a);

      if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
      }

      return a;
    } // Take input from [0, n] and return it as [0, 1]


    function bound01(n, max) {
      if (isOnePointZero(n)) {
        n = "100%";
      }

      var processPercent = isPercentage(n);
      n = mathMin(max, mathMax(0, parseFloat(n))); // Automatically convert percentage into number

      if (processPercent) {
        n = parseInt(n * max, 10) / 100;
      } // Handle floating point rounding errors


      if (Math.abs(n - max) < 0.000001) {
        return 1;
      } // Convert into [0, 1] range if it isn't already


      return n % max / parseFloat(max);
    } // Force a number between 0 and 1


    function clamp01(val) {
      return mathMin(1, mathMax(0, val));
    } // Parse a base-16 hex value into a base-10 integer


    function parseIntFromHex(val) {
      return parseInt(val, 16);
    } // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>


    function isOnePointZero(n) {
      return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
    } // Check to see if string passed in is a percentage


    function isPercentage(n) {
      return typeof n === "string" && n.indexOf('%') != -1;
    } // Force a hex value to have 2 characters


    function pad2(c) {
      return c.length == 1 ? '0' + c : '' + c;
    } // Replace a decimal with it's percentage value


    function convertToPercentage(n) {
      if (n <= 1) {
        n = n * 100 + "%";
      }

      return n;
    } // Converts a decimal to a hex value


    function convertDecimalToHex(d) {
      return Math.round(parseFloat(d) * 255).toString(16);
    } // Converts a hex value to a decimal


    function convertHexToDecimal(h) {
      return parseIntFromHex(h) / 255;
    }

    var matchers = function () {
      // <http://www.w3.org/TR/css3-values/#integers>
      var CSS_INTEGER = "[-\\+]?\\d+%?"; // <http://www.w3.org/TR/css3-values/#number-value>

      var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?"; // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.

      var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")"; // Actual matching.
      // Parentheses and commas are optional, but not required.
      // Whitespace can take the place of commas or opening paren

      var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
      var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
      return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
      };
    }(); // `isValidCSSUnit`
    // Take in a single string / number and check to see if it looks like a CSS unit
    // (see `matchers` above for definition).


    function isValidCSSUnit(color) {
      return !!matchers.CSS_UNIT.exec(color);
    } // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`


    function stringInputToObject(color) {
      color = color.replace(trimLeft, '').replace(trimRight, '').toLowerCase();
      var named = false;

      if (names[color]) {
        color = names[color];
        named = true;
      } else if (color == 'transparent') {
        return {
          r: 0,
          g: 0,
          b: 0,
          a: 0,
          format: "name"
        };
      } // Try to match string input using regular expressions.
      // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
      // Just return an object and let the conversion functions handle that.
      // This way the result will be the same whether the tinycolor is initialized with string or object.


      var match;

      if (match = matchers.rgb.exec(color)) {
        return {
          r: match[1],
          g: match[2],
          b: match[3]
        };
      }

      if (match = matchers.rgba.exec(color)) {
        return {
          r: match[1],
          g: match[2],
          b: match[3],
          a: match[4]
        };
      }

      if (match = matchers.hsl.exec(color)) {
        return {
          h: match[1],
          s: match[2],
          l: match[3]
        };
      }

      if (match = matchers.hsla.exec(color)) {
        return {
          h: match[1],
          s: match[2],
          l: match[3],
          a: match[4]
        };
      }

      if (match = matchers.hsv.exec(color)) {
        return {
          h: match[1],
          s: match[2],
          v: match[3]
        };
      }

      if (match = matchers.hsva.exec(color)) {
        return {
          h: match[1],
          s: match[2],
          v: match[3],
          a: match[4]
        };
      }

      if (match = matchers.hex8.exec(color)) {
        return {
          r: parseIntFromHex(match[1]),
          g: parseIntFromHex(match[2]),
          b: parseIntFromHex(match[3]),
          a: convertHexToDecimal(match[4]),
          format: named ? "name" : "hex8"
        };
      }

      if (match = matchers.hex6.exec(color)) {
        return {
          r: parseIntFromHex(match[1]),
          g: parseIntFromHex(match[2]),
          b: parseIntFromHex(match[3]),
          format: named ? "name" : "hex"
        };
      }

      if (match = matchers.hex4.exec(color)) {
        return {
          r: parseIntFromHex(match[1] + '' + match[1]),
          g: parseIntFromHex(match[2] + '' + match[2]),
          b: parseIntFromHex(match[3] + '' + match[3]),
          a: convertHexToDecimal(match[4] + '' + match[4]),
          format: named ? "name" : "hex8"
        };
      }

      if (match = matchers.hex3.exec(color)) {
        return {
          r: parseIntFromHex(match[1] + '' + match[1]),
          g: parseIntFromHex(match[2] + '' + match[2]),
          b: parseIntFromHex(match[3] + '' + match[3]),
          format: named ? "name" : "hex"
        };
      }

      return false;
    }

    function validateWCAG2Parms(parms) {
      // return valid WCAG2 parms for isReadable.
      // If input parms are invalid, return {"level":"AA", "size":"small"}
      var level, size;
      parms = parms || {
        "level": "AA",
        "size": "small"
      };
      level = (parms.level || "AA").toUpperCase();
      size = (parms.size || "small").toLowerCase();

      if (level !== "AA" && level !== "AAA") {
        level = "AA";
      }

      if (size !== "small" && size !== "large") {
        size = "small";
      }

      return {
        "level": level,
        "size": size
      };
    } // Node: Export function


    if (module.exports) {
      module.exports = tinycolor;
    } // AMD/requirejs: Define the module
    else {
        window.tinycolor = tinycolor;
      }
  })(Math);
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var defineProperty = function defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var taggedTemplateLiteral = function taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var toConsumableArray = function toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
};

function useBrowserStorage(key, initialValue) {
  var storage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : localStorage;

  var _useState = useState(function () {
    return getValue();
  }),
      _useState2 = slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  function updateValue(value) {
    setValue(value);

    try {
      storage.setItem(key, JSON.stringify(value));
    } catch (err) {}
  }

  function getValue() {
    try {
      var storedValue = storage.getItem(key);
      return JSON.parse(storedValue);
    } catch (err) {
      return initialValue;
    }
  }

  return [value, updateValue];
}

var UIContext = React.createContext(null);
var NotificationContext = React.createContext(null);
var c = {};
c.colors = {
  c1: "hsla(200, 30%, 20%, 1)",
  // Input, H1, H2
  c2: "hsla(200, 25%, 30%, 1)",
  c3: "hsla(200, 20%, 40%, 1)",
  c4: "hsla(200, 15%, 60%, 1)",
  c5: "hsla(200, 10%, 75%, 1)",
  c6: "hsla(200, 5%, 92%, 1)",
  bg0: "white",
  bg1: "hsla(220, 10%, 99%, 1)",
  bg2: "hsl(220, 15%, 98%)",
  bg3: "hsl(227, 20%, 97%)",
  bg4: "hsl(227, 20%, 96%)",
  accent1: "hsl(350, 90%, 60%)",
  accent2: "hsl(360, 95%, 70%)",
  // Action, small Headings, details
  error: "hsl(360, 90%, 60%)",
  success: "hsl(130, 70%, 45%)",
  uiBorderColor: "hsla(200, 10%, 87%, 1)",
  shadowColor: "hsla(200, 60%, 20%, .05)"
};
c.globals = {
  bodyBackground: function bodyBackground(c) {
    return c.colors.bg1;
  },
  fontSmoothing: "antialiased",
  custom: "" // any scss

};
c.inlineLinks = {
  color: function color(c) {
    return c.colors.accent1;
  },
  textDecoration: "none",
  border: {
    show: true,
    size: 1,
    color: function color(c) {
      return c.colors.accent1;
    },
    alpha: 0.25
  }
};
c.fonts = {
  faces: {
    normal: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;" // You can add h1, h2, p1, p2 etc.

  },
  weights: {
    normal: 400,
    H1: 700,
    H2: 700,
    H3: 600,
    H4: 600,
    H5: 500,
    Label: 400,
    Button: 500,
    Input: 400,
    smallHeading: 600
  },
  margins: {
    normal: "0.4rem 0 1rem 0",
    H1: "0.4rem 0 .2rem 0",
    H2: "0.3rem 0 .3rem 0",
    H3: "0.2rem 0 .6rem 0",
    H4: "0.2rem 0 1rem 0",
    H5: "0.2rem 0 1rem 0",
    SmallText: ".3rem 0 0.4rem 0",
    smallHeading: ".4rem 0 0.4rem 0",
    Badge: "0"
  },
  sizes: {
    normal: ["1em", "16px"],
    P2: ["0.9em", "16px"],
    H1: ["3em", "2em"],
    H2: ["1.8", "1.6em"],
    H3: "1.5em",
    H4: "1.2em",
    H5: "1.1em",
    Badge: ["0.9em", "16px"],
    SmallText: ["0.8em", "16px"],
    smallHeading: ["1em", "16px"],
    Button: ["0.95em", "16px"],
    Input: ["1em", "16px"]
  },
  lineHeights: {
    normal: 1.5,
    H1: 1.3,
    H2: 1.2,
    H3: 1.2,
    H4: 1.2,
    H5: 1.2,
    Badge: 1.3
  },
  colors: {
    normal: function normal(c) {
      return c.colors.c2;
    },
    H1: function H1(c) {
      return c.colors.c1;
    },
    H2: function H2(c) {
      return c.colors.c1;
    },
    H3: function H3(c) {
      return c.colors.c2;
    },
    H4: function H4(c) {
      return c.colors.c3;
    },
    H5: function H5(c) {
      return c.colors.c3;
    },
    P1: function P1(c) {
      return c.colors.c3;
    },
    P2: function P2(c) {
      return c.colors.c4;
    },
    SmallText: function SmallText(c) {
      return c.colors.c4;
    },
    smallHeading: function smallHeading(c) {
      return c.colors.c3;
    }
  },
  headingsEmphasis: {
    // Applies to H1 and H2
    emFontStyle: "normal",
    emColor: function emColor(c) {
      return c.colors.accent1;
    }
  },
  smallHeading: {
    uppercase: true
  }
};
c.responsive = {
  breakPoint: "768px",
  fontSize: ".95em"
};
c.sizes = {
  xxxl: "3em",
  xxl: "1.8em",
  xl: "1.6em",
  l: "1.4em",
  m: "1em",
  s: ".9em",
  xs: ".8em",
  xxs: ".4em",
  xxxs: ".1em"
};
c.layout = {
  gridGap: function gridGap(c) {
    return c.sizes.m;
  },
  stackGap: function stackGap(c) {
    return c.sizes.xxs;
  },
  layoutWidth: "76rem",
  layoutPadding: ["2.5rem", "1.5rem"]
};
c.section = {
  padding: ["5rem", "3rem"],
  skew: null,
  // Example: 5deg
  border: "none"
};
c.appearance = {
  bigRadius: ".8em",
  // cards
  smallRadius: ".3em",
  // inline cards, buttons
  badgeRadius: "1em",
  headingsAlign: "left"
};
c.divider = {
  color: function color(c) {
    return c.colors.c6;
  }
};
c.breadcrumbs = {
  spacing: "1px",
  separator: {
    icon: "chevronRight",
    color: function color(c) {
      return c.colors.c5;
    },
    size: "1.4em",
    strokeWidth: "1.6px"
  },
  crumbStyle: {
    color: function color(c) {
      return c.colors.c3;
    },
    cursor: "pointer"
  },
  lastCrumbStyle: {},
  emphasizedCrumbStyle: {
    fontWeight: 600,
    color: function color(c) {
      return c.colors.c1;
    }
  }
};
c.accordion = {
  toggleSpacing: "0.6em"
};
c.effects = {
  bigShadow: function bigShadow(c) {
    return "0em 0.5em 1.4em " + c.colors.shadowColor;
  },
  // Cards
  smallShadow: function smallShadow(c) {
    return "0em 0.15em .4em " + c.colors.shadowColor;
  } // Inline Cards

};
c.animations = {
  animationCurveIn: "cubic-bezier(0.4, 0, 0.2, 1)",
  animationCurveOut: "cubic-bezier(0.6, 0, .7, 1)",
  springs: {
    fast: {
      tension: 380,
      friction: 20,
      mass: 0.1
    },
    medium: {
      tension: 160,
      friction: 20,
      mass: 0.3
    },
    debug: {
      tension: 10,
      friction: 30,
      mass: 2
    }
  }
};
c.topLoader = {
  color: function color(c) {
    return c.colors.accent1;
  },
  height: 2,
  duration: "30s"
};
c.spinner = {
  color: function color(c) {
    return c.colors.c3;
  },
  size: 28,
  stroke: 3,
  rotation: "1.2s"
};
c.cards = {
  border: function border(c) {
    return "1px solid " + c.colors.uiBorderColor;
  },
  background: function background(c) {
    return c.colors.bg0;
  },
  inlineBackground: function inlineBackground(c) {
    return c.colors.bg0;
  },
  subtleBackground: function subtleBackground(c) {
    return c.colors.accent1;
  },
  bigPadding: function bigPadding(c) {
    return c.sizes.xl + " " + c.sizes.xxl;
  },
  smallPadding: function smallPadding(c) {
    return c.sizes.m + " " + c.sizes.l;
  },
  footerBorderWidth: 1,
  footerBorderColor: function footerBorderColor(c) {
    return c.colors.c6;
  }
};
c.tables = {
  border: function border(c) {
    return "1px solid " + c.colors.uiBorderColor;
  },
  innerBorder: function innerBorder(c) {
    return "1px solid " + c.colors.c6;
  },
  background: function background(c) {
    return c.colors.bg0;
  },
  headerBackground: function headerBackground(c) {
    return c.colors.bg4;
  },
  hoverBackground: function hoverBackground(c) {
    return c.colors.bg3;
  },
  padding: function padding(c) {
    return "0 " + c.sizes.xs;
  },
  rowHeight: "2.4em",
  radius: function radius(c) {
    return c.appearance.smallRadius;
  },
  textComponentStyle: "P1",
  headerStyle: {
    fontWeight: 600,
    color: function color(c) {
      return c.colors.c1;
    }
  },
  rowStyle: {}
};
c.notification = {
  side: "left",
  timeout: 6000,
  color: function color(c) {
    return c.colors.c6;
  },
  background: function background(c) {
    return c.colors.c1;
  },
  closeColor: function closeColor(c) {
    return c.colors.c4;
  },
  shadow: function shadow(c) {
    return c.effects.bigShadow;
  },
  horizontalPadding: function horizontalPadding(c) {
    return c.sizes.xs;
  },
  verticalPadding: function verticalPadding(c) {
    return c.sizes.xxs;
  },
  margin: function margin(c) {
    return c.sizes.l;
  },
  gap: "0.3em",
  radius: function radius(c) {
    return c.appearance.smallRadius;
  },
  iconSize: function iconSize(c) {
    return c.sizes.m;
  },
  spinnerSize: 14,
  spinnerStroke: 2,
  actionColor: function actionColor(c) {
    return c.colors.accent1;
  }
};
c.buttons = {
  // General and Buttons,
  textColor: "white",
  textColorInverted: "hsla(200, 25%, 30%, 1)",
  // Recommended: c2
  primaryColor: function primaryColor(c) {
    return c.colors.accent1;
  },
  secondaryColor: function secondaryColor(c) {
    return c.colors.accent1;
  },
  linksColor: function linksColor(c) {
    return c.colors.accent1;
  },
  linkBorderSize: "0",
  height: "2em",
  iconGap: "3px",
  padding: "0 1em",
  smallHeight: "1.8em",
  smallPadding: "0 .9em",
  radius: function radius(c) {
    return c.appearance.smallRadius;
  },
  smallRadius: function smallRadius(c) {
    return c.appearance.smallRadius;
  },
  shadowSize: "0 0.15em 0.2em .05em",
  iconSide: "left",
  hoverLighten: 3,
  activeLighten: -3,
  secondaryBackgroundAlpha: 0.15,
  transition: ".1s filter, .1s transform",
  whiteButtonsEffect: function whiteButtonsEffect(c) {
    return "border: 1px solid " + c.colors.c6 + ";";
  }
};
c.circleButton = {
  color: "white",
  colorInverted: "hsla(200, 25%, 30%, 1)",
  // Recommended: c2
  size: "4.5em",
  background: function background(c) {
    return c.colors.accent1;
  },
  iconSize: "2em",
  shadowSize: function shadowSize(c) {
    return "0 0.15em 0.2em .05em";
  }
};
c.floatingButton = {
  position: function position(c) {
    return {
      left: c.layout.layoutPadding,
      bottom: c.layout.layoutPadding
    };
  }
};
c["switch"] = {
  colorOn: function colorOn(c) {
    return c.colors.accent1;
  },
  colorOff: function colorOff(c) {
    return c.colors.c5;
  },
  colorForeground: "white",
  normal: {
    width: 44,
    height: 30,
    padding: 3
  },
  small: {
    width: 40,
    height: 26,
    padding: 2
  }
};
c.badge = {
  color: function color(c) {
    return c.colors.accent2;
  }
};
c.inputs = {
  width: "100%",
  padding: ".5em",
  background: function background(c) {
    return c.colors.bg0;
  },
  borderWidth: "1px",
  color: function color(c) {
    return c.colors.c5;
  },
  colorFocus: function colorFocus(c) {
    return c.colors.accent2;
  },
  colorError: function colorError(c) {
    return c.colors.error;
  },
  colorSuccess: function colorSuccess(c) {
    return c.colors.success;
  },
  outlineWidth: 2,
  outlineAlpha: 0.3,
  textColor: function textColor(c) {
    return c.colors.c1;
  },
  placeholderColor: function placeholderColor(c) {
    return c.colors.c4;
  },
  labelColor: function labelColor(c) {
    return c.colors.c3;
  },
  iconColor: function iconColor(c) {
    return c.colors.c5;
  },
  iconStrokeWidth: 1.7
};
c.radio = {
  gap: function gap(c) {
    return c.sizes.xxxs;
  },
  borderColor: function borderColor(c) {
    return c.colors.c5;
  },
  shadowSize: "0 0.15em 0.2em .05em",
  shadowAlpha: 0.15,
  colorNormal: function colorNormal(c) {
    return c.colors.bg0;
  },
  colorChecked: function colorChecked(c) {
    return c.colors.accent1;
  },
  colorDot: function colorDot(c) {
    return "white";
  },
  size: 16,
  dotSize: 4
};
c.checkbox = {
  gap: function gap(c) {
    return c.sizes.xxxs;
  },
  colorNormal: function colorNormal(c) {
    return c.colors.bg0;
  },
  activeColor: function activeColor(c) {
    return c.colors.accent1;
  },
  borderColor: function borderColor(c) {
    return c.colors.c5;
  },
  borderSize: "1px solid",
  radius: ".3em",
  shadowSize: "0 0.15em 0.2em .05em",
  shadowAlpha: 0.15,
  glyphSize: "80%",
  size: 18,
  strokeWidth: 3
};
c.slider = {
  thumbColor: function thumbColor(c) {
    return c.colors.accent1;
  },
  trackColor: function trackColor(c) {
    return c.colors.c6;
  },
  trackHeight: 6,
  thumbSize: 18,
  borderColor: function borderColor(c) {
    return c.colors.c5;
  },
  shadowSize: "0 0.15em 0.2em .05em",
  shadowAlpha: 0.15
};
c.dropdown = {
  offset: 10,
  anchor: "BOTTOM_CENTER",
  preferX: "RIGHT",
  buttonColor: function buttonColor(c) {
    return c.colors.bg0;
  },
  background: function background(c) {
    return c.colors.bg0;
  },
  border: function border(c) {
    return "1px solid " + c.colors.uiBorderColor;
  },
  shadow: function shadow(c) {
    return c.effects.smallShadow;
  },
  radius: function radius(c) {
    return c.appearance.smallRadius;
  },
  textColor: function textColor(c) {
    return c.colors.c2;
  },
  activeColor: function activeColor(c) {
    return c.colors.accent1;
  },
  lateralPadding: "0.6em",
  verticalPadding: "0.2em",
  headerPadding: "0.3em",
  rowPadding: ".3em",
  iconPadding: ".5em",
  rowSize: function rowSize(c) {
    return c.sizes.s;
  },
  rowIconSize: function rowIconSize(c) {
    return c.sizes.m;
  },
  rowImageSize: function rowImageSize(c) {
    return c.sizes.l;
  },
  rowImageCornerRadius: "0.2em",
  scrollableHeight: "10em",
  clipPadding: 20,
  detailsSize: function detailsSize(c) {
    return c.sizes.xs;
  },
  detailsColor: function detailsColor(c) {
    return c.colors.c4;
  }
};
c.icon = {
  size: "1em",
  sizeInButtons: function sizeInButtons(c) {
    return c.sizes.m;
  },
  strokeWidth: "2.5px",
  strokeInButtons: 2,
  color: function color(c) {
    return c.colors.accent1;
  },
  end: "round",
  // butt, round, square
  join: "round" // bevel, round, arcs

};
c.iconBadge = {
  backgroundAlpha: 0.15,
  size: "1.6em",
  iconSize: "60%",
  color: function color(c) {
    return c.colors.accent1;
  }
};
c.sidebar = {
  width: "420px",
  padding: {
    lateral: function lateral(c) {
      return c.layout.layoutPadding;
    },
    vertical: function vertical(c) {
      return c.sizes.xl;
    },
    header: function header(c) {
      return c.sizes.l;
    }
  },
  floatingAt: "1100px",
  fullScreenAt: "640px",
  background: function background(c) {
    return c.colors.bg4;
  },
  headerFooterBackground: function headerFooterBackground(c) {
    return c.colors.bg2;
  },
  backgroundOverlayColor: "rgba(0, 0, 0, .4)",
  border: function border(c) {
    return "1px solid " + c.colors.c6;
  },
  innerBorders: function innerBorders(c) {
    return "1px solid " + c.colors.uiBorderColor;
  },
  headerSticky: true,
  footerSticky: true,
  footerPlaceholderHeight: "0",
  handle: {
    show: true,
    hideAt: "0px",
    color: function color(c) {
      return c.colors.c5;
    },
    colorFixed: "rgba(255,255,255,.85)",
    height: "3em",
    width: "15px",
    innerWidth: "8px"
  },
  section: {
    hoverColor: function hoverColor(c) {
      return c.colors.bg0;
    },
    chevron: {
      width: "3em",
      size: "2em",
      icon: "chevronRight",
      strokeWidth: "1.5px",
      color: function color(c) {
        return c.colors.c4;
      }
    }
  }
};
c.header = {
  background: function background(c) {
    return c.colors.bg0;
  },
  openMenuBackground: function openMenuBackground(c) {
    return c.colors.bg1;
  },
  border: function border(c) {
    return "1px solid " + c.colors.uiBorderColor;
  },
  linksGap: function linksGap(c) {
    return c.sizes.s;
  },
  shadow: "",
  height: "3.5em",
  breakPoint: "640px",
  hamburgerMenuColor: function hamburgerMenuColor(c) {
    return c.colors.accent1;
  },
  hamburgerMenuStrokeWidth: 2,
  hamburgerMenuHeight: 12,
  hamburgerMenuWidth: 22,
  centerLinksOnFullscreen: false,
  centeredElementsZoom: 1.2,
  fixed: false
};
c.floatingFooter = {
  background: function background(c) {
    return c.colors.bg0;
  },
  border: function border(c) {
    return "1px solid " + c.colors.uiBorderColor;
  },
  shadow: "",
  height: "3.5em"
};
c.modals = {
  transitionDuration: "0.25s",
  modalWidth: "28rem",
  modalBackground: "rgba(5,15,30,.25)",
  modalFadeEffect: "transform: scale(0.97);",
  closeButtonMargin: "0.2em"
};
c.tabs = {
  tabsPadding: ".6em 1.2em",
  tabsRadius: function tabsRadius(c) {
    return c.appearance.smallRadius;
  },
  tabsBackground: function tabsBackground(c) {
    return c.colors.bg0;
  },
  tabShadow: function tabShadow(c) {
    return "0 .2em .8em " + c.colors.c6;
  },
  tabsActiveStyle: function tabsActiveStyle(c) {
    return "color: " + c.colors.accent1 + ";";
  },
  tabsInactiveStyle: function tabsInactiveStyle(c) {
    return "color: " + c.colors.c4 + ";";
  },
  tabsArrowIcons: ["arrowLeftBold", "arrowRightBold"],
  tabsArrowColor: function tabsArrowColor(c) {
    return c.colors.c4;
  },
  tabsBreakPoint: "600px"
};
c.H1 = {};
c.H2 = {};
c.H3 = {};
c.H4 = {};
c.H5 = {};
c.P1 = {};
c.P2 = {};
c.SmallText = {};
c.Badge = {};
c.Container = {};
c.Block = {};
c.Grid = {};
c.Button = {};
c.FloatingButton = {};
c.CircleButton = {};
c.Sidebar = {};
c.SidebarHeader = {};
c.SidebarFooter = {};
c.Body = {};
c.AutoGrid = {};
c.HStack = {};
c.VStack = {};
c.Card = {};
c.CardFooter = {};
c.SubtleCard = {};
c.Spacer = {};
c.Center = {};
c.Input = {};
c.FormContainer = {};
c.Modal = {};
c.ExitModal = {};
c.TabSet = {};

function isObject(item) {
  return item && (typeof item === "undefined" ? "undefined" : _typeof(item)) === "object" && !Array.isArray(item);
}

function deepMerge(target, source) {
  var output = Object.assign({}, target);

  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(function (key) {
      if (isObject(source[key])) {
        if (!(key in target)) {
          Object.assign(output, defineProperty({}, key, source[key]));
        } else {
          output[key] = deepMerge(target[key], source[key]);
        }
      } else {
        Object.assign(output, defineProperty({}, key, source[key]));
      }
    });
  }

  return output;
}
/**
 * Wraps the config and resolves functions to values on access.
 *
 * @param {object} config The config
 * @param {object} globalConfig Optional parameter used internally for recursion.
 */


function wrapConfig(config, globalConfig) {
  if (!config) {
    return config;
  }

  return new Proxy(config, {
    get: function get$$1(obj, key) {
      var value = obj[key];

      if (typeof value === "function") {
        var res = value(globalConfig || config);

        while (typeof res === "function") {
          res = res(globalConfig || config);
        }

        return res;
      } else if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" && !Array.isArray(value)) {
        return wrapConfig(value, globalConfig || config);
      } else {
        return value;
      }
    }
  });
}
/**
 * Global variables that we use in utility functions to not pass the config.
 */


var responsiveBreakpoint = null;
var globals = {
  notif: null
};

function updateAfterConfig(config) {
  responsiveBreakpoint = config.responsive.breakPoint;
}

function useConfigSetup(overrides) {
  var startConfig = deepMerge(c, overrides);

  var _useState = useState(startConfig),
      _useState2 = slicedToArray(_useState, 2),
      config = _useState2[0],
      setConfig = _useState2[1];

  updateAfterConfig(config);

  function updateConfig(update) {
    var updatedConfig = deepMerge(config, update);
    setConfig(updatedConfig);
  }

  function resetConfig() {
    setConfig(startConfig);
  }

  return {
    config: config,
    updateConfig: updateConfig,
    resetConfig: resetConfig
  };
}

function useConfig() {
  var _useContext = useContext(UIContext),
      config = _useContext.config;

  return wrapConfig(config);
}

function useUpdateConfig() {
  var _useContext2 = useContext(UIContext),
      updateConfig = _useContext2.updateConfig;

  return updateConfig;
}

function useResetConfig() {
  var _useContext3 = useContext(UIContext),
      resetConfig = _useContext3.resetConfig;

  return resetConfig;
}

function useNotificationSetup() {
  var _useState = useState(false),
      _useState2 = slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var _useState3 = useState(""),
      _useState4 = slicedToArray(_useState3, 2),
      text = _useState4[0],
      setText = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = slicedToArray(_useState5, 2),
      icon = _useState6[0],
      setIcon = _useState6[1];

  var _useState7 = useState("left"),
      _useState8 = slicedToArray(_useState7, 2),
      side = _useState8[0],
      setSide = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = slicedToArray(_useState9, 2),
      loading = _useState10[0],
      setLoading = _useState10[1];

  var _useState11 = useState(null),
      _useState12 = slicedToArray(_useState11, 2),
      actionLabel = _useState12[0],
      setActionLabel = _useState12[1];

  var onActionClickRef = useRef(null);
  var onCloseClickRef = useRef(null); // reset icon parameters after hide

  useEffect(function () {
    var timeout = void 0;

    if (!show) {
      timeout = setTimeout(function () {
        setText("");
        setIcon(null);
        setSide("left");
        setLoading(false);
        setActionLabel(null);
        onActionClickRef.current = null;
        onCloseClickRef.current = null;
      }, 300);
    }

    return function () {
      return timeout && clearTimeout(timeout);
    };
  }, [show]);
  var notif = {
    /**
     * Show a message with the given options. Options have sane defaults and their names
     * match the props of the `Notification` component.
     */
    show: function show(text, options) {
      var _ref = options || {},
          _ref$autohide = _ref.autohide,
          autohide = _ref$autohide === undefined ? 10000 : _ref$autohide,
          _ref$icon = _ref.icon,
          icon = _ref$icon === undefined ? null : _ref$icon,
          _ref$side = _ref.side,
          side = _ref$side === undefined ? "left" : _ref$side,
          _ref$loading = _ref.loading,
          loading = _ref$loading === undefined ? false : _ref$loading,
          _ref$actionLabel = _ref.actionLabel,
          actionLabel = _ref$actionLabel === undefined ? null : _ref$actionLabel,
          _ref$onActionClick = _ref.onActionClick,
          onActionClick = _ref$onActionClick === undefined ? null : _ref$onActionClick,
          _ref$onCloseClick = _ref.onCloseClick,
          onCloseClick = _ref$onCloseClick === undefined ? null : _ref$onCloseClick;

      setText(text);
      setShow(true);
      setIcon(icon);
      setSide(side);
      setLoading(loading);
      setActionLabel(actionLabel);
      onActionClickRef.current = onActionClick;
      onCloseClickRef.current = onCloseClick;
      var timeout = autohide && setTimeout(function () {
        return notif.hide();
      }, autohide);
      return function () {
        timeout && clearTimeout(timeout);
      };
    },

    /**
     * Show a success message with a checkmark and autohide shortly after than.
     */
    loading: function loading(text, options) {
      notif.show(text, _extends({
        loading: true,
        autohide: 0
      }, options));
    },

    /**
     * Show a success message with a checkmark and autohide shortly after than.
     */
    success: function success(text, options) {
      notif.show(text, _extends({
        icon: "checkmark"
      }, options));
    },
    error: function error(text, options) {
      notif.show(text, _extends({
        icon: "warningBold"
      }, options));
    },

    /**
     * Hide the notification.
     */
    hide: function hide() {
      setShow(false);
    }
  };
  return {
    notif: notif,
    props: {
      show: show,
      text: text,
      icon: icon,
      side: side,
      loading: loading,
      actionLabel: actionLabel,
      onActionClick: function onActionClick() {
        notif.hide();
        onActionClickRef.current && onActionClickRef.current();
      },
      onCloseClick: function onCloseClick() {
        notif.hide();
        onCloseClickRef.current && onCloseClickRef.current();
      }
    }
  };
}
/**
 * Exposes the notif interface for working with notifications.
 *
 * @example
 * ```
 * notif.show("Title", {autohide: 2000})
 * notif.hide()
 * ```
 */


function useNotification() {
  var notif = useContext(NotificationContext);
  return notif;
}

function useMedia(queries, values, defaultValue) {
  var _useState = useState(defaultValue),
      _useState2 = slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  useEffect(function () {
    var updateValue = function updateValue() {
      var matchedIndex = mediaQueryLists.findIndex(function (mql) {
        return mql.matches;
      });
      var matchedValue = typeof values[matchedIndex] !== "undefined" ? values[matchedIndex] : defaultValue;
      setValue(matchedValue);
    };

    var mediaQueryLists = queries.map(function (q) {
      return window.matchMedia(q);
    });
    updateValue();

    var handler = function handler() {
      return updateValue();
    };

    mediaQueryLists.forEach(function (mql) {
      return mql.addListener(handler);
    });
    return function () {
      return mediaQueryLists.forEach(function (mql) {
        return mql.removeListener(handler);
      });
    };
  }, [queries, values, defaultValue]);
  return value;
}

function usePrefersDarkMode() {
  return useMedia(["(prefers-color-scheme: dark)"], [true], false);
}

function useLocalStorage(key, initialValue) {
  var readAndParse = function readAndParse(key) {
    var item = window.localStorage.getItem(key);
    if (!item) return;
    var parsedItem = JSON.parse(item);
    return parsedItem;
  };

  var getInitialValue = function getInitialValue() {
    if (typeof window !== "undefined") {
      return readAndParse(key) || initialValue;
    }
  };

  var _useState = useState(getInitialValue),
      _useState2 = slicedToArray(_useState, 2),
      storedValue = _useState2[0],
      setStoredValue = _useState2[1];

  useEffect(function () {
    try {
      setStoredValue(readAndParse(key));
    } catch (error) {
      console.log("error reading local storage", error);
    }
  }, [key]);

  var setValue = function setValue(value) {
    try {
      var valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      console.log("error writing local storage", error);
    }
  };

  return [storedValue, setValue];
}

function useDarkMode() {
  var _useLocalStorage = useLocalStorage("dark-mode-enabled"),
      _useLocalStorage2 = slicedToArray(_useLocalStorage, 2),
      enabledState = _useLocalStorage2[0],
      setEnabledState = _useLocalStorage2[1]; // See if user has set a browser or OS preference for dark mode.


  var prefersDarkMode = usePrefersDarkMode(); // This allows user to override OS level setting on our website.

  var enabled = typeof enabledState !== "undefined" && enabledState !== null ? enabledState : prefersDarkMode; // Return enabled state and setter

  return [enabled, setEnabledState];
}
/**
 * We need this to fix "document/window undefined" in Gatsby.
 */


function useWindow() {
  var windowRef = useRef(typeof window !== "undefined" ? window : null);
  useEffect(function () {
    if (!windowRef.current) {
      windowRef.current = window;
    }
  }, []);
  return windowRef.current;
} // Hook


function useWindowSize() {
  var isClient = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object";

  function getSize() {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined
    };
  }

  var _useState = useState(getSize),
      _useState2 = slicedToArray(_useState, 2),
      windowSize = _useState2[0],
      setWindowSize = _useState2[1];

  useEffect(function () {
    if (!isClient) {
      return false;
    }

    function handleResize() {
      setWindowSize(getSize());
    }

    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return windowSize;
}

function useClickOutside(ref, handler) {
  useEffect(function () {
    if (!ref.current) return;
    var element = ref.current;

    var handleClickOutside = function handleClickOutside(event) {
      if (!element.contains(event.target)) {
        handler(event);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      return document.removeEventListener("mousedown", handleClickOutside);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref.current]);
}

function useResponsiveValue(property, selector) {
  var config = useConfig();
  var value = selector(config);

  if (typeof value === "string") {
    return "\n      " + property + ": " + value + ";\n    ";
  } else {
    return "\n      " + property + ": " + value[0] + ";\n      @media only screen and (max-width: " + config.responsive.breakPoint + ") {\n        " + property + ": " + value[1] + ";\n      }\n    ";
  }
}

var _templateObject = taggedTemplateLiteral(["\n    ", "\n    ", "\n    ", "\n    ", "\n  "], ["\n    ", "\n    ", "\n    ", "\n    ", "\n  "]),
    _templateObject2 = taggedTemplateLiteral(["\n            @media (max-width: ", ") {\n              display: none !important;\n              visibility: hidden !important;\n            }\n          "], ["\n            @media (max-width: ", ") {\n              display: none !important;\n              visibility: hidden !important;\n            }\n          "]),
    _templateObject3 = taggedTemplateLiteral(["\n            @media (min-width: ", ") {\n              display: none !important;\n              visibility: hidden !important;\n            }\n          "], ["\n            @media (min-width: ", ") {\n              display: none !important;\n              visibility: hidden !important;\n            }\n          "]);

function getHAlign(align) {
  var alignments = {
    center: "center",
    left: "flex-start",
    right: "flex-end",
    spaced: "space-between",
    even: "space-evenely",
    around: "space-around",
    stretch: "stretch"
  };

  if (align) {
    return alignments[align] || alignments["spaced"];
  } else {
    return null;
  }
}

function getVAlign(justify) {
  var alignments = {
    center: "center",
    top: "flex-start",
    bottom: "flex-end",
    spaced: "space-between",
    even: "space-evenely",
    around: "space-around",
    stretch: "stretch"
  };

  if (justify) {
    return alignments[justify] || alignments["spaced"];
  } else {
    return null;
  }
}
/**
 * Example:
 *
 * responsive("margin-right", lateralPadding, true, " - 1px")
 *
 * This takes the "lateralPadding" responsive values, reverses them (the "true") and subtracts 1 px (" - 1px").
 */


function responsive(property, value, options) {
  var _ref = options || {},
      negative = _ref.negative,
      operation = _ref.operation,
      providedBreakPoint = _ref.breakPoint;

  var negSign = negative ? "-" : "";
  var breakPoint = providedBreakPoint || responsiveBreakpoint;

  if (typeof value === "string" || typeof value === "number") {
    if (operation) {
      return "\n        " + property + ": calc( " + negSign + value + " " + operation + ");\n      ";
    } else {
      return "\n        " + property + ": " + negSign + value + ";\n      ";
    }
  } else {
    if (operation) {
      return "\n        " + property + ": calc( " + negSign + value[0] + " " + operation + ");\n        @media only screen and (max-width: " + breakPoint + ") {\n          " + property + ": calc( " + negSign + value[1] + " " + operation + ");\n        }\n      ";
    } else {
      return "\n        " + property + ": " + negSign + value[0] + ";\n        @media only screen and (max-width: " + breakPoint + ") {\n          " + property + ": " + negSign + value[1] + ";\n        }\n      ";
    }
  }
}

function getFontSize(elem, config) {
  var id = elem.toString();
  return responsive("font-size", config.fonts.sizes[id] || config.fonts.sizes.normal || "");
}

function getFontWeight(elem, config) {
  var id = elem.toString();
  return responsive("font-weight", config.fonts.weights[id] || config.fonts.weights.normal || "");
}

function showHideCss(props) {
  return css(_templateObject, props.hideBelow ? css(_templateObject2, props.hideBelow) : "", props.hideAbove ? css(_templateObject3, props.hideAbove) : "", props.showBelow ? css(_templateObject3, props.showBelow) : "", props.showAbove ? css(_templateObject2, props.showAbove) : "");
}

function unitMultiply(size, value) {
  return "" + parseFloat(size) * value + size.slice(size.length - 2, size.length);
}

function getSidebarValue(_ref2) {
  var openCloseValues = _ref2.openCloseValues,
      sidebarState = _ref2.sidebarState,
      sidebarOpen = _ref2.sidebarOpen;
  /**
   * @example
   *
   * {
   *   openCloseValues: [
   *     [openValue, closeValue, "default"],
   *     [openValue, closeValue, "floating"],
   *     [openValue, closeValue, "fullscreen"]
   *   ],
   *   sidebarState: sidebarState,
   *   sidebarOpen: open
   * }
   */

  var st = sidebarState;
  var vs = openCloseValues;

  if (sidebarOpen) {
    if (vs.find(function (value) {
      return value[2] === st;
    })) {
      return vs.find(function (value) {
        return value[2] === st;
      })[0];
    } else {
      return vs.find(function (value) {
        return value[2] === "default";
      })[0];
    }
  } else {
    if (vs.find(function (value) {
      return value[2] === st;
    })) {
      return vs.find(function (value) {
        return value[2] === st;
      })[1];
    } else {
      return vs.find(function (value) {
        return value[2] === "default";
      })[1];
    }
  }
}

var _templateObject$1 = taggedTemplateLiteral(["\n    ", "\n    flex: 0 0 auto;\n  "], ["\n    ", "\n    flex: 0 0 auto;\n  "]);

var Icon = function Icon(props) {
  var config = useConfig();
  var _config$icon = config.icon,
      configSize = _config$icon.size,
      configColor = _config$icon.color,
      configStrokeWidth = _config$icon.strokeWidth,
      end = _config$icon.end,
      join = _config$icon.join;
  var name = props.name,
      _props$size = props.size,
      size = _props$size === undefined ? configSize : _props$size,
      offset = props.offset,
      _props$strokeWidth = props.strokeWidth,
      strokeWidth = _props$strokeWidth === undefined ? configStrokeWidth : _props$strokeWidth,
      _props$color = props.color,
      color = _props$color === undefined ? configColor : _props$color,
      onClick = props.onClick;
  var style = props.style;
  var IconComponent = getIconComponent(name);
  style = _extends({
    position: "relative",
    bottom: offset
  }, style);
  var iconCSS = css(_templateObject$1, showHideCss(props));

  if (onClick) {
    style = _extends({
      cursor: "pointer"
    }, style);
  }

  if (IconComponent) {
    return jsx(IconComponent, {
      width: size,
      height: size,
      stroke: color,
      fillColor: color,
      strokeWidth: strokeWidth,
      strokeLinecap: end,
      strokeLinejoin: join,
      style: style,
      css: iconCSS,
      onClick: onClick
    });
  } else {
    return null;
  }
};

function getIconComponent(name) {
  if (icons[name]) {
    return icons[name];
  } else {
    console.error("No icon named \"" + name + "\"");
    return null;
  }
}

function getAllIconNames() {
  return Object.keys(icons).sort();
}

function sanitizeProps(p) {
  var props = _extends({}, p);

  delete props.fillColor;
  return props;
} // prettier-ignore


var icons = {
  pipe: function pipe(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M12 20L12 4"
    }));
  },
  slash: function slash(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M9 20L15 4"
    }));
  },
  arrowUp: function arrowUp(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M12 19V6M5 12l7-7 7 7"
    }));
  },
  arrowDown: function arrowDown(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M12 5v13M5 12l7 7 7-7"
    }));
  },
  arrowLeft: function arrowLeft(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M19 12H6M12 5l-7 7 7 7"
    }));
  },
  arrowRight: function arrowRight(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M5 12h13M12 5l7 7-7 7"
    }));
  },
  arrowUpBold: function arrowUpBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M12,24A12,12,0,1,0,0,12,12.013,12.013,0,0,0,12,24ZM6.793,10.291l4.5-4.5a1,1,0,0,1,1.414,0l4.5,4.5a1,1,0,1,1-1.414,1.414L13.427,9.338A.25.25,0,0,0,13,9.515V18a1,1,0,0,1-2,0V9.515a.25.25,0,0,0-.427-.177L8.207,11.705a1,1,0,1,1-1.414-1.414Z"
    }));
  },
  arrowDownBold: function arrowDownBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm5.207,13.707-4.5,4.5a1,1,0,0,1-1.414,0l-4.5-4.5a1,1,0,0,1,1.414-1.414l2.366,2.366A.25.25,0,0,0,11,14.48V6a1,1,0,0,1,2,0V14.48a.25.25,0,0,0,.427.177l2.366-2.366a1,1,0,0,1,1.414,1.414Z"
    }));
  },
  arrowLeftBold: function arrowLeftBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M24,12A12,12,0,1,0,12,24,12.013,12.013,0,0,0,24,12ZM10.293,17.2l-4.5-4.5a1,1,0,0,1,0-1.414l4.5-4.5a1,1,0,1,1,1.414,1.414L9.341,10.571A.25.25,0,0,0,9.518,11H18a1,1,0,0,1,0,2H9.518a.25.25,0,0,0-.177.426l2.366,2.367A1,1,0,0,1,10.293,17.2Z"
    }));
  },
  arrowRightBold: function arrowRightBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M0,12A12,12,0,1,0,12,0,12.014,12.014,0,0,0,0,12ZM13.707,6.791l4.5,4.5a1,1,0,0,1,0,1.414l-4.5,4.5a1,1,0,0,1-1.414-1.414l2.366-2.367A.25.25,0,0,0,14.482,13H6a1,1,0,1,1,0-2h8.482a.25.25,0,0,0,.177-.427L12.293,8.205a1,1,0,0,1,1.414-1.414Z"
    }));
  },
  currency: function currency(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm1.464,18.587a.251.251,0,0,0-.214.248V19.6a1.25,1.25,0,0,1-2.5,0v-.705a.249.249,0,0,0-.25-.25H9.353a1.25,1.25,0,0,1,0-2.5h3.588a1.118,1.118,0,0,0,.415-2.156l-3.64-1.457a3.605,3.605,0,0,1,.82-6.92.25.25,0,0,0,.214-.247V4.6a1.25,1.25,0,0,1,2.5,0v.706a.25.25,0,0,0,.25.25h1.147a1.25,1.25,0,0,1,0,2.5H11.059a1.117,1.117,0,0,0-.415,2.155l3.64,1.457a3.605,3.605,0,0,1-.82,6.92Z"
    }));
  },
  currencyExchange: function currencyExchange(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M21.4,16.526a.489.489,0,0,0-.692,0l-1.954,1.965a.49.49,0,0,0,.347.835h.551a.243.243,0,0,1,.205.109.246.246,0,0,1,.021.231,3.956,3.956,0,0,1-3.708,2.12.98.98,0,0,0,0,1.96h0a5.693,5.693,0,0,0,5.78-4.23.245.245,0,0,1,.24-.2l.827,0a.49.49,0,0,0,.344-.837Z"
    }), jsx("path", {
      d: "M2.11,7.461a.489.489,0,0,0,.692,0L4.756,5.494a.489.489,0,0,0-.347-.835h0l-.549,0a.244.244,0,0,1-.226-.34A3.955,3.955,0,0,1,7.34,2.2a.98.98,0,0,0,0-1.959h0A5.7,5.7,0,0,0,1.555,4.47a.245.245,0,0,1-.24.2l-.827,0a.489.489,0,0,0-.343.837Z"
    }), jsx("path", {
      d: "M8,9.267a.246.246,0,0,0-.243-.2,7.345,7.345,0,1,0,7.416,7.415.245.245,0,0,0-.2-.242A8.829,8.829,0,0,1,8,9.267Zm-.17,7.389a.735.735,0,0,1,0,1.47H6.04a.244.244,0,0,0-.228.333A1.908,1.908,0,0,0,7.834,19.6a.735.735,0,0,1,0,1.47,3.3,3.3,0,0,1-3.583-2.74.244.244,0,0,0-.241-.2H3.915a.735.735,0,0,1,0-1.47H4.01a.245.245,0,0,0,.241-.2,3.3,3.3,0,0,1,3.583-2.74.735.735,0,0,1,0,1.47,1.908,1.908,0,0,0-2.022,1.136.244.244,0,0,0,.228.333Z"
    }), jsx("path", {
      d: "M24,7.594a7.348,7.348,0,1,0-7.348,7.348A7.357,7.357,0,0,0,24,7.594ZM17.387,3.185a.245.245,0,0,0,.245.245h.734a.735.735,0,1,1,0,1.469H16.042a.8.8,0,0,0-.3,1.541l2.357.943a2.262,2.262,0,0,1-.508,4.341.243.243,0,0,0-.208.242v.485a.735.735,0,0,1-1.47,0V12a.245.245,0,0,0-.245-.245h-.735a.735.735,0,0,1,0-1.469h2.324a.8.8,0,0,0,.3-1.541L15.2,7.8a2.262,2.262,0,0,1,.508-4.34.245.245,0,0,0,.209-.243V2.736a.735.735,0,1,1,1.47,0Z"
    }));
  },
  bitcoin: function bitcoin(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M10.593,7.846a.25.25,0,0,0-.25.25v2.169a.25.25,0,0,0,.25.25h1.73a1.335,1.335,0,0,0,0-2.669Z"
    }), jsx("path", {
      d: "M12.323,13.015h-1.73a.25.25,0,0,0-.25.25v2.17a.25.25,0,0,0,.25.25h1.73a1.335,1.335,0,0,0,0-2.67Z"
    }), jsx("path", {
      d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm3.275,11.606a.249.249,0,0,0,0,.318,3.806,3.806,0,0,1-2.757,6.237.25.25,0,0,0-.238.249V19a1.25,1.25,0,0,1-2.5,0v-.565a.249.249,0,0,0-.25-.25H9.093a1.25,1.25,0,0,1-1.25-1.25V6.6a1.249,1.249,0,0,1,1.25-1.25h.438a.25.25,0,0,0,.25-.25V5a1.25,1.25,0,1,1,2.5,0v.151a.218.218,0,0,0,.209.218,3.8,3.8,0,0,1,2.785,6.237Z"
    }));
  },
  money: function money(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M23,11.25a1,1,0,0,0,0-2H17.75A.25.25,0,0,1,17.5,9V8a.25.25,0,0,1,.25-.25H23a1,1,0,0,0,0-2H17.75a.25.25,0,0,1-.25-.25V5.25a1,1,0,0,0-1-1h-9a1,1,0,0,0-1,1V5.5a.25.25,0,0,1-.25.25H1a1,1,0,0,0,0,2H6.25A.25.25,0,0,1,6.5,8V9a.25.25,0,0,1-.25.25H1a1,1,0,0,0,0,2H6.25a.25.25,0,0,1,.25.25v1a.25.25,0,0,1-.25.25H1a1,1,0,0,0,0,2H6.25A.25.25,0,0,1,6.5,15v1a.25.25,0,0,1-.25.25H1a1,1,0,0,0,0,2H6.25a.25.25,0,0,1,.25.25v.25a1,1,0,0,0,1,1h9a1,1,0,0,0,1-1V18.5a.25.25,0,0,1,.25-.25H23a1,1,0,0,0,0-2H17.75A.25.25,0,0,1,17.5,16V15a.25.25,0,0,1,.25-.25H23a1,1,0,0,0,0-2H17.75a.25.25,0,0,1-.25-.25v-1a.25.25,0,0,1,.25-.25Zm-9.689.217a2.084,2.084,0,0,1-.361,3.98.249.249,0,0,0-.2.245V16a.75.75,0,0,1-1.5,0v-.25A.25.25,0,0,0,11,15.5h-.5a.75.75,0,0,1,0-1.5h2.033a.592.592,0,0,0,.221-1.141l-2.065-.826a2.084,2.084,0,0,1,.361-3.98.249.249,0,0,0,.2-.245V7.5a.75.75,0,0,1,1.5,0v.25A.25.25,0,0,0,13,8h.5a.75.75,0,0,1,0,1.5H11.467a.592.592,0,0,0-.221,1.141Z"
    }));
  },
  moneyAlt: function moneyAlt(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M9,8h6a1,1,0,0,0,0-2H9A1,1,0,0,0,9,8Z"
    }), jsx("path", {
      d: "M9.471,4.5a.5.5,0,0,0,.5.438h4.064a.5.5,0,0,0,.5-.438,9.165,9.165,0,0,1,1.206-3.049.5.5,0,0,0-.638-.7l-1.862.8a.25.25,0,0,1-.33-.137l-.441-1.1a.5.5,0,0,0-.928,0l-.441,1.1a.25.25,0,0,1-.33.137L8.9.755a.5.5,0,0,0-.638.7A9.165,9.165,0,0,1,9.471,4.5Z"
    }), jsx("path", {
      d: "M15.438,9.121A.591.591,0,0,0,15.081,9H8.919a.585.585,0,0,0-.357.121c-2.551,1.95-5.4,5.4-5.4,8.4C3.16,21.75,5.518,24,12,24s8.84-2.25,8.84-6.482C20.84,14.523,17.99,11.071,15.438,9.121ZM12.955,20.13a.25.25,0,0,0-.205.246v.374a.75.75,0,0,1-1.5,0v-.323a.25.25,0,0,0-.25-.25h-.588a.75.75,0,1,1,0-1.5h2.152a.671.671,0,0,0,.25-1.294l-2.185-.873a2.164,2.164,0,0,1,.416-4.14.25.25,0,0,0,.205-.246V11.75a.75.75,0,0,1,1.5,0v.323a.25.25,0,0,0,.25.25h.588a.75.75,0,1,1,0,1.5H11.436a.671.671,0,0,0-.25,1.294l2.185.873a2.164,2.164,0,0,1-.416,4.14Z"
    }));
  },
  select: function select(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("g", null, jsx("path", {
      d: "m8 8 4-4 4 4"
    }), jsx("path", {
      d: "m8 16 4 4 4-4"
    })));
  },
  performance: function performance(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm7.327,18.8a15.838,15.838,0,0,0-14.655,0,10,10,0,1,1,14.655,0Z"
    }), jsx("path", {
      d: "M5.5,11.25H4a.75.75,0,0,0,0,1.5H5.5a.75.75,0,0,0,0-1.5Z"
    }), jsx("path", {
      d: "M6.97,5.91A.75.75,0,1,0,5.91,6.97L6.97,8.03A.75.75,0,1,0,8.03,6.97Z"
    }), jsx("path", {
      d: "M12,6.25a.75.75,0,0,0,.75-.75V4a.75.75,0,0,0-1.5,0V5.5A.75.75,0,0,0,12,6.25Z"
    }), jsx("path", {
      d: "M20,11.25H18.5a.75.75,0,0,0,0,1.5H20a.75.75,0,0,0,0-1.5Z"
    }), jsx("path", {
      d: "M18.354,6.646a.5.5,0,0,0-.611-.075c-.689.414-6.753,4.066-7.511,4.824a2.389,2.389,0,0,0,0,3.373,2.423,2.423,0,0,0,3.373,0c.758-.758,4.41-6.822,4.824-7.51A.5.5,0,0,0,18.354,6.646Z"
    }));
  },
  performanceAlt: function performanceAlt(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M12,3.348a12.013,12.013,0,0,0-12,12v2.391a2.916,2.916,0,0,0,2.913,2.913H21.087A2.916,2.916,0,0,0,24,17.739V15.348A12.013,12.013,0,0,0,12,3.348Zm9.087,15.3H2.913A.914.914,0,0,1,2,17.739V16.4H4.5a.75.75,0,0,0,0-1.5H2.01a9.922,9.922,0,0,1,.841-3.589L4.88,12.485a.75.75,0,0,0,.75-1.3l-2.07-1.2A10.052,10.052,0,0,1,6.037,7.325l1.13,1.957a.762.762,0,0,0,1.025.275.75.75,0,0,0,.274-1.025L7.305,6.521A9.911,9.911,0,0,1,11.25,5.376V7.652a.75.75,0,1,0,1.5,0V5.376a10.006,10.006,0,0,1,7.69,4.615l-2.07,1.2a.75.75,0,1,0,.75,1.3l2.029-1.172A9.922,9.922,0,0,1,21.99,14.9H19.5a.75.75,0,1,0,0,1.5H22v1.337A.914.914,0,0,1,21.087,18.652Z"
    }), jsx("path", {
      d: "M16.565,8.125a.749.749,0,0,0-1.037.221l-3,4.619a2.254,2.254,0,1,0,1.257.818l3-4.62A.751.751,0,0,0,16.565,8.125Z"
    }));
  },
  performanceBold: function performanceBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M12,16.25a16.79,16.79,0,0,1,9.152,2.737.5.5,0,0,0,.683-.12A11.93,11.93,0,0,0,24,11.877,12.111,12.111,0,0,0,12.494.01,11.994,11.994,0,0,0,2.165,18.867a.5.5,0,0,0,.683.12A16.792,16.792,0,0,1,12,16.25ZM11.25,3.5a.75.75,0,0,1,1.5,0V5a.75.75,0,0,1-1.5,0ZM5,12.75H3.5a.75.75,0,0,1,0-1.5H5a.75.75,0,0,1,0,1.5ZM7.58,7.58a.748.748,0,0,1-1.06,0L5.459,6.52A.75.75,0,0,1,6.52,5.46L7.58,6.519A.75.75,0,0,1,7.58,7.58Zm4.339,6.866a2.366,2.366,0,0,1-1.687-4.052c.756-.755,7.042-4.63,7.756-5.07a.5.5,0,0,1,.688.688c-.44.714-4.315,7-5.071,7.755A2.376,2.376,0,0,1,11.919,14.446ZM19,12.75a.75.75,0,0,1,0-1.5h1.5a.75.75,0,0,1,0,1.5Z"
    }), jsx("path", {
      d: "M12,17.75a15.051,15.051,0,0,0-8.031,2.3.508.508,0,0,0-.076.794,11.975,11.975,0,0,0,16.214,0,.507.507,0,0,0-.076-.793A15.046,15.046,0,0,0,12,17.75Z"
    }));
  },
  eye: function eye(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M23.432,10.524C20.787,7.614,16.4,4.538,12,4.6,7.6,4.537,3.213,7.615.568,10.524a2.211,2.211,0,0,0,0,2.948C3.182,16.351,7.507,19.4,11.839,19.4h.308c4.347,0,8.671-3.049,11.288-5.929A2.21,2.21,0,0,0,23.432,10.524ZM7.4,12A4.6,4.6,0,1,1,12,16.6,4.6,4.6,0,0,1,7.4,12Z"
    }), jsx("circle", {
      cx: "12",
      cy: "12",
      r: "2"
    }));
  },
  eyeOff: function eyeOff(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M23.2,10.549a20.954,20.954,0,0,0-4.3-3.6l4-3.995a1,1,0,1,0-1.414-1.414l-.018.018a.737.737,0,0,1-.173.291l-19.5,19.5c-.008.007-.018.009-.026.017a1,1,0,0,0,1.631,1.088l4.146-4.146a11.26,11.26,0,0,0,4.31.939h.3c4.256,0,8.489-2.984,11.051-5.8A2.171,2.171,0,0,0,23.2,10.549ZM16.313,13.27a4.581,4.581,0,0,1-3,3.028,4.3,4.3,0,0,1-3.1-.19.253.253,0,0,1-.068-.407l5.56-5.559a.252.252,0,0,1,.407.067A4.3,4.3,0,0,1,16.313,13.27Z"
    }), jsx("path", {
      d: "M7.615,13.4a.244.244,0,0,0,.061-.24A4.315,4.315,0,0,1,7.5,12,4.5,4.5,0,0,1,12,7.5a4.276,4.276,0,0,1,1.16.173.244.244,0,0,0,.24-.062l1.941-1.942a.254.254,0,0,0-.1-.421A10.413,10.413,0,0,0,12,4.75C7.7,4.692,3.4,7.7.813,10.549a2.15,2.15,0,0,0-.007,2.9,21.209,21.209,0,0,0,3.438,3.03.256.256,0,0,0,.326-.029Z"
    }));
  },
  chevronRight: function chevronRight(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M9 18l6-6-6-6"
    }));
  },
  chevronLeft: function chevronLeft(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M15 18l-6-6 6-6"
    }));
  },
  chevronDown: function chevronDown(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M6 9L12 15L18 9"
    }));
  },
  chevronUp: function chevronUp(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M18 15L12 9L6 15"
    }));
  },
  circleArrowUp: function circleArrowUp(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }), jsx("path", {
      d: "M16 12l-4-4-4 4M12 16V9"
    }));
  },
  circleArrowDown: function circleArrowDown(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), " ", jsx("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }), jsx("path", {
      d: "M16 12l-4 4-4-4M12 8v7"
    }));
  },
  circleArrowLeft: function circleArrowLeft(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }), jsx("path", {
      d: "M12 8l-4 4 4 4M16 12H9"
    }));
  },
  circleArrowRight: function circleArrowRight(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }), jsx("path", {
      d: "M12 8l4 4-4 4M8 12h7"
    }));
  },
  refresh: function refresh(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2"
    }));
  },
  bulb: function bulb(p) {
    return jsx("svg", _extends({
      version: "1.1",
      viewBox: "0 0 24 24"
    }, sanitizeProps(p)), jsx("g", {
      fill: "none"
    }, jsx("path", {
      d: "M12,2.25v-1.5"
    }), jsx("path", {
      d: "M18.36,4.89l1.06,-1.06"
    }), jsx("path", {
      d: "M21,11.25h1.5"
    }), jsx("path", {
      d: "M18.36,17.61l1.06,1.07"
    }), jsx("path", {
      d: "M5.64,4.89l-1.07,-1.06"
    }), jsx("path", {
      d: "M3,11.25h-1.5"
    }), jsx("path", {
      d: "M5.64,17.61l-1.07,1.07"
    }), jsx("path", {
      d: "M9,16.449v2.3l3.37508e-14,4.52987e-07c2.50178e-07,1.65685 1.34315,3 3,3c1.65685,-2.50178e-07 3,-1.34315 3,-3v-2.3"
    }), jsx("path", {
      d: "M16.2426,7.00836c2.34315,2.34315 2.34315,6.14214 0,8.48528c-2.34315,2.34315 -6.14214,2.34315 -8.48528,1.77636e-15c-2.34315,-2.34315 -2.34315,-6.14214 -1.77636e-15,-8.48528c2.34315,-2.34315 6.14214,-2.34315 8.48528,0"
    }), jsx("path", {
      d: "M12,21.75v1.5"
    })));
  },
  bulbBold: function bulbBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M13.875,21.5h-3.75a.5.5,0,0,0-.447.724l.336.671A1.989,1.989,0,0,0,11.8,24H12.2A1.99,1.99,0,0,0,13.987,22.9l.336-.671a.5.5,0,0,0-.448-.724Z"
    }), jsx("path", {
      d: "M12,4.5a1,1,0,0,0,1-1V1a1,1,0,0,0-2,0V3.5A1,1,0,0,0,12,4.5Z"
    }), jsx("path", {
      d: "M21.192,3.808a1,1,0,0,0-1.414,0L18.011,5.576A1,1,0,1,0,19.425,6.99l1.767-1.768A1,1,0,0,0,21.192,3.808Z"
    }), jsx("path", {
      d: "M23,12H21a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"
    }), jsx("path", {
      d: "M5.99,5.576,4.222,3.808A1,1,0,0,0,2.808,5.222L4.576,6.99A1,1,0,0,0,5.99,5.576Z"
    }), jsx("path", {
      d: "M3,12H1a1,1,0,0,0,0,2H3a1,1,0,0,0,0-2Z"
    }), jsx("path", {
      d: "M12,6A6.5,6.5,0,0,0,8.285,17.827a.5.5,0,0,1,.215.411V19a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1v-.763a.5.5,0,0,1,.215-.411A6.495,6.495,0,0,0,12,6Z"
    }));
  },
  rocket: function rocket(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p)), jsx("path", {
      fill: "none",
      d: "M22.5,1.567l-2.158.24a7.5,7.5,0,0,0-4.475,2.151L6.06,13.765,10.3,18.007,20.109,8.2A7.494,7.494,0,0,0,22.26,3.725Z"
    }), jsx("path", {
      fill: "none",
      d: "M6.06,13.765,2.438,12.557a.749.749,0,0,1-.293-1.241l.232-.232a6,6,0,0,1,6.14-1.45l1.255.418Z"
    }), jsx("path", {
      fill: "none",
      d: "M6.06,13.765,2.438,12.557a.749.749,0,0,1-.293-1.241l.232-.232a6,6,0,0,1,6.14-1.45l1.255.418Z"
    }), jsx("path", {
      fill: "none",
      d: "M10.3,18.007l1.208,3.622a.749.749,0,0,0,1.241.293l.233-.232a6,6,0,0,0,1.449-6.14L14.015,14.3Z"
    }), jsx("path", {
      fill: "none",
      d: "M10.3,18.007l1.208,3.622a.749.749,0,0,0,1.241.293l.233-.232a6,6,0,0,0,1.449-6.14L14.015,14.3Z"
    }), jsx("path", {
      fill: "none",
      d: "M7.779,18.538a2.243,2.243,0,0,1-.659,1.591c-.878.878-5.3,2.121-5.3,2.121s1.243-4.425,2.121-5.3a2.246,2.246,0,0,1,1.444-.655"
    }));
  },
  rotateLeft: function rotateLeft(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M2.5 2v6h6M2.66 15.57a10 10 0 1 0 .57-8.38"
    }));
  },
  rotateRight: function rotateRight(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38"
    }));
  },
  sync: function sync(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M17 2.1l4 4-4 4"
    }), jsx("path", {
      d: "M3 12.2v-2a4 4 0 0 1 4-4h12.8M7 21.9l-4-4 4-4"
    }), jsx("path", {
      d: "M21 11.8v2a4 4 0 0 1-4 4H4.2"
    }));
  },
  login: function login(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M10 17l5-5-5-5M13.8 12H3"
    }));
  },
  logout: function logout(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M10 3H6a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h4M16 17l5-5-5-5M19.8 12H9"
    }));
  },
  upload: function upload(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M3 15v4c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2v-4M17 8l-5-5-5 5M12 4.2v10.3"
    }));
  },
  download: function download(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M3 15v4c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2v-4M17 9l-5 5-5-5M12 12.8V2.5"
    }));
  },
  uploadCloud: function uploadCloud(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M21.2 15c.7-1.2 1-2.5.7-3.9-.6-2-2.4-3.5-4.4-3.5h-1.2c-.7-3-3.2-5.2-6.2-5.6-3-.3-5.9 1.3-7.3 4-1.2 2.5-1 6.5.5 8.8m8.7-1.6V21"
    }), jsx("path", {
      d: "M16 16l-4-4-4 4"
    }));
  },
  downloadCloud: function downloadCloud(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M21.2 15c.7-1.2 1-2.5.7-3.9-.6-2-2.4-3.5-4.4-3.5h-1.2c-.7-3-3.2-5.2-6.2-5.6-3-.3-5.9 1.3-7.3 4-1.2 2.5-1 6.5.5 8.8M12 19.8V12M16 17l-4 4-4-4"
    }));
  },
  compress: function compress(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M4 14h6v6M3 21l6.1-6.1M20 10h-6V4M21 3l-6.1 6.1"
    }));
  },
  expand: function expand(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M15 3h6v6M14 10l6.1-6.1M9 21H3v-6M10 14l-6.1 6.1"
    }));
  },
  move: function move(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M5.2 9l-3 3 3 3M9 5.2l3-3 3 3M15 18.9l-3 3-3-3M18.9 9l3 3-3 3M3.3 12h17.4M12 3.2v17.6"
    }));
  },
  open: function open(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("g", {
      fill: "none",
      fillRule: "evenodd"
    }, jsx("path", {
      d: "M18 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8c0-1.1.9-2 2-2h5M15 3h6v6M10 14L20.2 3.8"
    })));
  },
  hamburger: function hamburger(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("line", {
      x1: "3",
      y1: "12",
      x2: "21",
      y2: "12"
    }), jsx("line", {
      x1: "3",
      y1: "6",
      x2: "21",
      y2: "6"
    }), jsx("line", {
      x1: "3",
      y1: "18",
      x2: "21",
      y2: "18"
    }));
  },
  cursor: function cursor(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p)), jsx("path", {
      fill: "none",
      d: "M3.465,4.285,9.776,19.612A.75.75,0,0,0,11,19.856l3.447-3.447,3.712,3.713a.752.752,0,0,0,1.061,0l1.06-1.061a.75.75,0,0,0,0-1.061l-3.712-3.712,3.447-3.447a.75.75,0,0,0-.245-1.224L4.444,3.306A.75.75,0,0,0,3.465,4.285Z"
    }));
  },
  cursorAlt: function cursorAlt(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p)), jsx("path", {
      fill: "none",
      d: "M1.816,2.8l8.428,19.072a.75.75,0,0,0,1.411-.112l1.884-7.158a1.5,1.5,0,0,1,1.068-1.069l7.158-1.884a.75.75,0,0,0,.113-1.411L2.806,1.814A.75.75,0,0,0,1.816,2.8Z"
    }));
  },
  hand: function hand(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p)), jsx("path", {
      fill: "none",
      d: "M11.5,3A1.5,1.5,0,0,0,10,1.5h0A1.5,1.5,0,0,0,8.5,3v11.25L6.061,12.3a1.539,1.539,0,0,0-2.242.348h0a1.537,1.537,0,0,0,0,1.707l3.65,5.475A6,6,0,0,0,12.461,22.5h2.918A5.118,5.118,0,0,0,19,21h0a5.122,5.122,0,0,0,1.5-3.621V10.5A1.5,1.5,0,0,0,19,9h0a1.5,1.5,0,0,0-1.5,1.5v-.75a1.5,1.5,0,0,0-1.5-1.5h0a1.5,1.5,0,0,0-1.5,1.5,1.5,1.5,0,0,0-1.5-1.5h0a1.5,1.5,0,0,0-1.5,1.5Z"
    }), jsx("line", {
      x1: "11.5",
      y1: "9.747",
      x2: "11.5",
      y2: "11.997"
    }), jsx("line", {
      x1: "14.5",
      y1: "9.747",
      x2: "14.5",
      y2: "11.997"
    }), jsx("line", {
      x1: "17.5",
      y1: "10.497",
      x2: "17.5",
      y2: "11.997"
    }));
  },
  handBold: function handBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M19.7,9.141a.251.251,0,0,0-.334.236V11.5a.5.5,0,1,1-1,0V9a1.617,1.617,0,0,0-1.5-1h-.25a.25.25,0,0,0-.25.25V10.5a.5.5,0,1,1-1,0V8a1.617,1.617,0,0,0-1.5-1h-.25a.25.25,0,0,0-.25.25V10.5a.5.5,0,1,1-1,0V3a2,2,0,0,0-4,0l0,11.078a.25.25,0,0,1-.454.145L6.239,11.875a1.984,1.984,0,0,0-3.233,2.3l5.951,8.4A1,1,0,0,0,9.773,23h8.714a1,1,0,0,0,.962-.725l1.517-5.292a10.738,10.738,0,0,0,.4-2.883V11.5A2.5,2.5,0,0,0,19.7,9.141Z"
    }));
  },
  grid: function grid(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("rect", {
      x: "3",
      y: "3",
      width: "18",
      height: "18",
      rx: "2"
    }), jsx("path", {
      d: "M21 12H3M12 3v18"
    }));
  },
  gridAlt: function gridAlt(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("rect", {
      x: "3",
      y: "3",
      width: "7",
      height: "7"
    }), jsx("rect", {
      x: "14",
      y: "3",
      width: "7",
      height: "7"
    }), jsx("rect", {
      x: "14",
      y: "14",
      width: "7",
      height: "7"
    }), jsx("rect", {
      x: "3",
      y: "14",
      width: "7",
      height: "7"
    }));
  },
  warning: function warning(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
    }), jsx("line", {
      x1: "12",
      y1: "9",
      x2: "12",
      y2: "13"
    }), jsx("line", {
      x1: "12",
      y1: "17",
      x2: "12",
      y2: "17"
    }));
  },
  warningBold: function warningBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M23.119,20,13.772,2.15h0a2,2,0,0,0-3.543,0L.881,20a2,2,0,0,0,1.772,2.928H21.347A2,2,0,0,0,23.119,20ZM11,8.423a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Zm1.05,11.51h-.028a1.528,1.528,0,0,1-1.522-1.47,1.476,1.476,0,0,1,1.448-1.53h.028A1.527,1.527,0,0,1,13.5,18.4,1.475,1.475,0,0,1,12.05,19.933Z"
    }));
  },
  question: function question(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }), jsx("path", {
      d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
    }), jsx("line", {
      x1: "12",
      y1: "17",
      x2: "12",
      y2: "17"
    }));
  },
  questionBold: function questionBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,19a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,12,19Zm1.6-6.08a1,1,0,0,0-.6.917,1,1,0,1,1-2,0,3,3,0,0,1,1.8-2.75A2,2,0,1,0,10,9.255a1,1,0,1,1-2,0,4,4,0,1,1,5.6,3.666Z"
    }));
  },
  info: function info(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }), jsx("line", {
      x1: "12",
      y1: "16",
      x2: "12",
      y2: "12"
    }), jsx("line", {
      x1: "12",
      y1: "8",
      x2: "12",
      y2: "8"
    }));
  },
  infoBold: function infoBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
    }));
  },
  infoTiny: function infoTiny(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 12C0 5.37258 5.37259 0 12 0C18.624 0.00834462 23.9921 5.37596 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM13.2769 6C13.2769 4.9804 12.4504 4.15385 11.4308 4.15385C10.4112 4.15385 9.58461 4.9804 9.58462 6C9.58462 7.0196 10.4112 7.84615 11.4308 7.84615C12.4504 7.84615 13.2769 7.0196 13.2769 6ZM9.58462 19.8462H15.1231C15.8878 19.8462 16.5077 19.2262 16.5077 18.4615C16.5077 17.6968 15.8878 17.0769 15.1231 17.0769H13.9711C13.8423 17.0759 13.7385 16.9712 13.7385 16.8425V12C13.7364 10.7266 12.7041 9.69517 11.4308 9.69415H9.58462C8.81991 9.69415 8.2 10.3141 8.2 11.0788C8.2 11.8435 8.81991 12.4634 9.58462 12.4634H10.7385C10.8659 12.4634 10.9692 12.5667 10.9692 12.6942V16.8498C10.9692 16.9753 10.8676 17.0769 10.7422 17.0769H9.58462C8.81991 17.0769 8.2 17.6968 8.2 18.4615C8.2 19.2262 8.81991 19.8462 9.58462 19.8462Z"
    }));
  },
  square: function square(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("rect", {
      x: "3",
      y: "3",
      width: "18",
      height: "18",
      rx: "2",
      ry: "2"
    }));
  },
  copy: function copy(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("rect", {
      x: "9",
      y: "9",
      width: "13",
      height: "13",
      rx: "2",
      ry: "2"
    }), jsx("path", {
      d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
    }));
  },
  paste: function paste(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
    }), jsx("rect", {
      x: "8",
      y: "2",
      width: "8",
      height: "4",
      rx: "1",
      ry: "1"
    }));
  },
  plus: function plus(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("line", {
      x1: "12",
      y1: "5",
      x2: "12",
      y2: "19"
    }), jsx("line", {
      x1: "5",
      y1: "12",
      x2: "19",
      y2: "12"
    }));
  },
  plusCircle: function plusCircle(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }), jsx("line", {
      x1: "12",
      y1: "8",
      x2: "12",
      y2: "16"
    }), jsx("line", {
      x1: "8",
      y1: "12",
      x2: "16",
      y2: "12"
    }));
  },
  plusBold: function plusBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M12,23.5A11.5,11.5,0,1,0,.5,12,11.513,11.513,0,0,0,12,23.5ZM6,11h4.75a.25.25,0,0,0,.25-.25V6a1,1,0,0,1,2,0v4.75a.25.25,0,0,0,.25.25H18a1,1,0,0,1,0,2H13.25a.25.25,0,0,0-.25.25V18a1,1,0,0,1-2,0V13.25a.25.25,0,0,0-.25-.25H6a1,1,0,0,1,0-2Z"
    }));
  },
  minus: function minus(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("line", {
      x1: "5",
      y1: "12",
      x2: "19",
      y2: "12"
    }));
  },
  minusCircle: function minusCircle(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }), jsx("line", {
      x1: "8",
      y1: "12",
      x2: "16",
      y2: "12"
    }));
  },
  minusBold: function minusBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M12,23.5A11.5,11.5,0,1,0,.5,12,11.513,11.513,0,0,0,12,23.5ZM6,11H18a1,1,0,0,1,0,2H6a1,1,0,0,1,0-2Z"
    }));
  },
  close: function close(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("line", {
      x1: "18",
      y1: "6",
      x2: "6",
      y2: "18"
    }), jsx("line", {
      x1: "6",
      y1: "6",
      x2: "18",
      y2: "18"
    }));
  },
  closeCircle: function closeCircle(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }), jsx("line", {
      x1: "15",
      y1: "9",
      x2: "9",
      y2: "15"
    }), jsx("line", {
      x1: "9",
      y1: "9",
      x2: "15",
      y2: "15"
    }));
  },
  closeBold: function closeBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M20.488,3.515a11.994,11.994,0,1,0,0,16.97A12.014,12.014,0,0,0,20.488,3.515ZM16.709,15.279A1,1,0,0,1,15.3,16.694l-3.11-3.11a.252.252,0,0,0-.354,0l-3.109,3.11a1.019,1.019,0,0,1-1.415,0,1,1,0,0,1,0-1.415l3.11-3.109a.249.249,0,0,0,0-.353l-3.11-3.11A1,1,0,0,1,8.722,7.292l3.109,3.11a.25.25,0,0,0,.354,0l3.11-3.11a1,1,0,0,1,1.414,1.415l-3.11,3.11a.25.25,0,0,0,0,.353Z"
    }));
  },
  checkmark: function checkmark(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("polyline", {
      points: "20 6 9 17 4 12"
    }));
  },
  checkmarkBold: function checkmarkBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.2224 6.69148C21.6214 7.07337 21.6352 7.70639 21.2533 8.10536L9.73591 20.1376C9.34216 20.549 8.68488 20.549 8.29112 20.1376L2.7467 14.3454C2.3648 13.9464 2.37864 13.3134 2.77761 12.9315L4.2224 11.5485C4.62136 11.1666 5.25438 11.1805 5.63627 11.5794L8.29112 14.353C8.68488 14.7643 9.34216 14.7643 9.73591 14.353L18.3637 5.33943C18.7456 4.94046 19.3786 4.92662 19.7776 5.30852L21.2224 6.69148Z"
    }));
  },
  checkmarkSquare: function checkmarkSquare(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("polyline", {
      points: "9 11 12 14 22 4"
    }), jsx("path", {
      d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
    }));
  },
  denied: function denied(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }), jsx("line", {
      x1: "4.93",
      y1: "4.93",
      x2: "19.07",
      y2: "19.07"
    }));
  },
  dots: function dots(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("circle", {
      cx: "12",
      cy: "12",
      r: "1"
    }), jsx("circle", {
      cx: "19",
      cy: "12",
      r: "1"
    }), jsx("circle", {
      cx: "5",
      cy: "12",
      r: "1"
    }));
  },
  dotsBold: function dotsBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0ZM8.5,12a2,2,0,1,1-2-2A2,2,0,0,1,8.5,12ZM12,10a2,2,0,1,1-2,2A2,2,0,0,1,12,10Zm5.5,4a2,2,0,1,1,2-2A2,2,0,0,1,17.5,14Z"
    }));
  },
  dotsVertical: function dotsVertical(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("circle", {
      cx: "12",
      cy: "12",
      r: "1"
    }), jsx("circle", {
      cx: "12",
      cy: "5",
      r: "1"
    }), jsx("circle", {
      cx: "12",
      cy: "19",
      r: "1"
    }));
  },
  write: function write(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("polygon", {
      points: "16 3 21 8 8 21 3 21 3 16 16 3"
    }));
  },
  writeBold: function writeBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M14.5716 5.28272V5.28272C14.4931 5.20355 14.3864 5.15891 14.2749 5.15866V5.15866C14.1635 5.15868 14.0568 5.20302 13.9781 5.28189L4.82264 14.4399V14.4399C4.65902 14.6036 4.65902 14.8689 4.82264 15.0325L8.97036 19.1803V19.1803C9.13403 19.3439 9.39934 19.3439 9.56301 19.1803L18.7143 10.029V10.029C18.8774 9.86539 18.8774 9.60072 18.7143 9.43715L14.5716 5.28272Z"
    }), jsx("path", {
      d: "M3.97857 16.0232V16.0232C3.87124 15.9162 3.71453 15.8755 3.5687 15.9167V15.9167C3.42265 15.9577 3.31013 16.0744 3.2745 16.2218L2.0122 21.4831V21.4831C1.97833 21.6248 2.02054 21.774 2.12368 21.877H2.12368C2.22743 21.9789 2.37603 22.0206 2.51762 21.9877L7.7747 20.7304V20.7304C7.9998 20.6765 8.13861 20.4504 8.08474 20.2253C8.06671 20.1499 8.02815 20.0811 7.97335 20.0263L3.97857 16.0232Z"
    }), jsx("path", {
      d: "M21.3876 4.39256L19.6081 2.61226V2.61226C18.7902 1.79591 17.4657 1.79591 16.6477 2.61226L15.4591 3.79997V3.79997C15.2955 3.96362 15.2955 4.22891 15.4591 4.39256L19.6081 8.54072V8.54072C19.7718 8.70433 20.0371 8.70433 20.2007 8.54072L21.3876 7.35134V7.35134C22.2028 6.53355 22.2028 5.21035 21.3876 4.39256V4.39256Z"
    }));
  },
  writeSquare: function writeSquare(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34"
    }), jsx("polygon", {
      points: "18 2 22 6 12 16 8 16 8 12 18 2"
    }));
  },
  settings: function settings(p) {
    return jsx("svg", _extends({
      viewBox: "-1 -1 25 25",
      fill: "none"
    }, sanitizeProps(p)), jsx("circle", {
      cx: "12",
      cy: "12",
      r: "3"
    }), jsx("path", {
      d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
    }));
  },
  settingsAlt: function settingsAlt(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("line", {
      x1: "4",
      y1: "21",
      x2: "4",
      y2: "14"
    }), jsx("line", {
      x1: "4",
      y1: "10",
      x2: "4",
      y2: "3"
    }), jsx("line", {
      x1: "12",
      y1: "21",
      x2: "12",
      y2: "12"
    }), jsx("line", {
      x1: "12",
      y1: "8",
      x2: "12",
      y2: "3"
    }), jsx("line", {
      x1: "20",
      y1: "21",
      x2: "20",
      y2: "16"
    }), jsx("line", {
      x1: "20",
      y1: "12",
      x2: "20",
      y2: "3"
    }), jsx("line", {
      x1: "1",
      y1: "14",
      x2: "7",
      y2: "14"
    }), jsx("line", {
      x1: "9",
      y1: "8",
      x2: "15",
      y2: "8"
    }), jsx("line", {
      x1: "17",
      y1: "16",
      x2: "23",
      y2: "16"
    }));
  },
  search: function search(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("circle", {
      cx: "11",
      cy: "11",
      r: "8"
    }), jsx("line", {
      x1: "21",
      y1: "21",
      x2: "16.65",
      y2: "16.65"
    }));
  },
  zoomIn: function zoomIn(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("circle", {
      cx: "11",
      cy: "11",
      r: "8"
    }), jsx("line", {
      x1: "21",
      y1: "21",
      x2: "16.65",
      y2: "16.65"
    }), jsx("line", {
      x1: "11",
      y1: "8",
      x2: "11",
      y2: "14"
    }), jsx("line", {
      x1: "8",
      y1: "11",
      x2: "14",
      y2: "11"
    }));
  },
  zoomOut: function zoomOut(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("circle", {
      cx: "11",
      cy: "11",
      r: "8"
    }), jsx("line", {
      x1: "21",
      y1: "21",
      x2: "16.65",
      y2: "16.65"
    }), jsx("line", {
      x1: "8",
      y1: "11",
      x2: "14",
      y2: "11"
    }));
  },
  share: function share(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("circle", {
      cx: "18",
      cy: "5",
      r: "3"
    }), jsx("circle", {
      cx: "6",
      cy: "12",
      r: "3"
    }), jsx("circle", {
      cx: "18",
      cy: "19",
      r: "3"
    }), jsx("line", {
      x1: "8.59",
      y1: "13.51",
      x2: "15.42",
      y2: "17.49"
    }), jsx("line", {
      x1: "15.41",
      y1: "6.51",
      x2: "8.59",
      y2: "10.49"
    }));
  },
  shareBold: function shareBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M19,14a4.976,4.976,0,0,0-3.586,1.53L9.921,12.783A4.948,4.948,0,0,0,10,12a4.935,4.935,0,0,0-.079-.783L15.414,8.47A4.991,4.991,0,1,0,14,5a4.948,4.948,0,0,0,.079.784L8.586,8.529a5,5,0,1,0,0,6.941l5.493,2.746A4.935,4.935,0,0,0,14,19a5,5,0,1,0,5-5Z"
    }));
  },
  shareAlt: function shareAlt(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M20.5,9a2,2,0,0,0-2-2h-3.25a.25.25,0,0,0-.25.25v1.5a.25.25,0,0,0,.25.25H18a.5.5,0,0,1,.5.5v12a.5.5,0,0,1-.5.5H6a.5.5,0,0,1-.5-.5V9.5A.5.5,0,0,1,6,9h2.75A.25.25,0,0,0,9,8.749v-1.5A.25.25,0,0,0,8.748,7H5.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h13a2,2,0,0,0,2-2Z"
    }), jsx("path", {
      d: "M10.5,11a1.5,1.5,0,0,0,3,0V5.749a.25.25,0,0,1,.25-.25H15.5A1,1,0,0,0,16.2,3.792l-3.5-3.5a1,1,0,0,0-1.414,0l-3.5,3.5A1,1,0,0,0,8.5,5.5h1.75a.25.25,0,0,1,.25.25Z"
    }));
  },
  time: function time(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }), jsx("polyline", {
      points: "12 6 12 12 16 14"
    }));
  },
  look: function look(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
    }), jsx("circle", {
      cx: "12",
      cy: "12",
      r: "3"
    }));
  },
  lookBold: function lookBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M23.432,10.524C20.787,7.614,16.4,4.538,12,4.6,7.6,4.537,3.213,7.615.568,10.524a2.211,2.211,0,0,0,0,2.948C3.182,16.351,7.507,19.4,11.839,19.4h.308c4.347,0,8.671-3.049,11.288-5.929A2.21,2.21,0,0,0,23.432,10.524ZM7.4,12A4.6,4.6,0,1,1,12,16.6,4.6,4.6,0,0,1,7.4,12Z"
    }), jsx("circle", {
      cx: "12",
      cy: "12",
      r: "2"
    }));
  },
  mailbrew: function mailbrew(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.07739 7.23692C1.14728 5.18632 2.52838 3.52781 4.45954 3.33109C6.18219 3.1556 8.65325 3 12 3C15.3912 3 17.8832 3.15976 19.6086 3.33808C19.7629 3.35403 19.9136 3.37935 20.0604 3.41351C20.0603 3.41351 20.0604 3.41352 20.0604 3.41351C20.8832 3.60509 21.5808 4.07445 22.0821 4.725C22.0821 4.72497 22.0821 4.72503 22.0821 4.725C22.591 5.38531 22.8977 6.23239 22.9283 7.1651C22.9688 8.40139 23 10.0014 23 12C23 13.9472 22.9704 15.5162 22.9314 16.7389C22.8656 18.8015 21.4589 20.4553 19.5168 20.6551C17.7567 20.8362 15.2625 21 12 21C8.78029 21 6.30894 20.8404 4.5529 20.6622C2.57737 20.4618 1.14391 18.7639 1.07413 16.6662C1.03239 15.4117 1 13.844 1 12C1 10.1082 1.03409 8.50728 1.07739 7.23692ZM20.9498 6.57574C19.2964 8.74455 16.5303 11.8742 12.6515 14.6225C12.2559 14.9028 11.7405 14.9075 11.3394 14.636C7.23296 11.8563 4.57783 8.87969 3.02027 6.76468C2.97678 6.93478 2.95063 7.11647 2.9441 7.30809C2.90157 8.5561 2.86792 10.1333 2.86792 12C2.86792 13.8196 2.89989 15.364 2.9409 16.5967C2.97954 17.7583 3.73958 18.595 4.73131 18.6957C6.42693 18.8677 8.83873 19.0244 12 19.0244C15.2033 19.0244 17.6371 18.8635 19.336 18.6888C20.304 18.5892 21.0289 17.7879 21.0645 16.6723C21.1028 15.4728 21.1321 13.9261 21.1321 12C21.1321 10.0231 21.1013 8.44593 21.0615 7.23361C21.0537 6.9974 21.015 6.77699 20.9498 6.57574Z"
    }));
  },
  code: function code(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M7 7L2 12L7 17"
    }), jsx("path", {
      d: "M17 7L22 12L17 17"
    }), jsx("path", {
      d: "M14 4L10 20"
    }));
  },
  star: function star(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("polygon", {
      points: "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
    }));
  },
  heart: function heart(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
    }));
  },
  heartBold: function heartBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M23.3,5.076a6.582,6.582,0,0,0-10.446-1.71L12,4.147l-.827-.753A6.522,6.522,0,0,0,5.485,1.588,6.472,6.472,0,0,0,.7,5.075,6.4,6.4,0,0,0,1.91,12.544L11.283,22.2a1,1,0,0,0,1.434,0l9.36-9.638A6.414,6.414,0,0,0,23.3,5.076Z"
    }));
  },
  flag: function flag(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"
    }), jsx("line", {
      x1: "4",
      y1: "22",
      x2: "4",
      y2: "15"
    }));
  },
  flagBold: function flagBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M21.485 3.81171V3.81171C21.0852 3.53964 20.5687 3.50768 20.1383 3.72838V3.72838C19.0441 4.17311 17.8804 4.42272 16.7 4.46588V4.46588C15.3535 4.36679 14.0256 4.09254 12.75 3.65004C9.9525 2.83338 8.98334 2.64004 6.83834 2.91671H6.83834C6.21493 2.99802 5.74891 3.52969 5.75 4.15838V16.675V16.675C5.75 17.3653 6.30965 17.925 7 17.925C7.04787 17.925 7.0957 17.9222 7.14325 17.9167C9.02241 17.7009 9.89741 17.8842 12.5116 18.6492L12.5116 18.6492C13.8637 19.1178 15.2722 19.4039 16.7 19.5V19.5C18.1585 19.4459 19.5942 19.1204 20.9333 18.54C21.4933 18.3267 22 18.04 22 17.2667V4.83338V4.83338C22.0034 4.42963 21.8116 4.04911 21.485 3.81171V3.81171Z"
    }), jsx("path", {
      d: "M3.25 2H3.25C2.55964 2 2 2.55964 2 3.25V20.75H2C2 21.4404 2.55964 22 3.25 22C3.94036 22 4.5 21.4404 4.5 20.75V3.25C4.5 2.55964 3.94036 2 3.25 2L3.25 2Z"
    }));
  },
  tag: function tag(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"
    }));
  },
  bubble: function bubble(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
    }));
  },
  bubbleBold: function bubbleBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M12,1.337C5.659,1.337.5,5.587.5,10.811a8.6,8.6,0,0,0,3.175,6.54l-2.3,4.587a.5.5,0,0,0,.659.677l6.149-2.862A13.717,13.717,0,0,0,12,20.286c6.341,0,11.5-4.25,11.5-9.475S18.341,1.337,12,1.337Z"
    }));
  },
  quote: function quote(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M9.928,3.932A9.709,9.709,0,0,0,.5,13.88v1.243a4.942,4.942,0,1,0,4.941-4.941,4.609,4.609,0,0,0-1.115.14.25.25,0,0,1-.277-.368A6.832,6.832,0,0,1,9.928,6.432a1.25,1.25,0,0,0,0-2.5Z"
    }), jsx("path", {
      d: "M22.25,6.432a1.25,1.25,0,0,0,0-2.5,9.71,9.71,0,0,0-9.428,9.948v1.243a4.942,4.942,0,1,0,4.942-4.941,4.611,4.611,0,0,0-1.116.14.249.249,0,0,1-.26-.092.252.252,0,0,1-.017-.276A6.832,6.832,0,0,1,22.25,6.432Z"
    }));
  },
  chat: function chat(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M9.324,16.967c0-3.842,3.628-6.967,8.088-6.967a8.712,8.712,0,0,1,5.9,2.209.246.246,0,0,0,.239.056.25.25,0,0,0,.172-.176A8.245,8.245,0,0,0,24,10C24,4.486,18.617,0,12,0S0,4.486,0,10a9.037,9.037,0,0,0,2.766,6.376L1.347,21.107a.5.5,0,0,0,.681.6L7.5,19.271a13.422,13.422,0,0,0,2.091.518.251.251,0,0,0,.27-.349A6.047,6.047,0,0,1,9.324,16.967ZM9.5,12.25H6a.75.75,0,0,1,0-1.5H9.5a.75.75,0,0,1,0,1.5Zm7-4.5H6a.75.75,0,0,1,0-1.5H16.5a.75.75,0,0,1,0,1.5Z"
    }), jsx("path", {
      d: "M17.412,11.5c-3.633,0-6.588,2.452-6.588,5.467,0,3.521,4.078,6.322,8.456,5.232l3.5,1.748a.5.5,0,0,0,.7-.591l-.9-3A4.908,4.908,0,0,0,24,16.967C24,13.952,21.045,11.5,17.412,11.5Z"
    }));
  },
  trash: function trash(p) {
    return jsx("svg", _extends({
      viewBox: "-1 -1 25 25",
      fill: "none"
    }, sanitizeProps(p)), jsx("polyline", {
      points: "3 6 5 6 21 6"
    }), jsx("path", {
      d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
    }), jsx("line", {
      x1: "10",
      y1: "11",
      x2: "10",
      y2: "17"
    }), jsx("line", {
      x1: "14",
      y1: "11",
      x2: "14",
      y2: "17"
    }));
  },
  trashBold: function trashBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M19.5,7.5H4.5A.5.5,0,0,0,4,8V22a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V8A.5.5,0,0,0,19.5,7.5Zm-9.25,13a.75.75,0,0,1-1.5,0v-9a.75.75,0,0,1,1.5,0Zm5,0a.75.75,0,0,1-1.5,0v-9a.75.75,0,0,1,1.5,0Z"
    }), jsx("path", {
      d: "M22,4H17.25A.25.25,0,0,1,17,3.75V2.5A2.5,2.5,0,0,0,14.5,0h-5A2.5,2.5,0,0,0,7,2.5V3.75A.25.25,0,0,1,6.75,4H2A1,1,0,0,0,2,6H22a1,1,0,0,0,0-2ZM9,3.75V2.5A.5.5,0,0,1,9.5,2h5a.5.5,0,0,1,.5.5V3.75a.25.25,0,0,1-.25.25H9.25A.25.25,0,0,1,9,3.75Z"
    }));
  },
  "delete": function _delete(p) {
    return jsx("svg", _extends({
      viewBox: "-1 -1 27 27",
      fill: "none"
    }, sanitizeProps(p)), jsx("circle", {
      cx: "12",
      cy: "12",
      r: "11.25"
    }), jsx("line", {
      x1: "4.045",
      y1: "19.955",
      x2: "19.955",
      y2: "4.045"
    }));
  },
  dark: function dark(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
    }));
  },
  darkBold: function darkBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M19.9607 13.9616L19.9607 13.9616C15.9589 15.4394 11.5169 13.3934 10.039 9.39161C9.40139 7.66492 9.40132 5.76728 10.0388 4.04054V4.04054C10.1872 3.64085 9.98342 3.19657 9.58372 3.04823C9.41082 2.98407 9.22066 2.98392 9.04765 3.04782L9.04766 3.04782C4.25029 4.82521 1.80213 10.1551 3.57953 14.9524C5.35693 19.7497 10.6868 22.1979 15.4842 20.4205C18.0165 19.4823 20.0133 17.4857 20.9519 14.9535V14.9535C21.0997 14.5536 20.8954 14.1096 20.4955 13.9618C20.323 13.898 20.1333 13.8979 19.9607 13.9616L19.9607 13.9616Z"
    }));
  },
  like: function like(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
    }));
  },
  html: function html(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M18.231 18.0638L12.5702 21.1522V21.1522C12.2023 21.353 11.7576 21.353 11.3896 21.1522L5.72888 18.0638V18.0638C5.39616 17.8826 5.16528 17.5584 5.10283 17.1847L2.97573 4.423V4.423C2.86411 3.75159 3.31791 3.11682 3.98932 3.0052C4.0562 2.99408 4.12388 2.9885 4.19168 2.98851H19.7682V2.98851C20.4488 2.98882 21.0003 3.54083 21 4.22146C21 4.28898 20.9944 4.35639 20.9833 4.423L18.8562 17.1847V17.1847C18.7946 17.5586 18.5639 17.883 18.231 18.0638H18.231Z"
    }), jsx("path", {
      d: "M16.2929 6.68565H7.66618L8.28237 10.3828H15.6767L15.0605 15.3123L11.9795 17.1609L8.89856 15.3123"
    }));
  },
  react: function react(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("ellipse", {
      cx: "12",
      cy: "12",
      rx: "4.45133",
      ry: "11",
      transform: "rotate(-30 12 12)"
    }), jsx("ellipse", {
      cx: "12",
      cy: "12",
      rx: "4.45133",
      ry: "11",
      transform: "rotate(30 12 12)"
    }), jsx("ellipse", {
      cx: "12",
      cy: "12",
      rx: "4.45133",
      ry: "11",
      transform: "rotate(90 12 12)"
    }), jsx("circle", {
      cx: "12",
      cy: "12",
      r: "2"
    }));
  },
  github: function github(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 48 47"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "m723.999 560c-13.2525 0-23.9985 10.7871-23.9985 24.0966 0 10.644 6.876 19.6752 16.4145 22.8618 1.2.221374 1.638-.522563 1.638-1.16108 0-.57226-.021-2.08724-.033-4.09768-6.6765 1.45625-8.085-3.23025-8.085-3.23025-1.0905-2.78299-2.664-3.52391-2.664-3.52391-2.1795-1.49541.165-1.46529.165-1.46529 2.4075.170172 3.675 2.4833 3.675 2.4833 2.142 3.68204 5.6175 2.61884 6.9855 2.0014.2175-1.55715.8385-2.61884 1.524-3.22122-5.3295-.608402-10.932-2.67456-10.932-11.9075 0-2.63089.9345-4.78138 2.4705-6.46653-.2475-.609908-1.071-3.05858.234-6.37618 0 0 2.016-.647556 6.6 2.46975 1.9155-.534611 3.9675-.801163 6.009-.811705 2.0385.010542 4.092.277094 6.009.811705 4.581-3.11731 6.5925-2.46975 6.5925-2.46975 1.3095 3.3176.486 5.76627.2385 6.37618 1.539 1.68515 2.4675 3.83565 2.4675 6.46653 0 9.25555-5.6115 11.2931-10.9575 11.8894.861.743937 1.629 2.21374 1.629 4.46212 0 3.22122-.03 5.81898-.03 6.6096 0 .644545.432 1.39451 1.65 1.15807 9.5295-3.19261 16.3995-12.2177 16.3995-22.8588 0-13.3096-10.746-24.0966-24.0015-24.0966",
      fillRule: "evenodd",
      transform: "translate(-700 -560)"
    }));
  },
  bell: function bell(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M22 17H2a3 3 0 0 0 3-3V9a7 7 0 0 1 14 0v5a3 3 0 0 0 3 3zm-8.27 4a2 2 0 0 1-3.46 0"
    }));
  },
  email: function email(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
    }), jsx("polyline", {
      points: "22,6 12,13 2,6"
    }));
  },
  emailBold: function emailBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M23.888,5.832a.182.182,0,0,0-.2.039l-9.747,9.745a2.75,2.75,0,0,1-3.888,0L.31,5.871a.18.18,0,0,0-.2-.039A.182.182,0,0,0,0,6V18a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6A.181.181,0,0,0,23.888,5.832Z"
    }), jsx("path", {
      d: "M11.115,14.556a1.252,1.252,0,0,0,1.768,0L22.569,4.87a.5.5,0,0,0,.121-.511C22.58,4.03,22.274,4,22,4H2c-.275,0-.583.03-.691.359a.5.5,0,0,0,.121.511Z"
    }));
  },
  calendar: function calendar(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("rect", {
      x: "3",
      y: "4",
      width: "18",
      height: "18",
      rx: "2",
      ry: "2"
    }), jsx("line", {
      x1: "16",
      y1: "2",
      x2: "16",
      y2: "6"
    }), jsx("line", {
      x1: "8",
      y1: "2",
      x2: "8",
      y2: "6"
    }), jsx("line", {
      x1: "3",
      y1: "10",
      x2: "21",
      y2: "10"
    }));
  },
  calendarBold: function calendarBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M7.5,10.5h-1a1,1,0,1,0,0,2h1a1,1,0,0,0,0-2Z"
    }), jsx("path", {
      d: "M12.5,10.5h-1a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z"
    }), jsx("path", {
      d: "M17.5,10.5h-1a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z"
    }), jsx("path", {
      d: "M7.5,14.5h-1a1,1,0,1,0,0,2h1a1,1,0,0,0,0-2Z"
    }), jsx("path", {
      d: "M12.5,14.5h-1a1,1,0,1,0,0,2h1a1,1,0,0,0,0-2Z"
    }), jsx("path", {
      d: "M17.5,14.5h-1a1,1,0,1,0,0,2h1a1,1,0,0,0,0-2Z"
    }), jsx("path", {
      d: "M7.5,18.5h-1a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z"
    }), jsx("path", {
      d: "M12.5,18.5h-1a1,1,0,0,0,0,2h1a1,1,0,1,0,0-2Z"
    }), jsx("path", {
      d: "M17.5,18.5h-1a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z"
    }), jsx("path", {
      d: "M21.5,3H18.75a.25.25,0,0,1-.25-.25V1a1,1,0,0,0-2,0v4.75a.75.75,0,1,1-1.5,0V3.5a.5.5,0,0,0-.5-.5H8.25A.25.25,0,0,1,8,2.751V1A1,1,0,1,0,6,1v4.75a.75.75,0,1,1-1.5,0V3.5A.5.5,0,0,0,4,3H2.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h19a2,2,0,0,0,2-2V5A2,2,0,0,0,21.5,3Zm0,18.5a.5.5,0,0,1-.5.5H3a.5.5,0,0,1-.5-.5V9.5A.5.5,0,0,1,3,9H21a.5.5,0,0,1,.5.5Z"
    }));
  },
  lock: function lock(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("rect", {
      x: "3",
      y: "11",
      width: "18",
      height: "11",
      rx: "2",
      ry: "2"
    }), jsx("path", {
      d: "M7 11V7a5 5 0 0 1 10 0v4"
    }));
  },
  shopping: function shopping(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M6 2L3 6v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V6l-3-4H6zM3.8 6h16.4M16 10a4 4 0 1 1-8 0"
    }));
  },
  cart: function cart(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("circle", {
      cx: "10",
      cy: "20.5",
      r: "1"
    }), jsx("circle", {
      cx: "18",
      cy: "20.5",
      r: "1"
    }), jsx("path", {
      d: "M2.5 2.5h3l2.7 12.4a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.6l1.6-8.4H7.1"
    }));
  },
  coupon: function coupon(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
    }), jsx("line", {
      x1: "7",
      y1: "7",
      x2: "7",
      y2: "7"
    }));
  },
  couponBold: function couponBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M1.382,11.384,13.16,22.953l.017.016a2,2,0,0,0,2.808-.021l7.065-7.063a2,2,0,0,0-.012-2.841L11.3,1.5c-.018-.019-.035-.037-.054-.054A3.751,3.751,0,0,0,8.855.465H2.363a2,2,0,0,0-2,2L.37,8.96A3.784,3.784,0,0,0,1.382,11.384ZM4.863,6.465a1.5,1.5,0,1,1,1.5,1.5A1.5,1.5,0,0,1,4.863,6.465Z"
    }));
  },
  couponAltBold: function couponAltBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M23.5,9.5A.5.5,0,0,0,24,9V5.5A1.5,1.5,0,0,0,22.5,4H1.5A1.5,1.5,0,0,0,0,5.5V9a.5.5,0,0,0,.5.5,2.5,2.5,0,0,1,0,5A.5.5,0,0,0,0,15v3.5A1.5,1.5,0,0,0,1.5,20h21A1.5,1.5,0,0,0,24,18.5V15a.5.5,0,0,0-.5-.5,2.5,2.5,0,0,1,0-5ZM7.47,15.47l8-8a.75.75,0,0,1,1.06,1.06l-8,8a.75.75,0,0,1-1.06-1.06ZM7,9a2,2,0,1,1,2,2A2,2,0,0,1,7,9Zm8,4a2,2,0,1,1-2,2A2,2,0,0,1,15,13Z"
    }));
  },
  location: function location(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M12 22s-8-4.5-8-11.8A8 8 0 0 1 12 2a8 8 0 0 1 8 8.2c0 7.3-8 11.8-8 11.8z"
    }), jsx("circle", {
      cx: "12",
      cy: "10",
      r: "3"
    }));
  },
  world: function world(p) {
    return jsx("svg", _extends({
      viewBox: "-2 -2 28 28",
      fill: "none"
    }, sanitizeProps(p)), jsx("circle", {
      cx: "12",
      cy: "12",
      r: "11.25"
    }), jsx("path", {
      d: "M9.289,22.921C7.767,20.689,6.75,16.633,6.75,12S7.767,3.311,9.289,1.079"
    }), jsx("line", {
      x1: "0.75",
      y1: "12",
      x2: "23.25",
      y2: "12"
    }), jsx("line", {
      x1: "2.482",
      y1: "18",
      x2: "21.518",
      y2: "18"
    }), jsx("line", {
      x1: "2.482",
      y1: "6",
      x2: "21.518",
      y2: "6"
    }), jsx("path", {
      d: "M14.711,1.079C16.233,3.311,17.25,7.367,17.25,12s-1.017,8.689-2.539,10.921"
    }));
  },
  worldAlt: function worldAlt(p) {
    return jsx("svg", _extends({
      viewBox: "-2 -2 28 28",
      fill: "none"
    }, sanitizeProps(p)), jsx("circle", {
      cx: "12",
      cy: "12",
      r: "11.25"
    }), jsx("path", {
      d: "M7.079,15.75a1.5,1.5,0,0,0,1.455-1.864l-.75-3A1.5,1.5,0,0,0,6.329,9.75H.976A11.246,11.246,0,0,0,4.992,20.792L6,15.75Z"
    }), jsx("path", {
      d: "M20.985,5.25H16.921a1.5,1.5,0,0,0-1.455,1.136l-.75,3a1.5,1.5,0,0,0,1.455,1.864H17.75L18.541,16a1.5,1.5,0,0,0,1.48,1.253h1.925a11.2,11.2,0,0,0-.961-12Z"
    }));
  },
  worldAltBold: function worldAltBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M24,12A12,12,0,1,0,12,24c.021,0,.041,0,.062,0s.042,0,.063,0A11.888,11.888,0,0,0,24,12.125c0-.021,0-.042,0-.063S24,12.021,24,12Zm-2,0a9.862,9.862,0,0,1-.359,2.633.5.5,0,0,1-.681.326,3.484,3.484,0,0,1-1.517-1.268l-2.218-3.328a2.5,2.5,0,0,0-2.08-1.113h-.433a2.75,2.75,0,1,1,0-5.5h2.772a.5.5,0,0,1,.289.092A9.993,9.993,0,0,1,22,12ZM2.179,10.155a.5.5,0,0,1,.491-.4H7.007a3.477,3.477,0,0,1,2.475,1.025L10.6,11.9a3.5,3.5,0,0,1,.14,4.8L9.381,18.229a2.5,2.5,0,0,0-.631,1.662v.827a.5.5,0,0,1-.7.458A10,10,0,0,1,2,12,9.765,9.765,0,0,1,2.179,10.155Z"
    }));
  },
  book: function book(p) {
    return jsx("svg", _extends({
      viewBox: "-1 -1 26 26",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M18,4.144a31.156,31.156,0,0,1,4.732-.394.517.517,0,0,1,.366.144.5.5,0,0,1,.152.356V20.018a.505.505,0,0,1-.5.5C14.457,20.621,12,23.25,12,23.25V6.482S9.545,3.856,1.268,3.75A.517.517,0,0,0,.9,3.894.5.5,0,0,0,.75,4.25V20.018a.505.505,0,0,0,.5.5C9.543,20.621,12,23.25,12,23.25"
    }), jsx("path", {
      d: "M12,22.757a6.035,6.035,0,0,1,1.636-3.448A8.228,8.228,0,0,1,18,16.846V1.243a.481.481,0,0,0-.228-.4.6.6,0,0,0-.494-.066,7.8,7.8,0,0,0-3.642,2.277A6.035,6.035,0,0,0,12,6.5"
    }));
  },
  bookSimple: function bookSimple(p) {
    return jsx("svg", _extends({
      viewBox: "-1 -1 26 26",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M11.458,21.269a1.6,1.6,0,0,0,1.085,0,13.66,13.66,0,0,1,8.7-.448,1.607,1.607,0,0,0,2.006-1.559V4.928A1.607,1.607,0,0,0,22.129,3.4a13.878,13.878,0,0,0-9.586.2,1.61,1.61,0,0,1-1.085,0,13.881,13.881,0,0,0-9.587-.2A1.607,1.607,0,0,0,.75,4.928V19.262a1.607,1.607,0,0,0,2.006,1.559A13.663,13.663,0,0,1,11.458,21.269Z"
    }), jsx("line", {
      x1: "12",
      y1: "3.682",
      x2: "12",
      y2: "21.364"
    }));
  },
  bookAlt: function bookAlt(p) {
    return jsx("svg", _extends({
      viewBox: "-1 -1 26 26",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M4.5,5.523v15a2.25,2.25,0,0,0,2.25,2.25,2.207,2.207,0,0,0,.392-.039l9.406-1.682A3.584,3.584,0,0,0,19.5,17.524V7.024a1.256,1.256,0,0,0-1.476-1.236L7.147,7.738a2.25,2.25,0,1,1-.794-4.429L17.972,1.227"
    }), jsx("line", {
      x1: "16.37",
      y1: "1.514",
      x2: "18.512",
      y2: "5.797"
    }));
  },
  bookBold: function bookBold(p) {
    return jsx("svg", _extends({
      viewBox: "-1 -1 26 26"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M20.15,4.04a.5.5,0,0,1-.4-.489V2a2,2,0,0,0-2-2H5.25a3,3,0,0,0-3,3V21a3,3,0,0,0,3,3h14.5a2,2,0,0,0,2-2V6A2,2,0,0,0,20.15,4.04ZM5.25,2H17.5a.25.25,0,0,1,.25.25v1.5A.25.25,0,0,1,17.5,4H5.25a1,1,0,0,1,0-2Z"
    }));
  },
  home: function home(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M21.6649 9.28792L12.0044 2L2.33511 9.28792C2.13522 9.47236 2.01502 9.72738 2 9.99893V21.1281C2.00146 21.6076 2.38982 21.9959 2.86933 21.9973H8.66667V17.334C8.66666 15.4933 10.159 14.0011 12 14.0011C13.841 14.0011 15.3333 15.4933 15.3333 17.334V22H21.1298C21.6094 21.9985 21.998 21.6104 22 21.1308V9.99893C21.9846 9.72748 21.8645 9.47258 21.6649 9.28792Z"
    }));
  },
  homeBold: function homeBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M22 9.91673V9.91676C21.9998 9.65869 21.8801 9.41526 21.6759 9.25758L12.5092 2.17428V2.17428C12.2089 1.94191 11.7895 1.94191 11.4892 2.17428L2.32252 9.25758H2.32252C2.11885 9.41559 1.99977 9.65896 2 9.91673V21.1667H2C2 21.6269 2.3731 22 2.83333 22H9.5V22C9.73012 22 9.91667 21.8135 9.91667 21.5833V17.8334V17.8334C9.91667 16.6828 10.8494 15.75 12 15.75C13.1506 15.75 14.0833 16.6828 14.0833 17.8334V17.8334V21.5833V21.5833C14.0833 21.8135 14.2699 22 14.5 22H21.1667V22C21.6269 22 22 21.6269 22 21.1667V9.91673Z"
    }));
  },
  homeAlt: function homeAlt(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
    }), jsx("polyline", {
      points: "9 22 9 12 15 12 15 22"
    }));
  },
  key: function key(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M23.5,0h-3a.5.5,0,0,0-.354.147l-9.53,9.531a7.5,7.5,0,1,0,3.707,3.707l2.312-2.313,1.933.644a1,1,0,0,0,1.3-1.1L19.507,8.2l.726-.726,1.456.662a1,1,0,0,0,1.378-1.18l-.506-1.809,1.293-1.293A.5.5,0,0,0,24,3.5V.5A.5.5,0,0,0,23.5,0ZM7,18.5A1.5,1.5,0,1,1,5.5,17,1.5,1.5,0,0,1,7,18.5Z"
    }));
  },
  send: function send(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M22.35 3L2.03818 11.3906C1.91805 11.4413 1.81661 11.528 1.74786 11.6388C1.67911 11.7496 1.64643 11.879 1.65433 12.0092C1.66223 12.1393 1.71032 12.2638 1.79196 12.3655C1.87361 12.4672 1.9848 12.541 2.11018 12.5768L9.75019 14.6999L22.35 3Z"
    }), jsx("path", {
      d: "M22.3501 3L18.8851 19.4572C18.8574 19.5861 18.7987 19.7062 18.7141 19.8073C18.6295 19.9083 18.5214 19.9872 18.3994 20.037C18.2774 20.0869 18.1451 20.1062 18.0139 20.0933C17.8827 20.0804 17.7567 20.0357 17.6467 19.963L9.7502 14.6999L22.3501 3Z"
    }), jsx("path", {
      d: "M9.7502 14.6999V20.5318C9.7504 20.6343 9.78433 20.7339 9.84674 20.8153C9.90916 20.8966 9.9966 20.9551 10.0956 20.9818C10.1946 21.0086 10.2996 21.002 10.3944 20.9631C10.4893 20.9242 10.5687 20.8552 10.6205 20.7667L12.9254 16.8158"
    }));
  },
  sendBold: function sendBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M23.612.225a1.045,1.045,0,0,0-1.138-.1L.827,11.646a1.547,1.547,0,0,0,.125,2.8l3.254,1.38a.719.719,0,0,0,.043.245l2.5,6.746A1.817,1.817,0,0,0,8.463,24a1.846,1.846,0,0,0,1.219-.474c.039-.035,2.79-3.078,3.4-3.754a.249.249,0,0,1,.283-.062l3.157,1.339a1.591,1.591,0,0,0,1.3-.027,1.563,1.563,0,0,0,.835-.983L23.961,1.3A1.014,1.014,0,0,0,23.612.225ZM5.838,16.046,15.53,7.983A.226.226,0,0,1,15.867,8a.219.219,0,0,1,.019.332L8.648,17.187a.728.728,0,0,0-.157.351l-.633,3.95Z"
    }));
  },
  music: function music(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("circle", {
      cx: "5.5",
      cy: "17.5",
      r: "2.5"
    }), jsx("circle", {
      cx: "17.5",
      cy: "15.5",
      r: "2.5"
    }), jsx("path", {
      d: "M8 17V5l12-2v12"
    }));
  },
  video: function video(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M15.6 11.6L22 7v10l-6.4-4.5v-1zM4 5h9a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2z"
    }));
  },
  photo: function photo(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("g", {
      transform: "translate(2 3)"
    }, jsx("path", {
      d: "M20 16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3l2-3h6l2 3h3a2 2 0 0 1 2 2v11z"
    }), jsx("circle", {
      cx: "10",
      cy: "10",
      r: "4"
    })));
  },
  photoBold: function photoBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("circle", {
      cx: "14.75",
      cy: "13.125",
      r: "3.75"
    }), jsx("path", {
      d: "M21.444,6.125H20.128a.534.534,0,0,1-.481-.346C19.029,4.475,18.39,3.125,17,3.125H12c-1.071,0-1.636.778-2.659,2.191-.384.527-.51.809-.844.809h-6C.434,6.125,0,7.334,0,8.348V18.736a2.254,2.254,0,0,0,2.556,2.389H21.444A2.254,2.254,0,0,0,24,18.736V8.348C24,7.334,23.557,6.125,21.444,6.125Zm-.944,7a5.75,5.75,0,1,1-5.75-5.75A5.756,5.756,0,0,1,20.5,13.125ZM5,9.875a1.25,1.25,0,1,1-1.25-1.25A1.25,1.25,0,0,1,5,9.875Z"
    }), jsx("path", {
      d: "M2.5,5.109l3,.016h0a.5.5,0,0,0,.5-.5v-.25a1.5,1.5,0,0,0-1.5-1.5h-1A1.5,1.5,0,0,0,2,4.375v.234A.5.5,0,0,0,2.5,5.109Z"
    }));
  },
  sticker: function sticker(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M10.631,22.139a.25.25,0,0,0-.207-.246A9.984,9.984,0,1,1,21.791,9.445a.25.25,0,0,0,.263.184c.357-.031.717-.046,1.082-.046a1.965,1.965,0,0,1,.394.039.25.25,0,0,0,.293-.3,11.985,11.985,0,1,0-13.387,14.6.249.249,0,0,0,.275-.318,1.993,1.993,0,0,1-.08-.559Z"
    }), jsx("path", {
      d: "M8.094,7.763A1.672,1.672,0,1,0,9.766,9.434,1.671,1.671,0,0,0,8.094,7.763Z"
    }), jsx("path", {
      d: "M6.483,15.052a.75.75,0,1,0-1.326.7,7.9,7.9,0,0,0,5.424,4.063.25.25,0,0,0,.188-.037.256.256,0,0,0,.107-.159q.1-.488.233-.96a.25.25,0,0,0-.192-.314A6.461,6.461,0,0,1,6.483,15.052Z"
    }), jsx("path", {
      d: "M12.131,23.043a.5.5,0,0,0,.5.493.518.518,0,0,0,.379-.167L23.494,11.932l.014-.016a.493.493,0,0,0,.128-.333.5.5,0,0,0-.5-.5,11.017,11.017,0,0,0-11,11.005Z"
    }), jsx("path", {
      d: "M19.017,9.411A2.908,2.908,0,0,0,16.45,7.968h0a2.9,2.9,0,0,0-2.563,1.443.75.75,0,0,0,1.312.728,1.388,1.388,0,0,1,1.252-.671h0a1.393,1.393,0,0,1,1.256.671.75.75,0,1,0,1.311-.728Z"
    }));
  },
  picture: function picture(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("rect", {
      x: "3",
      y: "3",
      width: "18",
      height: "18",
      rx: "2"
    }), jsx("circle", {
      cx: "8.5",
      cy: "8.5",
      r: "1.5"
    }), jsx("path", {
      d: "M20.4 14.5L16 10 4 20"
    }));
  },
  pictureBold: function pictureBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.99609 4.00073C4.44381 4.00073 3.99609 4.44845 3.99609 5.00073V19.0007C3.99609 19.553 4.44381 20.0007 4.99609 20.0007H18.9961C19.5484 20.0007 19.9961 19.553 19.9961 19.0007V5.00073C19.9961 4.44845 19.5484 4.00073 18.9961 4.00073H4.99609ZM1.99609 5.00073C1.99609 3.34388 3.33924 2.00073 4.99609 2.00073H18.9961C20.6529 2.00073 21.9961 3.34388 21.9961 5.00073V19.0007C21.9961 20.6576 20.6529 22.0007 18.9961 22.0007H4.99609C3.33924 22.0007 1.99609 20.6576 1.99609 19.0007V5.00073Z"
    }), jsx("path", {
      d: "M8.5 11C9.88071 11 11 9.88071 11 8.5C11 7.11929 9.88071 6 8.5 6C7.11929 6 6 7.11929 6 8.5C6 9.88071 7.11929 11 8.5 11Z"
    }), jsx("path", {
      d: "M15.7915 10.9849L19.6298 13.9129C20.1164 14.2841 20.4063 14.8577 20.4165 15.4697L20.4664 18.4666C20.485 19.5841 19.5843 20.5 18.4667 20.5H4.89344C4.64172 20.5 4.40032 20.4 4.22233 20.222C3.83239 19.832 3.85574 19.193 4.27309 18.8326L13.2712 11.0614C13.9874 10.4429 15.0391 10.411 15.7915 10.9849Z"
    }));
  },
  playlist: function playlist(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("rect", {
      x: "3",
      y: "4",
      width: "18",
      height: "3",
      rx: "1"
    }), jsx("rect", {
      x: "3",
      y: "10",
      width: "18",
      height: "3",
      rx: "1"
    }), jsx("rect", {
      x: "3",
      y: "16",
      width: "11",
      height: "3",
      rx: "1"
    }), jsx("path", {
      d: "M20.7088 16.6614C21.3159 17.0557 21.3159 17.9443 20.7088 18.3386L17.5447 20.3938C16.8794 20.8259 16 20.3485 16 19.5552L16 15.4448C16 14.6515 16.8794 14.1741 17.5447 14.6062L20.7088 16.6614Z"
    }));
  },
  columns: function columns(p) {
    return jsx("svg", _extends({
      viewBox: "-2 -2 28 28"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("rect", {
      x: "0.25",
      y: "0.497",
      width: "6.5",
      height: "23",
      rx: "1.5",
      ry: "1.5"
    }), jsx("rect", {
      x: "8.75",
      y: "0.497",
      width: "6.5",
      height: "23",
      rx: "1.5",
      ry: "1.5"
    }), jsx("rect", {
      x: "17.25",
      y: "0.497",
      width: "6.5",
      height: "23",
      rx: "1.5",
      ry: "1.5"
    }));
  },
  rows: function rows(p) {
    return jsx("svg", _extends({
      viewBox: "-2 -2 28 28"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("rect", {
      y: "0.747",
      width: "24",
      height: "5.5",
      rx: "1.5",
      ry: "1.5"
    }), jsx("rect", {
      y: "9.247",
      width: "24",
      height: "5.5",
      rx: "1.5",
      ry: "1.5"
    }), jsx("rect", {
      y: "17.747",
      width: "24",
      height: "5.5",
      rx: "1.5",
      ry: "1.5"
    }));
  },
  content: function content(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("rect", {
      x: "0.5",
      y: "0.997",
      width: "10",
      height: "10",
      rx: "2",
      ry: "2"
    }), jsx("rect", {
      x: "0.5",
      y: "12.997",
      width: "10",
      height: "10",
      rx: "2",
      ry: "2"
    }), jsx("path", {
      d: "M13.747,3h9a.75.75,0,0,0,0-1.5h-9a.75.75,0,0,0,0,1.5Z"
    }), jsx("path", {
      d: "M22.75,4.5h-9a.75.75,0,0,0,0,1.5h9a.75.75,0,0,0,0-1.5Z"
    }), jsx("path", {
      d: "M22.75,7.5h-9a.75.75,0,0,0,0,1.5h9a.75.75,0,0,0,0-1.5Z"
    }), jsx("path", {
      d: "M22.75,14.5h-9a.75.75,0,0,0,0,1.5h9a.75.75,0,0,0,0-1.5Z"
    }), jsx("path", {
      d: "M22.75,17.5h-9a.75.75,0,0,0,0,1.5h9a.75.75,0,0,0,0-1.5Z"
    }), jsx("path", {
      d: "M22.75,20.5h-9a.75.75,0,0,0,0,1.5h9a.75.75,0,0,0,0-1.5Z"
    }));
  },
  gridBold: function gridBold(p) {
    return jsx("svg", _extends({
      viewBox: "-3 -3 30 30"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("rect", {
      y: "-0.003",
      width: "11",
      height: "11",
      rx: "1.5",
      ry: "1.5"
    }), jsx("rect", {
      x: "13",
      y: "-0.003",
      width: "11",
      height: "11",
      rx: "1.5",
      ry: "1.5"
    }), jsx("rect", {
      y: "12.997",
      width: "11",
      height: "11",
      rx: "1.5",
      ry: "1.5"
    }), jsx("rect", {
      x: "13",
      y: "12.997",
      width: "11",
      height: "11",
      rx: "1.5",
      ry: "1.5"
    }));
  },
  document: function document(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M13 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V9l-7-7z"
    }), jsx("path", {
      d: "M13 3v6h6"
    }));
  },
  folder: function folder(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
    }));
  },
  folderBold: function folderBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M22.5,5H11.236a.5.5,0,0,1-.447-.276l-.947-1.9A1.494,1.494,0,0,0,8.5,2h-7A1.5,1.5,0,0,0,0,3.5v17A1.5,1.5,0,0,0,1.5,22h21A1.5,1.5,0,0,0,24,20.5V6.5A1.5,1.5,0,0,0,22.5,5Z"
    }));
  },
  text: function text(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M17 9.5H3M21 4.5H3M21 14.5H3M17 19.5H3"
    }));
  },
  list: function list(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("line", {
      x1: "8",
      y1: "6",
      x2: "21",
      y2: "6"
    }), jsx("line", {
      x1: "8",
      y1: "12",
      x2: "21",
      y2: "12"
    }), jsx("line", {
      x1: "8",
      y1: "18",
      x2: "21",
      y2: "18"
    }), jsx("line", {
      x1: "3",
      y1: "6",
      x2: "3",
      y2: "6"
    }), jsx("line", {
      x1: "3",
      y1: "12",
      x2: "3",
      y2: "12"
    }), jsx("line", {
      x1: "3",
      y1: "18",
      x2: "3",
      y2: "18"
    }));
  },
  link: function link(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
    }), jsx("path", {
      d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
    }));
  },
  rss: function rss(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M4 11a9 9 0 0 1 9 9"
    }), jsx("path", {
      d: "M4 4a16 16 0 0 1 16 16"
    }), jsx("circle", {
      cx: "5",
      cy: "19",
      r: "1"
    }));
  },
  retweet: function retweet(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M5.94118 5.15123V18.8488H11.6765M5.94118 5.15123L2.5 8.57561M5.94118 5.15123L9.38235 8.57561"
    }), jsx("path", {
      d: "M18.5588 18.8488V5.15125H12.8235M18.5588 18.8488L22 15.4244M18.5588 18.8488L15.1176 15.4244"
    }));
  },
  sun: function sun(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("circle", {
      cx: "12.001",
      cy: "12",
      r: "4.5"
    }), jsx("line", {
      x1: "12.001",
      y1: "1.5",
      x2: "12.001",
      y2: "4.5"
    }), jsx("line", {
      x1: "12.001",
      y1: "19.5",
      x2: "12.001",
      y2: "22.5"
    }), jsx("line", {
      x1: "22.501",
      y1: "12",
      x2: "19.501",
      y2: "12"
    }), jsx("line", {
      x1: "4.501",
      y1: "12",
      x2: "1.501",
      y2: "12"
    }), jsx("line", {
      x1: "19.425",
      y1: "4.576",
      x2: "17.304",
      y2: "6.697"
    }), jsx("line", {
      x1: "6.697",
      y1: "17.304",
      x2: "4.576",
      y2: "19.425"
    }), jsx("line", {
      x1: "19.425",
      y1: "19.425",
      x2: "17.304",
      y2: "17.304"
    }), jsx("line", {
      x1: "6.697",
      y1: "6.697",
      x2: "4.576",
      y2: "4.576"
    }));
  },
  sunBold: function sunBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("circle", {
      cx: "12",
      cy: "12.001",
      r: "4.5"
    }), jsx("path", {
      d: "M12,5.827a1,1,0,0,0,1-1V1a1,1,0,0,0-2,0V4.827A1,1,0,0,0,12,5.827Z"
    }), jsx("path", {
      d: "M12,18.175a1,1,0,0,0-1,1V23a1,1,0,1,0,2,0V19.175A1,1,0,0,0,12,18.175Z"
    }), jsx("path", {
      d: "M6.219,7.636a1.018,1.018,0,0,0,1.414,0,1,1,0,0,0,0-1.414l-2.7-2.707A1,1,0,0,0,3.515,4.93Z"
    }), jsx("path", {
      d: "M17.779,16.366a1,1,0,0,0-1.414,1.414l2.706,2.707a1.017,1.017,0,0,0,1.414,0,1,1,0,0,0,0-1.414Z"
    }), jsx("path", {
      d: "M5.826,12.5a1,1,0,0,0-1-1H1a1,1,0,0,0,0,2H4.826A1,1,0,0,0,5.826,12.5Z"
    }), jsx("path", {
      d: "M23,11.5H19.174a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z"
    }), jsx("path", {
      d: "M6.219,16.366l-2.7,2.707a1,1,0,0,0,0,1.414,1.017,1.017,0,0,0,1.414,0l2.7-2.706a1,1,0,0,0-1.414-1.414Z"
    }), jsx("path", {
      d: "M17.072,7.923a1,1,0,0,0,.707-.287L20.485,4.93a1,1,0,0,0-1.414-1.415L16.365,6.222a.994.994,0,0,0,.707,1.7Z"
    }));
  },
  user: function user(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
    }), jsx("circle", {
      cx: "12",
      cy: "7",
      r: "4"
    }));
  },
  userCircleBold: function userCircleBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "m12 0a12 12 0 1 0 12 12 12.013 12.013 0 0 0 -12-12zm7.49 18.239a9.745 9.745 0 0 1 -14.979 0 .25.25 0 0 1 -.054-.207.257.257 0 0 1 .126-.173 33.03 33.03 0 0 1 4.04-1.669l.674-.249a.966.966 0 0 0 .477-.723 2.194 2.194 0 0 0 -.249-1.752c-.839-.924-1.659-2.064-1.659-4.915a4.043 4.043 0 0 1 4.134-4.4 4.043 4.043 0 0 1 4.135 4.4c0 2.851-.82 3.991-1.659 4.915a2.194 2.194 0 0 0 -.249 1.752.966.966 0 0 0 .477.723l.675.249a33.134 33.134 0 0 1 4.038 1.668.259.259 0 0 1 .126.173.25.25 0 0 1 -.053.208z"
    }));
  },
  userCircle: function userCircle(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M5.52 19c.64-2.2 1.84-3 3.22-3h6.52c1.38 0 2.58.8 3.22 3"
    }), jsx("circle", {
      cx: "12",
      cy: "10",
      r: "3"
    }), jsx("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }));
  },
  contactCard: function contactCard(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M24,4.5a2,2,0,0,0-2-2H2a2,2,0,0,0-2,2v15a2,2,0,0,0,2,2H5a1,1,0,0,0,1-1v-.75A.752.752,0,0,1,6.75,19a.761.761,0,0,1,.75.75v.75a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1v-.75a.752.752,0,0,1,.75-.75.761.761,0,0,1,.75.75v.75a1,1,0,0,0,1,1h3a2,2,0,0,0,2-2ZM22,19a.5.5,0,0,1-.5.5H20.208a.251.251,0,0,1-.247-.208,2.749,2.749,0,0,0-5.422,0,.251.251,0,0,1-.247.209H9.708a.251.251,0,0,1-.247-.208,2.749,2.749,0,0,0-5.422,0,.251.251,0,0,1-.247.209H2.5A.5.5,0,0,1,2,19V5a.5.5,0,0,1,.5-.5h19A.5.5,0,0,1,22,5Z"
    }), jsx("path", {
      d: "M15,12.25h4.782a.75.75,0,0,0,0-1.5H15a.75.75,0,0,0,0,1.5Z"
    }), jsx("path", {
      d: "M14.25,14.5a.75.75,0,0,0,.75.75h2.608a.75.75,0,1,0,0-1.5H15A.75.75,0,0,0,14.25,14.5Z"
    }), jsx("path", {
      d: "M15,9.25h5a.75.75,0,0,0,0-1.5H15a.75.75,0,0,0,0,1.5Z"
    }), jsx("path", {
      d: "M4,15.768h8a.5.5,0,0,0,.383-.179.5.5,0,0,0,.109-.407,4.247,4.247,0,0,0-.368-1.155c-.348-.7-1.2-1.129-2.667-1.657a.894.894,0,0,1-.026-.391A4.033,4.033,0,0,0,10.3,9.213a2.3,2.3,0,1,0-4.59,0,3.988,3.988,0,0,0,.833,2.723c.043.089.053.355.076.382-1.543.58-2.39,1-2.738,1.709a4.247,4.247,0,0,0-.368,1.155.5.5,0,0,0,.109.407A.5.5,0,0,0,4,15.768Z"
    }));
  },
  earphones: function earphones(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M3 18v-6a9 9 0 0 1 18 0v6"
    }), jsx("path", {
      d: "M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"
    }));
  },
  facebook: function facebook(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M22.5 0c.83 0 1.5.67 1.5 1.5v21c0 .83-.67 1.5-1.5 1.5h-6v-9h3l.75-3.75H16.5v-1.5c0-1.5.75-2.25 2.25-2.25h1.5V3.75h-3c-2.76 0-4.5 2.16-4.5 5.25v2.25h-3V15h3v9H1.5A1.5 1.5 0 0 1 0 22.5v-21C0 .67.67 0 1.5 0h21z"
    }));
  },
  twitter: function twitter(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M24 4.37a9.6 9.6 0 0 1-2.83.8 5.04 5.04 0 0 0 2.17-2.8c-.95.58-2 1-3.13 1.22A4.86 4.86 0 0 0 16.61 2a4.99 4.99 0 0 0-4.79 6.2A13.87 13.87 0 0 1 1.67 2.92 5.12 5.12 0 0 0 3.2 9.67a4.82 4.82 0 0 1-2.23-.64v.07c0 2.44 1.7 4.48 3.95 4.95a4.84 4.84 0 0 1-2.22.08c.63 2.01 2.45 3.47 4.6 3.51A9.72 9.72 0 0 1 0 19.74 13.68 13.68 0 0 0 7.55 22c9.06 0 14-7.7 14-14.37v-.65c.96-.71 1.79-1.6 2.45-2.61z"
    }));
  },
  google: function google(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 48 49"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("g", {
      transform: "translate(-400.000000, -860.000000)"
    }, jsx("path", {
      d: "M424.337382,879.648515 L424.337382,889.351485 C424.337382,889.351485 433.687756,889.338871 437.49499,889.338871 C435.4333,895.629064 432.227513,899.054455 424.337382,899.054455 C416.352552,899.054455 410.120495,892.538183 410.120495,884.5 C410.120495,876.461817 416.352552,869.945545 424.337382,869.945545 C428.559074,869.945545 431.285584,871.439317 433.786551,873.521332 C435.788481,871.506025 435.621252,871.218817 440.714512,866.376792 C436.390892,862.415069 430.644378,860 424.337382,860 C410.896159,860 400,870.968965 400,884.5 C400,898.030792 410.896159,909 424.337382,909 C444.428252,909 449.338861,891.389109 447.710907,879.648515 L424.337382,879.648515 L424.337382,879.648515 Z"
    })));
  },
  reddit: function reddit(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.4213 15.1144C14.5616 15.1144 13.8393 14.4236 13.8393 13.5718C13.8393 12.72 14.5616 12.0064 15.4213 12.0064C16.2809 12.0064 16.9781 12.72 16.9781 13.5718C16.9781 14.4236 16.2809 15.1144 15.4213 15.1144ZM15.7864 18.1085C14.9857 18.9012 13.7509 19.2865 12.0115 19.2865C12.0079 19.2865 12.0036 19.2858 11.9993 19.2858C11.9957 19.2858 11.9914 19.2865 11.9871 19.2865C10.2477 19.2865 9.0136 18.9012 8.21364 18.1085C7.96782 17.8649 7.96782 17.4711 8.21364 17.2282C8.45873 16.9854 8.8562 16.9854 9.10201 17.2282C9.65401 17.7752 10.5977 18.0415 11.9871 18.0415C11.9914 18.0415 11.9957 18.0422 11.9993 18.0422C12.0036 18.0422 12.0079 18.0415 12.0115 18.0415C13.4008 18.0415 14.3453 17.7752 14.898 17.2282C15.1438 16.9846 15.5413 16.9854 15.7864 17.2282C16.0315 17.4718 16.0315 17.8656 15.7864 18.1085ZM7.02195 13.5718C7.02195 12.7207 7.74285 12.0064 8.60176 12.0064C9.46138 12.0064 10.1586 12.7207 10.1586 13.5718C10.1586 14.4236 9.46138 15.1144 8.60176 15.1144C7.74285 15.1144 7.02195 14.4236 7.02195 13.5718ZM19.6647 3.74491C20.2469 3.74491 20.7206 4.21426 20.7206 4.79043C20.7206 5.3673 20.2469 5.83664 19.6647 5.83664C19.0825 5.83664 18.6089 5.36731 18.6089 4.79043C18.6089 4.21426 19.0825 3.74491 19.6647 3.74491ZM23.5 11.8775C23.5 10.3669 22.2602 9.1384 20.7357 9.1384C20.0759 9.1384 19.47 9.36915 18.9942 9.75303C17.3087 8.70325 15.1697 8.07081 12.8769 7.93691L14.0729 4.19007L17.3597 4.9571C17.446 6.14291 18.4465 7.08159 19.6647 7.08159C20.9391 7.08159 21.9763 6.05386 21.9763 4.79043C21.9763 3.5277 20.9391 2.5 19.6647 2.5C18.7735 2.5 17.9987 3.00283 17.6127 3.7371L13.7933 2.84616C13.4734 2.77137 13.15 2.95368 13.0508 3.2642L11.5659 7.91486C9.09553 7.97469 6.77326 8.60925 4.96417 9.72027C4.49483 9.35634 3.90471 9.1384 3.2643 9.1384C1.73984 9.1384 0.5 10.3669 0.5 11.8775C0.5 12.8112 0.974374 13.6366 1.69672 14.1309C1.66653 14.3481 1.65071 14.5668 1.65071 14.7882C1.65071 16.6763 2.7583 18.4326 4.76936 19.7331C6.69705 20.9801 9.24864 21.6667 11.9533 21.6667C14.6579 21.6667 17.2095 20.9801 19.1372 19.7331C21.1483 18.4326 22.2558 16.6763 22.2558 14.7882C22.2558 14.5867 22.2422 14.3866 22.217 14.1879C22.9875 13.7015 23.5 12.8475 23.5 11.8775"
    }));
  },
  instagram: function instagram(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M16.98 0a6.9 6.9 0 0 1 5.08 1.98A6.94 6.94 0 0 1 24 7.02v9.96c0 2.08-.68 3.87-1.98 5.13A7.14 7.14 0 0 1 16.94 24H7.06a7.06 7.06 0 0 1-5.03-1.89A6.96 6.96 0 0 1 0 16.94V7.02C0 2.8 2.8 0 7.02 0h9.96zm.05 2.23H7.06c-1.45 0-2.7.43-3.53 1.25a4.82 4.82 0 0 0-1.3 3.54v9.92c0 1.5.43 2.7 1.3 3.58a5 5 0 0 0 3.53 1.25h9.88a5 5 0 0 0 3.53-1.25 4.73 4.73 0 0 0 1.4-3.54V7.02a5 5 0 0 0-1.3-3.49 4.82 4.82 0 0 0-3.54-1.3zM12 5.76c3.39 0 6.2 2.8 6.2 6.2a6.2 6.2 0 0 1-12.4 0 6.2 6.2 0 0 1 6.2-6.2zm0 2.22a3.99 3.99 0 0 0-3.97 3.97A3.99 3.99 0 0 0 12 15.92a3.99 3.99 0 0 0 3.97-3.97A3.99 3.99 0 0 0 12 7.98zm6.44-3.77a1.4 1.4 0 1 1 0 2.8 1.4 1.4 0 0 1 0-2.8z"
    }));
  },
  youtube: function youtube(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M12.04 3.5c.59 0 7.54.02 9.34.5a3.02 3.02 0 0 1 2.12 2.15C24 8.05 24 12 24 12v.04c0 .43-.03 4.03-.5 5.8A3.02 3.02 0 0 1 21.38 20c-1.76.48-8.45.5-9.3.51h-.17c-.85 0-7.54-.03-9.29-.5A3.02 3.02 0 0 1 .5 17.84c-.42-1.61-.49-4.7-.5-5.6v-.5c.01-.9.08-3.99.5-5.6a3.02 3.02 0 0 1 2.12-2.14c1.8-.49 8.75-.51 9.34-.51zM9.54 8.4v7.18L15.82 12 9.54 8.41z"
    }));
  },
  dribbble: function dribbble(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M23.76 9.58A11.99 11.99 0 0 0 0 12a12.08 12.08 0 0 0 3.51 8.49 12.12 12.12 0 0 0 6.07 3.27A11.99 11.99 0 0 0 24 12a12 12 0 0 0-.24-2.42zm-1.51 2.32c-.15-.03-3.62-.78-7.14-.34a38.64 38.64 0 0 0-.9-2.01c4.04-1.66 5.69-4.03 5.7-4.06a10.2 10.2 0 0 1 2.34 6.4zm-3.48-7.6c-.03.05-1.49 2.27-5.35 3.72a52.06 52.06 0 0 0-3.83-5.98 10.23 10.23 0 0 1 9.18 2.27zM7.63 2.74a61.6 61.6 0 0 1 3.8 5.9A37.91 37.91 0 0 1 1.97 9.9c.67-3.18 2.8-5.8 5.66-7.16zM1.75 12l.01-.32c.18 0 5.25.11 10.52-1.46.3.57.58 1.15.83 1.74l-.4.12c-5.53 1.79-8.34 6.76-8.34 6.76A10.21 10.21 0 0 1 1.76 12zM12 22.25a10.2 10.2 0 0 1-6.53-2.35l.23.18s1.97-4.29 8.04-6.4l.07-.02a42.64 42.64 0 0 1 2.2 7.78 10.2 10.2 0 0 1-4.01.8zm5.73-1.75c-.1-.62-.65-3.63-2-7.32 3.31-.53 6.18.38 6.39.45a10.26 10.26 0 0 1-4.4 6.87z"
    }));
  },
  spotify: function spotify(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm4.87 17.66c-.2 0-.33-.06-.51-.18a12.03 12.03 0 0 0-6.2-1.6c-1.3 0-2.59.16-3.8.42-.19.04-.44.11-.59.11a.75.75 0 0 1-.75-.75c0-.5.29-.75.65-.82 1.48-.34 2.96-.53 4.49-.53 2.62 0 4.97.6 6.98 1.8.3.18.47.36.47.8 0 .43-.35.75-.74.75zm1.3-3.17c-.25 0-.42-.1-.6-.21a15.22 15.22 0 0 0-7.62-1.93c-1.51 0-2.83.21-3.91.5-.24.07-.37.14-.59.14a.94.94 0 0 1-.93-.95c0-.5.24-.86.74-1C6.61 10.67 8 10.4 10 10.4c3.15 0 6.18.78 8.57 2.2.4.24.55.53.55.96 0 .52-.41.94-.93.94zm1.5-3.7c-.25 0-.4-.06-.62-.18-2.18-1.3-5.55-2.02-8.8-2.02-1.63 0-3.29.16-4.8.57-.17.05-.4.14-.62.14-.64 0-1.13-.51-1.13-1.15 0-.65.4-1.02.84-1.15 1.71-.5 3.62-.74 5.7-.74 3.52 0 7.23.73 9.94 2.32.36.2.62.52.62 1.09 0 .65-.53 1.12-1.14 1.12z"
    }));
  },
  apple: function apple(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M16.46 5.79l.3.01a5.6 5.6 0 0 1 4.38 2.38c-.1.07-2.62 1.53-2.59 4.57.04 3.63 3.19 4.84 3.22 4.86-.02.08-.5 1.72-1.66 3.41-1 1.46-2.04 2.92-3.67 2.95-1.6.03-2.13-.96-3.96-.96-1.84 0-2.42.93-3.94.99-1.57.06-2.78-1.58-3.78-3.04-2.07-2.98-3.64-8.42-1.53-12.1a5.87 5.87 0 0 1 4.97-3c1.55-.03 3.01 1.04 3.96 1.04.95 0 2.73-1.29 4.6-1.1zM16.78 0a5.3 5.3 0 0 1-1.25 3.83 4.46 4.46 0 0 1-3.56 1.7 5.03 5.03 0 0 1 1.27-3.71A5.38 5.38 0 0 1 16.78 0z"
    }));
  },
  skype: function skype(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M23.31 14.55A11.37 11.37 0 0 0 10.17 1 6.67 6.67 0 0 0 0 6.55c0 1.2.33 2.33.91 3.3a11.37 11.37 0 0 0 13.31 13.37c.94.5 2 .78 3.14.78A6.6 6.6 0 0 0 24 17.45c0-1.04-.25-2.03-.69-2.9zM18 17.52a5.2 5.2 0 0 1-2.33 1.74c-1 .41-2.2.62-3.57.62a8.84 8.84 0 0 1-4.1-.85c-.77-.4-1.4-.96-1.89-1.65a3.56 3.56 0 0 1-.73-2.04c0-.4.16-.77.48-1.06.31-.3.71-.44 1.2-.44.39 0 .73.12 1 .34.27.23.49.55.67.97.2.46.43.85.66 1.15.23.3.55.54.96.73a4 4 0 0 0 1.66.3c.95 0 1.73-.2 2.3-.6.58-.38.86-.84.86-1.4 0-.45-.15-.8-.45-1.07a3.17 3.17 0 0 0-1.22-.67c-.52-.16-1.22-.33-2.1-.51a17 17 0 0 1-3-.89 4.95 4.95 0 0 1-1.96-1.42 3.5 3.5 0 0 1-.75-2.26c0-.85.27-1.62.78-2.28A4.83 4.83 0 0 1 8.7 4.7a9.84 9.84 0 0 1 3.36-.52c1.03 0 1.92.11 2.67.34.76.23 1.4.55 1.9.93.5.39.87.8 1.1 1.24.24.43.36.86.36 1.28 0 .4-.15.77-.46 1.1-.32.31-.71.48-1.18.48-.42 0-.76-.1-.99-.3a3.7 3.7 0 0 1-.68-.9 3.75 3.75 0 0 0-1.03-1.26c-.38-.29-1.02-.43-1.9-.43-.83 0-1.5.16-2 .48-.47.31-.7.66-.7 1.08 0 .26.07.47.23.66.16.2.4.37.68.51a5 5 0 0 0 .92.35c.32.1.85.22 1.58.39.93.2 1.78.41 2.54.65.76.24 1.42.54 1.95.88.55.35.99.8 1.3 1.34.3.55.46 1.22.46 2 0 .92-.27 1.77-.8 2.51z"
    }));
  },
  snapchat: function snapchat(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M12.15 23.5h-.3c-1.42 0-2.34-.66-3.22-1.3-.6-.44-1.18-.85-1.86-.97a5.9 5.9 0 0 0-.98-.08c-.57 0-1.02.1-1.35.16-.2.04-.38.07-.5.07-.15 0-.3-.03-.36-.25-.05-.2-.1-.39-.13-.57-.1-.47-.18-.76-.37-.8-2.26-.35-2.9-.84-3.04-1.18a.45.45 0 0 1-.04-.15c0-.13.08-.25.21-.27 3.47-.58 5.02-4.2 5.09-4.35v-.01c.22-.44.26-.82.13-1.14-.24-.57-1.02-.82-1.53-.99l-.34-.11c-1.02-.42-1.1-.84-1.07-1.06.07-.37.55-.62.94-.62.11 0 .2.02.28.05.47.22.88.34 1.24.34.5 0 .71-.22.74-.24l-.05-.75c-.1-1.68-.23-3.75.29-4.94A6.25 6.25 0 0 1 11.75.5h.49c.97 0 4.27.28 5.83 3.84.52 1.18.39 3.26.29 4.94v.07l-.05.68c.03.02.23.22.68.23.34 0 .73-.12 1.16-.33a.86.86 0 0 1 .36-.07c.15 0 .3.03.42.08.35.13.58.38.59.64 0 .25-.18.61-1.08.98l-.34.11c-.51.17-1.29.42-1.53 1-.13.3-.09.69.13 1.13.07.16 1.62 3.78 5.09 4.36.13.02.22.14.21.27 0 .05-.02.1-.04.15-.14.34-.78.83-3.04 1.18-.18.03-.26.28-.37.8a8.1 8.1 0 0 1-.13.56c-.05.16-.15.24-.32.24h-.03c-.12 0-.3-.02-.5-.06a6.6 6.6 0 0 0-2.34-.07c-.68.12-1.25.53-1.86.97-.88.64-1.8 1.3-3.22 1.3z"
    }));
  },
  hackernews: function hackernews(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 1C1.44772 1 1 1.44772 1 2V22C1 22.5523 1.44772 23 2 23H22C22.5523 23 23 22.5523 23 22V2C23 1.44772 22.5523 1 22 1H2ZM13.4053 19.1959V11.7421L17.7716 4.46785H14.7769C14.7769 4.46785 12.1347 9.13313 12.1167 9.15155H12.0673C12.0516 9.13313 9.47449 4.44943 9.47449 4.44943L6.23061 4.46555L10.5947 11.7421V19.1959H13.4053Z"
    }));
  },
  messenger: function messenger(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M12 0C5.37 0 0 4.97 0 11.11c0 3.5 1.74 6.62 4.47 8.65V24l4.09-2.24c1.09.3 2.24.46 3.44.46 6.63 0 12-4.97 12-11.1C24 4.96 18.63 0 12 0zm1.2 14.96l-3.06-3.26-5.97 3.26L10.73 8l3.13 3.26L19.76 8l-6.57 6.96z"
    }));
  },
  contacts: function contacts(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M20.15,4.04a.5.5,0,0,1-.4-.489V2a2,2,0,0,0-2-2H5.25a3,3,0,0,0-3,3V21a3,3,0,0,0,3,3h14.5a2,2,0,0,0,2-2V6A2,2,0,0,0,20.15,4.04Zm-9.739,11.8a4.981,4.981,0,0,1-1.13-3.511A2.881,2.881,0,0,1,12.25,9.273a2.881,2.881,0,0,1,2.969,3.053A5,5,0,0,1,14.07,15.86a.977.977,0,0,0,.027.7c2.061.736,3.2,1.274,3.652,2.151a5.282,5.282,0,0,1,.492,1.477.5.5,0,0,1-.106.41.5.5,0,0,1-.385.18h-11a.5.5,0,0,1-.385-.18.5.5,0,0,1-.106-.41,5.282,5.282,0,0,1,.492-1.477c.453-.877,1.591-1.415,3.667-2.159A1,1,0,0,0,10.411,15.837ZM5.25,2H17.5a.25.25,0,0,1,.25.25v1.5A.25.25,0,0,1,17.5,4H5.25a1,1,0,0,1,0-2Z"
    }));
  },
  layout: function layout(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("rect", {
      x: "3",
      y: "3",
      width: "18",
      height: "18",
      rx: "2"
    }), jsx("path", {
      d: "M3 9h18M9 21V9"
    }));
  },
  sidebar: function sidebar(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("rect", {
      x: "3",
      y: "3",
      width: "18",
      height: "18",
      rx: "2"
    }), jsx("path", {
      d: "M9 3v18"
    }));
  },
  play: function play(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("path", {
      d: "M2.338,3.255v17.49a1.5,1.5,0,0,0,2.209,1.322L20.87,13.322a1.5,1.5,0,0,0,0-2.644L4.547,1.933A1.5,1.5,0,0,0,2.338,3.255Z"
    }));
  },
  playBold: function playBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M19.4264 10.8397L5.50197 2.13583C5.34367 2.03745 5.16791 1.99118 4.99131 2.00139C4.81471 2.01159 4.64312 2.07795 4.49275 2.19417C4.34238 2.31039 4.21822 2.47264 4.132 2.66557C4.04577 2.8585 4.00034 3.07574 4 3.29674V20.7036C4.00027 20.9246 4.04567 21.1419 4.13189 21.3348C4.21812 21.5278 4.34231 21.69 4.49272 21.8062C4.64313 21.9223 4.81476 21.9886 4.99138 21.9987C5.16799 22.0087 5.34374 21.9622 5.50197 21.8637L19.4264 13.1606C19.5988 13.0529 19.7437 12.8872 19.845 12.6822C19.9463 12.4773 20 12.2411 20 12.0002C20 11.7592 19.9463 11.523 19.845 11.3181C19.7437 11.1131 19.5988 10.9475 19.4264 10.8397Z"
    }));
  },
  pause: function pause(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("rect", {
      x: "5.25",
      y: "3.75",
      width: "4.5",
      height: "16.5",
      rx: "1.5",
      ry: "1.5"
    }), jsx("rect", {
      x: "14.25",
      y: "3.75",
      width: "4.5",
      height: "16.5",
      rx: "1.5",
      ry: "1.5"
    }));
  },
  pauseBold: function pauseBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M8.42857 3H5.57143C4.97969 3 4.5 3.54947 4.5 4.22727V19.7727C4.5 20.4505 4.97969 21 5.57143 21H8.42857C9.02031 21 9.5 20.4505 9.5 19.7727V4.22727C9.5 3.54947 9.02031 3 8.42857 3Z"
    }), jsx("path", {
      d: "M18.4286 3H15.5714C14.9797 3 14.5 3.54947 14.5 4.22727V19.7727C14.5 20.4505 14.9797 21 15.5714 21H18.4286C19.0203 21 19.5 20.4505 19.5 19.7727V4.22727C19.5 3.54947 19.0203 3 18.4286 3Z"
    }));
  },
  stop: function stop(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24",
      fill: "none"
    }, sanitizeProps(p)), jsx("rect", {
      x: "3.75",
      y: "3.75",
      width: "16.5",
      height: "16.5",
      rx: "1.5",
      ry: "1.5"
    }));
  },
  stopBold: function stopBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M19.65 3H4.35C3.60442 3 3 3.60442 3 4.35V19.65C3 20.3956 3.60442 21 4.35 21H19.65C20.3956 21 21 20.3956 21 19.65V4.35C21 3.60442 20.3956 3 19.65 3Z"
    }));
  },
  musicBold: function musicBold(p) {
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M21.5,2.25A2.25,2.25,0,0,0,18.4.168L9.4,3.85A2.241,2.241,0,0,0,8,5.932V15.75a.25.25,0,0,1-.25.25H6.5a4,4,0,0,0,0,8,4.1,4.1,0,0,0,4-4V10.758a.248.248,0,0,1,.155-.231l8-3.273A.25.25,0,0,1,19,7.485v4.27a.25.25,0,0,1-.25.25H17.5a4,4,0,1,0,0,8,4.1,4.1,0,0,0,4-4Zm-10.655,5.5a.25.25,0,0,1-.234-.024.247.247,0,0,1-.111-.207V6.436a.5.5,0,0,1,.311-.463l7.5-3.069A.5.5,0,0,1,19,3.367v.876a.249.249,0,0,1-.155.231Z"
    }));
  },
  computer: function computer(p) {
    //bold
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5V18a1.5,1.5,0,0,0,1.5,1.5h9.25a.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25H7.5a1,1,0,0,0,0,2h9a1,1,0,0,0,0-2H13.25a.25.25,0,0,1-.25-.25v-2a.25.25,0,0,1,.25-.25H22.5A1.5,1.5,0,0,0,24,18V1.5A1.5,1.5,0,0,0,22.5,0ZM22,15a.5.5,0,0,1-.5.5H2.5A.5.5,0,0,1,2,15V2.5A.5.5,0,0,1,2.5,2h19a.5.5,0,0,1,.5.5Z"
    }));
  },
  laptop: function laptop(p) {
    //bold
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M3.5,14.734a1,1,0,0,0,1-1V5.418a.667.667,0,0,1,.667-.667H18.833a.667.667,0,0,1,.667.667v8.316a1,1,0,1,0,2,0V5.418a2.669,2.669,0,0,0-2.667-2.667H5.167A2.669,2.669,0,0,0,2.5,5.418v8.316A1,1,0,0,0,3.5,14.734Z"
    }), jsx("path", {
      d: "M23.894,16.443a.5.5,0,0,0-.394-.192h-8a.5.5,0,0,0-.5.5c0,.71-1.232,1.5-3,1.5s-3-.79-3-1.5a.5.5,0,0,0-.5-.5H.5a.5.5,0,0,0-.485.621,5.773,5.773,0,0,0,5.608,4.379H18.377a5.773,5.773,0,0,0,5.608-4.379A.5.5,0,0,0,23.894,16.443Z"
    }));
  },
  brain: function brain(p) {
    //bold
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M21.428,9.856a7.235,7.235,0,0,1-.721-1.45C20.707,3.145,15.845,0,11.143,0a9.925,9.925,0,0,0-10,10.063c0,3.5,1.271,6.124,3.779,7.813a.5.5,0,0,1,.221.415V23.5a.5.5,0,0,0,.5.5h10a.5.5,0,0,0,.5-.5v-3a.5.5,0,0,1,.5-.5h1.5a2.5,2.5,0,0,0,2.5-2.5V15.516a.5.5,0,0,1,.5-.5c.187,0,.378,0,.552-.01a1.245,1.245,0,0,0,.963-.52,1.222,1.222,0,0,0,.19-.743l0-.138C22.931,12.489,22.133,11.091,21.428,9.856Zm-7.052.131a.5.5,0,0,0-.448.189,3.521,3.521,0,0,1-2.379,1.3.5.5,0,0,0-.391.273A3.968,3.968,0,0,1,7.643,14a4.135,4.135,0,0,1-4-4.25A4.357,4.357,0,0,1,5.091,6.479a.5.5,0,0,0,.156-.263A3.492,3.492,0,0,1,8.643,3.5a3.351,3.351,0,0,1,.826.1.5.5,0,0,0,.49-.145,2.985,2.985,0,0,1,4.659.345.5.5,0,0,0,.358.215,3,3,0,0,1-.6,5.968Z"
    }));
  },
  brainAlt: function brainAlt(p) {
    //bold
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M23.064,9.715a.5.5,0,0,0-.673-.065l-1.452,1.093c-.012.009-.025.019-.037.03l-.039.027-1.656,1.247a.221.221,0,0,0-.088.189,1.31,1.31,0,0,1-.009.272,1.5,1.5,0,1,1-1.274-1.7,1.354,1.354,0,0,1,.265.067.214.214,0,0,0,.2-.031l.7-.524a.5.5,0,0,0,.1-.7l-.86-1.145a.5.5,0,0,0-.392-.2,1.4,1.4,0,0,1-.156-.012,1.5,1.5,0,1,1,1.7-1.274,1.537,1.537,0,0,1-.032.153.5.5,0,0,0,.082.432L20.3,8.72a.5.5,0,0,0,.7.1l1.257-.946a.5.5,0,0,0,.191-.312A3.173,3.173,0,0,0,22.5,7,3.5,3.5,0,0,0,19,3.5a.008.008,0,0,1-.009-.008A3.755,3.755,0,0,0,15.25,0a3.714,3.714,0,0,0-2.31.807.5.5,0,0,0-.19.393V10a.75.75,0,0,1-1.5,0V1.2a.5.5,0,0,0-.19-.393A3.714,3.714,0,0,0,8.75,0,3.755,3.755,0,0,0,5.009,3.492.008.008,0,0,1,5,3.5,3.5,3.5,0,0,0,1.5,7a3.173,3.173,0,0,0,.053.561.5.5,0,0,0,.191.312L3,8.82a.5.5,0,0,0,.7-.1L4.56,7.578a.5.5,0,0,0,.082-.433,1.479,1.479,0,0,1-.032-.153,1.5,1.5,0,1,1,1.7,1.274,1.4,1.4,0,0,1-.156.012.5.5,0,0,0-.392.2L4.9,9.623a.5.5,0,0,0,.1.7l.7.524a.217.217,0,0,0,.2.032,1.288,1.288,0,0,1,.265-.068,1.5,1.5,0,1,1-1.274,1.7,1.374,1.374,0,0,1-.01-.271.218.218,0,0,0-.088-.19L3.108,10.779l-.01-.006a.429.429,0,0,0-.035-.028L1.609,9.65a.5.5,0,0,0-.673.065A3.484,3.484,0,0,0,0,12a3.668,3.668,0,0,0,1.651,2.916.5.5,0,0,1,.171.623,3.475,3.475,0,0,0,1.942,4.718.5.5,0,0,0,.531-.114L5.97,18.469a.218.218,0,0,0,.059-.2A1.329,1.329,0,0,1,6,18a1.5,1.5,0,1,1,1.5,1.5,1.279,1.279,0,0,1-.271-.03.219.219,0,0,0-.2.06L5.411,21.149A.5.5,0,0,0,5.3,21.7a3.721,3.721,0,0,0,5.755,1.5.5.5,0,0,0,.191-.393V20.5a.75.75,0,0,1,1.5,0v2.3a.5.5,0,0,0,.191.393A3.721,3.721,0,0,0,18.7,21.7a.5.5,0,0,0-.107-.547L16.97,19.53a.222.222,0,0,0-.2-.06,1.279,1.279,0,0,1-.271.03A1.5,1.5,0,1,1,18,18a1.329,1.329,0,0,1-.029.27.218.218,0,0,0,.059.2L19.7,20.144a.5.5,0,0,0,.531.114,3.475,3.475,0,0,0,1.942-4.718.5.5,0,0,1,.171-.623A3.668,3.668,0,0,0,24,12,3.484,3.484,0,0,0,23.064,9.715Z"
    }));
  },
  vinyl: function vinyl(p) {
    //bold
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M10,10.75a2.75,2.75,0,1,0,2.75,2.75A2.752,2.752,0,0,0,10,10.75Zm0,4a1.25,1.25,0,1,1,1.25-1.25A1.252,1.252,0,0,1,10,14.75Z"
    }), jsx("path", {
      d: "M22.5,3a2.5,2.5,0,0,0-5,0V5a1.5,1.5,0,0,0,1.286,1.485A.249.249,0,0,1,19,6.732V12.02a.253.253,0,0,1-.064.168c-4.5,5-4.2,4.667-4.244,4.722a1,1,0,0,0,1.551,1.259h0l4.5-5A1,1,0,0,0,21,12.5V6.732a.249.249,0,0,1,.214-.247A1.5,1.5,0,0,0,22.5,5Z"
    }), jsx("path", {
      d: "M23.724,6.5a.224.224,0,0,0-.19.1,3.02,3.02,0,0,1-.919.923.25.25,0,0,0-.115.211V12.5a2.5,2.5,0,0,1-.642,1.673l-4.5,5a2.5,2.5,0,0,1-2.97.568.251.251,0,0,0-.25.015,7.5,7.5,0,1,1,2.874-8.916.252.252,0,0,0,.487-.091V7.738a.25.25,0,0,0-.115-.211A3,3,0,0,1,16,5V3.75a.25.25,0,0,0-.25-.25H1.5A1.5,1.5,0,0,0,0,5V22a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,22V6.776A.277.277,0,0,0,23.724,6.5Z"
    }));
  },
  starBold: function starBold(p) {
    //bold
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M23.555,8.729a1.505,1.505,0,0,0-1.406-.98H16.062a.5.5,0,0,1-.472-.334L13.405,1.222a1.5,1.5,0,0,0-2.81,0l-.005.016L8.41,7.415a.5.5,0,0,1-.471.334H1.85A1.5,1.5,0,0,0,.887,10.4l5.184,4.3a.5.5,0,0,1,.155.543L4.048,21.774a1.5,1.5,0,0,0,2.31,1.684l5.346-3.92a.5.5,0,0,1,.591,0l5.344,3.919a1.5,1.5,0,0,0,2.312-1.683l-2.178-6.535a.5.5,0,0,1,.155-.543l5.194-4.306A1.5,1.5,0,0,0,23.555,8.729Z"
    }));
  },
  airplane: function airplane(p) {
    //bold
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M6.088,6.323l3.9,1.614a.5.5,0,0,0,.391,0l4.152-1.807a.25.25,0,0,0,0-.46L9.243,3.485a1.006,1.006,0,0,0-.766,0l-2.388.991a1,1,0,0,0,0,1.847Z"
    }), jsx("path", {
      d: "M23.587,6.052A2.5,2.5,0,0,0,20.321,4.7l-.008,0L7.074,10.462a.5.5,0,0,1-.423-.012L4.275,9.262a1.012,1.012,0,0,0-.841-.024L.828,10.355a1,1,0,0,0-.315,1.627l3.745,3.745a1,1,0,0,0,1.078.221L10.953,13.7a.249.249,0,0,1,.327.319L9.324,19.238a1,1,0,0,0,1.383,1.246l2.71-1.355a1,1,0,0,0,.45-.448l3.749-7.5a.5.5,0,0,1,.273-.245l4.345-1.619a2.5,2.5,0,0,0,1.353-3.266Z"
    }));
  },
  coffee: function coffee(p) {
    //bold
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M22.941,18.982H1a1,1,0,0,0,0,2H22.941a1,1,0,1,0,0-2Z"
    }), jsx("path", {
      d: "M10.007,17.469a7.739,7.739,0,0,0,5.024-2.328.5.5,0,0,1,.355-.149h3.627a4.987,4.987,0,0,0,0-9.974H17.954a.5.5,0,0,1-.5-.5v-.5a1,1,0,0,0-1-1H2.493a1,1,0,0,0-1,1V9.506A7.981,7.981,0,0,0,10.007,17.469ZM19.013,7.013a2.992,2.992,0,0,1,0,5.984H17.334a.5.5,0,0,1-.464-.681,8.421,8.421,0,0,0,.585-3.083V7.511a.5.5,0,0,1,.5-.5Z"
    }));
  },
  coffeeAlt: function coffeeAlt(p) {
    //bold
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M7.273,6.685a1,1,0,1,0,1.41-1.409.768.768,0,0,1,0-1.083,2.762,2.762,0,0,0,0-3.9A1,1,0,0,0,7.273,1.7a.768.768,0,0,1,0,1.083A2.762,2.762,0,0,0,7.273,6.685Z"
    }), jsx("path", {
      d: "M11.294,6.187a1,1,0,0,0,1.412-1.41.588.588,0,0,1,0-.833,2.588,2.588,0,0,0,0-3.652A1,1,0,0,0,11.3,1.7a.591.591,0,0,1,0,.834A2.588,2.588,0,0,0,11.294,6.187Z"
    }), jsx("path", {
      d: "M15.317,6.685a1,1,0,0,0,1.41-1.409.768.768,0,0,1,0-1.083,2.762,2.762,0,0,0,0-3.9A1,1,0,1,0,15.317,1.7a.768.768,0,0,1,0,1.083A2.762,2.762,0,0,0,15.317,6.685Z"
    }), jsx("path", {
      d: "M19.321,15.02a.238.238,0,0,1-.1-.231,20.622,20.622,0,0,0,.257-3.207C19.476,9.31,16.262,7.6,12,7.6S4.524,9.31,4.524,11.582a20.622,20.622,0,0,0,.257,3.207.238.238,0,0,1-.1.231,4.355,4.355,0,0,0-2.148,3.5C2.531,21.592,6.69,24,12,24s9.469-2.408,9.469-5.482A4.355,4.355,0,0,0,19.321,15.02Zm-2.928,2.73a.981.981,0,0,1-.256.376A6.06,6.06,0,0,1,12,19.556a6.068,6.068,0,0,1-4.137-1.429.96.96,0,0,1-.253-.371,15.436,15.436,0,0,1-.79-2.811.252.252,0,0,1,.351-.274,12.181,12.181,0,0,0,4.829.9,12.182,12.182,0,0,0,4.819-.894.249.249,0,0,1,.349.27A15.279,15.279,0,0,1,16.393,17.75Zm.07-5.116a.6.6,0,0,1-.4-.072A6.832,6.832,0,0,0,12,11.541a6.861,6.861,0,0,0-4.049,1.012.656.656,0,0,1-.439.068c-.631-.344-.994-.722-.994-1.039,0-.793,2.186-1.993,5.482-1.993s5.482,1.2,5.482,1.993C17.482,11.9,17.109,12.287,16.463,12.634Z"
    }));
  },
  drink: function drink(p) {
    //bold
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M4.061,2.58a.5.5,0,0,0,.375.17H5.758a.5.5,0,0,0,.376-.829L4.9.51A1.5,1.5,0,0,0,3.77,0H1A1,1,0,0,0,1,2H3.55Z"
    }), jsx("path", {
      d: "M24,4.5a4.5,4.5,0,0,0-8.218-2.533.5.5,0,0,0,.412.783h1.319a.5.5,0,0,0,.329-.123A2.5,2.5,0,1,1,20.99,6.51a2.823,2.823,0,0,1-.42.62L19.3,8.567A.261.261,0,0,0,19.5,9,4.507,4.507,0,0,0,24,4.5Z"
    }), jsx("path", {
      d: "M16.543,23a1,1,0,0,0-1-1H12.5a.5.5,0,0,1-.5-.5V14.781a.5.5,0,0,1,.125-.33l7.334-8.323a1.184,1.184,0,0,0,.215-1.2,1,1,0,0,0-.92-.68H3.246a1,1,0,0,0-.92.68,1.184,1.184,0,0,0,.215,1.2h0l7.333,8.323a.5.5,0,0,1,.125.33V21.5a.5.5,0,0,1-.5.5H6.543a1,1,0,1,0,0,2h9A1,1,0,0,0,16.543,23ZM5.263,6.143a.184.184,0,0,1,.171-.129H16.566a.184.184,0,0,1,.171.129.215.215,0,0,1-.046.222L14.574,8.594a.5.5,0,0,1-.363.156H7.789a.5.5,0,0,1-.363-.156L5.309,6.365A.215.215,0,0,1,5.263,6.143Z"
    }));
  },
  paint: function paint(p) {
    //bold
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M23.06.872a3.071,3.071,0,0,0-4.564.345L8.571,14.228a.251.251,0,0,0,.086.375,5.136,5.136,0,0,1,2.406,2.452.25.25,0,0,0,.406.073L23.1,5.256A3.072,3.072,0,0,0,23.06.872Z"
    }), jsx("path", {
      d: "M7.876,15.877a3.649,3.649,0,0,0-4.824,1.836c-.192.426-.335.828-.468,1.2-.394,1.109-.574,1.616-1.578,1.874A1.338,1.338,0,0,0,.782,23.3a7.513,7.513,0,0,0,3.137.7,6.992,6.992,0,0,0,2.469-.447A5.945,5.945,0,0,0,9.711,20.7a3.649,3.649,0,0,0-1.835-4.824Z"
    }));
  },
  bucket: function bucket(p) {
    //bold
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M21.868,14.326a1,1,0,0,0-1.735,0C19.159,16.025,18,18.273,18,19.334a3,3,0,1,0,6,0C24,18.275,22.841,16.026,21.868,14.326Z"
    }), jsx("path", {
      d: "M18.544,10.72a.929.929,0,0,0-.313-1.044L10.645,2.09a1.539,1.539,0,0,0-2.121,0L6.6,4.011a.25.25,0,0,1-.22.07L2.172,3.338a1,1,0,1,0-.347,1.968l7.94,1.4a.25.25,0,0,1,.2.29l-.143.808a.25.25,0,0,1-.29.2L3.772,6.992a.249.249,0,0,0-.22.07L.731,9.883a2.5,2.5,0,0,0,0,3.536L5.4,18.09a2.5,2.5,0,0,0,3.535,0L15.231,11.8a2.313,2.313,0,0,1,1.353-.561h1A.932.932,0,0,0,18.544,10.72Z"
    }));
  },
  paintAlt: function paintAlt(p) {
    //bold
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M23.92,11.237A12.337,12.337,0,0,0,14.935.868,9.789,9.789,0,0,0,9.159.84a12.483,12.483,0,0,0-8.8,8.906A11.918,11.918,0,0,0,3.518,21.131a2.487,2.487,0,0,0,3.081.358,1.5,1.5,0,0,0,.256-2.334l-.809-.81a1,1,0,0,1,0-1.414,1.1,1.1,0,0,1,1.6-.189c1.41,1.409,5.62,5.656,5.622,5.657a3.985,3.985,0,0,0,2.815,1.183,3.751,3.751,0,0,0,1.928-.53A12.018,12.018,0,0,0,23.92,11.237Zm-9.443,7.626a2.506,2.506,0,0,1,0-3.537,2.562,2.562,0,0,1,3.535,0,2.5,2.5,0,1,1-3.535,3.537ZM14.245,7.2a2,2,0,0,1,2-2h0a2,2,0,1,1-2,2Zm3.7,6.01h0a1.5,1.5,0,1,1,2.121,0A1.5,1.5,0,0,1,17.942,13.205ZM11.649,4.72a2,2,0,1,1-2.827,0A2.048,2.048,0,0,1,11.649,4.72Z"
    }));
  },
  briefcase: function briefcase(p) {
    //bold
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M3,22.5H21a3,3,0,0,0,3-3V8.5a3,3,0,0,0-3-3H17.1a.25.25,0,0,1-.248-.219l-.144-1.153A3,3,0,0,0,13.734,1.5H10.266A3,3,0,0,0,7.289,4.128L7.145,5.281A.25.25,0,0,1,6.9,5.5H3a3,3,0,0,0-3,3v11A3,3,0,0,0,3,22.5ZM9.273,4.376a1,1,0,0,1,.993-.876h3.468a1,1,0,0,1,.993.876l.105.844a.25.25,0,0,1-.248.28H9.416a.25.25,0,0,1-.248-.28ZM5.25,11A.75.75,0,0,1,6,10.25H18a.75.75,0,0,1,.75.75v.5a.75.75,0,0,1-.75.75H6a.75.75,0,0,1-.75-.75Zm0,5.5A.75.75,0,0,1,6,15.75H18a.75.75,0,0,1,.75.75V17a.75.75,0,0,1-.75.75H6A.75.75,0,0,1,5.25,17Z"
    }));
  },
  wallet: function wallet(p) {
    //bold
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M24,3.805a3.5,3.5,0,0,0-3.5-3.5H3.5A3.487,3.487,0,0,0,1.007,1.351.477.477,0,0,0,.869,1.5,3.483,3.483,0,0,0,0,3.805v13a4.51,4.51,0,0,0,3.306,4.174L14.465,23.6a3.352,3.352,0,0,0,.771.092,2.725,2.725,0,0,0,1.716-.582A2.86,2.86,0,0,0,18,20.805v-2.5h0V11.112a4.262,4.262,0,0,0-3.119-4.1L4.056,4.027a.749.749,0,1,1,.4-1.445s3.149.87,3.5.966a.237.237,0,0,0,.065.009l12.478,0a.75.75,0,1,1,0,1.5H15.265a.25.25,0,0,0-.067.491l.086.023a5.725,5.725,0,0,1,2.9,1.893.254.254,0,0,0,.2.093H20.5a.75.75,0,0,1,0,1.5H19.462a.252.252,0,0,0-.2.1.248.248,0,0,0-.035.224,5.608,5.608,0,0,1,.281,1.73v6.943a.25.25,0,0,0,.25.25H20.5a3.5,3.5,0,0,0,3.5-3.5Zm-8.5,11.5a2,2,0,1,1-2-2A2,2,0,0,1,15.5,15.305Z"
    }));
  },
  newspaper: function newspaper(p) {
    //bold
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("rect", {
      x: "4.252",
      y: "4.5",
      width: "5.75",
      height: "7.25",
      rx: "1.25",
      ry: "1.25"
    }), jsx("path", {
      d: "M24,10a3,3,0,0,0-3-3H19V2.5a2,2,0,0,0-2-2H2a2,2,0,0,0-2,2V20a3.5,3.5,0,0,0,3.5,3.5h17A3.5,3.5,0,0,0,24,20ZM3.5,21.5A1.5,1.5,0,0,1,2,20V3a.5.5,0,0,1,.5-.5h14A.5.5,0,0,1,17,3V20a3.494,3.494,0,0,0,.11.874.5.5,0,0,1-.484.625ZM22,20a1.5,1.5,0,1,1-3,0V9.5a.5.5,0,0,1,.5-.5H21a1,1,0,0,1,1,1Z"
    }), jsx("path", {
      d: "M12.751,6.047h2a.75.75,0,0,1,.75.75v.5a.75.75,0,0,1-.75.75h-2A.749.749,0,0,1,12,7.3V6.8A.751.751,0,0,1,12.751,6.047Z"
    }), jsx("path", {
      d: "M12.751,10.047h2a.75.75,0,0,1,.75.75v.5a.75.75,0,0,1-.75.75h-2A.75.75,0,0,1,12,11.3v-.5A.751.751,0,0,1,12.751,10.047Z"
    }), jsx("path", {
      d: "M4.751,14.047h10a.75.75,0,0,1,.75.75v.5a.75.75,0,0,1-.75.75h-10A.75.75,0,0,1,4,15.3v-.5A.751.751,0,0,1,4.751,14.047Z"
    }), jsx("path", {
      d: "M4.75,18.047h7.5a.75.75,0,0,1,.75.75v.5a.75.75,0,0,1-.75.75h-7.5A.749.749,0,0,1,4,19.3v-.5A.75.75,0,0,1,4.75,18.047Z"
    }));
  },
  growth: function growth(p) {
    //bold
    return jsx("svg", _extends({
      viewBox: "0 0 24 24"
    }, sanitizeProps(p), {
      stroke: "none",
      fill: p.fillColor
    }), jsx("path", {
      d: "M1.25,20.75h3.5A.249.249,0,0,0,5,20.5V18.25a.5.5,0,0,0-.5-.5h-3a.5.5,0,0,0-.5.5V20.5A.249.249,0,0,0,1.25,20.75Z"
    }), jsx("path", {
      d: "M7.5,12.75a.5.5,0,0,0-.5.5V20.5a.249.249,0,0,0,.25.25h3.5A.249.249,0,0,0,11,20.5V13.25a.5.5,0,0,0-.5-.5Z"
    }), jsx("path", {
      d: "M13.5,14.75a.5.5,0,0,0-.5.5V20.5a.249.249,0,0,0,.25.25h3.5A.249.249,0,0,0,17,20.5V15.25a.5.5,0,0,0-.5-.5Z"
    }), jsx("path", {
      d: "M19.5,7.75a.5.5,0,0,0-.5.5V20.5a.249.249,0,0,0,.25.25h3.5A.249.249,0,0,0,23,20.5V8.25a.5.5,0,0,0-.5-.5Z"
    }), jsx("path", {
      d: "M1,23.75H23a1,1,0,0,0,0-2H1a1,1,0,0,0,0,2Z"
    }), jsx("path", {
      d: "M20.108,4.174a.252.252,0,0,1,.182.073l.856.857a.5.5,0,0,0,.354.146.489.489,0,0,0,.191-.038A.5.5,0,0,0,22,4.75v-4a.5.5,0,0,0-.5-.5h-4a.5.5,0,0,0-.354.854l1.021,1.021a.249.249,0,0,1,.007.346L14.96,5.956a.751.751,0,0,1-.786.2l-3.722-1.24A3.228,3.228,0,0,0,7.345,5.5L2.2,9.79a1.25,1.25,0,0,0,1.6,1.921L8.945,7.423a.755.755,0,0,1,.716-.134l3.722,1.24A3.253,3.253,0,0,0,16.8,7.653l3.134-3.4A.255.255,0,0,1,20.108,4.174Z"
    }));
  }
}; // prettier-ignore

var includeDefault = ["onClick", "className"];
/**
 * Filters the passed `props` leaving only the safe props to pass down the component,
 * removing the ones in `exclude`, adding the ones in `include`.
 * @param {*} props The props to filter.
 * @param {*} exclude Extra props to exclude.
 * @param {*} include Extra props to include.
 *
 * @example
 * ```
 * // this way the H2 will get onClick and other default props that we pick
 * <H2 {...defaultProps(props)} />
 * ```
 */

function defaultProps(props, exclude, include) {
  var propsToInclude = includeDefault.filter(function (prop) {
    return !exclude || !exclude.includes(prop);
  }) // remove props in exclude
  .concat(include || []); // add props in include

  var res = {};

  for (var propName in props) {
    if (propsToInclude.includes(propName)) {
      res[propName] = props[propName];
    }
  }

  return res;
}

var _templateObject$2 = taggedTemplateLiteral(["\n    ", "\n    color: ", ";\n    font-family: ", ";\n    ", "\n    ", "\n    margin: ", ";\n    line-height: ", ";\n    ", "\n    ", "\n  "], ["\n    ", "\n    color: ", ";\n    font-family: ", ";\n    ", "\n    ", "\n    margin: ", ";\n    line-height: ", ";\n    ", "\n    ", "\n  "]),
    _templateObject2$1 = taggedTemplateLiteral(["\n    color: ", ";\n    ", "\n    ", "\n    margin: ", ";\n    ", "\n  "], ["\n    color: ", ";\n    ", "\n    ", "\n    margin: ", ";\n    ", "\n  "]),
    _templateObject3$1 = taggedTemplateLiteral(["\n    ", "\n    ", "\n    ", "\n    text-align: ", ";\n    ", "\n    ", "\n    svg {\n      margin-right: 0.1em;\n    }\n    :first-child:not(style) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n      margin-top: 0;\n    }\n    :last-child:not(style) {\n      margin-bottom: 0;\n    }\n    a {\n      ", "\n    }\n    em {\n      color: ", ";\n      font-style: ", ";\n    }\n  "], ["\n    ", "\n    ", "\n    ", "\n    text-align: ", ";\n    ", "\n    ", "\n    svg {\n      margin-right: 0.1em;\n    }\n    :first-child:not(style) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n      margin-top: 0;\n    }\n    :last-child:not(style) {\n      margin-bottom: 0;\n    }\n    a {\n      ", "\n    }\n    em {\n      color: ", ";\n      font-style: ", ";\n    }\n  "]),
    _templateObject4 = taggedTemplateLiteral(["\n    ", "\n    ", "\n    ", "\n    text-align: ", ";\n    ", "\n    ", "\n    svg {\n      margin-right: 0.1em;\n    }\n    :first-child:not(style) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n      margin-top: 0;\n    }\n    :last-child:not(style) {\n      margin-bottom: 0;\n    }\n    a {\n      ", "\n    }\n  "], ["\n    ", "\n    ", "\n    ", "\n    text-align: ", ";\n    ", "\n    ", "\n    svg {\n      margin-right: 0.1em;\n    }\n    :first-child:not(style) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n      margin-top: 0;\n    }\n    :last-child:not(style) {\n      margin-bottom: 0;\n    }\n    a {\n      ", "\n    }\n  "]),
    _templateObject5 = taggedTemplateLiteral(["\n    ", "\n    ", "\n    ", "\n    text-align: ", ";\n    ", "\n    ", "\n\n    svg {\n      margin-right: 0.1em;\n    }\n    :first-child:not(style) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n      margin-top: 0;\n    }\n    :last-child:not(style) {\n      margin-bottom: 0;\n    }\n    a {\n      ", "\n    }\n  "], ["\n    ", "\n    ", "\n    ", "\n    text-align: ", ";\n    ", "\n    ", "\n\n    svg {\n      margin-right: 0.1em;\n    }\n    :first-child:not(style) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n      margin-top: 0;\n    }\n    :last-child:not(style) {\n      margin-bottom: 0;\n    }\n    a {\n      ", "\n    }\n  "]),
    _templateObject6 = taggedTemplateLiteral(["\n    ", "\n    ", "\n    ", "\n    text-align: ", ";\n    ", "\n    svg {\n      margin-right: 0.1em;\n    }\n    :first-child:not(style) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n      margin-top: 0;\n    }\n    :last-child:not(style) {\n      margin-bottom: 0;\n    }\n    a {\n      ", "\n    }\n  "], ["\n    ", "\n    ", "\n    ", "\n    text-align: ", ";\n    ", "\n    svg {\n      margin-right: 0.1em;\n    }\n    :first-child:not(style) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n      margin-top: 0;\n    }\n    :last-child:not(style) {\n      margin-bottom: 0;\n    }\n    a {\n      ", "\n    }\n  "]),
    _templateObject7 = taggedTemplateLiteral(["\n    ", "\n    ", "\n    ", "\n    text-align: ", ";\n    ", "\n\n    svg {\n      margin-right: 0.1em;\n    }\n    :first-child:not(style) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n      margin-top: 0;\n    }\n    :last-child:not(style) {\n      margin-bottom: 0;\n    }\n    a {\n      ", "\n    }\n  "], ["\n    ", "\n    ", "\n    ", "\n    text-align: ", ";\n    ", "\n\n    svg {\n      margin-right: 0.1em;\n    }\n    :first-child:not(style) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n      margin-top: 0;\n    }\n    :last-child:not(style) {\n      margin-bottom: 0;\n    }\n    a {\n      ", "\n    }\n  "]),
    _templateObject8 = taggedTemplateLiteral(["\n    ", "\n    ", "\n    display: inline-block;\n    ", "\n    text-align: ", ";\n    width: 100%;\n    ", "\n    svg {\n      margin-right: 0.1em;\n    }\n    :first-child:not(style) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n      margin-top: 0;\n    }\n    :last-child:not(style) {\n      margin-bottom: 0;\n    }\n    a {\n      ", "\n    }\n  "], ["\n    ", "\n    ", "\n    display: inline-block;\n    ", "\n    text-align: ", ";\n    width: 100%;\n    ", "\n    svg {\n      margin-right: 0.1em;\n    }\n    :first-child:not(style) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n      margin-top: 0;\n    }\n    :last-child:not(style) {\n      margin-bottom: 0;\n    }\n    a {\n      ", "\n    }\n  "]),
    _templateObject9 = taggedTemplateLiteral(["\n    ", "\n    flex: 0 999 auto;\n    width: auto;\n    overflow: hidden;\n    ", "\n    border-radius: ", ";\n    padding: 0.35em 0.8em;\n    text-align: ", ";\n    ", "\n    ", "\n    >div {\n      width: 100%;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n    }\n    span {\n      ", "\n    }\n  "], ["\n    ", "\n    flex: 0 999 auto;\n    width: auto;\n    overflow: hidden;\n    ", "\n    border-radius: ", ";\n    padding: 0.35em 0.8em;\n    text-align: ", ";\n    ", "\n    ", "\n    >div {\n      width: 100%;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n    }\n    span {\n      ", "\n    }\n  "]);

function createInlineLinksStyle(inlineLinksConfig) {
  var c = inlineLinksConfig;
  var borderColorTransparent = tinycolor(c.borderColor).setAlpha(c.borderColorAlpha).toString();
  return "\n    color: " + c.color + ";\n    text-decoration: " + c.textDecoration + ";\n    border-bottom: " + c.borderSize + " " + borderColorTransparent + ";\n    :hover {\n      border-bottom: " + c.borderSize + " " + c.borderColor + ";\n    }\n  ";
}

function typeStyle(elem, config, props) {
  var centerAt = props.centerAt,
      noWrap = props.noWrap;
  var f = config.fonts;
  return css(_templateObject$2, centerAt ? "@media (max-width: " + centerAt + ") {text-align: center !important;}" : "", f.colors[elem] || f.colors.normal || "inherit", f.faces[elem] || f.faces.normal || "inherit", getFontSize(elem, config), getFontWeight(elem, config), f.margins[elem] || f.margins.normal || "inherit", f.lineHeights[elem] || f.lineHeights.normal || "inherit", showHideCss(props), noWrap ? "\n            text-overflow: ellipsis;\n            overflow: hidden;\n            max-width: 100%;\n            white-space: nowrap;\n          " : "");
}

function makeSmallHeading(config) {
  var f = config.fonts;
  return css(_templateObject2$1, f.colors.smallHeading || f.colors.normal || "inherit", getFontSize("smallHeading", config), getFontWeight("smallHeading", config), f.margins.smallHeading || f.margins.normal || "inherit", f.smallHeading.uppercase ? "text-transform: uppercase;" : "");
}

var H1 = function H1(props) {
  var config = useConfig();
  var headingsAlign = config.appearance.headingsAlign;
  var _config$fonts$heading = config.fonts.headingsEmphasis,
      emFontStyle = _config$fonts$heading.emFontStyle,
      emColor = _config$fonts$heading.emColor;
  var children = props.children,
      _props$align = props.align,
      align = _props$align === undefined ? headingsAlign : _props$align,
      color = props.color,
      _props$noMargin = props.noMargin,
      noMargin = _props$noMargin === undefined ? false : _props$noMargin,
      vAlign = props.vAlign,
      small = props.small,
      externalCSS = props.CSS;
  var inlineLinksStyle = createInlineLinksStyle(config.inlineLinks);
  var flexAlign = getVAlign(vAlign);
  var flexJustify = getHAlign(align);

  var style = _extends({}, config.H1.style, props.style);

  var mainCSS = css(_templateObject3$1, typeStyle("H1", config, props), color ? "color: " + color + ";" : "", noMargin ? "margin-top: 0 !important; margin-bottom: 0 !important;" : "", align, small ? makeSmallHeading(config) : "", flexAlign ? "display: flex; align-items: " + flexAlign + "; justify-content: " + flexJustify + ";" : "", inlineLinksStyle, emColor, emFontStyle);
  return jsx("h1", _extends({
    style: style,
    css: [mainCSS, externalCSS]
  }, defaultProps(props)), children);
};

var H2 = function H2(props) {
  var config = useConfig();
  var headingsAlign = config.appearance.headingsAlign;
  var _config$fonts$heading2 = config.fonts.headingsEmphasis,
      emFontStyle = _config$fonts$heading2.emFontStyle,
      emColor = _config$fonts$heading2.emColor;
  var children = props.children,
      _props$align2 = props.align,
      align = _props$align2 === undefined ? headingsAlign : _props$align2,
      color = props.color,
      _props$noMargin2 = props.noMargin,
      noMargin = _props$noMargin2 === undefined ? false : _props$noMargin2,
      vAlign = props.vAlign,
      small = props.small,
      externalCSS = props.CSS;
  var inlineLinksStyle = createInlineLinksStyle(config.inlineLinks);
  var flexAlign = getVAlign(vAlign);
  var flexJustify = getHAlign(align);

  var style = _extends({}, config.H2.style, props.style);

  var mainCSS = css(_templateObject3$1, typeStyle("H2", config, props), color ? "color: " + color + ";" : "", noMargin ? "margin-top: 0 !important; margin-bottom: 0 !important;" : "", align, small ? makeSmallHeading(config) : "", flexAlign ? "display: flex; align-items: " + flexAlign + "; justify-content: " + flexJustify + ";" : "", inlineLinksStyle, emColor, emFontStyle);
  return jsx("h2", _extends({
    style: style,
    css: [mainCSS, externalCSS]
  }, defaultProps(props)), children);
};

var H3 = function H3(props) {
  var config = useConfig();
  var headingsAlign = config.appearance.headingsAlign;
  var children = props.children,
      _props$align3 = props.align,
      align = _props$align3 === undefined ? headingsAlign : _props$align3,
      color = props.color,
      _props$noMargin3 = props.noMargin,
      noMargin = _props$noMargin3 === undefined ? false : _props$noMargin3,
      vAlign = props.vAlign,
      small = props.small,
      externalCSS = props.CSS;
  var inlineLinksStyle = createInlineLinksStyle(config.inlineLinks);
  var flexAlign = getVAlign(vAlign);
  var flexJustify = getHAlign(align);

  var style = _extends({}, config.H3.style, props.style);

  var mainCSS = css(_templateObject4, typeStyle("H3", config, props), color ? "color: " + color + ";" : "", noMargin ? "margin-top: 0 !important; margin-bottom: 0 !important;" : "", align, small ? makeSmallHeading(config) : "", flexAlign ? "display: flex; align-items: " + flexAlign + "; justify-content: " + flexJustify + ";" : "", inlineLinksStyle);
  return jsx("h3", _extends({
    style: style,
    css: [mainCSS, externalCSS]
  }, defaultProps(props)), children);
};

var H4 = function H4(props) {
  var config = useConfig();
  var headingsAlign = config.appearance.headingsAlign;
  var children = props.children,
      _props$align4 = props.align,
      align = _props$align4 === undefined ? headingsAlign : _props$align4,
      color = props.color,
      _props$noMargin4 = props.noMargin,
      noMargin = _props$noMargin4 === undefined ? false : _props$noMargin4,
      vAlign = props.vAlign,
      small = props.small,
      externalCSS = props.CSS;
  var inlineLinksStyle = createInlineLinksStyle(config.inlineLinks);
  var flexAlign = getVAlign(vAlign);
  var flexJustify = getHAlign(align);

  var style = _extends({}, config.H4.style, props.style);

  var mainCSS = css(_templateObject5, typeStyle("H4", config, props), color ? "color: " + color + ";" : "", noMargin ? "margin-top: 0 !important; margin-bottom: 0 !important;" : "", align, small ? makeSmallHeading(config) : "", flexAlign ? "display: flex; align-items: " + flexAlign + "; justify-content: " + flexJustify + ";" : "", inlineLinksStyle);
  return jsx("h4", _extends({
    style: style,
    css: [mainCSS, externalCSS]
  }, defaultProps(props)), children);
};

var H5 = function H5(props) {
  var config = useConfig();
  var headingsAlign = config.appearance.headingsAlign;
  var children = props.children,
      _props$align5 = props.align,
      align = _props$align5 === undefined ? headingsAlign : _props$align5,
      color = props.color,
      _props$noMargin5 = props.noMargin,
      noMargin = _props$noMargin5 === undefined ? false : _props$noMargin5,
      vAlign = props.vAlign,
      small = props.small,
      externalCSS = props.CSS;
  var inlineLinksStyle = createInlineLinksStyle(config.inlineLinks);
  var flexAlign = getVAlign(vAlign);
  var flexJustify = getHAlign(align);

  var style = _extends({}, config.H5.style, props.style);

  var mainCSS = css(_templateObject5, typeStyle("H5", config, props), color ? "color: " + color + ";" : "", noMargin ? "margin-top: 0 !important; margin-bottom: 0 !important;" : "", align, small ? makeSmallHeading(config) : "", flexAlign ? "display: flex; align-items: " + flexAlign + "; justify-content: " + flexJustify + ";" : "", inlineLinksStyle);
  return jsx("h4", _extends({
    style: style,
    css: [mainCSS, externalCSS]
  }, defaultProps(props)), children);
};

var P1 = function P1(props) {
  var config = useConfig();
  var children = props.children,
      _props$align6 = props.align,
      align = _props$align6 === undefined ? "left" : _props$align6,
      color = props.color,
      _props$noMargin6 = props.noMargin,
      noMargin = _props$noMargin6 === undefined ? false : _props$noMargin6,
      vAlign = props.vAlign,
      externalCSS = props.CSS;
  var inlineLinksStyle = createInlineLinksStyle(config.inlineLinks);
  var flexAlign = getVAlign(vAlign);
  var flexJustify = getHAlign(align);

  var style = _extends({}, config.P1.style, props.style);

  var mainCSS = css(_templateObject6, typeStyle("P1", config, props), color ? "color: " + color + ";" : "", noMargin ? "margin-top: 0 !important; margin-bottom: 0 !important;" : "", align, flexAlign ? "display: flex; align-items: " + flexAlign + "; justify-content: " + flexJustify + ";" : "", inlineLinksStyle);
  return jsx("p", _extends({
    style: style,
    css: [mainCSS, externalCSS]
  }, defaultProps(props)), children);
};

var P2 = function P2(props) {
  var config = useConfig();
  var children = props.children,
      _props$align7 = props.align,
      align = _props$align7 === undefined ? "left" : _props$align7,
      color = props.color,
      _props$noMargin7 = props.noMargin,
      noMargin = _props$noMargin7 === undefined ? false : _props$noMargin7,
      vAlign = props.vAlign,
      externalCSS = props.CSS;
  var inlineLinksStyle = createInlineLinksStyle(config.inlineLinks);
  var flexAlign = getVAlign(vAlign);
  var flexJustify = getHAlign(align);

  var style = _extends({}, config.P2.style, props.style);

  var mainCSS = css(_templateObject7, typeStyle("P2", config, props), color ? "color: " + color + ";" : "", noMargin ? "margin-top: 0 !important; margin-bottom: 0 !important;" : "", align, flexAlign ? "display: flex; align-items: " + flexAlign + "; justify-content: " + flexJustify + ";" : "", inlineLinksStyle);
  return jsx("p", _extends({
    style: style,
    css: [mainCSS, externalCSS]
  }, defaultProps(props)), children);
};

var SmallText = function SmallText(props) {
  var config = useConfig();
  var inlineLinksStyle = createInlineLinksStyle(config.inlineLinks);
  var children = props.children,
      _props$align8 = props.align,
      align = _props$align8 === undefined ? "left" : _props$align8,
      color = props.color,
      _props$noMargin8 = props.noMargin,
      noMargin = _props$noMargin8 === undefined ? false : _props$noMargin8,
      vAlign = props.vAlign,
      externalCSS = props.CSS;
  var flexAlign = getVAlign(vAlign);
  var flexJustify = getHAlign(align);

  var style = _extends({}, config.SmallText.style, props.style);

  var mainCSS = css(_templateObject8, typeStyle("SmallText", config, props), color ? "color: " + color + ";" : "", noMargin ? "margin-top: 0 !important; margin-bottom: 0 !important;" : "", align, flexAlign ? "display: flex; align-items: " + flexAlign + "; justify-content: " + flexJustify + ";" : "", inlineLinksStyle);
  return jsx("span", _extends({
    style: style,
    css: [mainCSS, externalCSS]
  }, defaultProps(props)), children);
};

var Badge = function Badge(props) {
  var config = useConfig();
  var badgeRadius = config.appearance.badgeRadius;
  var configColor = config.badge.color;
  var children = props.children,
      _props$align9 = props.align,
      align = _props$align9 === undefined ? "left" : _props$align9,
      _props$type = props.type,
      type = _props$type === undefined ? "primary" : _props$type,
      _props$borderRadius = props.borderRadius,
      borderRadius = _props$borderRadius === undefined ? badgeRadius : _props$borderRadius,
      _props$color = props.color,
      color = _props$color === undefined ? configColor : _props$color,
      _props$margin = props.margin,
      iconName = props.iconName,
      externalCSS = props.CSS,
      noWrap = props.noWrap;
  var xs = config.sizes.xs;
  var colorTransparent = tinycolor(color).setAlpha(0.15).toString();

  var style = _extends({}, config.Badge.style, props.style);

  var mainCSS = css(_templateObject9, typeStyle("Badge", config, props), align === "center" ? "\n      margin: 0 auto;\n      text-align: center;\n      " : "", borderRadius, align, type === "primary" ? "color: white;\n      background-color: " + color + ";" : "", type === "secondary" ? "color: " + color + ";\n      background-color: " + colorTransparent + ";" : "", noWrap ? "\n      white-space: nowrap;\n      word-break: break-word;\n      text-overflow: ellipsis;\n      overflow: hidden;\n    " : "");
  return jsx("div", _extends({
    css: [mainCSS, externalCSS],
    style: style
  }, defaultProps(props)), jsx("div", null, jsx("span", null, children), iconName && jsx(Icon, {
    style: {
      marginLeft: ".3em"
    },
    name: iconName,
    size: "1.1em",
    color: color
  })));
};

var _templateObject$3 = taggedTemplateLiteral(["\n    border: ", ";\n    background: ", ";\n    border-radius: ", ";\n    display: block;\n    overflow-x: auto;\n    white-space: nowrap;\n    max-width: 100%;\n  "], ["\n    border: ", ";\n    background: ", ";\n    border-radius: ", ";\n    display: block;\n    overflow-x: auto;\n    white-space: nowrap;\n    max-width: 100%;\n  "]),
    _templateObject2$2 = taggedTemplateLiteral(["\n    /* border-collapse: collapse; */\n    border-spacing: 0;\n    margin: 0;\n    padding: 0;\n\n    overflow: hidden;\n    width: 100%;\n    max-width: 100%;\n\n    caption,\n    tbody,\n    tfoot,\n    thead,\n    tr,\n    th,\n    td {\n      text-align: left;\n      margin: 0;\n      border: 0;\n    }\n  "], ["\n    /* border-collapse: collapse; */\n    border-spacing: 0;\n    margin: 0;\n    padding: 0;\n\n    overflow: hidden;\n    width: 100%;\n    max-width: 100%;\n\n    caption,\n    tbody,\n    tfoot,\n    thead,\n    tr,\n    th,\n    td {\n      text-align: left;\n      margin: 0;\n      border: 0;\n    }\n  "]),
    _templateObject3$2 = taggedTemplateLiteral(["\n    height: ", ";\n    vertical-align: middle;\n\n    :not(:last-child) {\n      th,\n      td {\n        border-bottom: ", ";\n      }\n    }\n\n    ", "\n  "], ["\n    height: ", ";\n    vertical-align: middle;\n\n    :not(:last-child) {\n      th,\n      td {\n        border-bottom: ", ";\n      }\n    }\n\n    ", "\n  "]),
    _templateObject4$1 = taggedTemplateLiteral(["\n          background: ", ";\n        "], ["\n          background: ", ";\n        "]),
    _templateObject5$1 = taggedTemplateLiteral(["\n          :hover {\n            background: ", ";\n          }\n        "], ["\n          :hover {\n            background: ", ";\n          }\n        "]),
    _templateObject6$1 = taggedTemplateLiteral(["\n    padding: ", ";\n    ", "\n  "], ["\n    padding: ", ";\n    ", "\n  "]);

var Table = function Table(props) {
  var config = useConfig();
  var children = props.children,
      width = props.width,
      style = props.style,
      externalCSS = props.CSS;
  var _config$tables = config.tables,
      border = _config$tables.border,
      background = _config$tables.background,
      headerBackground = _config$tables.headerBackground,
      padding = _config$tables.padding,
      radius = _config$tables.radius;
  var wrapperCSS = css(_templateObject$3, border, background, radius);
  var mainCSS = css(_templateObject2$2);
  return jsx("div", {
    css: wrapperCSS,
    style: {
      width: width
    }
  }, jsx("table", _extends({
    style: _extends({}, style),
    css: [mainCSS, externalCSS]
  }, defaultProps(props)), jsx("tbody", null, children)));
};

var Tr = function Tr(props) {
  var config = useConfig();
  var children = props.children,
      header = props.header,
      style = props.style,
      externalCSS = props.CSS;
  var _config$tables2 = config.tables,
      border = _config$tables2.border,
      innerBorder = _config$tables2.innerBorder,
      background = _config$tables2.background,
      hoverBackground = _config$tables2.hoverBackground,
      alternateRowBackground = _config$tables2.alternateRowBackground,
      headerBackground = _config$tables2.headerBackground,
      padding = _config$tables2.padding,
      rowHeight = _config$tables2.rowHeight;
  var mainCSS = css(_templateObject3$2, rowHeight, innerBorder, header ? css(_templateObject4$1, headerBackground) : css(_templateObject5$1, hoverBackground));
  return jsx("tr", _extends({
    style: style,
    css: [mainCSS, externalCSS]
  }, defaultProps(props)), children);
};

var Th = function Th(props) {
  var config = useConfig();
  var children = props.children,
      width = props.width,
      align = props.align,
      color = props.color,
      style = props.style,
      externalCSS = props.CSS;
  var _config$tables3 = config.tables,
      border = _config$tables3.border,
      background = _config$tables3.background,
      headerBackground = _config$tables3.headerBackground,
      padding = _config$tables3.padding,
      rowHeight = _config$tables3.rowHeight,
      textComponentStyle = _config$tables3.textComponentStyle,
      headerStyle = _config$tables3.headerStyle;
  var mainCSS = css(_templateObject6$1, padding, typeStyle(textComponentStyle, config, props));
  return jsx("th", _extends({
    style: _extends({}, style, headerStyle, {
      width: width,
      textAlign: align,
      color: color
    }),
    css: [mainCSS, externalCSS]
  }, defaultProps(props)), children);
};

var Td = function Td(props) {
  var config = useConfig();
  var children = props.children,
      width = props.width,
      align = props.align,
      color = props.color,
      style = props.style,
      externalCSS = props.CSS;
  var _config$tables4 = config.tables,
      background = _config$tables4.background,
      headerBackground = _config$tables4.headerBackground,
      padding = _config$tables4.padding,
      rowHeight = _config$tables4.rowHeight,
      textComponentStyle = _config$tables4.textComponentStyle,
      rowStyle = _config$tables4.rowStyle;
  var mainCSS = css(_templateObject6$1, padding, typeStyle(textComponentStyle, config, props));
  return jsx("td", _extends({
    style: _extends({}, style, rowStyle, {
      width: width,
      textAlign: align,
      color: color
    }),
    css: [mainCSS, externalCSS]
  }, defaultProps(props)), children);
};

var _templateObject$4 = taggedTemplateLiteral(["\n    color: ", ";\n    text-decoration: ", ";\n    ", "\n  "], ["\n    color: ", ";\n    text-decoration: ", ";\n    ", "\n  "]),
    _templateObject2$3 = taggedTemplateLiteral(["\n          border-bottom: ", "px solid ", ";\n          :hover {\n            border-bottom: ", "px solid ", ";\n          }\n        "], ["\n          border-bottom: ", "px solid ", ";\n          :hover {\n            border-bottom: ", "px solid ", ";\n          }\n        "]),
    _templateObject3$3 = taggedTemplateLiteral(["\n        body {\n          background: ", ";\n          font-family: ", ";\n          margin: 0;\n          padding: 0;\n          -webkit-font-smoothing: ", ";\n          @media only screen and (max-width: ", ") {\n            font-size: ", ";\n          }\n        }\n        a {\n          ", "\n        }\n        ", "\n      "], ["\n        body {\n          background: ", ";\n          font-family: ", ";\n          margin: 0;\n          padding: 0;\n          -webkit-font-smoothing: ", ";\n          @media only screen and (max-width: ", ") {\n            font-size: ", ";\n          }\n        }\n        a {\n          ", "\n        }\n        ", "\n      "]);
/**
 * Component used to inject global styles.
 * It's appended at the end of the DOM by the UIContextProvider.
 * It needs to be injected as a component because it needs
 * to read the config, and be updated when it changes.
 */


var GlobalStyleInjector = function GlobalStyleInjector() {
  var config = useConfig();
  var inlineLinks = config.inlineLinks;
  var _inlineLinks$border = inlineLinks.border,
      showBorder = _inlineLinks$border.show,
      size = _inlineLinks$border.size,
      borderColor = _inlineLinks$border.color,
      borderColorAlpha = _inlineLinks$border.alpha;
  var _config$globals = config.globals,
      bodyBackground = _config$globals.bodyBackground,
      fontSmoothing = _config$globals.fontSmoothing,
      custom = _config$globals.custom;
  var normal = config.fonts.faces.normal;
  var _config$responsive = config.responsive,
      breakPoint = _config$responsive.breakPoint,
      fontSize = _config$responsive.fontSize;
  var borderColorTransparent = tinycolor(borderColor).setAlpha(borderColorAlpha).toString();
  var inlineLinkStyle = css(_templateObject$4, inlineLinks.color, inlineLinks.textDecoration, showBorder ? css(_templateObject2$3, size, borderColorTransparent, size, borderColorAlpha) : "");
  return jsx(Global, {
    styles: css(_templateObject3$3, bodyBackground, normal, fontSmoothing, breakPoint, fontSize, inlineLinkStyle, custom)
  });
};

function insertWithoutScoping(cache, serialized) {
  if (cache.inserted[serialized.name] === undefined) {
    return cache.insert('', serialized, cache.sheet, true);
  }
}

function merge$1(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var createEmotion = function createEmotion(options) {
  var cache = createCache(options); // $FlowFixMe

  cache.sheet.speedy = function (value) {
    if (process.env.NODE_ENV !== 'production' && this.ctr !== 0) {
      throw new Error('speedy must be changed before any rules are inserted');
    }

    this.isSpeedy = value;
  };

  cache.compat = true;

  var css = function css() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered, undefined);
    insertStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var keyframes = function keyframes() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var serialized = serializeStyles(args, cache.registered);
    var animation = "animation-" + serialized.name;
    insertWithoutScoping(cache, {
      name: serialized.name,
      styles: "@keyframes " + animation + "{" + serialized.styles + "}"
    });
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    var serialized = serializeStyles(args, cache.registered);
    insertWithoutScoping(cache, serialized);
  };

  var cx = function cx() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return merge$1(cache.registered, css, classnames$1(args));
  };

  return {
    css: css,
    cx: cx,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    hydrate: function hydrate(ids) {
      ids.forEach(function (key) {
        cache.inserted[key] = true;
      });
    },
    flush: function flush() {
      cache.registered = {};
      cache.inserted = {};
      cache.sheet.flush();
    },
    // $FlowFixMe
    sheet: cache.sheet,
    cache: cache,
    getRegisteredStyles: getRegisteredStyles.bind(null, cache.registered),
    merge: merge$1.bind(null, cache.registered, css)
  };
};

var classnames$1 = function classnames(args) {
  var cls = '';

  for (var i = 0; i < args.length; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

var _createEmotion = createEmotion(),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    merge$2 = _createEmotion.merge,
    getRegisteredStyles$1 = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes$1 = _createEmotion.keyframes,
    css$1 = _createEmotion.css,
    sheet = _createEmotion.sheet,
    cache = _createEmotion.cache;

var _templateObject$5 = taggedTemplateLiteral(["\n    100% {\n      transform: rotateZ(360deg);\n    }\n  "], ["\n    100% {\n      transform: rotateZ(360deg);\n    }\n  "]),
    _templateObject2$4 = taggedTemplateLiteral(["\n    ", "\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", "px;\n    border: ", "px solid ", ";\n    border-color: ", " ", " ", " ", ";\n    animation: ", " ", " infinite linear;\n    box-sizing: border-box;\n  "], ["\n    ", "\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", "px;\n    border: ", "px solid ", ";\n    border-color: ", " ", " ", " ", ";\n    animation: ", " ", " infinite linear;\n    box-sizing: border-box;\n  "]),
    _templateObject3$4 = taggedTemplateLiteral(["\n            position: absolute;\n            top: calc(50% - ", "px);\n            left: calc(50% - ", "px);\n            margin: 0;\n            padding: 0;\n          "], ["\n            position: absolute;\n            top: calc(50% - ", "px);\n            left: calc(50% - ", "px);\n            margin: 0;\n            padding: 0;\n          "]);

var Spinner = function Spinner(props) {
  var config = useConfig();
  var _config$spinner = config.spinner,
      configSize = _config$spinner.size,
      configColor = _config$spinner.color,
      configStroke = _config$spinner.stroke,
      rotation = _config$spinner.rotation;
  var _props$center = props.center,
      center = _props$center === undefined ? false : _props$center,
      _props$size = props.size,
      size = _props$size === undefined ? configSize : _props$size,
      _props$color = props.color,
      color = _props$color === undefined ? configColor : _props$color,
      _props$stroke = props.stroke,
      stroke = _props$stroke === undefined ? configStroke : _props$stroke,
      style = props.style,
      _props$show = props.show,
      show = _props$show === undefined ? false : _props$show;
  var color2 = tinycolor(color).setAlpha(0.2).toString();
  var rotate = keyframes(_templateObject$5);
  var mainCSS = css(_templateObject2$4, center ? css(_templateObject3$4, parseInt(size) / 2, parseInt(size) / 2) : "", size, size, size, stroke, color, color, color, color2, color2, rotate, rotation);

  if (show) {
    return jsx("div", {
      style: style
    }, jsx("div", {
      css: mainCSS
    }));
  } else {
    return null;
  }
};

var _templateObject$6 = taggedTemplateLiteral(["\n    display: ", ";\n    ", "\n    min-width: 0;\n    /* max-width: 100%; */\n    align-items: ", ";\n    justify-content: ", ";\n    flex-flow: row ", ";\n    ", "\n    > *, > h1, > h2, > h3, > h4, > p, > div {\n      ", "\n      margin: 0 ", ";\n      :first-child /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n        margin-left: 0;\n      }\n      :last-child {\n        margin-right: 0;\n      }\n      :only-child {\n        margin-left: 0;\n        margin-right: 0;\n      }\n    }\n\n    @media (max-width: ", ") {\n      flex-direction: column;\n      align-items: ", " !important;\n      ", "\n      > *, > h1, > h2, > h3, > h4, > p, > div {\n         margin: ", " 0;\n        :first-child /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n          margin-top: 0;\n        }\n        :last-child {\n          margin-bottom: 0;\n        }\n        :only-child {\n          margin-top: 0;\n          margin-bottom: 0;\n        }\n      }\n    }\n\n    > h1, > h2, > h3, > h4, > p {\n      ", "\n      margin-top: 0;\n      margin-bottom: 0;\n    }\n  "], ["\n    display: ", ";\n    ", "\n    min-width: 0;\n    /* max-width: 100%; */\n    align-items: ", ";\n    justify-content: ", ";\n    flex-flow: row ", ";\n    ", "\n    > *, > h1, > h2, > h3, > h4, > p, > div {\n      ", "\n      margin: 0 ", ";\n      :first-child /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n        margin-left: 0;\n      }\n      :last-child {\n        margin-right: 0;\n      }\n      :only-child {\n        margin-left: 0;\n        margin-right: 0;\n      }\n    }\n\n    @media (max-width: ", ") {\n      flex-direction: column;\n      align-items: ", " !important;\n      ", "\n      > *, > h1, > h2, > h3, > h4, > p, > div {\n         margin: ", " 0;\n        :first-child /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n          margin-top: 0;\n        }\n        :last-child {\n          margin-bottom: 0;\n        }\n        :only-child {\n          margin-top: 0;\n          margin-bottom: 0;\n        }\n      }\n    }\n\n    > h1, > h2, > h3, > h4, > p {\n      ", "\n      margin-top: 0;\n      margin-bottom: 0;\n    }\n  "]),
    _templateObject2$5 = taggedTemplateLiteral(["\n              white-space: nowrap;\n              text-overflow: ellipsis;\n              overflow: hidden;\n            "], ["\n              white-space: nowrap;\n              text-overflow: ellipsis;\n              overflow: hidden;\n            "]);

var HStack = function HStack(props) {
  var config = useConfig();
  var stackGap = config.layout.stackGap;
  var children = props.children,
      _props$center = props.center,
      center = _props$center === undefined ? false : _props$center,
      _props$align = props.align,
      align = _props$align === undefined ? "left" : _props$align,
      _props$vAlign = props.vAlign,
      vAlign = _props$vAlign === undefined ? "center" : _props$vAlign,
      _props$inline = props.inline,
      inline = _props$inline === undefined ? false : _props$inline,
      _props$noWrap = props.noWrap,
      noWrap = _props$noWrap === undefined ? false : _props$noWrap,
      _props$softNoWrap = props.softNoWrap,
      softNoWrap = _props$softNoWrap === undefined ? false : _props$softNoWrap,
      _props$breakAt = props.breakAt,
      breakAt = _props$breakAt === undefined ? "0px" : _props$breakAt,
      _props$breakAlign = props.breakAlign,
      breakAlign = _props$breakAlign === undefined ? "center" : _props$breakAlign,
      width = props.width,
      maxWidth = props.maxWidth,
      _props$id = props.id,
      id = _props$id === undefined ? "stack" : _props$id,
      providedGap = props.gap,
      externalCSS = props.CSS;
  var flexAlign = center ? "center" : getVAlign(vAlign);
  var justifyContent = center ? "center" : getHAlign(align);
  var flexWrap = noWrap || softNoWrap ? "nowrap" : "wrap";

  var gap = function () {
    return providedGap !== undefined ? providedGap : stackGap;
  }();

  var style = _extends({}, config.HStack.style, props.style);

  var mainCSS = css(_templateObject$6, !inline ? "flex" : "inline-flex", maxWidth || width ? "\n      width: " + (width || "unset") + ";\n      max-width: " + (maxWidth || "unset") + ";\n    " : "", flexAlign, justifyContent, flexWrap, showHideCss(props), align === "stretch" ? "flex-grow: 1;" : "", gap, breakAt, breakAlign, breakAlign === "center" ? "text-align: center;" : "", gap, noWrap ? css(_templateObject2$5) : "");
  return jsx("div", _extends({
    style: style,
    id: id,
    css: [mainCSS, externalCSS]
  }, defaultProps(props)), children);
};

var _templateObject$7 = taggedTemplateLiteral(["\n    position: fixed;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    display: flex;\n    z-index: 99;\n    align-items: flex-end;\n    justify-content: ", ";\n    pointer-events: none;\n    ", "\n    transition: .4s ", ";\n    transform: translateY(", ");\n    opacity: ", ";\n  "], ["\n    position: fixed;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    display: flex;\n    z-index: 99;\n    align-items: flex-end;\n    justify-content: ", ";\n    pointer-events: none;\n    ", "\n    transition: .4s ", ";\n    transform: translateY(", ");\n    opacity: ", ";\n  "]),
    _templateObject2$6 = taggedTemplateLiteral(["\n    max-width: 100%;\n    pointer-events: ", ";\n    background: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n    padding-left: ", ";\n    padding-right: ", ";\n    border-radius: ", ";\n    box-shadow: ", ";\n    ", ";\n  "], ["\n    max-width: 100%;\n    pointer-events: ", ";\n    background: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n    padding-left: ", ";\n    padding-right: ", ";\n    border-radius: ", ";\n    box-shadow: ", ";\n    ", ";\n  "]);

var Notification = function Notification(props) {
  var config = useConfig();
  var _config$notification = config.notification,
      sideConfig = _config$notification.side,
      colorConfig = _config$notification.color,
      backgroundConfig = _config$notification.background,
      closeColor = _config$notification.closeColor,
      shadow = _config$notification.shadow,
      horizontalPadding = _config$notification.horizontalPadding,
      verticalPadding = _config$notification.verticalPadding,
      margin = _config$notification.margin,
      gap = _config$notification.gap,
      radius = _config$notification.radius,
      spinnerSize = _config$notification.spinnerSize,
      spinnerStroke = _config$notification.spinnerStroke,
      iconSize = _config$notification.iconSize,
      actionColor = _config$notification.actionColor;
  var _config$animations = config.animations,
      animationCurveIn = _config$animations.animationCurveIn,
      animationCurveOut = _config$animations.animationCurveOut;
  var _props$show = props.show,
      show = _props$show === undefined ? true : _props$show,
      _props$side = props.side,
      side = _props$side === undefined ? sideConfig : _props$side,
      loading = props.loading,
      text = props.text,
      children = props.children,
      small = props.small,
      icon = props.icon,
      _props$background = props.background,
      background = _props$background === undefined ? backgroundConfig : _props$background,
      _props$color = props.color,
      color = _props$color === undefined ? colorConfig : _props$color,
      maxWidth = props.maxWidth,
      actionLabel = props.actionLabel,
      onActionClick = props.onActionClick,
      onCloseClick = props.onCloseClick,
      _props$noWrap = props.noWrap,
      noWrap = _props$noWrap === undefined ? true : _props$noWrap;
  var translate = show ? "0" : "20em";
  var animationCurve = show ? animationCurveIn : animationCurveOut;

  var justify = function () {
    if (side === "left") return "flex-start";
    if (side === "right") return "flex-end";
    if (side === "center") return "center";
  }();

  var wrapperCSS = css$1(_templateObject$7, justify, responsive("padding", margin), animationCurve, translate, show ? 1 : 0);
  var notificationCSS = css$1(_templateObject2$6, show ? "auto" : "none", background, verticalPadding, verticalPadding, horizontalPadding, horizontalPadding, radius, shadow, maxWidth ? "max-width: " + maxWidth + ";" : "");
  var window = useWindow();
  var TextComponent = small ? P2 : P1;
  return window && ReactDOM.createPortal(React.createElement("div", {
    className: wrapperCSS
  }, React.createElement("div", {
    className: notificationCSS,
    background: background
  }, React.createElement(HStack, {
    gap: gap,
    noWrap: noWrap,
    softNoWrap: !noWrap
  }, React.createElement(Spinner, {
    size: spinnerSize,
    stroke: spinnerStroke,
    color: color,
    show: loading
  }), icon && React.createElement(Icon, {
    size: iconSize,
    color: color,
    name: icon
  }), (text || children) && React.createElement(TextComponent, {
    noMargin: true,
    color: color
  }, text || children), actionLabel && React.createElement(TextComponent, {
    noMargin: true,
    color: actionColor,
    style: {
      cursor: "pointer",
      fontWeight: 600
    },
    onClick: function onClick() {
      return onActionClick();
    }
  }, actionLabel), !loading && React.createElement(Icon, {
    size: iconSize,
    onClick: onCloseClick,
    color: closeColor,
    name: "closeBold"
  })))), document.querySelector("body"));
};

var UIContextProvider = function UIContextProvider(props) {
  var configOverrides = props.configOverrides,
      children = props.children,
      notification = props.notification;
  var configSetup = useConfigSetup(configOverrides);

  var _useNotificationSetup = useNotificationSetup(),
      notif = _useNotificationSetup.notif,
      notificationProps = _useNotificationSetup.props;

  globals.notif = notif;
  return React.createElement(UIContext.Provider, {
    value: configSetup
  }, React.createElement(NotificationContext.Provider, {
    value: notif
  }, typeof children === "function" ? children(configSetup) : children, React.createElement(GlobalStyleInjector, null), notification && React.createElement(Notification, notificationProps)));
};

var _templateObject$8 = taggedTemplateLiteral(["\n    position: relative;\n    background: ", ";\n    box-sizing: border-box;\n    box-shadow: ", ";\n    padding: ", ";\n    border-radius: ", ";\n    border: ", ";\n    min-height: ", ";\n    min-width: ", ";\n    max-width: ", ";\n    width: ", ";\n    display: flex;\n    flex-direction: column;\n    ", "\n    ", "\n    ", "\n  "], ["\n    position: relative;\n    background: ", ";\n    box-sizing: border-box;\n    box-shadow: ", ";\n    padding: ", ";\n    border-radius: ", ";\n    border: ", ";\n    min-height: ", ";\n    min-width: ", ";\n    max-width: ", ";\n    width: ", ";\n    display: flex;\n    flex-direction: column;\n    ", "\n    ", "\n    ", "\n  "]),
    _templateObject2$7 = taggedTemplateLiteral(["\n        align-items: ", ";\n        justify-content: ", ";\n      "], ["\n        align-items: ", ";\n        justify-content: ", ";\n      "]),
    _templateObject3$5 = taggedTemplateLiteral(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: ", ";\n    opacity: ", ";\n    transition: opacity 0.2s;\n    border-radius: ", ";\n    pointer-events: ", ";\n  "], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: ", ";\n    opacity: ", ";\n    transition: opacity 0.2s;\n    border-radius: ", ";\n    pointer-events: ", ";\n  "]);

var Card = function Card(props) {
  var config = useConfig();
  var _config$appearance = config.appearance,
      bigRadius = _config$appearance.bigRadius,
      smallRadius = _config$appearance.smallRadius;
  var _config$effects = config.effects,
      bigShadow = _config$effects.bigShadow,
      smallShadow = _config$effects.smallShadow;
  var _config$cards = config.cards,
      configBackground = _config$cards.background,
      cardBorder = _config$cards.border,
      bigPadding = _config$cards.bigPadding,
      smallPadding = _config$cards.smallPadding;
  var inline = props.inline,
      children = props.children,
      _props$border = props.border,
      border = _props$border === undefined ? cardBorder : _props$border,
      _props$minHeight = props.minHeight,
      minHeight = _props$minHeight === undefined ? "0" : _props$minHeight,
      _props$width = props.width,
      width = _props$width === undefined ? "auto" : _props$width,
      _props$minWidth = props.minWidth,
      minWidth = _props$minWidth === undefined ? "0em" : _props$minWidth,
      _props$maxWidth = props.maxWidth,
      maxWidth = _props$maxWidth === undefined ? "100%" : _props$maxWidth,
      _props$background = props.background,
      background = _props$background === undefined ? configBackground : _props$background,
      _props$noShadow = props.noShadow,
      noShadow = _props$noShadow === undefined ? false : _props$noShadow,
      id = props.id,
      _props$loading = props.loading,
      loading = _props$loading === undefined ? false : _props$loading,
      _props$center = props.center,
      center = _props$center === undefined ? false : _props$center,
      providedAlign = props.align,
      providedVAlign = props.vAlign,
      fullScreenAt = props.fullScreenAt,
      externalCSS = props.CSS;
  var radius = inline ? smallRadius : bigRadius;
  var shadow = inline ? smallShadow : bigShadow;
  var padding = inline ? smallPadding : bigPadding;
  var align = center ? "center" : getHAlign(providedAlign);
  var vAlign = center ? "center" : getHAlign(providedVAlign);

  var style = _extends({}, config.Card.style, props.style);

  var mainCSS = css(_templateObject$8, background, !noShadow ? shadow : "", padding, radius, border, minHeight, minWidth, maxWidth, width, showHideCss(props), (align || vAlign) && css(_templateObject2$7, align, vAlign), fullScreenAt ? "\n      @media (max-width: " + fullScreenAt + ") {\n        border-radius: 0;\n        border: none;\n        padding: " + smallPadding + ";\n        min-height: 100% !important;\n        min-width: 100% !important;\n      }\n    " : "");
  var loadingCSS = css(_templateObject3$5, background, loading ? 0.8 : 0, bigRadius, loading ? "auto" : "none");
  return jsx("div", _extends({
    id: id,
    css: [mainCSS, externalCSS]
  }, defaultProps(props), {
    style: style
  }), children, jsx("div", {
    css: loadingCSS
  }), jsx(Spinner, {
    center: true,
    show: loading
  }));
};

var _templateObject$9 = taggedTemplateLiteral(["\n    background: ", ";\n    width: ", ";\n    height: ", ";\n    border-radius: ", ";\n    display: flex;\n    ", "\n    ", "\n    svg {\n      margin: auto;\n      width: ", ";\n      height: ", ";\n    }\n  "], ["\n    background: ", ";\n    width: ", ";\n    height: ", ";\n    border-radius: ", ";\n    display: flex;\n    ", "\n    ", "\n    svg {\n      margin: auto;\n      width: ", ";\n      height: ", ";\n    }\n  "]);

var IconBadge = function IconBadge(props) {
  var config = useConfig();
  var _config$iconBadge = config.iconBadge,
      bgAlphaConfig = _config$iconBadge.backgroundAlpha,
      iconSize = _config$iconBadge.iconSize,
      sizeConfig = _config$iconBadge.size,
      colorConfig = _config$iconBadge.color;
  var name = props.name,
      _props$color = props.color,
      color = _props$color === undefined ? colorConfig : _props$color,
      onClick = props.onClick,
      _props$backgroundAlph = props.backgroundAlpha,
      backgroundAlpha = _props$backgroundAlph === undefined ? bgAlphaConfig : _props$backgroundAlph,
      _props$size = props.size,
      size = _props$size === undefined ? sizeConfig : _props$size,
      externalCSS = props.CSS,
      style = props.style;
  var bgColor = tinycolor(color).setAlpha(backgroundAlpha).toString();
  var wrapperCSS = css(_templateObject$9, bgColor, size, size, size, onClick ? "cursor: pointer;" : "", showHideCss(props), iconSize, iconSize);
  return jsx("div", {
    css: [wrapperCSS, externalCSS],
    style: style,
    onClick: onClick
  }, jsx(Icon, {
    color: color,
    name: name,
    size: iconSize
  }));
};

var _templateObject$a = taggedTemplateLiteral(["\n    width: 100%;\n    height: ", ";\n    flex: 0 0 auto;\n    ", "\n  "], ["\n    width: 100%;\n    height: ", ";\n    flex: 0 0 auto;\n    ", "\n  "]);

var Spacer = function Spacer(props) {
  var _props$size = props.size,
      providedSize = _props$size === undefined ? "l" : _props$size,
      id = props.id;
  var config = useConfig();
  var size = config.sizes[providedSize];

  if (typeof size === "undefined") {
    if (process.env.NODE_ENV === "development") {
      throw new Error("Size \"" + providedSize + "\" is not valid for Spacer.");
    }
  }

  var style = _extends({}, config.Card.style, props.style);

  var mainCSS = css(_templateObject$a, size, showHideCss(props));
  return jsx("div", {
    style: style,
    id: id,
    css: mainCSS
  });
};

var Callout = function Callout(props) {
  var config = useConfig();
  var title = props.title,
      body = props.body,
      icon = props.icon,
      _props$iconSize = props.iconSize,
      iconSize = _props$iconSize === undefined ? "1.8em" : _props$iconSize,
      _props$color = props.color,
      color = _props$color === undefined ? config.colors.c3 : _props$color,
      _props$maxWidth = props.maxWidth,
      maxWidth = _props$maxWidth === undefined ? "unset" : _props$maxWidth,
      _props$breakAt = props.breakAt;
  var bgColor = tinycolor(color).setAlpha(0.08).toString();
  var borderColor = tinycolor(color).setAlpha(0.25).toString();
  var bodyColor = tinycolor(color).setAlpha(0.85).toString();
  return React.createElement(Card, {
    inline: true,
    background: bgColor,
    style: {
      border: "1px solid " + borderColor,
      borderLeft: "4px solid " + color
    },
    noShadow: true,
    maxWidth: maxWidth
  }, React.createElement(HStack, {
    gap: "0.3em"
  }, icon && React.createElement(IconBadge, {
    name: icon,
    color: bodyColor,
    size: iconSize,
    strokeWidth: "1.5px"
  }), title && React.createElement(P1, {
    noMargin: true,
    style: {
      fontWeight: 700
    },
    color: color
  }, title)), React.createElement(Spacer, {
    size: "xxs"
  }), body && React.createElement(P2, {
    noMargin: true,
    color: bodyColor
  }, body));
};
/**
 * Returns the value that `value` hold at the previous render.
 *
 * @example
 * ```
 * const prevShow = usePreviousValue(show);
 *
 * if (!prevShow && show) {
 *    // show transitioned from false to true
 * }
 * ```
 */


function usePreviousValue(value) {
  var _useState = useState(undefined),
      _useState2 = slicedToArray(_useState, 2),
      previousValue = _useState2[0],
      setPreviousValue = _useState2[1];

  var _useState3 = useState(value),
      _useState4 = slicedToArray(_useState3, 2),
      currentValue = _useState4[0],
      setCurrentValue = _useState4[1];

  useEffect(function () {
    setPreviousValue(currentValue);
    setCurrentValue(value);
  }, [currentValue, value]);
  return previousValue;
}
/**
 * Use this when you want to create a delay between
 * mounting a component and changing its visibility
 * through a show prop.
 */


function useMountAnimation(show, delay) {
  var _useState = useState(show),
      _useState2 = slicedToArray(_useState, 2),
      mount = _useState2[0],
      setMount = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = slicedToArray(_useState3, 2),
      visible = _useState4[0],
      setVisible = _useState4[1];

  var prevShow = usePreviousValue(show);
  useEffect(function () {
    if (show) {
      setMount(true);
      setTimeout(function () {
        setVisible(true);
      }, 50);
    } // when hiding


    if (prevShow && !show) {
      setVisible(false);
      setTimeout(function () {
        setMount(false);
      }, delay || 500);
    }
  }, [delay, prevShow, show]);
  return [mount, visible];
}

var _templateObject$b = taggedTemplateLiteral(["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 10;\n    display: flex;\n    overflow: scroll;\n    -webkit-overflow-scrolling: touch;\n    /* align-items: center;\n    justify-content: center; */\n    transition: opacity ", " ", ";\n    will-change: opacity;\n    ", "\n    box-sizing: border-box;\n    > div:first-child:not(style) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n      transition: transform ", " ", ";\n    }\n    ", "\n    ", "\n  "], ["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 10;\n    display: flex;\n    overflow: scroll;\n    -webkit-overflow-scrolling: touch;\n    /* align-items: center;\n    justify-content: center; */\n    transition: opacity ", " ", ";\n    will-change: opacity;\n    ", "\n    box-sizing: border-box;\n    > div:first-child:not(style) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n      transition: transform ", " ", ";\n    }\n    ", "\n    ", "\n  "]),
    _templateObject2$8 = taggedTemplateLiteral(["\n          pointer-events: none;\n          opacity: 0;\n          > div:first-child:not(style) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n            will-change: transform;\n            ", "\n          }\n        "], ["\n          pointer-events: none;\n          opacity: 0;\n          > div:first-child:not(style) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n            will-change: transform;\n            ", "\n          }\n        "]),
    _templateObject3$6 = taggedTemplateLiteral(["\n          > div:first-child:not(style) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n            transform: scale(1);\n          }\n        "], ["\n          > div:first-child:not(style) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n            transform: scale(1);\n          }\n        "]),
    _templateObject4$2 = taggedTemplateLiteral(["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: -1;\n    background: ", ";\n  "], ["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: -1;\n    background: ", ";\n  "]),
    _templateObject5$2 = taggedTemplateLiteral(["\n                position: absolute;\n                top: ", ";\n                right: ", ";\n                width: 2.4em;\n                height: 2.4em;\n                display: flex;\n                cursor: pointer;\n                color: ", ";\n                :hover {\n                  color: ", ";\n                }\n              "], ["\n                position: absolute;\n                top: ", ";\n                right: ", ";\n                width: 2.4em;\n                height: 2.4em;\n                display: flex;\n                cursor: pointer;\n                color: ", ";\n                :hover {\n                  color: ", ";\n                }\n              "]);

var Modal = function Modal(props) {
  var config = useConfig();
  var window = useWindow();
  var _config$modals = config.modals,
      modalWidth = _config$modals.modalWidth,
      modalBackground = _config$modals.modalBackground,
      modalFadeEffect = _config$modals.modalFadeEffect,
      transitionDuration = _config$modals.transitionDuration,
      closeButtonMarginConfig = _config$modals.closeButtonMargin;
  var animationCurveIn = config.animations.animationCurveIn;
  var layoutPadding = config.layout.layoutPadding;
  var style = props.style,
      children = props.children,
      _props$width = props.width,
      width = _props$width === undefined ? modalWidth : _props$width,
      minHeight = props.minHeight,
      show = props.show,
      setShow = props.setShow,
      onClose = props.onClose,
      _props$closeButtonMar = props.closeButtonMargin,
      closeButtonMargin = _props$closeButtonMar === undefined ? closeButtonMarginConfig : _props$closeButtonMar,
      fullScreenAt = props.fullScreenAt,
      loading = props.loading,
      persistent = props.persistent;

  var _useMountAnimation = useMountAnimation(show),
      _useMountAnimation2 = slicedToArray(_useMountAnimation, 2),
      mount = _useMountAnimation2[0],
      visible = _useMountAnimation2[1];

  var wrapperCSS = css(_templateObject$b, transitionDuration, animationCurveIn, responsive("padding", layoutPadding), transitionDuration, animationCurveIn, !visible ? css(_templateObject2$8, modalFadeEffect) : css(_templateObject3$6), fullScreenAt ? "\n      @media (max-width: " + fullScreenAt + ") {\n        padding: 0;\n      }" : "");
  var backgroundCSS = css(_templateObject4$2, modalBackground);
  return window && ReactDOM.createPortal((mount || persistent) && jsx("div", {
    css: wrapperCSS
  }, jsx(Card, {
    style: _extends({}, style, {
      margin: "auto"
    }),
    width: width,
    minHeight: minHeight,
    fullScreenAt: fullScreenAt,
    loading: loading
  }, jsx("div", {
    css: css(_templateObject5$2, closeButtonMargin, closeButtonMargin, config.colors.c5, config.colors.c4),
    onClick: function onClick() {
      setShow && setShow(false);
      onClose && onClose();
    }
  }, jsx(Icon, {
    name: "close",
    color: "currentColor",
    size: "1.4em",
    style: {
      margin: "auto"
    }
  })), children), jsx("div", {
    onClick: function onClick() {
      setShow && setShow(false);
      onClose && onClose();
    },
    css: backgroundCSS
  })), document.querySelector("body"));
};

var ExitModal = function ExitModal(props) {
  var children = props.children,
      _props$delay = props.delay,
      delay = _props$delay === undefined ? 10000 : _props$delay,
      _props$savedKey = props.savedKey,
      savedKey = _props$savedKey === undefined ? null : _props$savedKey;

  var _useState = useState(null),
      _useState2 = slicedToArray(_useState, 2),
      savedClosed = _useState2[0],
      setSavedClosed = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = slicedToArray(_useState3, 2),
      modalShown = _useState4[0],
      setModalShown = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = slicedToArray(_useState5, 2),
      userClosed = _useState6[0],
      setUserClosed = _useState6[1];

  useEffect(function () {
    savedKey && setSavedClosed(localStorage.getItem("popup_dismissed:" + savedKey));
  }, [savedKey]);

  function showPopup(event) {
    if (event.toElement === null) {
      setModalShown(true);
    }
  }

  useEffect(function () {
    var timer = setTimeout(function () {
      window.addEventListener("mouseout", showPopup);
    }, delay);
    return function () {
      window.removeEventListener("mouseout", showPopup);
      clearTimeout(timer);
    };
  }, [delay]);

  function handleClose() {
    setModalShown(false);
    setUserClosed(true);
    savedKey && localStorage.setItem("popup_dismissed:" + savedKey, true);
  } // Show the popup if the user shows an exit intent, and he hasn't closed it, and also if the browser didn't saved a dismissed status.


  var modalShownCondition = !userClosed && modalShown && savedClosed == null;
  return React.createElement(Modal, {
    show: modalShownCondition,
    onClose: function onClose() {
      return handleClose();
    }
  }, children);
};

var _templateObject$c = taggedTemplateLiteral(["\n    z-index: 0;\n    box-sizing: border-box;\n    width: 100%;\n    position: relative;\n    flex: 3 1 auto;\n    min-height: ", ";\n    ", "\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n    border-bottom: ", ";\n    display: flex;\n    flex: 1 0 auto;\n    :first-of-type:not(style) {\n      flex: 0 0 auto;\n    }\n    :last-of-type:not(style) {\n      flex: 1 0 auto;\n      border-bottom: none;\n    }\n    :only-of-type {\n      flex: 1 0 auto;\n    }\n    ", "\n    box-sizing: border-box;\n\n    :before {\n      content: \"\";\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      z-index: -1;\n      ", "\n      background: ", ";\n      ", "\n    }\n\n    > div {\n      width: ", ";\n      max-width: 100%;\n      margin: 0 auto;\n      ", "\n      padding-top: 0 !important;\n      padding-bottom: 0 !important;\n      box-sizing: border-box;\n      ", "\n    }\n  "], ["\n    z-index: 0;\n    box-sizing: border-box;\n    width: 100%;\n    position: relative;\n    flex: 3 1 auto;\n    min-height: ", ";\n    ", "\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n    border-bottom: ", ";\n    display: flex;\n    flex: 1 0 auto;\n    :first-of-type:not(style) {\n      flex: 0 0 auto;\n    }\n    :last-of-type:not(style) {\n      flex: 1 0 auto;\n      border-bottom: none;\n    }\n    :only-of-type {\n      flex: 1 0 auto;\n    }\n    ", "\n    box-sizing: border-box;\n\n    :before {\n      content: \"\";\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      z-index: -1;\n      ", "\n      background: ", ";\n      ", "\n    }\n\n    > div {\n      width: ", ";\n      max-width: 100%;\n      margin: 0 auto;\n      ", "\n      padding-top: 0 !important;\n      padding-bottom: 0 !important;\n      box-sizing: border-box;\n      ", "\n    }\n  "]),
    _templateObject2$9 = taggedTemplateLiteral(["\n          display: flex;\n          flex-direction: column;\n          align-items: ", ";\n          justify-content: ", ";\n        "], ["\n          display: flex;\n          flex-direction: column;\n          align-items: ", ";\n          justify-content: ", ";\n        "]);

var Section = function Section(props) {
  var config = useConfig();
  var _config$layout = config.layout,
      layoutPadding = _config$layout.layoutPadding,
      layoutWidth = _config$layout.layoutWidth;
  var _config$section = config.section,
      padding = _config$section.padding,
      border = _config$section.border,
      skewConfig = _config$section.skew;
  var children = props.children,
      _props$center = props.center,
      center = _props$center === undefined ? false : _props$center,
      providedAlign = props.align,
      providedVAlign = props.vAlign,
      _props$noPadding = props.noPadding,
      noPadding = _props$noPadding === undefined ? false : _props$noPadding,
      _props$noLateralPaddi = props.noLateralPadding,
      noLateralPadding = _props$noLateralPaddi === undefined ? false : _props$noLateralPaddi,
      _props$background = props.background,
      background = _props$background === undefined ? false : _props$background,
      _props$noBorder = props.noBorder,
      noBorder = _props$noBorder === undefined ? false : _props$noBorder,
      _props$minHeight = props.minHeight,
      minHeight = _props$minHeight === undefined ? 0 : _props$minHeight,
      _props$skew = props.skew,
      skew = _props$skew === undefined ? skewConfig : _props$skew,
      expandBackground = props.expandBackground,
      _props$width = props.width,
      width = _props$width === undefined ? layoutWidth : _props$width,
      first = props.first,
      externalCSS = props.CSS,
      id = props.id;
  var bg3 = config.colors.bg3;
  var align = center ? "center" : getHAlign(providedAlign);
  var vAlign = center ? "center" : getHAlign(providedVAlign);
  var style = props.style;
  var mainCSS = css(_templateObject$c, minHeight, !noPadding ? responsive("padding", padding) : "", !noBorder ? border : "none", first ? "flex: 0 1 auto;" : "", expandBackground ? "\n        margin: -" + expandBackground + " 0;\n        padding: " + expandBackground + " 0;\n      " : "", background ? typeof background === "string" ? background : bg3 : "transparent", skew ? "transform: skewY(" + skew + ");" : "", width, !noLateralPadding ? responsive("padding", layoutPadding) : "", (align || vAlign) && css(_templateObject2$9, align, vAlign));
  return jsx("div", {
    style: style,
    id: id,
    css: [mainCSS, externalCSS]
  }, jsx("div", null, children));
};

var _templateObject$d = taggedTemplateLiteral(["\n    display: ", ";\n    width: auto;\n    max-width: 100%;\n    ", "\n    min-width: 0;\n    min-height: ", ";\n    align-items: ", ";\n    ", "\n    ", "\n    justify-content: ", ";\n    flex-flow: column ", ";\n    > *, > h1, > h2, > h3, > h4, > p, > div {\n      ", "\n      margin: ", " 0;\n      :first-child /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n        margin-top: 0;\n      }\n      :last-child {\n        margin-bottom: 0;\n      }\n    }\n  "], ["\n    display: ", ";\n    width: auto;\n    max-width: 100%;\n    ", "\n    min-width: 0;\n    min-height: ", ";\n    align-items: ", ";\n    ", "\n    ", "\n    justify-content: ", ";\n    flex-flow: column ", ";\n    > *, > h1, > h2, > h3, > h4, > p, > div {\n      ", "\n      margin: ", " 0;\n      :first-child /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n        margin-top: 0;\n      }\n      :last-child {\n        margin-bottom: 0;\n      }\n    }\n  "]);

var VStack = function VStack(props) {
  var config = useConfig();
  var stackGap = config.layout.stackGap;
  var children = props.children,
      _props$center = props.center,
      center = _props$center === undefined ? false : _props$center,
      _props$vAlign = props.vAlign,
      vAlign = _props$vAlign === undefined ? "top" : _props$vAlign,
      _props$align = props.align,
      align = _props$align === undefined ? "left" : _props$align,
      centerAt = props.centerAt,
      _props$inline = props.inline,
      inline = _props$inline === undefined ? false : _props$inline,
      _props$width = props.width,
      width = _props$width === undefined ? null : _props$width,
      _props$minHeight = props.minHeight,
      minHeight = _props$minHeight === undefined ? 0 : _props$minHeight,
      _props$noWrap = props.noWrap,
      noWrap = _props$noWrap === undefined ? true : _props$noWrap,
      _props$id = props.id,
      id = _props$id === undefined ? "stack" : _props$id,
      providedGap = props.gap;
  var alignItems = center ? "center" : getHAlign(align);
  var justifyContent = center ? "center" : getVAlign(vAlign);
  var flexWrap = noWrap ? "nowrap" : "wrap";

  var gap = function () {
    return providedGap !== undefined ? providedGap : stackGap;
  }();

  var style = _extends({}, config.VStack.style, props.style);

  var mainCSS = css(_templateObject$d, !inline ? "flex" : "inline-flex", width ? "\n      width: " + width + ";\n      margin: 0 auto;\n    " : "", minHeight, alignItems, showHideCss(props), centerAt && "\n      @media (max-width: " + centerAt + ") {\n        align-items: center;\n        width: auto;\n        margin-left: auto;\n        margin-right: auto;\n      }\n    ", justifyContent, flexWrap, align === "stretch" ? "flex: 1 1 auto !important;" : "", gap);
  return jsx("div", _extends({
    style: style,
    id: id,
    css: mainCSS
  }, defaultProps(props)), children);
};

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var is = {
  arr: Array.isArray,
  obj: function obj(a) {
    return Object.prototype.toString.call(a) === '[object Object]';
  },
  fun: function fun(a) {
    return typeof a === 'function';
  },
  str: function str(a) {
    return typeof a === 'string';
  },
  num: function num(a) {
    return typeof a === 'number';
  },
  und: function und(a) {
    return a === void 0;
  },
  nul: function nul(a) {
    return a === null;
  },
  set: function set(a) {
    return a instanceof Set;
  },
  map: function map(a) {
    return a instanceof Map;
  },
  equ: function equ(a, b) {
    if (typeof a !== typeof b) return false;
    if (is.str(a) || is.num(a)) return a === b;
    if (is.obj(a) && is.obj(b) && Object.keys(a).length + Object.keys(b).length === 0) return true;
    var i;

    for (i in a) {
      if (!(i in b)) return false;
    }

    for (i in b) {
      if (a[i] !== b[i]) return false;
    }

    return is.und(i) ? a === b : true;
  }
};

function merge$3(target, lowercase) {
  if (lowercase === void 0) {
    lowercase = true;
  }

  return function (object) {
    return (is.arr(object) ? object : Object.keys(object)).reduce(function (acc, element) {
      var key = lowercase ? element[0].toLowerCase() + element.substring(1) : element;
      acc[key] = target(key);
      return acc;
    }, target);
  };
}

function useForceUpdate() {
  var _useState = useState(false),
      f = _useState[1];

  var forceUpdate = useCallback(function () {
    return f(function (v) {
      return !v;
    });
  }, []);
  return forceUpdate;
}

function withDefault(value, defaultValue) {
  return is.und(value) || is.nul(value) ? defaultValue : value;
}

function toArray$1(a) {
  return !is.und(a) ? is.arr(a) ? a : [a] : [];
}

function callProp(obj) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return is.fun(obj) ? obj.apply(void 0, args) : obj;
}

function getForwardProps(props) {
  var to = props.to,
      from = props.from,
      config = props.config,
      onStart = props.onStart,
      onRest = props.onRest,
      onFrame = props.onFrame,
      children = props.children,
      reset = props.reset,
      reverse = props.reverse,
      force = props.force,
      immediate = props.immediate,
      delay = props.delay,
      attach = props.attach,
      destroyed = props.destroyed,
      interpolateTo = props.interpolateTo,
      ref = props.ref,
      lazy = props.lazy,
      forward = _objectWithoutPropertiesLoose(props, ["to", "from", "config", "onStart", "onRest", "onFrame", "children", "reset", "reverse", "force", "immediate", "delay", "attach", "destroyed", "interpolateTo", "ref", "lazy"]);

  return forward;
}

function interpolateTo(props) {
  var forward = getForwardProps(props);
  if (is.und(forward)) return _extends({
    to: forward
  }, props);
  var rest = Object.keys(props).reduce(function (a, k) {
    return !is.und(forward[k]) ? a : _extends({}, a, _defineProperty({}, k, props[k]));
  }, {});
  return _extends({
    to: forward
  }, rest);
}

function handleRef(ref, forward) {
  if (forward) {
    // If it's a function, assume it's a ref callback
    if (is.fun(forward)) forward(ref);else if (is.obj(forward)) {
      forward.current = ref;
    }
  }

  return ref;
}

var Animated = /*#__PURE__*/function () {
  function Animated() {
    _classCallCheck(this, Animated);

    this.payload = void 0;
    this.children = [];
  }

  _createClass(Animated, [{
    key: "getAnimatedValue",
    value: function getAnimatedValue() {
      return this.getValue();
    }
  }, {
    key: "getPayload",
    value: function getPayload() {
      return this.payload || this;
    }
  }, {
    key: "attach",
    value: function attach() {}
  }, {
    key: "detach",
    value: function detach() {}
  }, {
    key: "getChildren",
    value: function getChildren() {
      return this.children;
    }
  }, {
    key: "addChild",
    value: function addChild(child) {
      if (this.children.length === 0) this.attach();
      this.children.push(child);
    }
  }, {
    key: "removeChild",
    value: function removeChild(child) {
      var index = this.children.indexOf(child);
      this.children.splice(index, 1);
      if (this.children.length === 0) this.detach();
    }
  }]);

  return Animated;
}();

var AnimatedArray = /*#__PURE__*/function (_Animated) {
  _inherits(AnimatedArray, _Animated);

  var _super = _createSuper(AnimatedArray);

  function AnimatedArray() {
    var _this2;

    _classCallCheck(this, AnimatedArray);

    _this2 = _super.apply(this, arguments);
    _this2.payload = [];

    _this2.attach = function () {
      return _this2.payload.forEach(function (p) {
        return p instanceof Animated && p.addChild(_assertThisInitialized(_this2));
      });
    };

    _this2.detach = function () {
      return _this2.payload.forEach(function (p) {
        return p instanceof Animated && p.removeChild(_assertThisInitialized(_this2));
      });
    };

    return _this2;
  }

  return AnimatedArray;
}(Animated);

var AnimatedObject = /*#__PURE__*/function (_Animated2) {
  _inherits(AnimatedObject, _Animated2);

  var _super2 = _createSuper(AnimatedObject);

  function AnimatedObject() {
    var _this3;

    _classCallCheck(this, AnimatedObject);

    _this3 = _super2.apply(this, arguments);
    _this3.payload = {};

    _this3.attach = function () {
      return Object.values(_this3.payload).forEach(function (s) {
        return s instanceof Animated && s.addChild(_assertThisInitialized(_this3));
      });
    };

    _this3.detach = function () {
      return Object.values(_this3.payload).forEach(function (s) {
        return s instanceof Animated && s.removeChild(_assertThisInitialized(_this3));
      });
    };

    return _this3;
  }

  _createClass(AnimatedObject, [{
    key: "getValue",
    value: function getValue(animated) {
      if (animated === void 0) {
        animated = false;
      }

      var payload = {};

      for (var key in this.payload) {
        var value = this.payload[key];
        if (animated && !(value instanceof Animated)) continue;
        payload[key] = value instanceof Animated ? value[animated ? 'getAnimatedValue' : 'getValue']() : value;
      }

      return payload;
    }
  }, {
    key: "getAnimatedValue",
    value: function getAnimatedValue() {
      return this.getValue(true);
    }
  }]);

  return AnimatedObject;
}(Animated);

var applyAnimatedValues;

function injectApplyAnimatedValues(fn, transform) {
  applyAnimatedValues = {
    fn: fn,
    transform: transform
  };
}

var colorNames;

function injectColorNames(names) {
  colorNames = names;
}

var requestFrame = function requestFrame(cb) {
  return typeof window !== 'undefined' ? window.requestAnimationFrame(cb) : -1;
};

var cancelFrame = function cancelFrame(id) {
  typeof window !== 'undefined' && window.cancelAnimationFrame(id);
};

function injectFrame(raf, caf) {
  requestFrame = raf;
  cancelFrame = caf;
}

var interpolation;

function injectStringInterpolator(fn) {
  interpolation = fn;
}

var now = function now() {
  return Date.now();
};

function injectNow(nowFn) {
  now = nowFn;
}

var defaultElement;

function injectDefaultElement(el) {
  defaultElement = el;
}

var animatedApi = function animatedApi(node) {
  return node.current;
};

function injectAnimatedApi(fn) {
  animatedApi = fn;
}

var createAnimatedStyle;

function injectCreateAnimatedStyle(factory) {
  createAnimatedStyle = factory;
}

var manualFrameloop;

function injectManualFrameloop(callback) {
  manualFrameloop = callback;
}

var Globals = /*#__PURE__*/Object.freeze({
  get applyAnimatedValues() {
    return applyAnimatedValues;
  },

  injectApplyAnimatedValues: injectApplyAnimatedValues,

  get colorNames() {
    return colorNames;
  },

  injectColorNames: injectColorNames,

  get requestFrame() {
    return requestFrame;
  },

  get cancelFrame() {
    return cancelFrame;
  },

  injectFrame: injectFrame,

  get interpolation() {
    return interpolation;
  },

  injectStringInterpolator: injectStringInterpolator,

  get now() {
    return now;
  },

  injectNow: injectNow,

  get defaultElement() {
    return defaultElement;
  },

  injectDefaultElement: injectDefaultElement,

  get animatedApi() {
    return animatedApi;
  },

  injectAnimatedApi: injectAnimatedApi,

  get createAnimatedStyle() {
    return createAnimatedStyle;
  },

  injectCreateAnimatedStyle: injectCreateAnimatedStyle,

  get manualFrameloop() {
    return manualFrameloop;
  },

  injectManualFrameloop: injectManualFrameloop
});
/**
 * Wraps the `style` property with `AnimatedStyle`.
 */

var AnimatedProps = /*#__PURE__*/function (_AnimatedObject) {
  _inherits(AnimatedProps, _AnimatedObject);

  var _super3 = _createSuper(AnimatedProps);

  function AnimatedProps(props, callback) {
    var _this4;

    _classCallCheck(this, AnimatedProps);

    _this4 = _super3.call(this);
    _this4.update = void 0;
    _this4.payload = !props.style ? props : _extends({}, props, {
      style: createAnimatedStyle(props.style)
    });
    _this4.update = callback;

    _this4.attach();

    return _this4;
  }

  return AnimatedProps;
}(AnimatedObject);

var isFunctionComponent = function isFunctionComponent(val) {
  return is.fun(val) && !(val.prototype instanceof React.Component);
};

var createAnimatedComponent = function createAnimatedComponent(Component$$1) {
  var AnimatedComponent = forwardRef(function (props, ref) {
    var forceUpdate = useForceUpdate();
    var mounted = useRef(true);
    var propsAnimated = useRef(null);
    var node = useRef(null);
    var attachProps = useCallback(function (props) {
      var oldPropsAnimated = propsAnimated.current;

      var callback = function callback() {
        var didUpdate = false;

        if (node.current) {
          didUpdate = applyAnimatedValues.fn(node.current, propsAnimated.current.getAnimatedValue());
        }

        if (!node.current || didUpdate === false) {
          // If no referenced node has been found, or the update target didn't have a
          // native-responder, then forceUpdate the animation ...
          forceUpdate();
        }
      };

      propsAnimated.current = new AnimatedProps(props, callback);
      oldPropsAnimated && oldPropsAnimated.detach();
    }, []);
    useEffect(function () {
      return function () {
        mounted.current = false;
        propsAnimated.current && propsAnimated.current.detach();
      };
    }, []);
    useImperativeHandle(ref, function () {
      return animatedApi(node, mounted, forceUpdate);
    });
    attachProps(props);

    var _getValue = propsAnimated.current.getValue(),
        scrollTop = _getValue.scrollTop,
        scrollLeft = _getValue.scrollLeft,
        animatedProps = _objectWithoutPropertiesLoose(_getValue, ["scrollTop", "scrollLeft"]); // Functions cannot have refs, see:
    // See: https://github.com/react-spring/react-spring/issues/569


    var refFn = isFunctionComponent(Component$$1) ? undefined : function (childRef) {
      return node.current = handleRef(childRef, ref);
    };
    return React.createElement(Component$$1, _extends({}, animatedProps, {
      ref: refFn
    }));
  });
  return AnimatedComponent;
};

var active = false;
var controllers = new Set();

var update = function update() {
  if (!active) return false;
  var time = now();

  var _iterator2 = _createForOfIteratorHelper(controllers),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var controller = _step2.value;
      var isActive = false;

      for (var configIdx = 0; configIdx < controller.configs.length; configIdx++) {
        var config = controller.configs[configIdx];
        var endOfAnimation = void 0,
            lastTime = void 0;

        for (var valIdx = 0; valIdx < config.animatedValues.length; valIdx++) {
          var animation = config.animatedValues[valIdx]; // If an animation is done, skip, until all of them conclude

          if (animation.done) continue;
          var from = config.fromValues[valIdx];
          var to = config.toValues[valIdx];
          var position = animation.lastPosition;
          var isAnimated = to instanceof Animated;
          var velocity = Array.isArray(config.initialVelocity) ? config.initialVelocity[valIdx] : config.initialVelocity;
          if (isAnimated) to = to.getValue(); // Conclude animation if it's either immediate, or from-values match end-state

          if (config.immediate) {
            animation.setValue(to);
            animation.done = true;
            continue;
          } // Break animation when string values are involved


          if (typeof from === 'string' || typeof to === 'string') {
            animation.setValue(to);
            animation.done = true;
            continue;
          }

          if (config.duration !== void 0) {
            /** Duration easing */
            position = from + config.easing((time - animation.startTime) / config.duration) * (to - from);
            endOfAnimation = time >= animation.startTime + config.duration;
          } else if (config.decay) {
            /** Decay easing */
            position = from + velocity / (1 - 0.998) * (1 - Math.exp(-(1 - 0.998) * (time - animation.startTime)));
            endOfAnimation = Math.abs(animation.lastPosition - position) < 0.1;
            if (endOfAnimation) to = position;
          } else {
            /** Spring easing */
            lastTime = animation.lastTime !== void 0 ? animation.lastTime : time;
            velocity = animation.lastVelocity !== void 0 ? animation.lastVelocity : config.initialVelocity; // If we lost a lot of frames just jump to the end.

            if (time > lastTime + 64) lastTime = time; // http://gafferongames.com/game-physics/fix-your-timestep/

            var numSteps = Math.floor(time - lastTime);

            for (var i = 0; i < numSteps; ++i) {
              var force = -config.tension * (position - to);
              var damping = -config.friction * velocity;
              var acceleration = (force + damping) / config.mass;
              velocity = velocity + acceleration * 1 / 1000;
              position = position + velocity * 1 / 1000;
            } // Conditions for stopping the spring animation


            var isOvershooting = config.clamp && config.tension !== 0 ? from < to ? position > to : position < to : false;
            var isVelocity = Math.abs(velocity) <= config.precision;
            var isDisplacement = config.tension !== 0 ? Math.abs(to - position) <= config.precision : true;
            endOfAnimation = isOvershooting || isVelocity && isDisplacement;
            animation.lastVelocity = velocity;
            animation.lastTime = time;
          } // Trails aren't done until their parents conclude


          if (isAnimated && !config.toValues[valIdx].done) endOfAnimation = false;

          if (endOfAnimation) {
            // Ensure that we end up with a round value
            if (animation.value !== to) position = to;
            animation.done = true;
          } else isActive = true;

          animation.setValue(position);
          animation.lastPosition = position;
        } // Keep track of updated values only when necessary


        if (controller.props.onFrame) controller.values[config.name] = config.interpolation.getValue();
      } // Update callbacks in the end of the frame


      if (controller.props.onFrame) controller.props.onFrame(controller.values); // Either call onEnd or next frame

      if (!isActive) {
        controllers["delete"](controller);
        controller.stop(true);
      }
    } // Loop over as long as there are controllers ...

  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  if (controllers.size) {
    if (manualFrameloop) manualFrameloop();else requestFrame(update);
  } else {
    active = false;
  }

  return active;
};

var _start = function start(controller) {
  if (!controllers.has(controller)) controllers.add(controller);

  if (!active) {
    active = true;
    if (manualFrameloop) requestFrame(manualFrameloop);else requestFrame(update);
  }
};

var stop = function stop(controller) {
  if (controllers.has(controller)) controllers["delete"](controller);
};

function createInterpolator(range, output, extrapolate) {
  if (typeof range === 'function') {
    return range;
  }

  if (Array.isArray(range)) {
    return createInterpolator({
      range: range,
      output: output,
      extrapolate: extrapolate
    });
  }

  if (interpolation && typeof range.output[0] === 'string') {
    return interpolation(range);
  }

  var config = range;
  var outputRange = config.output;
  var inputRange = config.range || [0, 1];
  var extrapolateLeft = config.extrapolateLeft || config.extrapolate || 'extend';
  var extrapolateRight = config.extrapolateRight || config.extrapolate || 'extend';

  var easing = config.easing || function (t) {
    return t;
  };

  return function (input) {
    var range = findRange(input, inputRange);
    return interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight, config.map);
  };
}

function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
  var result = map ? map(input) : input; // Extrapolate

  if (result < inputMin) {
    if (extrapolateLeft === 'identity') return result;else if (extrapolateLeft === 'clamp') result = inputMin;
  }

  if (result > inputMax) {
    if (extrapolateRight === 'identity') return result;else if (extrapolateRight === 'clamp') result = inputMax;
  }

  if (outputMin === outputMax) return outputMin;
  if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax; // Input Range

  if (inputMin === -Infinity) result = -result;else if (inputMax === Infinity) result = result - inputMin;else result = (result - inputMin) / (inputMax - inputMin); // Easing

  result = easing(result); // Output Range

  if (outputMin === -Infinity) result = -result;else if (outputMax === Infinity) result = result + outputMin;else result = result * (outputMax - outputMin) + outputMin;
  return result;
}

function findRange(input, inputRange) {
  for (var i = 1; i < inputRange.length - 1; ++i) {
    if (inputRange[i] >= input) break;
  }

  return i - 1;
}

var AnimatedInterpolation = /*#__PURE__*/function (_AnimatedArray) {
  _inherits(AnimatedInterpolation, _AnimatedArray);

  var _super4 = _createSuper(AnimatedInterpolation);

  function AnimatedInterpolation(parents, range, output, extrapolate) {
    var _this5;

    _classCallCheck(this, AnimatedInterpolation);

    _this5 = _super4.call(this);
    _this5.calc = void 0;
    _this5.payload = parents instanceof AnimatedArray && !(parents instanceof AnimatedInterpolation) ? parents.getPayload() : Array.isArray(parents) ? parents : [parents];
    _this5.calc = createInterpolator(range, output, extrapolate);
    return _this5;
  }

  _createClass(AnimatedInterpolation, [{
    key: "getValue",
    value: function getValue() {
      return this.calc.apply(this, _toConsumableArray(this.payload.map(function (value) {
        return value.getValue();
      })));
    }
  }, {
    key: "updateConfig",
    value: function updateConfig(range, output, extrapolate) {
      this.calc = createInterpolator(range, output, extrapolate);
    }
  }, {
    key: "interpolate",
    value: function interpolate(range, output, extrapolate) {
      return new AnimatedInterpolation(this, range, output, extrapolate);
    }
  }]);

  return AnimatedInterpolation;
}(AnimatedArray);
/**
 * Animated works by building a directed acyclic graph of dependencies
 * transparently when you render your Animated components.
 *
 *               new Animated.Value(0)
 *     .interpolate()        .interpolate()    new Animated.Value(1)
 *         opacity               translateY      scale
 *          style                         transform
 *         View#234                         style
 *                                         View#123
 *
 * A) Top Down phase
 * When an AnimatedValue is updated, we recursively go down through this
 * graph in order to find leaf nodes: the views that we flag as needing
 * an update.
 *
 * B) Bottom Up phase
 * When a view is flagged as needing an update, we recursively go back up
 * in order to build the new value that it needs. The reason why we need
 * this two-phases process is to deal with composite props such as
 * transform which can receive values from multiple parents.
 */


function addAnimatedStyles(node, styles) {
  if ('update' in node) {
    styles.add(node);
  } else {
    node.getChildren().forEach(function (child) {
      return addAnimatedStyles(child, styles);
    });
  }
}

var AnimatedValue = /*#__PURE__*/function (_Animated3) {
  _inherits(AnimatedValue, _Animated3);

  var _super5 = _createSuper(AnimatedValue);

  function AnimatedValue(_value) {
    var _this6;

    _classCallCheck(this, AnimatedValue);

    var _this;

    _this6 = _super5.call(this);
    _this = _assertThisInitialized(_this6);
    _this6.animatedStyles = new Set();
    _this6.value = void 0;
    _this6.startPosition = void 0;
    _this6.lastPosition = void 0;
    _this6.lastVelocity = void 0;
    _this6.startTime = void 0;
    _this6.lastTime = void 0;
    _this6.done = false;

    _this6.setValue = function (value, flush) {
      if (flush === void 0) {
        flush = true;
      }

      _this.value = value;
      if (flush) _this.flush();
    };

    _this6.value = _value;
    _this6.startPosition = _value;
    _this6.lastPosition = _value;
    return _this6;
  }

  _createClass(AnimatedValue, [{
    key: "flush",
    value: function flush() {
      if (this.animatedStyles.size === 0) {
        addAnimatedStyles(this, this.animatedStyles);
      }

      this.animatedStyles.forEach(function (animatedStyle) {
        return animatedStyle.update();
      });
    }
  }, {
    key: "clearStyles",
    value: function clearStyles() {
      this.animatedStyles.clear();
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.value;
    }
  }, {
    key: "interpolate",
    value: function interpolate(range, output, extrapolate) {
      return new AnimatedInterpolation(this, range, output, extrapolate);
    }
  }]);

  return AnimatedValue;
}(Animated);

var AnimatedValueArray = /*#__PURE__*/function (_AnimatedArray2) {
  _inherits(AnimatedValueArray, _AnimatedArray2);

  var _super6 = _createSuper(AnimatedValueArray);

  function AnimatedValueArray(values) {
    var _this7;

    _classCallCheck(this, AnimatedValueArray);

    _this7 = _super6.call(this);
    _this7.payload = values.map(function (n) {
      return new AnimatedValue(n);
    });
    return _this7;
  }

  _createClass(AnimatedValueArray, [{
    key: "setValue",
    value: function setValue(value, flush) {
      var _this8 = this;

      if (flush === void 0) {
        flush = true;
      }

      if (Array.isArray(value)) {
        if (value.length === this.payload.length) {
          value.forEach(function (v, i) {
            return _this8.payload[i].setValue(v, flush);
          });
        }
      } else {
        this.payload.forEach(function (p) {
          return p.setValue(value, flush);
        });
      }
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.payload.map(function (v) {
        return v.getValue();
      });
    }
  }, {
    key: "interpolate",
    value: function interpolate(range, output) {
      return new AnimatedInterpolation(this, range, output);
    }
  }]);

  return AnimatedValueArray;
}(AnimatedArray);

var G = 0;

var Controller = /*#__PURE__*/function () {
  function Controller() {
    var _this9 = this;

    _classCallCheck(this, Controller);

    this.id = void 0;
    this.idle = true;
    this.hasChanged = false;
    this.guid = 0;
    this.local = 0;
    this.props = {};
    this.merged = {};
    this.animations = {};
    this.interpolations = {};
    this.values = {};
    this.configs = [];
    this.listeners = [];
    this.queue = [];
    this.localQueue = void 0;

    this.getValues = function () {
      return _this9.interpolations;
    };

    this.id = G++;
  }
  /** update(props)
   *  This function filters input props and creates an array of tasks which are executed in .start()
   *  Each task is allowed to carry a delay, which means it can execute asnychroneously */


  _createClass(Controller, [{
    key: "update",
    value: function update(args) {
      //this._id = n + this.id
      if (!args) return this; // Extract delay and the to-prop from props

      var _ref = interpolateTo(args),
          _ref$delay = _ref.delay,
          delay = _ref$delay === void 0 ? 0 : _ref$delay,
          to = _ref.to,
          props = _objectWithoutPropertiesLoose(_ref, ["delay", "to"]);

      if (is.arr(to) || is.fun(to)) {
        // If config is either a function or an array queue it up as is
        this.queue.push(_extends({}, props, {
          delay: delay,
          to: to
        }));
      } else if (to) {
        // Otherwise go through each key since it could be delayed individually
        var ops = {};
        Object.entries(to).forEach(function (_ref2) {
          var k = _ref2[0],
              v = _ref2[1]; // Fetch delay and create an entry, consisting of the to-props, the delay, and basic props

          var entry = _extends({
            to: _defineProperty({}, k, v),
            delay: callProp(delay, k)
          }, props);

          var previous = ops[entry.delay] && ops[entry.delay].to;
          ops[entry.delay] = _extends({}, ops[entry.delay], entry, {
            to: _extends({}, previous, entry.to)
          });
        });
        this.queue = Object.values(ops);
      } // Sort queue, so that async calls go last


      this.queue = this.queue.sort(function (a, b) {
        return a.delay - b.delay;
      }); // Diff the reduced props immediately (they'll contain the from-prop and some config)

      this.diff(props);
      return this;
    }
    /** start(onEnd)
     *  This function either executes a queue, if present, or starts the frameloop, which animates */

  }, {
    key: "start",
    value: function start(onEnd) {
      var _this10 = this;

      // If a queue is present we must excecute it
      if (this.queue.length) {
        this.idle = false; // Updates can interrupt trailing queues, in that case we just merge values

        if (this.localQueue) {
          this.localQueue.forEach(function (_ref3) {
            var _ref3$from = _ref3.from,
                from = _ref3$from === void 0 ? {} : _ref3$from,
                _ref3$to = _ref3.to,
                to = _ref3$to === void 0 ? {} : _ref3$to;
            if (is.obj(from)) _this10.merged = _extends({}, from, _this10.merged);
            if (is.obj(to)) _this10.merged = _extends({}, _this10.merged, to);
          });
        } // The guid helps us tracking frames, a new queue over an old one means an override
        // We discard async calls in that caseÍ


        var local = this.local = ++this.guid;
        var queue = this.localQueue = this.queue;
        this.queue = []; // Go through each entry and execute it

        queue.forEach(function (_ref4, index) {
          var delay = _ref4.delay,
              props = _objectWithoutPropertiesLoose(_ref4, ["delay"]);

          var cb = function cb(finished) {
            if (index === queue.length - 1 && local === _this10.guid && finished) {
              _this10.idle = true;
              if (_this10.props.onRest) _this10.props.onRest(_this10.merged);
            }

            if (onEnd) onEnd();
          }; // Entries can be delayed, ansyc or immediate


          var async = is.arr(props.to) || is.fun(props.to);

          if (delay) {
            setTimeout(function () {
              if (local === _this10.guid) {
                if (async) _this10.runAsync(props, cb);else _this10.diff(props).start(cb);
              }
            }, delay);
          } else if (async) _this10.runAsync(props, cb);else _this10.diff(props).start(cb);
        });
      } // Otherwise we kick of the frameloop
      else {
          if (is.fun(onEnd)) this.listeners.push(onEnd);
          if (this.props.onStart) this.props.onStart();

          _start(this);
        }

      return this;
    }
  }, {
    key: "stop",
    value: function stop(finished) {
      this.listeners.forEach(function (onEnd) {
        return onEnd(finished);
      });
      this.listeners = [];
      return this;
    }
    /** Pause sets onEnd listeners free, but also removes the controller from the frameloop */

  }, {
    key: "pause",
    value: function pause(finished) {
      this.stop(true);
      if (finished) stop(this);
      return this;
    }
  }, {
    key: "runAsync",
    value: function runAsync(_ref5, onEnd) {
      var _this11 = this;

      var _this = this;

      var delay = _ref5.delay,
          props = _objectWithoutPropertiesLoose(_ref5, ["delay"]);

      var local = this.local; // If "to" is either a function or an array it will be processed async, therefor "to" should be empty right now
      // If the view relies on certain values "from" has to be present

      var queue = Promise.resolve(undefined);

      if (is.arr(props.to)) {
        var _loop = function _loop(i) {
          var index = i;

          var fresh = _extends({}, props, interpolateTo(props.to[index]));

          if (is.arr(fresh.config)) fresh.config = fresh.config[index];
          queue = queue.then(function () {
            //this.stop()
            if (local === _this11.guid) return new Promise(function (r) {
              return _this11.diff(fresh).start(r);
            });
          });
        };

        for (var i = 0; i < props.to.length; i++) {
          _loop(i);
        }
      } else if (is.fun(props.to)) {
        var _index = 0;
        var last;
        queue = queue.then(function () {
          return props.to( // next(props)
          function (p) {
            var fresh = _extends({}, props, interpolateTo(p));

            if (is.arr(fresh.config)) fresh.config = fresh.config[_index];
            _index++; //this.stop()

            if (local === _this11.guid) return last = new Promise(function (r) {
              return _this11.diff(fresh).start(r);
            });
            return;
          }, // cancel()
          function (finished) {
            if (finished === void 0) {
              finished = true;
            }

            return _this.stop(finished);
          }).then(function () {
            return last;
          });
        });
      }

      queue.then(onEnd);
    }
  }, {
    key: "diff",
    value: function diff(props) {
      var _this12 = this;

      this.props = _extends({}, this.props, props);
      var _this$props = this.props,
          _this$props$from = _this$props.from,
          from = _this$props$from === void 0 ? {} : _this$props$from,
          _this$props$to = _this$props.to,
          to = _this$props$to === void 0 ? {} : _this$props$to,
          _this$props$config = _this$props.config,
          config = _this$props$config === void 0 ? {} : _this$props$config,
          reverse = _this$props.reverse,
          attach = _this$props.attach,
          reset = _this$props.reset,
          immediate = _this$props.immediate; // Reverse values when requested

      if (reverse) {
        var _ref6 = [to, from];
        from = _ref6[0];
        to = _ref6[1];
      } // This will collect all props that were ever set, reset merged props when necessary


      this.merged = _extends({}, from, this.merged, to);
      this.hasChanged = false; // Attachment handling, trailed springs can "attach" themselves to a previous spring

      var target = attach && attach(this); // Reduces input { name: value } pairs into animated values

      this.animations = Object.entries(this.merged).reduce(function (acc, _ref7) {
        var name = _ref7[0],
            value = _ref7[1]; // Issue cached entries, except on reset

        var entry = acc[name] || {}; // Figure out what the value is supposed to be

        var isNumber = is.num(value);
        var isString = is.str(value) && !value.startsWith('#') && !/\d/.test(value) && !colorNames[value];
        var isArray = is.arr(value);
        var isInterpolation = !isNumber && !isArray && !isString;
        var fromValue = !is.und(from[name]) ? from[name] : value;
        var toValue = isNumber || isArray ? value : isString ? value : 1;
        var toConfig = callProp(config, name);
        if (target) toValue = target.animations[name].parent;
        var parent = entry.parent,
            interpolation$$1 = entry.interpolation,
            toValues = toArray$1(target ? toValue.getPayload() : toValue),
            animatedValues;
        var newValue = value;
        if (isInterpolation) newValue = interpolation({
          range: [0, 1],
          output: [value, value]
        })(1);
        var currentValue = interpolation$$1 && interpolation$$1.getValue(); // Change detection flags

        var isFirst = is.und(parent);
        var isActive = !isFirst && entry.animatedValues.some(function (v) {
          return !v.done;
        });
        var currentValueDiffersFromGoal = !is.equ(newValue, currentValue);
        var hasNewGoal = !is.equ(newValue, entry.previous);
        var hasNewConfig = !is.equ(toConfig, entry.config); // Change animation props when props indicate a new goal (new value differs from previous one)
        // and current values differ from it. Config changes trigger a new update as well (though probably shouldn't?)

        if (reset || hasNewGoal && currentValueDiffersFromGoal || hasNewConfig) {
          // Convert regular values into animated values, ALWAYS re-use if possible
          if (isNumber || isString) parent = interpolation$$1 = entry.parent || new AnimatedValue(fromValue);else if (isArray) parent = interpolation$$1 = entry.parent || new AnimatedValueArray(fromValue);else if (isInterpolation) {
            var prev = entry.interpolation && entry.interpolation.calc(entry.parent.value);
            prev = prev !== void 0 && !reset ? prev : fromValue;

            if (entry.parent) {
              parent = entry.parent;
              parent.setValue(0, false);
            } else parent = new AnimatedValue(0);

            var range = {
              output: [prev, value]
            };

            if (entry.interpolation) {
              interpolation$$1 = entry.interpolation;
              entry.interpolation.updateConfig(range);
            } else interpolation$$1 = parent.interpolate(range);
          }
          toValues = toArray$1(target ? toValue.getPayload() : toValue);
          animatedValues = toArray$1(parent.getPayload());
          if (reset && !isInterpolation) parent.setValue(fromValue, false);
          _this12.hasChanged = true; // Reset animated values

          animatedValues.forEach(function (value) {
            value.startPosition = value.value;
            value.lastPosition = value.value;
            value.lastVelocity = isActive ? value.lastVelocity : undefined;
            value.lastTime = isActive ? value.lastTime : undefined;
            value.startTime = now();
            value.done = false;
            value.animatedStyles.clear();
          }); // Set immediate values

          if (callProp(immediate, name)) {
            parent.setValue(isInterpolation ? toValue : value, false);
          }

          return _extends({}, acc, _defineProperty({}, name, _extends({}, entry, {
            name: name,
            parent: parent,
            interpolation: interpolation$$1,
            animatedValues: animatedValues,
            toValues: toValues,
            previous: newValue,
            config: toConfig,
            fromValues: toArray$1(parent.getValue()),
            immediate: callProp(immediate, name),
            initialVelocity: withDefault(toConfig.velocity, 0),
            clamp: withDefault(toConfig.clamp, false),
            precision: withDefault(toConfig.precision, 0.01),
            tension: withDefault(toConfig.tension, 170),
            friction: withDefault(toConfig.friction, 26),
            mass: withDefault(toConfig.mass, 1),
            duration: toConfig.duration,
            easing: withDefault(toConfig.easing, function (t) {
              return t;
            }),
            decay: toConfig.decay
          })));
        } else {
          if (!currentValueDiffersFromGoal) {
            // So ... the current target value (newValue) appears to be different from the previous value,
            // which normally constitutes an update, but the actual value (currentValue) matches the target!
            // In order to resolve this without causing an animation update we silently flag the animation as done,
            // which it technically is. Interpolations also needs a config update with their target set to 1.
            if (isInterpolation) {
              parent.setValue(1, false);
              interpolation$$1.updateConfig({
                output: [newValue, newValue]
              });
            }

            parent.done = true;
            _this12.hasChanged = true;
            return _extends({}, acc, _defineProperty({}, name, _extends({}, acc[name], {
              previous: newValue
            })));
          }

          return acc;
        }
      }, this.animations);

      if (this.hasChanged) {
        // Make animations available to frameloop
        this.configs = Object.values(this.animations);
        this.values = {};
        this.interpolations = {};

        for (var key in this.animations) {
          this.interpolations[key] = this.animations[key].interpolation;
          this.values[key] = this.animations[key].interpolation.getValue();
        }
      }

      return this;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.stop();
      this.props = {};
      this.merged = {};
      this.animations = {};
      this.interpolations = {};
      this.values = {};
      this.configs = [];
      this.local = 0;
    }
  }]);

  return Controller;
}();
/** API
 * const props = useSprings(number, [{ ... }, { ... }, ...])
 * const [props, set] = useSprings(number, (i, controller) => ({ ... }))
 */


var useSprings = function useSprings(length, props) {
  var mounted = useRef(false);
  var ctrl = useRef();
  var isFn = is.fun(props); // The controller maintains the animation values, starts and stops animations

  var _useMemo = useMemo(function () {
    // Remove old controllers
    if (ctrl.current) {
      ctrl.current.map(function (c) {
        return c.destroy();
      });
      ctrl.current = undefined;
    }

    var ref;
    return [new Array(length).fill().map(function (_, i) {
      var ctrl = new Controller();
      var newProps = isFn ? callProp(props, i, ctrl) : props[i];
      if (i === 0) ref = newProps.ref;
      ctrl.update(newProps);
      if (!ref) ctrl.start();
      return ctrl;
    }), ref];
  }, [length]),
      controllers = _useMemo[0],
      ref = _useMemo[1];

  ctrl.current = controllers; // The hooks reference api gets defined here ...

  var api = useImperativeHandle(ref, function () {
    return {
      start: function start() {
        return Promise.all(ctrl.current.map(function (c) {
          return new Promise(function (r) {
            return c.start(r);
          });
        }));
      },
      stop: function stop(finished) {
        return ctrl.current.forEach(function (c) {
          return c.stop(finished);
        });
      },

      get controllers() {
        return ctrl.current;
      }

    };
  }); // This function updates the controllers

  var updateCtrl = useMemo(function () {
    return function (updateProps) {
      return ctrl.current.map(function (c, i) {
        c.update(isFn ? callProp(updateProps, i, c) : updateProps[i]);
        if (!ref) c.start();
      });
    };
  }, [length]); // Update controller if props aren't functional

  useEffect(function () {
    if (mounted.current) {
      if (!isFn) updateCtrl(props);
    } else if (!ref) ctrl.current.forEach(function (c) {
      return c.start();
    });
  }); // Update mounted flag and destroy controller on unmount

  useEffect(function () {
    return mounted.current = true, function () {
      return ctrl.current.forEach(function (c) {
        return c.destroy();
      });
    };
  }, []); // Return animated props, or, anim-props + the update-setter above

  var propValues = ctrl.current.map(function (c) {
    return c.getValues();
  });
  return isFn ? [propValues, updateCtrl, function (finished) {
    return ctrl.current.forEach(function (c) {
      return c.pause(finished);
    });
  }] : propValues;
};
/** API
 * const props = useSpring({ ... })
 * const [props, set] = useSpring(() => ({ ... }))
 */


var useSpring = function useSpring(props) {
  var isFn = is.fun(props);

  var _useSprings = useSprings(1, isFn ? props : [props]),
      result = _useSprings[0],
      set = _useSprings[1],
      pause = _useSprings[2];

  return isFn ? [result[0], set, pause] : result;
};

var AnimatedStyle = /*#__PURE__*/function (_AnimatedObject2) {
  _inherits(AnimatedStyle, _AnimatedObject2);

  var _super7 = _createSuper(AnimatedStyle);

  function AnimatedStyle(style) {
    var _this13;

    _classCallCheck(this, AnimatedStyle);

    if (style === void 0) {
      style = {};
    }

    _this13 = _super7.call(this);

    if (style.transform && !(style.transform instanceof Animated)) {
      style = applyAnimatedValues.transform(style);
    }

    _this13.payload = style;
    return _this13;
  }

  return AnimatedStyle;
}(AnimatedObject); // http://www.w3.org/TR/css3-color/#svg-color


var colors = {
  transparent: 0x00000000,
  aliceblue: 0xf0f8ffff,
  antiquewhite: 0xfaebd7ff,
  aqua: 0x00ffffff,
  aquamarine: 0x7fffd4ff,
  azure: 0xf0ffffff,
  beige: 0xf5f5dcff,
  bisque: 0xffe4c4ff,
  black: 0x000000ff,
  blanchedalmond: 0xffebcdff,
  blue: 0x0000ffff,
  blueviolet: 0x8a2be2ff,
  brown: 0xa52a2aff,
  burlywood: 0xdeb887ff,
  burntsienna: 0xea7e5dff,
  cadetblue: 0x5f9ea0ff,
  chartreuse: 0x7fff00ff,
  chocolate: 0xd2691eff,
  coral: 0xff7f50ff,
  cornflowerblue: 0x6495edff,
  cornsilk: 0xfff8dcff,
  crimson: 0xdc143cff,
  cyan: 0x00ffffff,
  darkblue: 0x00008bff,
  darkcyan: 0x008b8bff,
  darkgoldenrod: 0xb8860bff,
  darkgray: 0xa9a9a9ff,
  darkgreen: 0x006400ff,
  darkgrey: 0xa9a9a9ff,
  darkkhaki: 0xbdb76bff,
  darkmagenta: 0x8b008bff,
  darkolivegreen: 0x556b2fff,
  darkorange: 0xff8c00ff,
  darkorchid: 0x9932ccff,
  darkred: 0x8b0000ff,
  darksalmon: 0xe9967aff,
  darkseagreen: 0x8fbc8fff,
  darkslateblue: 0x483d8bff,
  darkslategray: 0x2f4f4fff,
  darkslategrey: 0x2f4f4fff,
  darkturquoise: 0x00ced1ff,
  darkviolet: 0x9400d3ff,
  deeppink: 0xff1493ff,
  deepskyblue: 0x00bfffff,
  dimgray: 0x696969ff,
  dimgrey: 0x696969ff,
  dodgerblue: 0x1e90ffff,
  firebrick: 0xb22222ff,
  floralwhite: 0xfffaf0ff,
  forestgreen: 0x228b22ff,
  fuchsia: 0xff00ffff,
  gainsboro: 0xdcdcdcff,
  ghostwhite: 0xf8f8ffff,
  gold: 0xffd700ff,
  goldenrod: 0xdaa520ff,
  gray: 0x808080ff,
  green: 0x008000ff,
  greenyellow: 0xadff2fff,
  grey: 0x808080ff,
  honeydew: 0xf0fff0ff,
  hotpink: 0xff69b4ff,
  indianred: 0xcd5c5cff,
  indigo: 0x4b0082ff,
  ivory: 0xfffff0ff,
  khaki: 0xf0e68cff,
  lavender: 0xe6e6faff,
  lavenderblush: 0xfff0f5ff,
  lawngreen: 0x7cfc00ff,
  lemonchiffon: 0xfffacdff,
  lightblue: 0xadd8e6ff,
  lightcoral: 0xf08080ff,
  lightcyan: 0xe0ffffff,
  lightgoldenrodyellow: 0xfafad2ff,
  lightgray: 0xd3d3d3ff,
  lightgreen: 0x90ee90ff,
  lightgrey: 0xd3d3d3ff,
  lightpink: 0xffb6c1ff,
  lightsalmon: 0xffa07aff,
  lightseagreen: 0x20b2aaff,
  lightskyblue: 0x87cefaff,
  lightslategray: 0x778899ff,
  lightslategrey: 0x778899ff,
  lightsteelblue: 0xb0c4deff,
  lightyellow: 0xffffe0ff,
  lime: 0x00ff00ff,
  limegreen: 0x32cd32ff,
  linen: 0xfaf0e6ff,
  magenta: 0xff00ffff,
  maroon: 0x800000ff,
  mediumaquamarine: 0x66cdaaff,
  mediumblue: 0x0000cdff,
  mediumorchid: 0xba55d3ff,
  mediumpurple: 0x9370dbff,
  mediumseagreen: 0x3cb371ff,
  mediumslateblue: 0x7b68eeff,
  mediumspringgreen: 0x00fa9aff,
  mediumturquoise: 0x48d1ccff,
  mediumvioletred: 0xc71585ff,
  midnightblue: 0x191970ff,
  mintcream: 0xf5fffaff,
  mistyrose: 0xffe4e1ff,
  moccasin: 0xffe4b5ff,
  navajowhite: 0xffdeadff,
  navy: 0x000080ff,
  oldlace: 0xfdf5e6ff,
  olive: 0x808000ff,
  olivedrab: 0x6b8e23ff,
  orange: 0xffa500ff,
  orangered: 0xff4500ff,
  orchid: 0xda70d6ff,
  palegoldenrod: 0xeee8aaff,
  palegreen: 0x98fb98ff,
  paleturquoise: 0xafeeeeff,
  palevioletred: 0xdb7093ff,
  papayawhip: 0xffefd5ff,
  peachpuff: 0xffdab9ff,
  peru: 0xcd853fff,
  pink: 0xffc0cbff,
  plum: 0xdda0ddff,
  powderblue: 0xb0e0e6ff,
  purple: 0x800080ff,
  rebeccapurple: 0x663399ff,
  red: 0xff0000ff,
  rosybrown: 0xbc8f8fff,
  royalblue: 0x4169e1ff,
  saddlebrown: 0x8b4513ff,
  salmon: 0xfa8072ff,
  sandybrown: 0xf4a460ff,
  seagreen: 0x2e8b57ff,
  seashell: 0xfff5eeff,
  sienna: 0xa0522dff,
  silver: 0xc0c0c0ff,
  skyblue: 0x87ceebff,
  slateblue: 0x6a5acdff,
  slategray: 0x708090ff,
  slategrey: 0x708090ff,
  snow: 0xfffafaff,
  springgreen: 0x00ff7fff,
  steelblue: 0x4682b4ff,
  tan: 0xd2b48cff,
  teal: 0x008080ff,
  thistle: 0xd8bfd8ff,
  tomato: 0xff6347ff,
  turquoise: 0x40e0d0ff,
  violet: 0xee82eeff,
  wheat: 0xf5deb3ff,
  white: 0xffffffff,
  whitesmoke: 0xf5f5f5ff,
  yellow: 0xffff00ff,
  yellowgreen: 0x9acd32ff
}; // const INTEGER = '[-+]?\\d+';

var NUMBER = '[-+]?\\d*\\.?\\d+';
var PERCENTAGE = NUMBER + '%';

function call() {
  for (var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++) {
    parts[_key] = arguments[_key];
  }

  return '\\(\\s*(' + parts.join(')\\s*,\\s*(') + ')\\s*\\)';
}

var rgb = new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER));
var rgba = new RegExp('rgba' + call(NUMBER, NUMBER, NUMBER, NUMBER));
var hsl = new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE));
var hsla = new RegExp('hsla' + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER));
var hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex6 = /^#([0-9a-fA-F]{6})$/;
var hex8 = /^#([0-9a-fA-F]{8})$/;
/*
https://github.com/react-community/normalize-css-color

BSD 3-Clause License

Copyright (c) 2016, React Community
All rights reserved.

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

* Redistributions of source code must retain the above copyright notice, this
  list of conditions and the following disclaimer.

* Redistributions in binary form must reproduce the above copyright notice,
  this list of conditions and the following disclaimer in the documentation
  and/or other materials provided with the distribution.

* Neither the name of the copyright holder nor the names of its
  contributors may be used to endorse or promote products derived from
  this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

function normalizeColor(color) {
  var match;

  if (typeof color === 'number') {
    return color >>> 0 === color && color >= 0 && color <= 0xffffffff ? color : null;
  } // Ordered based on occurrences on Facebook codebase


  if (match = hex6.exec(color)) return parseInt(match[1] + 'ff', 16) >>> 0;
  if (colors.hasOwnProperty(color)) return colors[color];

  if (match = rgb.exec(color)) {
    return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    0x000000ff) >>> // a
    0;
  }

  if (match = rgba.exec(color)) {
    return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    parse1(match[4])) >>> // a
    0;
  }

  if (match = hex3.exec(color)) {
    return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    'ff', // a
    16) >>> 0;
  } // https://drafts.csswg.org/css-color-4/#hex-notation


  if (match = hex8.exec(color)) return parseInt(match[1], 16) >>> 0;

  if (match = hex4.exec(color)) {
    return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
  }

  if (match = hsl.exec(color)) {
    return (hslToRgb(parse360(match[1]), // h
    parsePercentage(match[2]), // s
    parsePercentage(match[3]) // l
    ) | 0x000000ff) >>> // a
    0;
  }

  if (match = hsla.exec(color)) {
    return (hslToRgb(parse360(match[1]), // h
    parsePercentage(match[2]), // s
    parsePercentage(match[3]) // l
    ) | parse1(match[4])) >>> // a
    0;
  }

  return null;
}

function hue2rgb(p, q, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p + (q - p) * 6 * t;
  if (t < 1 / 2) return q;
  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}

function hslToRgb(h, s, l) {
  var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  var p = 2 * l - q;
  var r = hue2rgb(p, q, h + 1 / 3);
  var g = hue2rgb(p, q, h);
  var b = hue2rgb(p, q, h - 1 / 3);
  return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}

function parse255(str) {
  var _int = parseInt(str, 10);

  if (_int < 0) return 0;
  if (_int > 255) return 255;
  return _int;
}

function parse360(str) {
  var _int2 = parseFloat(str);

  return (_int2 % 360 + 360) % 360 / 360;
}

function parse1(str) {
  var num = parseFloat(str);
  if (num < 0) return 0;
  if (num > 1) return 255;
  return Math.round(num * 255);
}

function parsePercentage(str) {
  // parseFloat conveniently ignores the final %
  var _int3 = parseFloat(str);

  if (_int3 < 0) return 0;
  if (_int3 > 100) return 1;
  return _int3 / 100;
}

function colorToRgba(input) {
  var int32Color = normalizeColor(input);
  if (int32Color === null) return input;
  int32Color = int32Color || 0;
  var r = (int32Color & 0xff000000) >>> 24;
  var g = (int32Color & 0x00ff0000) >>> 16;
  var b = (int32Color & 0x0000ff00) >>> 8;
  var a = (int32Color & 0x000000ff) / 255;
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
} // Problem: https://github.com/animatedjs/animated/pull/102
// Solution: https://stackoverflow.com/questions/638565/parsing-scientific-notation-sensibly/658662


var stringShapeRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g; // Covers rgb, rgba, hsl, hsla
// Taken from https://gist.github.com/olmokramer/82ccce673f86db7cda5e

var colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi; // Covers color names (transparent, blue, etc.)

var colorNamesRegex = new RegExp("(".concat(Object.keys(colors).join('|'), ")"), 'g');
/**
 * Supports string shapes by extracting numbers so new values can be computed,
 * and recombines those values into new strings of the same shape.  Supports
 * things like:
 *
 *   rgba(123, 42, 99, 0.36)           // colors
 *   -45deg                            // values with units
 *   0 2px 2px 0px rgba(0, 0, 0, 0.12) // box shadows
 */

var createStringInterpolator = function createStringInterpolator(config) {
  // Replace colors with rgba
  var outputRange = config.output.map(function (rangeValue) {
    return rangeValue.replace(colorRegex, colorToRgba);
  }).map(function (rangeValue) {
    return rangeValue.replace(colorNamesRegex, colorToRgba);
  });
  var outputRanges = outputRange[0].match(stringShapeRegex).map(function () {
    return [];
  });
  outputRange.forEach(function (value) {
    value.match(stringShapeRegex).forEach(function (number, i) {
      return outputRanges[i].push(+number);
    });
  });
  var interpolations = outputRange[0].match(stringShapeRegex).map(function (_value, i) {
    return createInterpolator(_extends({}, config, {
      output: outputRanges[i]
    }));
  });
  return function (input) {
    var i = 0;
    return outputRange[0] // 'rgba(0, 100, 200, 0)'
    // ->
    // 'rgba(${interpolations[0](input)}, ${interpolations[1](input)}, ...'
    .replace(stringShapeRegex, function () {
      return interpolations[i++](input);
    }) // rgba requires that the r,g,b are integers.... so we want to round them, but we *dont* want to
    // round the opacity (4th column).
    .replace(/rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi, function (_, p1, p2, p3, p4) {
      return "rgba(".concat(Math.round(p1), ", ").concat(Math.round(p2), ", ").concat(Math.round(p3), ", ").concat(p4, ")");
    });
  };
};

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

var prefixKey = function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
};

var prefixes = ['Webkit', 'Ms', 'Moz', 'O'];
isUnitlessNumber = Object.keys(isUnitlessNumber).reduce(function (acc, prop) {
  prefixes.forEach(function (prefix) {
    return acc[prefixKey(prefix, prop)] = acc[prop];
  });
  return acc;
}, isUnitlessNumber);

function dangerousStyleValue(name, value, isCustomProperty) {
  if (value == null || typeof value === 'boolean' || value === '') return '';
  if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers

  return ('' + value).trim();
}

var attributeCache = {};
injectCreateAnimatedStyle(function (style) {
  return new AnimatedStyle(style);
});
injectDefaultElement('div');
injectStringInterpolator(createStringInterpolator);
injectColorNames(colors);
injectApplyAnimatedValues(function (instance, props) {
  if (instance.nodeType && instance.setAttribute !== undefined) {
    var style = props.style,
        children = props.children,
        scrollTop = props.scrollTop,
        scrollLeft = props.scrollLeft,
        attributes = _objectWithoutPropertiesLoose(props, ["style", "children", "scrollTop", "scrollLeft"]);

    var filter = instance.nodeName === 'filter' || instance.parentNode && instance.parentNode.nodeName === 'filter';
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft; // Set textContent, if children is an animatable value

    if (children !== void 0) instance.textContent = children; // Set styles ...

    for (var styleName in style) {
      if (!style.hasOwnProperty(styleName)) continue;
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = dangerousStyleValue(styleName, style[styleName], isCustomProperty);
      if (styleName === 'float') styleName = 'cssFloat';
      if (isCustomProperty) instance.style.setProperty(styleName, styleValue);else instance.style[styleName] = styleValue;
    } // Set attributes ...


    for (var name in attributes) {
      // Attributes are written in dash case
      var dashCase = filter ? name : attributeCache[name] || (attributeCache[name] = name.replace(/([A-Z])/g, function (n) {
        return '-' + n.toLowerCase();
      }));
      if (typeof instance.getAttribute(dashCase) !== 'undefined') instance.setAttribute(dashCase, attributes[name]);
    }

    return;
  } else return false;
}, function (style) {
  return style;
});
var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan']; // Extend animated with all the available THREE elements

var apply = merge$3(createAnimatedComponent, false);
var extendedAnimated = apply(domElements);

var _templateObject$e = taggedTemplateLiteral(["\n    width: 100%;\n    ", ";\n    ", ";\n  "], ["\n    width: 100%;\n    ", ";\n    ", ";\n  "]),
    _templateObject2$a = taggedTemplateLiteral(["\n    width: 100%;\n    ", ";\n    z-index: 6;\n    ", ";\n    @media (min-width: ", ") {\n      #hamburger-menu-icon {\n        display: none;\n      }\n    }\n    @media (max-width: ", ") {\n      #inline-links {\n        display: none;\n      }\n    }\n    ", "\n  "], ["\n    width: 100%;\n    ", ";\n    z-index: 6;\n    ", ";\n    @media (min-width: ", ") {\n      #hamburger-menu-icon {\n        display: none;\n      }\n    }\n    @media (max-width: ", ") {\n      #inline-links {\n        display: none;\n      }\n    }\n    ", "\n  "]),
    _templateObject3$7 = taggedTemplateLiteral(["\n    display: block;\n    position: fixed;\n    background: ", ";\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n    z-index: 8;\n    opacity: 0;\n    pointer-events: none;\n    transition: 0.2s;\n    ", "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    #floating-links {\n      ", "\n    }\n  "], ["\n    display: block;\n    position: fixed;\n    background: ", ";\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n    z-index: 8;\n    opacity: 0;\n    pointer-events: none;\n    transition: 0.2s;\n    ", "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    #floating-links {\n      ", "\n    }\n  "]),
    _templateObject4$3 = taggedTemplateLiteral(["\n          z-index: 3;\n          box-shadow: ", ";\n          border-bottom: ", " !important;\n          ", "\n        "], ["\n          z-index: 3;\n          box-shadow: ", ";\n          border-bottom: ", " !important;\n          ", "\n        "]),
    _templateObject5$3 = taggedTemplateLiteral(["\n                z-index: 3;\n                box-shadow: ", ";\n                border-bottom: ", " !important;\n                ", "\n              "], ["\n                z-index: 3;\n                box-shadow: ", ";\n                border-bottom: ", " !important;\n                ", "\n              "]),
    _templateObject6$2 = taggedTemplateLiteral(["\n      flex: 0 0 auto;\n      width: ", "px;\n      height: ", "px;\n      margin-left: ", " !important;\n      position: relative;\n      cursor: pointer;\n      transform: rotate(0deg);\n      z-index: 5;\n    "], ["\n      flex: 0 0 auto;\n      width: ", "px;\n      height: ", "px;\n      margin-left: ", " !important;\n      position: relative;\n      cursor: pointer;\n      transform: rotate(0deg);\n      z-index: 5;\n    "]),
    _templateObject7$1 = taggedTemplateLiteral(["\n      display: block;\n      height: ", "px;\n      width: 100%;\n      background: ", ";\n      border-radius: 1px;\n      transform-origin: center;\n      position: absolute;\n    "], ["\n      display: block;\n      height: ", "px;\n      width: 100%;\n      background: ", ";\n      border-radius: 1px;\n      transform-origin: center;\n      position: absolute;\n    "]),
    _templateObject8$1 = taggedTemplateLiteral(["\n      margin-top: ", "px;\n    "], ["\n      margin-top: ", "px;\n    "]),
    _templateObject9$1 = taggedTemplateLiteral(["\n      top: ", "px;\n      margin-top: ", "px;\n    "], ["\n      top: ", "px;\n      margin-top: ", "px;\n    "]);

var Header = function Header(props) {
  var config$$1 = useConfig();
  var _config$header = config$$1.header,
      configBackground = _config$header.background,
      openMenuBackground = _config$header.openMenuBackground,
      shadow = _config$header.shadow,
      configBorder = _config$header.border,
      configHeight = _config$header.height,
      linksGap = _config$header.linksGap,
      configBreakPoint = _config$header.breakPoint,
      centerLinksOnFullscreen = _config$header.centerLinksOnFullscreen,
      centeredElementsZoom = _config$header.centeredElementsZoom,
      fixedConfig = _config$header.fixed;
  var animationCurveIn = config$$1.animations.animationCurveIn;
  var width = props.width,
      children = props.children,
      _props$breakPoint = props.breakPoint,
      breakPoint = _props$breakPoint === undefined ? configBreakPoint : _props$breakPoint,
      _props$height = props.height,
      height = _props$height === undefined ? configHeight : _props$height,
      heightBreakPoint = props.heightBreakPoint,
      _props$background = props.background,
      background = _props$background === undefined ? configBackground : _props$background,
      _props$border = props.border,
      border = _props$border === undefined ? configBorder : _props$border,
      leftComponents = props.leftComponents,
      rightComponents = props.rightComponents,
      permanentComponents = props.permanentComponents,
      _props$fixed = props.fixed,
      fixed = _props$fixed === undefined ? fixedConfig : _props$fixed;

  var _useState = useState(false),
      _useState2 = slicedToArray(_useState, 2),
      menuOpen = _useState2[0],
      setMenuOpen = _useState2[1];

  var window = useWindow();
  var linksTrasforms = "";

  for (var i = 0; i < 30; i++) {
    linksTrasforms = linksTrasforms + ("\n      > *:nth-child(" + i + "):not(style) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n        opacity: " + (menuOpen ? 1 : 0) + ";\n        transform: translateY(" + (!menuOpen ? i : 0) + "em);\n        transition: " + i * 2 / 10 + "s " + animationCurveIn + ";\n        " + (menuOpen ? "transition-delay: .1s;" : "transition-delay: 0.4s;") + ";\n      }\n    ");
  }

  var headerPlaceholderCSS = css(_templateObject$e, responsive("height", height, {
    breakPoint: heightBreakPoint
  }), responsive("min-height", height, {
    breakPoint: heightBreakPoint
  }));
  var headerCSS = css(_templateObject2$a, responsive("height", height, {
    breakPoint: heightBreakPoint
  }), fixed ? "\n      position: fixed;\n      top: 0;\n      left: 0;\n    " : "", breakPoint, breakPoint, !rightComponents ? "#hamburger-menu-icon{display: none;}" : "");
  var floatingDiv = css(_templateObject3$7, openMenuBackground, menuOpen && "\n      pointer-events: auto;\n      opacity: 1;\n    ", linksTrasforms);
  var leftLinksProps = {
    align: "left",
    gap: linksGap,
    noWrap: true,
    style: {
      flex: "0 1 auto"
    }
  };
  var rightLinksProps = {
    align: "right",
    gap: linksGap,
    noWrap: true,
    style: {
      flex: "0 1 auto"
    }
  };
  var permanentComponentProps = {
    align: "right",
    gap: linksGap,
    noWrap: true,
    style: {
      marginLeft: linksGap,
      paddingLeft: linksGap,
      flex: "0 1 auto"
    }
  };
  var HeaderPlaceholder = jsx("div", {
    css: headerPlaceholderCSS
  });
  var rightComponentsMobileVisibility = useMedia(["(max-width: " + breakPoint + ")"], [true], false);
  var HeaderInner = jsx("div", {
    css: headerCSS
  }, jsx(Section, {
    width: width,
    noPadding: true,
    noBorder: true,
    CSS: css(_templateObject4$3, shadow, border, responsive("height", height, {
      breakPoint: heightBreakPoint
    })),
    background: background,
    vAlign: "center"
  }, children, jsx(HStack, {
    align: "spaced",
    vAlign: "center",
    noWrap: true,
    gap: 0
  }, jsx(HStack, leftLinksProps, leftComponents), jsx("div", {
    style: {
      flex: "99 1 auto"
    }
  }), jsx(HStack, _extends({
    id: "inline-links"
  }, rightLinksProps), !rightComponentsMobileVisibility && rightComponents), jsx(HStack, permanentComponentProps, permanentComponents), jsx(HamburgerMenu, {
    id: "hamburger-menu-icon",
    config: config$$1,
    setMenuOpen: setMenuOpen,
    menuOpen: menuOpen
  }))), window && ReactDOM.createPortal(jsx("div", {
    css: floatingDiv
  }, jsx(Section, {
    noBorder: true,
    noPadding: true,
    style: {
      zIndex: 3,
      height: height
    },
    CSS: css(_templateObject5$3, shadow, border, responsive("height", height, {
      breakPoint: heightBreakPoint
    })),
    background: "transparent",
    vAlign: "center"
  }, jsx(HStack, {
    align: "spaced",
    vAlign: "center",
    wrap: false
  }, jsx("div", null), jsx(HamburgerMenu, {
    config: config$$1,
    setMenuOpen: setMenuOpen,
    menuOpen: menuOpen
  }))), jsx(Section, {
    noBorder: true,
    noPadding: true,
    background: "transparent",
    center: centerLinksOnFullscreen,
    style: {
      zoom: centeredElementsZoom
    }
  }, children, jsx(VStack, {
    style: {
      lineHeight: 1.8
    },
    id: "floating-links",
    align: "right",
    center: centerLinksOnFullscreen
  }, rightComponentsMobileVisibility && rightComponents))), document.querySelector("body")));

  if (!fixed) {
    return HeaderInner;
  } else {
    return jsx(Fragment, null, HeaderPlaceholder, window && ReactDOM.createPortal(HeaderInner, document.querySelector("body")));
  }
};

var HamburgerMenu = function HamburgerMenu(props) {
  var id = props.id,
      config$$1 = props.config,
      setMenuOpen = props.setMenuOpen,
      menuOpen = props.menuOpen;
  var _config$header2 = config$$1.header,
      hamburgerMenuColorConfig = _config$header2.hamburgerMenuColor,
      configBackground = _config$header2.background,
      hamburgerMenuStrokeWidth = _config$header2.hamburgerMenuStrokeWidth,
      hamburgerMenuHeight = _config$header2.hamburgerMenuHeight,
      hamburgerMenuWidth = _config$header2.hamburgerMenuWidth;

  var hamburgerMenuColor = function () {
    if (configBackground === "transparent") return hamburgerMenuColorConfig;
    if (tinycolor(configBackground).getLuminance() < 0.6) return "white";
    return hamburgerMenuColorConfig;
  }();

  var fast = config$$1.animations.springs.fast;
  var halfHeight = hamburgerMenuHeight / 2,
      strokeWidth = hamburgerMenuStrokeWidth,
      halfStrokeWidth = "-" + strokeWidth / 2;
  var styles = {
    container: css(_templateObject6$2, hamburgerMenuWidth, hamburgerMenuHeight, unitMultiply(config$$1.header.linksGap, 2)),
    lineBase: css(_templateObject7$1, strokeWidth, hamburgerMenuColor || "#000"),
    firstLine: css(_templateObject8$1, halfStrokeWidth),
    secondLine: css(_templateObject9$1, halfHeight, halfStrokeWidth),
    thirdLine: css(_templateObject8$1, halfStrokeWidth)
  };
  var style1 = useSpring({
    to: {
      transform: "translate3d(0," + (menuOpen ? halfHeight : 0) + "px,0) rotate(" + (menuOpen ? 45 : 0) + "deg)"
    },
    config: _extends({}, fast)
  });
  var style2 = useSpring({
    to: {
      opacity: menuOpen ? 0 : 1
    },
    config: _extends({}, fast)
  });
  var style3 = useSpring({
    to: {
      transform: "translate3d(0," + (menuOpen ? halfHeight : hamburgerMenuHeight) + "px,0) rotate(" + (menuOpen ? -45 : 0) + "deg)"
    },
    config: _extends({}, fast)
  });
  return jsx("div", {
    css: styles.container,
    onClick: function onClick() {
      setMenuOpen(!menuOpen);
    },
    id: id
  }, jsx(extendedAnimated.div, {
    css: [styles.lineBase, styles.firstLine],
    style: style1
  }), jsx(extendedAnimated.div, {
    css: [styles.lineBase, styles.secondLine],
    style: style2
  }), jsx(extendedAnimated.div, {
    css: [styles.lineBase, styles.thirdLine],
    style: style3
  }));
};

Header.propTypes = {
  /** A logo component or image to diplay in the header. */
  logoComponent: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),

  /** Link components that will float inside the header. **/
  linksComponents: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),

  /** Height override, elements will stay vertically centered.  */
  height: PropTypes.string,

  /** Background of the header, defaults to transparent. */
  background: PropTypes.string
};

var _templateObject$f = taggedTemplateLiteral(["\n    z-index: 6;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: ", ";\n    min-height: ", ";\n    background: ", ";\n  "], ["\n    z-index: 6;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: ", ";\n    min-height: ", ";\n    background: ", ";\n  "]),
    _templateObject2$b = taggedTemplateLiteral(["\n    width: 100%;\n    height: ", ";\n    min-height: ", ";\n  "], ["\n    width: 100%;\n    height: ", ";\n    min-height: ", ";\n  "]);

var FloatingFooter = function FloatingFooter(props) {
  var config = useConfig();
  var _config$floatingFoote = config.floatingFooter,
      configBackground = _config$floatingFoote.background,
      configBorder = _config$floatingFoote.border,
      shadow = _config$floatingFoote.shadow,
      configHeight = _config$floatingFoote.height,
      externalCSS = _config$floatingFoote.CSS;
  var children = props.children,
      _props$height = props.height,
      height = _props$height === undefined ? configHeight : _props$height,
      _props$background = props.background,
      background = _props$background === undefined ? configBackground : _props$background,
      _props$border = props.border,
      border = _props$border === undefined ? configBorder : _props$border,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === undefined ? true : _props$placeholder;
  var window = useWindow();
  var footerCSS = css(_templateObject$f, height, height, background);
  var footerPlaceholderCSS = css(_templateObject2$b, height, height);
  var FooterPlaceholder = jsx("div", {
    css: footerPlaceholderCSS
  });
  var FooterInner = jsx("div", {
    css: [footerCSS, externalCSS]
  }, jsx(Section, {
    noPadding: true,
    noBorder: true,
    style: {
      zIndex: 3,
      height: height,
      boxShadow: shadow,
      borderTop: border
    },
    background: background,
    vAlign: "center"
  }, children));
  return jsx(Fragment, null, placeholder && FooterPlaceholder, window && ReactDOM.createPortal(FooterInner, document.querySelector("body")));
};

var _templateObject$g = taggedTemplateLiteral(["\n    box-sizing: border-box;\n    display: grid;\n    grid-template-columns: ", ";\n    grid-template-rows: ", ";\n    grid-gap: ", ";\n    align-items: ", ";\n    ", "\n    ", "\n    ", "\n    ", "\n    @media (max-width: ", ") {\n      grid-template-columns: 1fr;\n    }\n  "], ["\n    box-sizing: border-box;\n    display: grid;\n    grid-template-columns: ", ";\n    grid-template-rows: ", ";\n    grid-gap: ", ";\n    align-items: ", ";\n    ", "\n    ", "\n    ", "\n    ", "\n    @media (max-width: ", ") {\n      grid-template-columns: 1fr;\n    }\n  "]);

var Grid = function Grid(props) {
  var config = useConfig();
  var gridGap = config.layout.gridGap;
  var children = props.children,
      _props$columns = props.columns,
      columns = _props$columns === undefined ? "1fr 1fr" : _props$columns,
      align = props.align,
      _props$vAlign = props.vAlign,
      vAlign = _props$vAlign === undefined ? "stretch" : _props$vAlign,
      _props$gap = props.gap,
      gap = _props$gap === undefined ? gridGap : _props$gap,
      _props$rows = props.rows,
      rows = _props$rows === undefined ? "1fr" : _props$rows,
      breakAt = props.breakAt,
      id = props.id,
      externalCSS = props.CSS,
      expand = props.expand,
      width = props.width;
  var alignItems = getVAlign(vAlign);
  var justifyItems = getHAlign(align);

  var style = _extends({}, config.Grid.style, props.style);

  var mainCSS = css(_templateObject$g, columns, rows, gap, alignItems, align ? "justify-items: " + justifyItems + ";" : "", width ? "width: " + width + ";" : "", showHideCss(props), expand ? "\n      flex: 1 1 auto;\n      width: 100%;" : "", breakAt);
  return jsx("div", {
    style: style,
    id: id,
    css: [mainCSS, externalCSS]
  }, children);
};

var _templateObject$h = taggedTemplateLiteral(["\n    min-height: ", ";\n  "], ["\n    min-height: ", ";\n  "]),
    _templateObject2$c = taggedTemplateLiteral(["\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    align-items: center;\n    justify-content: ", ";\n    /* overflow: hidden; */\n    li {\n      padding: ", ";\n      border-radius: ", ";\n      cursor: pointer;\n      position: relative;\n      transition: none;\n      font-size: ", ";\n      font-weight: 500;\n      ", "\n    }\n    li#active {\n      background: ", ";\n      box-shadow: ", ";\n      ", "\n    }\n    @media (max-width: ", ") {\n      display: flex;\n      li:not(#active) {\n        display: none;\n      }\n      li#active {\n        flex: 1 1 100%;\n        text-align: center;\n      }\n    }\n  "], ["\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    align-items: center;\n    justify-content: ", ";\n    /* overflow: hidden; */\n    li {\n      padding: ", ";\n      border-radius: ", ";\n      cursor: pointer;\n      position: relative;\n      transition: none;\n      font-size: ", ";\n      font-weight: 500;\n      ", "\n    }\n    li#active {\n      background: ", ";\n      box-shadow: ", ";\n      ", "\n    }\n    @media (max-width: ", ") {\n      display: flex;\n      li:not(#active) {\n        display: none;\n      }\n      li#active {\n        flex: 1 1 100%;\n        text-align: center;\n      }\n    }\n  "]),
    _templateObject3$8 = taggedTemplateLiteral(["\n    > div {\n      display: none;\n    }\n    > div:nth-child(", "):not(style) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n      display: block;\n    }\n  "], ["\n    > div {\n      display: none;\n    }\n    > div:nth-child(", "):not(style) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n      display: block;\n    }\n  "]),
    _templateObject4$4 = taggedTemplateLiteral(["\n    ", "\n    padding-top: 0;\n    padding-bottom: 0;\n    position: relative;\n    /* top: 0.7em; */\n    @media (min-width: ", ") {\n      opacity: 0;\n      pointer-events: none;\n    }\n  "], ["\n    ", "\n    padding-top: 0;\n    padding-bottom: 0;\n    position: relative;\n    /* top: 0.7em; */\n    @media (min-width: ", ") {\n      opacity: 0;\n      pointer-events: none;\n    }\n  "]);

var TabSet = function TabSet(props) {
  var config = useConfig();
  var _config$tabs = config.tabs,
      tabsPadding = _config$tabs.tabsPadding,
      tabsRadius = _config$tabs.tabsRadius,
      tabsBackground = _config$tabs.tabsBackground,
      tabsActiveStyle = _config$tabs.tabsActiveStyle,
      tabsInactiveStyle = _config$tabs.tabsInactiveStyle,
      tabShadow = _config$tabs.tabShadow,
      tabsArrowIcons = _config$tabs.tabsArrowIcons,
      tabsArrowColor = _config$tabs.tabsArrowColor,
      tabsBreakPoint = _config$tabs.tabsBreakPoint;
  var layoutPadding = config.layout.layoutPadding;
  var buttonSize = config.fonts.sizes.Button;
  var children = props.children,
      tabs = props.tabs,
      _props$initialTab = props.initialTab,
      initialTab = _props$initialTab === undefined ? 0 : _props$initialTab,
      onTabChange = props.onTabChange,
      _props$align = props.align,
      align = _props$align === undefined ? "center" : _props$align,
      _props$background = props.background,
      background = _props$background === undefined ? tabsBackground : _props$background,
      _props$minHeight = props.minHeight,
      minHeight = _props$minHeight === undefined ? "auto" : _props$minHeight,
      _props$noShadow = props.noShadow,
      noShadow = _props$noShadow === undefined ? false : _props$noShadow,
      _props$breakPoint = props.breakPoint,
      breakPoint = _props$breakPoint === undefined ? tabsBreakPoint : _props$breakPoint,
      _props$arrowColor = props.arrowColor,
      arrowColor = _props$arrowColor === undefined ? tabsArrowColor : _props$arrowColor;

  var _useState = useState(initialTab),
      _useState2 = slicedToArray(_useState, 2),
      selectedTab = _useState2[0],
      setSelectedTab = _useState2[1];

  var lastTab = tabs.length - 1;
  var WrapperCSS = css(_templateObject$h, minHeight);
  var tabSetCSS = css(_templateObject2$c, align, tabsPadding, tabsRadius, buttonSize, tabsInactiveStyle, background, !noShadow ? tabShadow : "", tabsActiveStyle, breakPoint);
  var tabsContentCSS = css(_templateObject3$8, selectedTab + 1);
  var arrowCSS = css(_templateObject4$4, responsive("padding", layoutPadding), breakPoint);
  return jsx("div", {
    css: WrapperCSS
  }, jsx(Grid, {
    columns: "auto 1fr auto",
    vAlign: "center",
    gap: 0,
    breakAt: 0
  }, jsx("div", {
    css: arrowCSS
  }, jsx(Icon, {
    name: tabsArrowIcons[0],
    size: "1.3em",
    color: arrowColor,
    onClick: function onClick() {
      setSelectedTab(selectedTab - 1);
      onTabChange && onTabChange(tabs[selectedTab - 1], selectedTab - 1);
    },
    style: {
      opacity: selectedTab > 0 ? 1 : 0,
      pointerEvents: selectedTab > 0 ? "auto" : "none"
    }
  })), jsx("ul", {
    css: tabSetCSS
  }, tabs.map(function (tab, i) {
    var act = selectedTab === i;
    return jsx("li", {
      key: i,
      id: act ? "active" : "",
      onClick: function onClick() {
        setSelectedTab(i);
        onTabChange && onTabChange(tabs[i], i);
      }
    }, tab);
  })), jsx("div", {
    css: arrowCSS
  }, jsx(Icon, {
    name: tabsArrowIcons[1],
    size: "1.3em",
    color: arrowColor,
    onClick: function onClick() {
      setSelectedTab(selectedTab + 1);
      onTabChange && onTabChange(tabs[selectedTab + 1], selectedTab + 1);
    },
    style: {
      opacity: selectedTab < lastTab ? 1 : 0,
      pointerEvents: selectedTab < lastTab ? "auto" : "none"
    }
  }))), jsx("div", {
    id: "tabs-content",
    css: tabsContentCSS
  }, children));
};

var _templateObject$i = taggedTemplateLiteral(["\n    position: absolute;\n    pointer-events: none;\n    user-select: none;\n    opacity: ", ";\n    z-index: 10;\n    top: 0px;\n    left: 0px;\n    height: ", "px;\n    width: ", "%;\n    transition: ", ";\n    background: linear-gradient(to right, ", ", ", ");\n  "], ["\n    position: absolute;\n    pointer-events: none;\n    user-select: none;\n    opacity: ", ";\n    z-index: 10;\n    top: 0px;\n    left: 0px;\n    height: ", "px;\n    width: ", "%;\n    transition: ", ";\n    background: linear-gradient(to right, ", ", ", ");\n  "]);

var TopLoader = function TopLoader(props) {
  var config = useConfig();

  var _useState = useState(false),
      _useState2 = slicedToArray(_useState, 2),
      wasLoading = _useState2[0],
      setWasLoading = _useState2[1];

  var _config$topLoader = config.topLoader,
      configColor = _config$topLoader.color,
      configHeight = _config$topLoader.height,
      configDuration = _config$topLoader.duration;
  var _props$color = props.color,
      color = _props$color === undefined ? configColor : _props$color,
      _props$height = props.height,
      height = _props$height === undefined ? configHeight : _props$height,
      _props$loading = props.loading,
      loading = _props$loading === undefined ? false : _props$loading,
      _props$duration = props.duration,
      duration = _props$duration === undefined ? configDuration : _props$duration;

  var _useState3 = useState(0),
      _useState4 = slicedToArray(_useState3, 2),
      width = _useState4[0],
      setWidth = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = slicedToArray(_useState5, 2),
      opacity = _useState6[0],
      setOpacity = _useState6[1];

  var _useState7 = useState("0s"),
      _useState8 = slicedToArray(_useState7, 2),
      transition = _useState8[0],
      setTransition = _useState8[1];

  var color2 = tinycolor(color).setAlpha(0.2).toString();
  useEffect(function () {
    if (!loading && !wasLoading) {
      // START LOADING
      setTransition("0s");
      setWidth(0);
      setOpacity(0);
    } else if (loading && !wasLoading) {
      // LOADING
      setOpacity(1);
      setWidth(100);
      setTransition("width " + duration + " cubic-bezier(0.1, 0.1, 0, 1)");
      setWasLoading(true);
    } else if (!loading && wasLoading) {
      // FINISH LOADING
      setWidth(99.9);
      setOpacity(0);
      setTransition("width 1s, opacity 1s");
      var resetAnimation = setTimeout(function () {
        setWidth(100);
        setTransition("0s");
        setWasLoading(false);
      }, 1000);
      return function () {
        return clearTimeout(resetAnimation);
      };
    }
  }, [loading, wasLoading, width, transition]);
  var mainCSS = css(_templateObject$i, opacity, height, width, transition, color2, color);
  return jsx("div", {
    css: mainCSS
  });
};

var _templateObject$j = taggedTemplateLiteral(["\n    0% {\n      box-shadow: 0px 0px 0px 3px ", ";\n      ;\n    }\n    100% {\n      box-shadow: 0px 0px 0px 8px ", ";\n      ;\n    }\n  "], ["\n    0% {\n      box-shadow: 0px 0px 0px 3px ", ";\n      ;\n    }\n    100% {\n      box-shadow: 0px 0px 0px 8px ", ";\n      ;\n    }\n  "]),
    _templateObject2$d = taggedTemplateLiteral(["\n    ", "\n    overflow: hidden;\n    box-sizing: border-box;\n    font-weight: ", ";\n    border: none;\n    ", "\n    outline: none;\n    transition: ", ";\n    cursor: pointer;\n    user-select: none;\n    font-size: 1em;\n    ", "\n    > span, > div {\n      ", "\n    }\n  "], ["\n    ", "\n    overflow: hidden;\n    box-sizing: border-box;\n    font-weight: ", ";\n    border: none;\n    ", "\n    outline: none;\n    transition: ", ";\n    cursor: pointer;\n    user-select: none;\n    font-size: 1em;\n    ", "\n    > span, > div {\n      ", "\n    }\n  "]),
    _templateObject3$9 = taggedTemplateLiteral(["\n      ", "\n      background: ", ";\n      color: ", ";\n      a {\n\n      }\n      box-shadow: ", " ", ";\n      :hover {\n        background: ", ";\n      }\n      :active {\n        background: ", ";\n      }\n      ", "\n    "], ["\n      ", "\n      background: ", ";\n      color: ", ";\n      a {\n\n      }\n      box-shadow: ", " ", ";\n      :hover {\n        background: ", ";\n      }\n      :active {\n        background: ", ";\n      }\n      ", "\n    "]),
    _templateObject4$5 = taggedTemplateLiteral(["\n              animation: ", " 0.8s ease-in-out infinite alternate;\n            "], ["\n              animation: ", " 0.8s ease-in-out infinite alternate;\n            "]),
    _templateObject5$4 = taggedTemplateLiteral(["\n      ", "\n      background: ", ";\n      color: ", ";\n      :hover {\n        background: ", ";\n      }\n      :active {\n        background: ", ";\n      }\n    "], ["\n      ", "\n      background: ", ";\n      color: ", ";\n      :hover {\n        background: ", ";\n      }\n      :active {\n        background: ", ";\n      }\n    "]),
    _templateObject6$3 = taggedTemplateLiteral(["\n      ", "\n      background: transparent;\n      font-weight: ", ";\n      color: ", ";\n      border: none;\n      padding: 0;\n      outline: none;\n      border-bottom: ", " solid ", ";\n      outline: none;\n      text-align: center;\n      cursor: pointer;\n      :hover {\n        border-bottom: ", " solid\n          ", ";\n      }\n    "], ["\n      ", "\n      background: transparent;\n      font-weight: ", ";\n      color: ", ";\n      border: none;\n      padding: 0;\n      outline: none;\n      border-bottom: ", " solid ", ";\n      outline: none;\n      text-align: center;\n      cursor: pointer;\n      :hover {\n        border-bottom: ", " solid\n          ", ";\n      }\n    "]);

function getColorBasedOnLuminance(background, color, colorInverted, type) {
  var backgroundDark = tinycolor(background).getLuminance() < 0.6;

  if (type === "primary") {
    if (backgroundDark) {
      return color;
    } else {
      return colorInverted;
    }
  } else {
    return background;
  }
}

function transparent(color, alpha) {
  return tinycolor(color).setAlpha(alpha).toString();
}

function getShadowColor(background, color) {
  if (background) {
    return tinycolor(background).darken(30).setAlpha(0.1).toString();
  }

  return tinycolor(color).setAlpha(0.2).toString();
}

function lighten(color, lighten) {
  return tinycolor(color).lighten(lighten).toString();
}

function typeStyle$1(elem, config) {
  var f = config.fonts;
  return "\n    font-family: " + (f.faces[elem] || f.faces.normal || "inherit") + ";\n    font-weight: " + (f.weights[elem] || f.weights.normal || "inherit") + ";\n    line-height: " + (f.lineHeights[elem] || f.lineHeights.normal || "inherit") + ";\n  ";
}

function _styleForType(type, config, small, textColor, backgroundColor, glow) {
  var validTextColor = tinycolor(textColor).isValid() ? textColor : null;
  var validBackgroundColor = tinycolor(backgroundColor).isValid() ? backgroundColor : null;
  var _config$buttons = config.buttons,
      primaryColor = _config$buttons.primaryColor,
      secondaryColor = _config$buttons.secondaryColor,
      linksColor = _config$buttons.linksColor,
      buttonsHeight = _config$buttons.height,
      padding = _config$buttons.padding,
      smallHeight = _config$buttons.smallHeight,
      smallPadding = _config$buttons.smallPadding,
      radius = _config$buttons.radius,
      smallRadius = _config$buttons.smallRadius,
      shadowSize = _config$buttons.shadowSize,
      hoverLighten = _config$buttons.hoverLighten,
      activeLighten = _config$buttons.activeLighten,
      secondaryBackgroundAlpha = _config$buttons.secondaryBackgroundAlpha,
      whiteButtonsEffectConfig = _config$buttons.whiteButtonsEffect,
      transition = _config$buttons.transition,
      linkBorderSize = _config$buttons.linkBorderSize;
  var fontWeight = config.fonts.weights.Button;
  var linkBorderColor = validBackgroundColor ? transparent(validBackgroundColor, 0.2) : transparent(linksColor, 0.2);
  var shadowColor = getShadowColor(validBackgroundColor, primaryColor);
  var glowColorOn = tinycolor(validBackgroundColor).setAlpha(0.3).toString();
  var glowColorOff = tinycolor(validBackgroundColor).setAlpha(0.1).toString();
  var hoverBackgroundColor = lighten(validBackgroundColor || primaryColor, hoverLighten);
  var activeBackgroundColor = lighten(validBackgroundColor || primaryColor, activeLighten);
  var whiteButtonEffect = validBackgroundColor === "white" ? whiteButtonsEffectConfig : "";
  var secondaryButtonsColorTransparent = transparent(validBackgroundColor ? validBackgroundColor : secondaryColor, secondaryBackgroundAlpha);
  var secondaryHoverBackgroundColor = transparent(hoverBackgroundColor, secondaryBackgroundAlpha);
  var secondaryActiveBackgroundColor = transparent(activeBackgroundColor, secondaryBackgroundAlpha);
  var animatedGlow = keyframes(_templateObject$j, glowColorOff, glowColorOn);
  var generalStyle = css(_templateObject2$d, typeStyle$1("Button", config), fontWeight, small ? "\n      padding: " + smallPadding + ";\n      height: " + smallHeight + ";\n      border-radius: " + smallRadius + ";" : "\n      padding: " + padding + ";\n      height: " + buttonsHeight + ";\n      border-radius: " + radius + ";\n    ", transition, whiteButtonEffect, getFontSize("Button", config));
  var typeStyles = {
    primary: css(_templateObject3$9, generalStyle, validBackgroundColor ? validBackgroundColor : primaryColor, validTextColor, shadowSize, shadowColor, hoverBackgroundColor, activeBackgroundColor, glow ? css(_templateObject4$5, animatedGlow) : ""),
    secondary: css(_templateObject5$4, generalStyle, secondaryButtonsColorTransparent, validBackgroundColor ? validBackgroundColor : secondaryColor, secondaryHoverBackgroundColor, secondaryActiveBackgroundColor),
    link: css(_templateObject6$3, getFontSize("Button", config), fontWeight, validTextColor ? validTextColor : linksColor, linkBorderSize, linkBorderColor, linkBorderSize, validBackgroundColor ? validBackgroundColor : linksColor)
  };
  return typeStyles[type] || typeStyles["link"];
}

var _templateObject$k = taggedTemplateLiteral(["\n    position: relative;\n    width: ", ";\n    ", "\n    ", "\n    display: inline-flex !important;\n    ", "\n    svg {\n      opacity: ", ";\n    }\n\n    align-items: center;\n    justify-content: center;\n    :disabled {\n      cursor: auto;\n    }\n    ", "\n    ", "\n  "], ["\n    position: relative;\n    width: ", ";\n    ", "\n    ", "\n    display: inline-flex !important;\n    ", "\n    svg {\n      opacity: ", ";\n    }\n\n    align-items: center;\n    justify-content: center;\n    :disabled {\n      cursor: auto;\n    }\n    ", "\n    ", "\n  "]),
    _templateObject2$e = taggedTemplateLiteral(["\n          color: transparent !important;\n        "], ["\n          color: transparent !important;\n        "]),
    _templateObject3$a = taggedTemplateLiteral(["\n          opacity: 0.5;\n          :hover {\n            transform: none !important;\n          }\n        "], ["\n          opacity: 0.5;\n          :hover {\n            transform: none !important;\n          }\n        "]);

var Button = function Button(props) {
  var config = useConfig();
  var _config$icon = config.icon,
      configIconSize = _config$icon.sizeInButtons,
      strokeInButtons = _config$icon.strokeInButtons;
  var _config$buttons = config.buttons,
      primaryColor = _config$buttons.primaryColor,
      configTextColor = _config$buttons.textColor,
      textColorInverted = _config$buttons.textColorInverted,
      configIconSide = _config$buttons.iconSide,
      configIconGap = _config$buttons.iconGap;

  var _useWindowSize = useWindowSize(),
      windowWidth = _useWindowSize.width;

  var children = props.children,
      _onClick = props.onClick,
      icon = props.icon,
      _props$iconSize = props.iconSize,
      iconSize = _props$iconSize === undefined ? configIconSize : _props$iconSize,
      _props$iconSide = props.iconSide,
      iconSide = _props$iconSide === undefined ? configIconSide : _props$iconSide,
      _props$iconGap = props.iconGap,
      iconGap = _props$iconGap === undefined ? configIconGap : _props$iconGap,
      _props$noIconAt = props.noIconAt,
      noIconAt = _props$noIconAt === undefined ? 0 : _props$noIconAt,
      _props$type = props.type,
      type = _props$type === undefined ? "primary" : _props$type,
      glow = props.glow,
      _props$small = props.small,
      small = _props$small === undefined ? false : _props$small,
      _props$loading = props.loading,
      loading = _props$loading === undefined ? false : _props$loading,
      _props$stopPropagatio = props.stopPropagation,
      stopPropagation = _props$stopPropagatio === undefined ? true : _props$stopPropagatio,
      noStretch = props.noStretch,
      stretch = props.stretch,
      _props$color = props.color,
      providedBgColor = _props$color === undefined ? primaryColor : _props$color,
      submit = props.submit,
      disabled = props.disabled,
      CSS = props.CSS,
      width = props.width,
      className = props.className;
  var textColor = getColorBasedOnLuminance(providedBgColor, configTextColor, textColorInverted, type);

  var typeStyle = _styleForType(type, config, small, textColor, providedBgColor, glow);

  var style = _extends({}, config.Button.style, props.style);

  var mainCSS = css(_templateObject$k, width, noStretch ? "flex: 0 0 auto;" : "", stretch ? "flex: 1 1 auto;" : "", showHideCss(props), loading ? 0 : 1, loading ? css(_templateObject2$e) : "", disabled ? css(_templateObject3$a) : "");
  return jsx("button", {
    onClick: function onClick(event) {
      stopPropagation && event.stopPropagation();
      _onClick && _onClick(event);
    },
    style: style,
    css: [mainCSS, typeStyle, CSS],
    type: submit ? "submit" : undefined,
    disabled: disabled || loading,
    className: className
  }, jsx(HStack, {
    noWrap: true,
    align: "center",
    vAlign: "center",
    gap: iconGap
  }, icon && iconSide === "left" && windowWidth > parseInt(noIconAt) && jsx(Icon, {
    name: icon,
    color: textColor,
    size: small ? ".8em" : iconSize
  }), children && jsx("div", {
    style: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      position: "relative"
    }
  }, children), icon && iconSide === "right" && windowWidth > parseInt(noIconAt) && jsx(Icon, {
    name: icon,
    color: textColor,
    size: small ? ".8em" : iconSize
  })), jsx(Spinner, {
    center: true,
    size: 20,
    stroke: strokeInButtons,
    color: textColor,
    show: loading
  }));
};

var SegmentedControl = function SegmentedControl(props) {
  var config = useConfig();
  var height = config.buttons.height;
  var _props$options = props.options,
      options = _props$options === undefined ? ["On", "Off"] : _props$options,
      optionsNames = props.optionsNames,
      _props$active = props.active,
      active = _props$active === undefined ? "On" : _props$active,
      onOptionChange = props.onOptionChange,
      style = props.style,
      width = props.width,
      color = props.color;
  var num = options.length;
  var last = num - 1;
  var columns = new Array(num).fill("1fr").join(" ");
  return React.createElement(Grid, {
    gap: "0",
    align: "stretch",
    columns: columns,
    style: _extends({
      maxWidth: "100%",
      width: width
    }, style)
  }, options.map(function (thisOption, i) {
    var selected = thisOption === active;
    var type = selected ? "primary" : "secondary";
    var btnStyle = makeSegmentedButtonStyle({
      i: i,
      last: last,
      selected: selected,
      height: height
    });
    return React.createElement(Button, {
      color: color,
      key: i,
      style: btnStyle,
      type: type,
      onClick: function onClick() {
        onOptionChange(thisOption);
      }
    }, optionsNames ? optionsNames[i] : thisOption);
  }));
};

var makeSegmentedButtonStyle = function makeSegmentedButtonStyle(_ref) {
  var i = _ref.i,
      last = _ref.last,
      selected = _ref.selected,
      height = _ref.height;
  var heightInt = parseFloat(height);
  return {
    borderTopRightRadius: i !== last && !selected && "0",
    borderBottomRightRadius: i !== last && !selected && "0",
    borderTopLeftRadius: i !== 0 && !selected && "0",
    borderBottomLeftRadius: i !== 0 && !selected && "0",
    margin: (selected ? "0" : ".1em") + " 1px",
    height: selected ? "" : heightInt - 0.2 + "em",
    paddingRight: "0.5em",
    paddingLeft: "0.5em"
  };
};

var MultiSegmentedControl = function MultiSegmentedControl(props) {
  var config = useConfig();
  var configHeight = config.buttons.height;
  var _props$options = props.options,
      options = _props$options === undefined ? ["On", "Off"] : _props$options,
      optionsNames = props.optionsNames,
      _props$active = props.active,
      active = _props$active === undefined ? ["On"] : _props$active,
      onOptionChange = props.onOptionChange,
      _props$allowEmptySele = props.allowEmptySelection,
      allowEmptySelection = _props$allowEmptySele === undefined ? true : _props$allowEmptySele,
      _props$singleSelectio = props.singleSelectionMode,
      singleSelectionMode = _props$singleSelectio === undefined ? false : _props$singleSelectio;
  var num = options.length;
  var last = num - 1;
  var columns = new Array(num).fill("1fr").join(" ");

  var handleOptionClick = function handleOptionClick(option) {
    var selected = active.includes(option);

    if (singleSelectionMode) {
      onOptionChange([option]);
    } else {
      if (selected) {
        // disallow deselect when it would result in an empty selection
        if (!allowEmptySelection && active.length === 1 && active[0] === option) return;
        onOptionChange(active.filter(function (e) {
          return e !== option;
        }));
      } else {
        onOptionChange([].concat(toConsumableArray(active), [option]));
      }
    }
  };

  return React.createElement(Grid, {
    gap: "0",
    align: "stretch",
    columns: columns,
    vAlign: "center",
    breakAt: 0
  }, options.map(function (option, optionIndex) {
    var selected = active.includes(option);
    var type = selected ? "primary" : "secondary";
    var btnStyle = makeSegmentedButtonStyle({
      i: optionIndex,
      last: last,
      selected: selected,
      configHeight: configHeight
    });
    return React.createElement(Button, {
      key: optionIndex,
      style: btnStyle,
      type: type,
      onClick: function onClick() {
        return handleOptionClick(option);
      }
    }, optionsNames ? optionsNames[optionIndex] : option);
  }));
};

var _templateObject$l = taggedTemplateLiteral(["\n    -webkit-appearance: none;\n    appearance: none;\n    outline: none;\n    width: 100%;\n    height: ", "px;\n    border-radius: ", "px;\n    background: ", ";\n    &::-webkit-slider-thumb {\n      -webkit-appearance: none;\n      appearance: none;\n      width: ", "px;\n      height: ", "px;\n      background: ", ";\n      border-radius: ", "px;\n      box-shadow: ", " ", ";\n      cursor: pointer;\n    }\n    &::-moz-range-thumb {\n      -webkit-appearance: none;\n      appearance: none;\n      width: ", "px;\n      height: ", "px;\n      background: ", ";\n      border-radius: ", "px;\n      box-shadow: ", " ", ";\n      cursor: pointer;\n    }\n  "], ["\n    -webkit-appearance: none;\n    appearance: none;\n    outline: none;\n    width: 100%;\n    height: ", "px;\n    border-radius: ", "px;\n    background: ", ";\n    &::-webkit-slider-thumb {\n      -webkit-appearance: none;\n      appearance: none;\n      width: ", "px;\n      height: ", "px;\n      background: ", ";\n      border-radius: ", "px;\n      box-shadow: ", " ", ";\n      cursor: pointer;\n    }\n    &::-moz-range-thumb {\n      -webkit-appearance: none;\n      appearance: none;\n      width: ", "px;\n      height: ", "px;\n      background: ", ";\n      border-radius: ", "px;\n      box-shadow: ", " ", ";\n      cursor: pointer;\n    }\n  "]);

var Slider = function Slider(props) {
  var config = useConfig();
  var _config$slider = config.slider,
      thumbColor = _config$slider.thumbColor,
      trackColor = _config$slider.trackColor,
      trackHeight = _config$slider.trackHeight,
      thumbSize = _config$slider.thumbSize,
      borderColor = _config$slider.borderColor,
      shadowSize = _config$slider.shadowSize,
      shadowAlpha = _config$slider.shadowAlpha;
  var min = props.min,
      max = props.max,
      value = props.value,
      _onChange = props.onChange,
      style = props.style,
      externalCSS = props.CSS;
  var shadowColor = tinycolor(thumbColor).setAlpha(shadowAlpha).toString();
  var sliderCSS = css(_templateObject$l, trackHeight, trackHeight, trackColor, thumbSize, thumbSize, thumbColor, thumbSize, shadowSize, shadowColor, thumbSize, thumbSize, thumbColor, thumbSize, shadowSize, shadowColor);
  return jsx("input", {
    css: [sliderCSS, externalCSS],
    style: style,
    type: "range",
    min: min,
    max: max,
    value: value,
    id: "range",
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    }
  });
};

function cleanedProps(props, excludedProps) {
  var copy = _extends({}, props);

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = excludedProps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var ex = _step.value;
      delete copy[ex];
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"]) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return copy;
}

var _templateObject$m = taggedTemplateLiteral(["\n  line-height: 1.3;\n"], ["\n  line-height: 1.3;\n"]),
    _templateObject2$f = taggedTemplateLiteral(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n    ", "\n    ", "\n    display: block;\n    padding: 0 ", ";\n    color: ", ";\n    outline: none;\n    border-radius: ", ";\n    border: none;\n    text-align: left;\n    background: transparent;\n  "], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n    ", "\n    ", "\n    display: block;\n    padding: 0 ", ";\n    color: ", ";\n    outline: none;\n    border-radius: ", ";\n    border: none;\n    text-align: left;\n    background: transparent;\n  "]),
    _templateObject3$b = taggedTemplateLiteral(["\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n  user-select: none;\n"], ["\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n  user-select: none;\n"]);

var messageCSS = function messageCSS() {
  return css(_templateObject$m);
};

function inputWrapperGeneralStyle(config) {
  return "\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    width: 100%;\n    padding-right: 0;\n    border-radius: " + config.appearance.smallRadius + ";\n    height: " + config.buttons.height + ";\n    background: " + config.inputs.background + ";\n    transition: 0.2s box-shadow;\n  ";
}

function inputComponentGeneralStyle(config) {
  return css(_templateObject2$f, getFontSize("Input", config), getFontWeight("Input", config), config.inputs.padding, config.inputs.textColor, config.appearance.smallRadius);
}

function iconWrapperStyle(config) {
  return "\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    margin-right: " + config.inputs.padding + ";\n    pointer-events: none;\n  ";
}

var htmlInputResets = css(_templateObject3$b);

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function useEvent(element, event, callback, enabled, capture) {
  if (enabled === void 0) {
    enabled = true;
  }

  if (capture === void 0) {
    capture = false;
  }

  return useEffect(function () {
    if (!enabled || !element) {
      return;
    }

    var cb = callback;
    var el = Array.isArray(element) ? element : [element];
    var ev = Array.isArray(event) ? event : [event];
    el.forEach(function (e) {
      ev.forEach(function (event) {
        e.addEventListener(event, cb, capture);
      });
    });
    return function () {
      el.forEach(function (e) {
        ev.forEach(function (event) {
          e.removeEventListener(event, cb, capture);
        });
      });
    };
  }, [callback, element, enabled, event, capture]);
}

function isChildOf(parent, target) {
  if (parent === target) {
    return true;
  }

  var hasChildren = parent.children && parent.children.length > 0;

  if (hasChildren) {
    // tslint:disable-next-line
    for (var i = 0; i < parent.children.length; i++) {
      var child = parent.children[i];

      if (child && isChildOf(child, target)) {
        return true;
      }
    }
  }

  return false;
}

function useOutsideClick(refs, callback) {
  var _React$useState = React.useState(["click"]),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      events = _React$useState2[0];

  useEvent(typeof document !== "undefined" ? document : null, events, React.useCallback(function (evt) {
    var _iterator3 = _createForOfIteratorHelper(refs),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var ref = _step3.value;

        if (!ref.current) {
          continue;
        }

        if (isChildOf(ref.current, evt.target)) {
          return;
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    callback();
  }, [callback]), true, true);
}

function useOnScroll(elements, onScroll, environment, trackScroll) {
  if (trackScroll === void 0) {
    trackScroll = true;
  }

  var memoElements = useMemo(function () {
    return typeof environment !== "undefined" ? [environment].concat(_toConsumableArray(elements)) : [];
  }, [elements]);
  useEvent(memoElements, "scroll", onScroll, trackScroll);
}

function useOnWindowResize(onResize, environment, trackResize) {
  if (trackResize === void 0) {
    trackResize = true;
  }

  useEvent(typeof environment !== "undefined" ? environment : null, "resize", onResize, trackResize);
}

var useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;

function useTrackElementResize(injectedResizeObserver, layerRef, triggerElement, isOpen, callback, environment) {
  var callbackRef = useRef(callback);
  callbackRef.current = callback;
  var ResizeObserver = injectedResizeObserver || (typeof environment === "undefined" ? function ResizeObserver() {
    _classCallCheck(this, ResizeObserver);
  } : environment.ResizeObserver);

  if (!ResizeObserver) {
    throw new Error("This browser does not support `ResizeObserver` out of the box. Please provide a polyfill as a prop.");
  }

  var resizeObserver = useRef(new ResizeObserver(function () {
    if (layerRef.current) {
      callbackRef.current();
    }
  }));
  useIsomorphicLayoutEffect(function () {
    if (isOpen) {
      if (triggerElement) {
        resizeObserver.current.observe(triggerElement);
      }
    } else {
      if (triggerElement) {
        resizeObserver.current.unobserve(triggerElement);
      }

      if (layerRef.current) {
        resizeObserver.current.unobserve(layerRef.current);
      }
    }
  }, [isOpen, triggerElement]);
  useEffect(function () {
    return function () {
      resizeObserver.current.disconnect();
    };
  }, []);
  return resizeObserver.current;
}

var EMPTY_STYLE = {};

function isSet(value) {
  return value !== undefined && value !== null;
}

function areStylesTheSame(a, b) {
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);

  if (aKeys.length !== bKeys.length) {
    return false;
  }

  for (var i = 0; i < Math.max(aKeys.length, bKeys.length); i++) {
    var key = aKeys[i] || bKeys[i];

    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
}

function shouldUpdateStyles(prev, next) {
  if (areStylesTheSame(prev.layer, next.layer) && areStylesTheSame(prev.arrow, next.arrow)) {
    return false;
  }

  return true;
} // creates a ClientRect-like object from the viewport's dimensions


function getWindowClientRect(environment) {
  return {
    top: 0,
    left: 0,
    right: environment ? environment.innerWidth : 0,
    bottom: environment ? environment.innerHeight : 0,
    height: environment ? environment.innerHeight : 0,
    width: environment ? environment.innerWidth : 0
  };
}

var convertFloat = function convertFloat(value) {
  return parseFloat(value.replace("px", ""));
}; // get the outer width / height of an element
// We effectively want the same width / height that `getBoundingClientRect()`
// gives, minus optional `scale` transforms


function getContentBox(element, environment) {
  if (!environment) {
    return {
      width: 0,
      height: 0
    };
  }

  var _environment$getCompu = environment.getComputedStyle(element),
      width = _environment$getCompu.width,
      height = _environment$getCompu.height,
      boxSizing = _environment$getCompu.boxSizing,
      borderLeft = _environment$getCompu.borderLeft,
      borderRight = _environment$getCompu.borderRight,
      borderTop = _environment$getCompu.borderTop,
      borderBottom = _environment$getCompu.borderBottom,
      paddingLeft = _environment$getCompu.paddingLeft,
      paddingRight = _environment$getCompu.paddingRight,
      paddingTop = _environment$getCompu.paddingTop,
      paddingBottom = _environment$getCompu.paddingBottom;

  return {
    width: boxSizing === "border-box" ? convertFloat(width) : [width, borderLeft, borderRight, paddingLeft, paddingRight].reduce(function (total, value) {
      return total + (value ? convertFloat(value) : 0);
    }, 0),
    height: boxSizing === "border-box" ? convertFloat(height) : [height, borderTop, borderBottom, paddingTop, paddingBottom].reduce(function (total, value) {
      return total + (value ? convertFloat(value) : 0);
    }, 0)
  };
} // converts a ClientRect (or DOMRect) to a plain js-object
// usefull for destructuring for instance


function clientRectToObject(clientRect) {
  return {
    top: clientRect.top,
    left: clientRect.left,
    right: clientRect.right,
    bottom: clientRect.bottom,
    width: clientRect.width,
    height: clientRect.height
  };
}

function useStyleState(anchor) {
  var _useState13 = useState({
    layer: EMPTY_STYLE,
    arrow: EMPTY_STYLE,
    layerSide: anchor.split("_")[0].toLowerCase()
  }),
      _useState14 = _slicedToArray(_useState13, 1),
      INITIAL_STYLES = _useState14[0];

  var _useState15 = useState(INITIAL_STYLES),
      _useState16 = _slicedToArray(_useState15, 2),
      styles = _useState16[0],
      setStyles = _useState16[1];

  var lastStyles = useRef(styles);
  return {
    styles: styles,
    lastStyles: lastStyles,
    setStyles: setStyles,
    resetLastStyles: function resetLastStyles() {
      lastStyles.current = INITIAL_STYLES;
    }
  };
}

var Anchor = {
  BOTTOM_LEFT: "BOTTOM_LEFT",
  BOTTOM_RIGHT: "BOTTOM_RIGHT",
  BOTTOM_CENTER: "BOTTOM_CENTER",
  TOP_LEFT: "TOP_LEFT",
  TOP_CENTER: "TOP_CENTER",
  TOP_RIGHT: "TOP_RIGHT",
  LEFT_BOTTOM: "LEFT_BOTTOM",
  LEFT_CENTER: "LEFT_CENTER",
  LEFT_TOP: "LEFT_TOP",
  RIGHT_BOTTOM: "RIGHT_BOTTOM",
  RIGHT_CENTER: "RIGHT_CENTER",
  RIGHT_TOP: "RIGHT_TOP"
};
var POSSIBLE_ANCHORS = Object.keys(Anchor);

function getPrimaryDirection(anchor) {
  return anchor.startsWith("TOP_") || anchor.startsWith("BOTTOM_") ? "Y" : "X";
}

function primaryIsY(primary) {
  return primary === "TOP" || primary === "BOTTOM";
}

function getPrimaryByIndex(index, preferedPrimary, preferedX, preferedY) {
  var prefferedIsY = primaryIsY(preferedPrimary);

  if (index < 3) {
    return preferedPrimary;
  }

  if (index < 6) {
    return prefferedIsY ? preferedX : preferedY;
  }

  if (index < 9) {
    if (prefferedIsY) {
      return ["LEFT", "RIGHT"].filter(function (x) {
        return x !== preferedX;
      })[0];
    } else {
      return ["TOP", "BOTTOM"].filter(function (x) {
        return x !== preferedY;
      })[0];
    }
  }

  if (prefferedIsY) {
    return ["TOP", "BOTTOM"].filter(function (x) {
      return x !== preferedPrimary;
    })[0];
  } else {
    return ["LEFT", "RIGHT"].filter(function (x) {
      return x !== preferedPrimary;
    })[0];
  }
}

function getSecondaryByIndex(index, preferedPrimary, preferedSecondary, rects) {
  var prefferedIsY = primaryIsY(preferedPrimary);
  var triggerHasBiggerHeight = rects.trigger.height > rects.layer.height;
  var triggerHasBiggerWidth = rects.trigger.width > rects.layer.width;

  switch (index) {
    case 9:
    case 0:
      return preferedSecondary;

    case 1:
    case 10:
      {
        if (preferedSecondary === "CENTER") {
          return prefferedIsY ? "RIGHT" : "BOTTOM";
        }

        return "CENTER";
      }

    case 4:
    case 7:
      return "CENTER";

    case 2:
    case 11:
      {
        if (prefferedIsY) {
          return ["LEFT", "RIGHT"].filter(function (x) {
            return x !== preferedSecondary;
          })[0];
        } else {
          return ["TOP", "BOTTOM"].filter(function (x) {
            return x !== preferedSecondary;
          })[0];
        }
      }

    case 3:
    case 6:
      {
        if (prefferedIsY) {
          return preferedPrimary === "BOTTOM" ? triggerHasBiggerHeight ? "BOTTOM" : "TOP" : triggerHasBiggerHeight ? "TOP" : "BOTTOM";
        }

        return preferedPrimary === "LEFT" ? triggerHasBiggerWidth ? "LEFT" : "RIGHT" : triggerHasBiggerWidth ? "RIGHT" : "LEFT";
      }

    case 5:
    case 8:
      {
        if (prefferedIsY) {
          return preferedPrimary === "BOTTOM" ? triggerHasBiggerHeight ? "TOP" : "BOTTOM" : triggerHasBiggerHeight ? "BOTTOM" : "TOP";
        }

        return preferedPrimary === "LEFT" ? triggerHasBiggerWidth ? "RIGHT" : "LEFT" : triggerHasBiggerWidth ? "LEFT" : "RIGHT";
      }
  }
  /* istanbul ignore next */


  return "LEFT";
}

function getSecondaryAnchorOptionsByPrimary(primary, anchorOptions) {
  return anchorOptions.filter(function (anchor) {
    return anchor.startsWith(primary);
  });
}

function splitAnchor(anchor) {
  var _anchor$split = anchor.split("_"),
      _anchor$split2 = _slicedToArray(_anchor$split, 2),
      primary = _anchor$split2[0],
      secondary = _anchor$split2[1];

  return {
    primary: primary,
    secondary: secondary
  };
}

function getLayerSideByAnchor(anchor) {
  if (anchor === "CENTER") {
    return "center";
  }

  return splitAnchor(anchor).primary.toLowerCase();
}

function getAnchorPriority(preferedAnchor, possibleAnchors, preferedX, preferedY, rects) {
  var _ref8 = preferedAnchor !== "CENTER" ? splitAnchor(preferedAnchor) : {
    primary: preferedY,
    secondary: "CENTER"
  },
      primary = _ref8.primary,
      secondary = _ref8.secondary;

  var anchors = POSSIBLE_ANCHORS.map(function (_, index) {
    return getPrimaryByIndex(index, primary, preferedX, preferedY) + "_" + getSecondaryByIndex(index, primary, secondary, rects);
  }).filter(function (anchor) {
    return possibleAnchors.indexOf(anchor) > -1;
  }); // include prefered anchor if not included in possibleAnchors

  if (anchors.indexOf(preferedAnchor) === -1) {
    /* istanbul ignore next */
    anchors = [preferedAnchor].concat(_toConsumableArray(anchors));
  }

  return anchors;
}

function getPrimaryStyle(primary, rects, scroll, triggerOffset) {
  var prop = primary === "TOP" || primary === "BOTTOM" ? "top" : "left";
  var size = primary === "TOP" || primary === "BOTTOM" ? "height" : "width";

  if (primary === "TOP" || primary === "LEFT") {
    return _defineProperty({}, prop, rects.trigger[prop] - rects.layer[size] - (rects.relativeParent[prop] - scroll[prop]) - triggerOffset);
  }

  return _defineProperty({}, prop, rects.trigger[prop] + rects.trigger[size] - (rects.relativeParent[prop] - scroll[prop]) + triggerOffset);
}

function getCenter(rects, scroll, offsetSecondary, prop, size) {
  return rects.trigger[prop] - rects.relativeParent[prop] + scroll[prop] + rects.trigger[size] / 2 - rects.layer[size] / 2 - offsetSecondary;
}

function getSecondaryStyle(secondary, rects, scroll, offsetSecondary, primaryDirection) {
  if (secondary === "CENTER") {
    var _prop = primaryDirection === "X" ? "top" : "left";

    var _size = primaryDirection === "X" ? "height" : "width";

    return _defineProperty({}, _prop, getCenter(rects, scroll, offsetSecondary, _prop, _size));
  }

  var prop = secondary === "TOP" || secondary === "BOTTOM" ? "top" : "left";
  var size = secondary === "TOP" || secondary === "BOTTOM" ? "height" : "width";

  if (secondary === "TOP" || secondary === "LEFT") {
    return _defineProperty({}, prop, rects.trigger[prop] - rects.relativeParent[prop] + scroll[prop] + offsetSecondary);
  }

  return _defineProperty({}, prop, rects.trigger[prop] + rects.trigger[size] - rects.layer[size] - (rects.relativeParent[prop] - scroll[prop]) - offsetSecondary);
}

function getAbsolutePositions(_ref) {
  var anchor = _ref.anchor,
      rects = _ref.rects,
      triggerOffset = _ref.triggerOffset,
      offsetSecondary = _ref.offsetSecondary,
      scrollLeft = _ref.scrollLeft,
      scrollTop = _ref.scrollTop;
  var scroll = {
    left: scrollLeft,
    top: scrollTop
  };

  if (anchor === "CENTER") {
    return {
      top: getCenter(rects, scroll, 0, "top", "height"),
      left: getCenter(rects, scroll, 0, "left", "width")
    };
  }

  var _splitAnchor = splitAnchor(anchor),
      primary = _splitAnchor.primary,
      secondary = _splitAnchor.secondary;

  var primaryDirection = getPrimaryDirection(anchor);
  return _extends$2({}, getPrimaryStyle(primary, rects, scroll, triggerOffset), {}, getSecondaryStyle(secondary, rects, scroll, offsetSecondary, primaryDirection));
} // anticipate the width / height based on the current anchor


function fixLayerDimensions(originalLayer, anchor, layerDimensions) {
  var dimensions = typeof layerDimensions === "function" ? layerDimensions(getLayerSideByAnchor(anchor)) : layerDimensions;
  return _extends$2({}, clientRectToObject(originalLayer), {}, dimensions);
}

var propMap = {
  TOP: {
    side1: "bottom",
    side2: "top",
    size: "height",
    factor: -1
  },
  BOTTOM: {
    side1: "top",
    side2: "bottom",
    size: "height",
    factor: 1
  },
  LEFT: {
    side1: "right",
    side2: "left",
    size: "width",
    factor: -1
  },
  RIGHT: {
    side1: "left",
    side2: "right",
    size: "width",
    factor: 1
  }
};

function getPrimaryRect(primary, trigger, layer, triggerOffset) {
  var _ref14;

  var _propMap$primary = propMap[primary],
      side1 = _propMap$primary.side1,
      side2 = _propMap$primary.side2,
      size = _propMap$primary.size,
      factor = _propMap$primary.factor;
  var value = trigger[side2] + triggerOffset * factor;
  return _ref14 = {}, _defineProperty(_ref14, side1, value), _defineProperty(_ref14, side2, value + layer[size] * factor), _ref14;
}

function getCenter$1(trigger, layer, offsetSecondary, prop, size) {
  var _ref15;

  var value = trigger[prop] + trigger[size] / 2 - layer[size] / 2 - offsetSecondary;
  return _ref15 = {}, _defineProperty(_ref15, prop, value), _defineProperty(_ref15, prop === "left" ? "right" : "bottom", value + layer[size]), _ref15;
}

function getSecondaryRect(secondary, trigger, layer, offsetSecondary, primaryDirection) {
  var _ref16;

  if (secondary === "CENTER") {
    var prop = primaryDirection === "X" ? "top" : "left";

    var _size2 = primaryDirection === "X" ? "height" : "width";

    return getCenter$1(trigger, layer, offsetSecondary, prop, _size2);
  }

  var _propMap$secondary = propMap[secondary],
      side1 = _propMap$secondary.side1,
      side2 = _propMap$secondary.side2,
      size = _propMap$secondary.size,
      factor = _propMap$secondary.factor;
  var value = trigger[side2] - offsetSecondary * factor;
  return _ref16 = {}, _defineProperty(_ref16, side2, value), _defineProperty(_ref16, side1, value - layer[size] * factor), _ref16;
}

function getLayerRectByAnchor(_ref) {
  var trigger = _ref.trigger,
      layer = _ref.layer,
      anchor = _ref.anchor,
      triggerOffset = _ref.triggerOffset,
      _ref$scrollOffset = _ref.scrollOffset,
      scrollOffset = _ref$scrollOffset === void 0 ? 0 : _ref$scrollOffset,
      _ref$offsetSecondary = _ref.offsetSecondary,
      offsetSecondary = _ref$offsetSecondary === void 0 ? 0 : _ref$offsetSecondary,
      layerDimensions = _ref.layerDimensions;
  var primaryRect;
  var secondaryRect; // get the correct anticipated ClientRect based on the provided Anchor

  var layerRect = layerDimensions ? fixLayerDimensions(layer, anchor, layerDimensions) : layer;

  if (anchor === "CENTER") {
    primaryRect = getCenter$1(trigger, layerRect, 0, "top", "height");
    secondaryRect = getCenter$1(trigger, layerRect, 0, "left", "width");
  } else {
    var _splitAnchor2 = splitAnchor(anchor),
        primary = _splitAnchor2.primary,
        secondary = _splitAnchor2.secondary;

    var primaryDirection = getPrimaryDirection(anchor);
    primaryRect = getPrimaryRect(primary, trigger, layerRect, triggerOffset);
    secondaryRect = getSecondaryRect(secondary, trigger, layerRect, offsetSecondary, primaryDirection);
  }

  var result = _extends$2({}, layerRect, {}, primaryRect, {}, secondaryRect); // correct scrollOffsets


  result.top = result.top - scrollOffset;
  result.right = result.right + scrollOffset;
  result.left = result.left - scrollOffset;
  result.bottom = result.bottom + scrollOffset;
  return result;
}

var ALL_OFFSET_SIDES = ["bottom", "top", "left", "right"];

function getLayerOffsetsToParent(layer, parent) {
  return {
    top: layer.top - parent.top,
    bottom: parent.bottom - layer.bottom,
    left: layer.left - parent.left,
    right: parent.right - layer.right
  };
}

function getLayerOffsetsToParents(layer, parents) {
  return parents.map(function (parent) {
    return getLayerOffsetsToParent(layer, parent);
  });
}

function isLayerCompletelyInvisible(layer, parents) {
  return parents.some(function (parent) {
    return layer.bottom <= parent.top || layer.right <= parent.left || layer.top >= parent.bottom || layer.left >= parent.right;
  });
}

function doesEntireLayerFitWithinScrollParents(layer, parents) {
  var parentOffsets = getLayerOffsetsToParents(layer, parents);
  return parentOffsets.every(function (offsets) {
    return ALL_OFFSET_SIDES.every(function (side) {
      return offsets[side] >= 0;
    });
  });
}

function reduceOffsets(parentOffsets) {
  var parentOffsetsCombined = parentOffsets.reduce(function (result, offsets) {
    ALL_OFFSET_SIDES.forEach(function (side) {
      result[side] = [].concat(_toConsumableArray(result[side]), [offsets[side]]);
    });
    return result;
  }, {
    top: [],
    bottom: [],
    left: [],
    right: []
  });
  return ALL_OFFSET_SIDES.reduce(function (result, side) {
    result[side] = parentOffsetsCombined[side].sort(function (a, b) {
      return a - b;
    })[0];
    return result;
  }, {});
}

function getNegativeOffsetSides(parentOffsets) {
  var offsets = reduceOffsets(parentOffsets);
  return ALL_OFFSET_SIDES.filter(function (side) {
    return offsets[side] < 0;
  });
}

function getVisibleLayerSurface(layer, parent) {
  var offsets = getLayerOffsetsToParent(layer, parent);
  var visibleRect = ALL_OFFSET_SIDES.filter(function (side) {
    return offsets[side] < 0;
  }).reduce(function (rect, side) {
    var affectedProperty = side === "top" || side === "bottom" ? "height" : "width";
    return _extends$2({}, rect, _defineProperty({}, affectedProperty, rect[affectedProperty] + offsets[side]));
  }, layer);
  return visibleRect.width * visibleRect.height;
}

function getVisibleLayerSurfaceWithinScrollParent(layer, parents) {
  var surfaces = parents.map(function (parent) {
    return getVisibleLayerSurface(layer, parent);
  }); // pick smallest

  return surfaces.sort(function (a, b) {
    return a - b;
  })[0];
}

function doesAnchorFitWithinScrollParents(anchor, rects, triggerOffset, scrollOffset, layerDimensions) {
  var layerRect = getLayerRectByAnchor({
    anchor: anchor,
    trigger: rects.trigger,
    layer: rects.layer,
    triggerOffset: triggerOffset,
    scrollOffset: scrollOffset,
    layerDimensions: layerDimensions
  });
  return doesEntireLayerFitWithinScrollParents(layerRect, rects.scrollParents);
}

function getLayerOffsetsToScrollParentsByAnchor(anchor, rects, triggerOffset, scrollOffset) {
  return getLayerOffsetsToParents(getLayerRectByAnchor({
    anchor: anchor,
    trigger: rects.trigger,
    layer: rects.layer,
    triggerOffset: triggerOffset,
    scrollOffset: scrollOffset,
    layerDimensions: null
  }), rects.scrollParents);
}

function triggerIsBiggerThanLayer(layerSide, layer, trigger) {
  return (layerSide === "top" || layerSide === "bottom") && trigger.width > layer.width || (layerSide === "left" || layerSide === "right") && trigger.height > layer.height;
}

function getOffsetSurface(anchor, layer, triggerOffset, scrollOffset) {
  var primaryDirection = getPrimaryDirection(anchor);
  var primarySize = layer[primaryDirection === "X" ? "width" : "height"] - triggerOffset - scrollOffset * 2;
  var secondarySize = layer[primaryDirection === "X" ? "height" : "width"] - triggerOffset - scrollOffset * 2;
  return primarySize * secondarySize;
}

function findAnchorByLayerSurface(rects, anchorOptions, triggerOffset, scrollOffset, layerDimensions) {
  var result = anchorOptions.map(function (anchor) {
    // get layerRect based on all offsets
    var layerRect = getLayerRectByAnchor({
      anchor: anchor,
      layer: rects.layer,
      trigger: rects.trigger,
      scrollOffset: scrollOffset,
      triggerOffset: triggerOffset,
      layerDimensions: layerDimensions
    }); // get smallest visible layer surface for current anchor

    var surface = getVisibleLayerSurfaceWithinScrollParent(layerRect, rects.scrollParents); // get surface of the offsets
    // offsets are important for collision detection, but
    // eventually we are interested in the 'meat' of the layer

    var offsetSurface = getOffsetSurface(anchor, layerRect, triggerOffset, scrollOffset);
    return {
      anchor: anchor,
      square: surface - offsetSurface
    };
  }) // sort -> biggest surface first
  .sort(function (a, b) {
    return b.square - a.square;
  });
  return result[0].anchor;
}

function findBestSuitableAnchor(rects, anchorOptions, triggerOffset, scrollOffset, layerDimensions) {
  // STRATEGY A
  // find first that fits parent
  var anchor = anchorOptions.find(function (anchor) {
    return doesAnchorFitWithinScrollParents(anchor, rects, triggerOffset, scrollOffset, layerDimensions);
  });

  if (anchor) {
    return anchor;
  } // STRATEGY B
  // find first with biggest surface


  return findAnchorByLayerSurface(rects, anchorOptions, triggerOffset, scrollOffset, layerDimensions);
}

function getSecondaryOffsetSide(currentAnchor, firstAnchorThatDoesNotFit, rects, triggerOffset, scrollOffset) {
  var primaryDirection = getPrimaryDirection(currentAnchor);
  var offsets = getLayerOffsetsToScrollParentsByAnchor(firstAnchorThatDoesNotFit, rects, triggerOffset, scrollOffset);
  var sides = getNegativeOffsetSides(offsets);
  return sides.find(function (side) {
    if (primaryDirection === "X") {
      return side === "top" || side === "bottom";
    }

    return side === "left" || side === "right";
  });
}

function findSecondaryOffset(anchor, anchorOptions, rects, triggerOffset, scrollOffset) {
  var _splitAnchor3 = splitAnchor(anchor),
      primary = _splitAnchor3.primary;
  /**
   * A.
   * Check wether there are other anchors available
   * If not, skip secondary offset
   */


  var secondaryAnchorOptions = getSecondaryAnchorOptionsByPrimary(primary, anchorOptions);

  if (secondaryAnchorOptions.length === 1) {
    return 0;
  }
  /**
   * B.
   * Check whether current anchor is the preffered anchor and whether
   * it fits
   * If so, skip secondary offset
   */


  var currentAnchorHasHighestPriority = secondaryAnchorOptions.indexOf(anchor) === 0;
  var currentAnchorFits = doesAnchorFitWithinScrollParents(anchor, rects, triggerOffset, scrollOffset, null);

  if (currentAnchorHasHighestPriority && currentAnchorFits) {
    return 0;
  }
  /**
   * C.
   * Retrieve the first anchor on same primary side (by priority) that
   * does not fit.
   * Check if there's a relevant side that has a negative offset.
   * If not, skip secondary offset
   */


  var firstAnchorThatDoesNotFit = secondaryAnchorOptions.find(function (anchor) {
    return !doesAnchorFitWithinScrollParents(anchor, rects, triggerOffset, scrollOffset, null);
  });
  var affectedSide = getSecondaryOffsetSide(anchor, firstAnchorThatDoesNotFit, rects, triggerOffset, scrollOffset);

  if (!affectedSide) {
    return 0;
  }
  /**
   * Determine the final secondary offset
   */


  var currentOffsets = reduceOffsets(getLayerOffsetsToScrollParentsByAnchor(anchor, rects, triggerOffset, scrollOffset)); // ensure `secondaryOffset` is always negative or 0

  var secondaryOffset = Math.min(-currentOffsets[affectedSide], 0);
  var triggerIsBigger = triggerIsBiggerThanLayer(getLayerSideByAnchor(anchor), rects.layer, rects.trigger);
  var isCenter = anchor.includes("_CENTER");
  var isLeft = anchor.includes("_LEFT");
  var isTop = anchor.includes("_TOP"); // when trigger is bigger, make `secondaryOffset` positive
  // conditionally

  if (triggerIsBigger && (isLeft && affectedSide === "right" || affectedSide === "left" || isTop && affectedSide === "bottom" || affectedSide === "top")) {
    secondaryOffset = -secondaryOffset;
  } else if ( // when current anchor is center, make `secondaryOffset` positive
  // when affectedSide is top or right
  !triggerIsBigger && isCenter && (affectedSide === "top" || affectedSide === "left")) {
    secondaryOffset = -secondaryOffset;
  }

  return secondaryOffset;
}

function getArrowStyle(layer, trigger, layerSide) {
  var triggerIsBigger = triggerIsBiggerThanLayer(layerSide, layer, trigger);

  if (layerSide === "bottom") {
    return {
      bottom: "100%",
      top: null,
      left: triggerIsBigger ? "50%" : trigger.left + trigger.width / 2 - layer.left,
      right: null
    };
  }

  if (layerSide === "right") {
    return {
      right: "100%",
      left: null,
      top: triggerIsBigger ? "50%" : trigger.top + trigger.height / 2 - layer.top,
      bottom: null
    };
  }

  if (layerSide === "top") {
    return {
      top: "100%",
      bottom: null,
      left: triggerIsBigger ? "50%" : trigger.left + trigger.width / 2 - layer.left,
      right: null
    };
  }

  return {
    left: "100%",
    right: null,
    top: triggerIsBigger ? "50%" : trigger.top + trigger.height / 2 - layer.top,
    bottom: null
  };
}

function getAbsoluteStyle(_ref) {
  var rects = _ref.rects,
      scrollTop = _ref.scrollTop,
      scrollLeft = _ref.scrollLeft,
      triggerOffset = _ref.triggerOffset,
      scrollOffset = _ref.scrollOffset,
      possibleAnchors = _ref.possibleAnchors,
      preferedAnchor = _ref.preferedAnchor,
      preferedX = _ref.preferedX,
      preferedY = _ref.preferedY,
      autoAdjust = _ref.autoAdjust,
      snapToAnchor = _ref.snapToAnchor,
      layerDimensions = _ref.layerDimensions; // get a list of possible anchors bases on user set props

  var possibleAnchorsByPriority = getAnchorPriority(preferedAnchor, possibleAnchors, preferedX, preferedY, rects); // on `autoAdjust` find best suitable anchor based on
  // window's / scrollParent's position

  var anchor = autoAdjust ? findBestSuitableAnchor(rects, possibleAnchorsByPriority, triggerOffset, scrollOffset, layerDimensions) : preferedAnchor; // calculate a secondary offset when `autoAdjust` is set
  // and `snapToAnchor` is not.
  // Basically it creates a visual effect where it seems that
  // the layer has glued to it's parents sides
  // Note: `offsetSecondary` is disabled when anchor is CENTER

  var offsetSecondary = autoAdjust && !snapToAnchor && anchor !== "CENTER" ? findSecondaryOffset(anchor, possibleAnchorsByPriority, rects, triggerOffset, scrollOffset) : 0;
  var layerStyle = getAbsolutePositions({
    anchor: anchor,
    rects: rects,
    triggerOffset: triggerOffset,
    offsetSecondary: offsetSecondary,
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  });
  var layerRect = getLayerRectByAnchor({
    anchor: anchor,
    trigger: rects.trigger,
    layer: rects.layer,
    triggerOffset: triggerOffset,
    offsetSecondary: offsetSecondary,
    layerDimensions: layerDimensions
  });

  if (layerDimensions) {
    layerStyle.width = layerRect.width;
    layerStyle.height = layerRect.height;
  }

  return {
    layerStyle: layerStyle,
    layerRect: layerRect,
    anchor: anchor
  };
}

function compensateScrollbars(rect, clientWidth, clientHeight) {
  var scrollbarWidth = rect.width - clientWidth;
  var scrollbarHeight = rect.height - clientHeight;
  return {
    left: rect.left,
    top: rect.top,
    width: rect.width - scrollbarWidth,
    right: rect.right - scrollbarWidth,
    height: rect.height - scrollbarHeight,
    bottom: rect.bottom - scrollbarHeight
  };
}

var defaultPlacement = {
  autoAdjust: false,
  snapToAnchor: false,
  anchor: "TOP_CENTER",
  layerDimensions: null,
  possibleAnchors: POSSIBLE_ANCHORS,
  preferX: "RIGHT",
  preferY: "BOTTOM",
  scrollOffset: 10,
  triggerOffset: 0
};

function getPositioning(_ref) {
  var triggerRect = _ref.triggerRect,
      layerElement = _ref.layerElement,
      relativeParentElement = _ref.relativeParentElement,
      scrollParents = _ref.scrollParents,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? {} : _ref$placement,
      environment = _ref.environment,
      fixed = _ref.fixed;
  /**
   * A.
   * Calculate new layer positions
   */
  // sometimes ResizeObserver calls this function when all values in the
  // trigger ClientRect are 0. Return early in that case

  if (triggerRect.height === 0) {
    return;
  }

  if (!layerElement) {
    return;
  } // gather all scroll parents (including the window ClientRect)
  // in order to check for collisions


  var scrollParentRects = fixed ? [getWindowClientRect(environment)] : [].concat(_toConsumableArray(scrollParents.map(function (parent) {
    return compensateScrollbars(parent.getBoundingClientRect(), parent.clientWidth, parent.clientHeight);
  })), [getWindowClientRect(environment)]);
  var options = {
    autoAdjust: placement.autoAdjust || defaultPlacement.autoAdjust,
    snapToAnchor: placement.snapToAnchor || defaultPlacement.snapToAnchor,
    triggerOffset: isSet(placement.triggerOffset) ? placement.triggerOffset : defaultPlacement.triggerOffset,
    scrollOffset: isSet(placement.scrollOffset) ? placement.scrollOffset : defaultPlacement.scrollOffset,
    possibleAnchors: placement.possibleAnchors || defaultPlacement.possibleAnchors,
    preferedAnchor: placement.anchor || defaultPlacement.anchor,
    preferedX: placement.preferX || defaultPlacement.preferX,
    preferedY: placement.preferY || defaultPlacement.preferY,
    scrollLeft: relativeParentElement === document.body ? 0 : relativeParentElement.scrollLeft,
    scrollTop: relativeParentElement === document.body ? 0 : relativeParentElement.scrollTop,
    relativeParentElement: relativeParentElement,
    layerDimensions: placement.layerDimensions || defaultPlacement.layerDimensions
  };
  var layerBox = layerElement.getBoundingClientRect(); // construct layerRect

  var layer = _extends$2({
    top: layerBox.top,
    left: layerBox.left,
    right: layerBox.right,
    bottom: layerBox.bottom
  }, getContentBox(layerElement, environment));

  var rects = {
    layer: layer,
    relativeParent: relativeParentElement.getBoundingClientRect(),
    scrollParents: scrollParentRects,
    trigger: triggerRect
  };

  var _getAbsoluteStyle = getAbsoluteStyle(_extends$2({
    rects: rects
  }, options)),
      layerRect = _getAbsoluteStyle.layerRect,
      layerStyle = _getAbsoluteStyle.layerStyle,
      anchor = _getAbsoluteStyle.anchor;

  if (fixed) {
    layerStyle.top = layerRect.top;
    layerStyle.left = layerRect.left;
  } // determine in which side to layer will be relative to
  // the trigger


  var layerSide = getLayerSideByAnchor(anchor); // get optional arrow positions
  // anchor-style is pointless when rendered anchor is CENTER

  var arrowStyle = anchor === "CENTER" ? EMPTY_STYLE : getArrowStyle(layerRect, triggerRect, layerSide);
  var styles = {
    layer: layerStyle,
    arrow: arrowStyle,
    layerSide: layerSide
  };
  return {
    styles: styles,
    layerRect: layerRect
  };
}
/**
 * Tracks an element and keeps it in state
 * (together with other relevant state that depends on the element)
 */


function useElementRef(initialState, elementToState) {
  var _useState17 = useState(initialState || null),
      _useState18 = _slicedToArray(_useState17, 2),
      state = _useState18[0],
      setState = _useState18[1];

  var lastElement = useRef(null);
  var setRef = useCallback(function (node) {
    if (node && node !== lastElement.current) {
      lastElement.current = node;

      if (elementToState) {
        setState(elementToState(node));
      } else {
        setState(node);
      }
    }
  }, []);
  return [setRef, state];
}

function findScrollContainers(element, environment) {
  var result = [];

  if (!element || !environment) {
    return result;
  }

  if (element === document.body) {
    return result;
  }

  var _environment$getCompu2 = environment.getComputedStyle(element),
      overflow = _environment$getCompu2.overflow,
      overflowX = _environment$getCompu2.overflowX,
      overflowY = _environment$getCompu2.overflowY;

  if ([overflow, overflowX, overflowY].some(function (prop) {
    return prop === "auto" || prop === "scroll";
  })) {
    result.push(element);
  }

  return [].concat(result, _toConsumableArray(findScrollContainers(element.parentElement, environment)));
}

function useElementState(container, fixed, environment) {
  return useElementRef({
    triggerElement: null,
    relativeParentElement: null,
    scrollParents: []
  }, useCallback(function (triggerElement) {
    var scrollParents = findScrollContainers(triggerElement, environment);
    var relativeParentElement = scrollParents[0] || document.body;

    if (relativeParentElement === document.body) {
      document.body.style.position = "relative";
    } else if (process.env.NODE_ENV === "development" && environment) {
      // Check if we should warn the user about 'position: relative; stuff...'
      var containerElement = typeof container === "function" ? container() : container;
      var position = environment.getComputedStyle(relativeParentElement).position;
      var shouldWarnAboutPositionStyle = position !== "relative" && position !== "absolute" && position !== "fixed" && !fixed && !containerElement;

      if (shouldWarnAboutPositionStyle) {
        console.error("react-laag: Set the 'position' style of the nearest scroll-container to 'relative', 'absolute' or 'fixed', or set the 'fixed' prop to true. This is needed in order to position the layers properly. Currently the scroll-container is positioned: \"" + position + "\". Visit https://react-laag.com/docs/#position-relative for more info.", relativeParentElement);
      }
    }

    return {
      triggerElement: triggerElement,
      relativeParentElement: relativeParentElement,
      scrollParents: scrollParents
    };
  }, []));
}

function ToggleLayer(_ref) {
  var children = _ref.children,
      renderLayer = _ref.renderLayer,
      _ref$placement2 = _ref.placement,
      placement = _ref$placement2 === void 0 ? {} : _ref$placement2,
      onStyle = _ref.onStyle,
      isOpenExternal = _ref.isOpen,
      closeOnOutsideClick = _ref.closeOnOutsideClick,
      onOutsideClick = _ref.onOutsideClick,
      onDisappear = _ref.onDisappear,
      closeOnDisappear = _ref.closeOnDisappear,
      fixed = _ref.fixed,
      container = _ref.container,
      _ref$environment = _ref.environment,
      environment = _ref$environment === void 0 ? typeof window !== "undefined" ? window : undefined : _ref$environment,
      props = _objectWithoutPropertiesLoose$1(_ref, ["children", "renderLayer", "placement", "onStyle", "isOpen", "closeOnOutsideClick", "onOutsideClick", "onDisappear", "closeOnDisappear", "fixed", "container", "environment"]);
  /**
   * Tracks trigger element and keeps it in state together with it's
   * relative/absolute positioned parent
   */


  var _useElementState = useElementState(container, fixed, environment),
      _useElementState2 = _slicedToArray(_useElementState, 2),
      triggerRef = _useElementState2[0],
      _useElementState2$ = _useElementState2[1],
      relativeParentElement = _useElementState2$.relativeParentElement,
      triggerElement = _useElementState2$.triggerElement,
      scrollParents = _useElementState2$.scrollParents;

  var _useStyleState = useStyleState(placement.anchor || defaultPlacement.anchor),
      styles = _useStyleState.styles,
      setStyles = _useStyleState.setStyles,
      lastStyles = _useStyleState.lastStyles,
      resetLastStyles = _useStyleState.resetLastStyles;

  var layerRef = useRef(null);

  var _useState19 = useState(false),
      _useState20 = _slicedToArray(_useState19, 2),
      isOpenInternal = _useState20[0],
      setOpenInternal = _useState20[1];

  var isOpen = isSet(isOpenExternal) ? isOpenExternal : isOpenInternal;
  var handlePositioning = useCallback(function () {
    if (!triggerElement) {
      throw new Error("Could not find a valid reference of the trigger element. See https://www.react-laag.com/docs/togglelayer/#children for more info.");
    }

    var triggerRect = triggerElement.getBoundingClientRect();
    var result = getPositioning({
      triggerRect: triggerRect,
      layerElement: layerRef.current,
      placement: placement,
      relativeParentElement: relativeParentElement,
      scrollParents: scrollParents,
      fixed: fixed,
      environment: environment
    });

    if (!result) {
      return;
    }

    var layerRect = result.layerRect,
        styles = result.styles; // only update styles when necessary

    if (shouldUpdateStyles(lastStyles.current, styles)) {
      // is parent in control of styles? (onStyle)
      if (isSet(onStyle)) {
        lastStyles.current = styles;
        onStyle(styles.layer, styles.arrow, styles.layerSide);
      } // ... otherwise set styles internally
      else {
          setStyles(styles);
        }
    }
    /**
     * B.
     * Manage disappearance
     */


    var hasOnDisappear = isSet(onDisappear);
    var shouldCloseOnDisappear = closeOnDisappear && !isSet(isOpenExternal); // Should we respond to the layer's partial or full disappearance?
    // (trigger's disappearance when `fixed` props is set)

    if (hasOnDisappear || shouldCloseOnDisappear) {
      var allScrollParents = [].concat(_toConsumableArray(scrollParents.map(function (parent) {
        return parent.getBoundingClientRect();
      })), [getWindowClientRect(environment)]);
      var partial = !doesEntireLayerFitWithinScrollParents(fixed ? triggerRect : layerRect, allScrollParents);
      var full = isLayerCompletelyInvisible(fixed ? triggerRect : layerRect, allScrollParents); // if parent is interested in diseappearance...

      if (hasOnDisappear) {
        if (partial || full) {
          onDisappear(full ? "full" : "partial");
        }
      } // ... else close accordingly
      else {
          if (closeOnDisappear === "partial" && partial) {
            setOpenInternal(false);
          }

          if (closeOnDisappear === "full" && full) {
            setOpenInternal(false);
          }
        }
    }
  }, [relativeParentElement, isOpen, triggerElement, scrollParents, fixed, placement]); // call `handlePositioning` when the layer's / trigger's
  // height and / or width changes

  var resizeObserver = useTrackElementResize(props.ResizeObserver, layerRef, triggerElement, isOpen, handlePositioning, environment); // On every render, check a few things...

  useIsomorphicLayoutEffect(function () {
    /**
     * A.
     * Ignore when render is caused by internal style change
     */
    var styleIsSetInterally = !isSet(onStyle);
    var effectBecauseOfInternalStyleChange = styles !== lastStyles.current;

    if (effectBecauseOfInternalStyleChange && styleIsSetInterally) {
      lastStyles.current = styles;
      return;
    } // reset lastStyles-ref when closed


    if (!isOpen) {
      resetLastStyles();
      return;
    }
    /**
     * B.
     * Prepare to calculate new layer style
     */
    // if (!triggerElement) {
    //   throw new Error("Please provide a valid ref to the trigger element");
    // } else if (!layerRef.current) {
    //   throw new Error("Please provide a valid ref to the layer element");
    // }


    handlePositioning();
  }); // calculate new layer style when window size changes

  useOnWindowResize(handlePositioning, environment, isOpen); // calculate new layer style when user scrolls

  useOnScroll(scrollParents, handlePositioning, environment, isOpen); // handle clicks that are not originated from the trigger / layer
  // element

  useOutsideClick([{
    current: triggerElement
  }, layerRef], useCallback(function () {
    if (!isOpen) {
      return;
    }

    if (onOutsideClick) {
      onOutsideClick();
    }

    if (closeOnOutsideClick && !isSet(isOpenExternal)) {
      setOpenInternal(false);
    }
  }, [isOpen, setOpenInternal, isOpenExternal]));
  var containerElement = typeof container === "function" ? container() : container;
  return createElement(Fragment, null, children({
    isOpen: isOpen,
    close: function close() {
      /* istanbul ignore next */
      if (isSet(isOpenExternal)) {
        throw new Error("You cannot call `close()` while using the `isOpen` prop");
      }
      /* istanbul ignore next */


      setOpenInternal(false);
    },
    open: function open() {
      /* istanbul ignore next */
      if (isSet(isOpenExternal)) {
        throw new Error("You cannot call `open()` while using the `isOpen` prop");
      }
      /* istanbul ignore next */


      setOpenInternal(true);
    },
    toggle: function toggle() {
      /* istanbul ignore next */
      if (isSet(isOpenExternal)) {
        throw new Error("You cannot call `toggle()` while using the `isOpen` prop");
      }

      setOpenInternal(!isOpenInternal);
    },
    triggerRef: triggerRef,
    layerSide: isOpen ? styles.layerSide : null
  }), relativeParentElement && createPortal(renderLayer({
    layerProps: {
      ref: function ref(element) {
        if (element) {
          // observe the layer for resizing
          // it's ok to observe the same element multiple times
          // since multiple observes of same element are ignored
          resizeObserver.observe(element);
        }

        layerRef.current = element;
      },
      style: _extends$2({}, isSet(onStyle) ? EMPTY_STYLE : styles.layer, {
        position: fixed ? "fixed" : "absolute",
        willChange: "top, bottom, left, right, width, height"
      })
    },
    arrowStyle: _extends$2({}, isSet(onStyle) ? EMPTY_STYLE : styles.arrow, {
      position: "absolute",
      willChange: "top, bottom, left, right"
    }),
    isOpen: isOpen,
    layerSide: styles.layerSide,
    triggerRect: triggerElement ? triggerElement.getBoundingClientRect() : null,
    close: function close() {
      /* istanbul ignore next */
      if (isSet(isOpenExternal)) {
        throw new Error("You cannot call `close()` while using the `isOpen` prop");
      }
      /* istanbul ignore next */


      setOpenInternal(false);
    }
  }), containerElement || relativeParentElement));
}
/**
 * Assign multiple refs at the same time.
 *
 * Taken from here: https://codesandbox.io/s/popover-menu-bvplm
 *
 * @example
 * ```
 * <div ref={composeRefs(ref1, ref2, ref3)} />
 * ```
 * @param  {...any} args Refs.
 */


function composeRefs() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return function (ref) {
    args.forEach(function (arg) {
      if (!arg) {
        return;
      }

      if (typeof arg === "function") {
        arg(ref);
        return;
      }

      arg.current = ref;
    });
  };
}
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */

/* eslint-disable require-jsdoc, valid-jsdoc */


var MapShim = function () {
  if (typeof Map !== 'undefined') {
    return Map;
  }
  /**
   * Returns index in provided array that matches the specified key.
   *
   * @param {Array<Array>} arr
   * @param {*} key
   * @returns {number}
   */


  function getIndex(arr, key) {
    var result = -1;
    arr.some(function (entry, index) {
      if (entry[0] === key) {
        result = index;
        return true;
      }

      return false;
    });
    return result;
  }

  return (
    /** @class */
    function () {
      function class_1() {
        this.__entries__ = [];
      }

      Object.defineProperty(class_1.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function get() {
          return this.__entries__.length;
        },
        enumerable: true,
        configurable: true
      });
      /**
       * @param {*} key
       * @returns {*}
       */

      class_1.prototype.get = function (key) {
        var index = getIndex(this.__entries__, key);
        var entry = this.__entries__[index];
        return entry && entry[1];
      };
      /**
       * @param {*} key
       * @param {*} value
       * @returns {void}
       */


      class_1.prototype.set = function (key, value) {
        var index = getIndex(this.__entries__, key);

        if (~index) {
          this.__entries__[index][1] = value;
        } else {
          this.__entries__.push([key, value]);
        }
      };
      /**
       * @param {*} key
       * @returns {void}
       */


      class_1.prototype["delete"] = function (key) {
        var entries = this.__entries__;
        var index = getIndex(entries, key);

        if (~index) {
          entries.splice(index, 1);
        }
      };
      /**
       * @param {*} key
       * @returns {void}
       */


      class_1.prototype.has = function (key) {
        return !!~getIndex(this.__entries__, key);
      };
      /**
       * @returns {void}
       */


      class_1.prototype.clear = function () {
        this.__entries__.splice(0);
      };
      /**
       * @param {Function} callback
       * @param {*} [ctx=null]
       * @returns {void}
       */


      class_1.prototype.forEach = function (callback, ctx) {
        if (ctx === void 0) {
          ctx = null;
        }

        for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
          var entry = _a[_i];
          callback.call(ctx, entry[1], entry[0]);
        }
      };

      return class_1;
    }()
  );
}();
/**
 * Detects whether window and document objects are available in current environment.
 */


var isBrowser$3 = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document; // Returns global object of a current environment.

var global$1 = function () {
  if (typeof global !== 'undefined' && global.Math === Math) {
    return global;
  }

  if (typeof self !== 'undefined' && self.Math === Math) {
    return self;
  }

  if (typeof window !== 'undefined' && window.Math === Math) {
    return window;
  } // eslint-disable-next-line no-new-func


  return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */


var requestAnimationFrame$1 = function () {
  if (typeof requestAnimationFrame === 'function') {
    // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind(global$1);
  }

  return function (callback) {
    return setTimeout(function () {
      return callback(Date.now());
    }, 1000 / 60);
  };
}(); // Defines minimum timeout before adding a trailing call.


var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */

function throttle(callback, delay) {
  var leadingCall = false,
      trailingCall = false,
      lastCallTime = 0;
  /**
   * Invokes the original callback function and schedules new invocation if
   * the "proxy" was called during current request.
   *
   * @returns {void}
   */

  function resolvePending() {
    if (leadingCall) {
      leadingCall = false;
      callback();
    }

    if (trailingCall) {
      proxy();
    }
  }
  /**
   * Callback invoked after the specified delay. It will further postpone
   * invocation of the original function delegating it to the
   * requestAnimationFrame.
   *
   * @returns {void}
   */


  function timeoutCallback() {
    requestAnimationFrame$1(resolvePending);
  }
  /**
   * Schedules invocation of the original function.
   *
   * @returns {void}
   */


  function proxy() {
    var timeStamp = Date.now();

    if (leadingCall) {
      // Reject immediately following calls.
      if (timeStamp - lastCallTime < trailingTimeout) {
        return;
      } // Schedule new call to be in invoked when the pending one is resolved.
      // This is important for "transitions" which never actually start
      // immediately so there is a chance that we might miss one if change
      // happens amids the pending invocation.


      trailingCall = true;
    } else {
      leadingCall = true;
      trailingCall = false;
      setTimeout(timeoutCallback, delay);
    }

    lastCallTime = timeStamp;
  }

  return proxy;
} // Minimum delay before invoking the update of observers.


var REFRESH_DELAY = 20; // A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.

var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight']; // Check if MutationObserver is available.

var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */

var ResizeObserverController =
/** @class */
function () {
  /**
   * Creates a new instance of ResizeObserverController.
   *
   * @private
   */
  function ResizeObserverController() {
    /**
     * Indicates whether DOM listeners have been added.
     *
     * @private {boolean}
     */
    this.connected_ = false;
    /**
     * Tells that controller has subscribed for Mutation Events.
     *
     * @private {boolean}
     */

    this.mutationEventsAdded_ = false;
    /**
     * Keeps reference to the instance of MutationObserver.
     *
     * @private {MutationObserver}
     */

    this.mutationsObserver_ = null;
    /**
     * A list of connected observers.
     *
     * @private {Array<ResizeObserverSPI>}
     */

    this.observers_ = [];
    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
  }
  /**
   * Adds observer to observers list.
   *
   * @param {ResizeObserverSPI} observer - Observer to be added.
   * @returns {void}
   */


  ResizeObserverController.prototype.addObserver = function (observer) {
    if (!~this.observers_.indexOf(observer)) {
      this.observers_.push(observer);
    } // Add listeners if they haven't been added yet.


    if (!this.connected_) {
      this.connect_();
    }
  };
  /**
   * Removes observer from observers list.
   *
   * @param {ResizeObserverSPI} observer - Observer to be removed.
   * @returns {void}
   */


  ResizeObserverController.prototype.removeObserver = function (observer) {
    var observers = this.observers_;
    var index = observers.indexOf(observer); // Remove observer if it's present in registry.

    if (~index) {
      observers.splice(index, 1);
    } // Remove listeners if controller has no connected observers.


    if (!observers.length && this.connected_) {
      this.disconnect_();
    }
  };
  /**
   * Invokes the update of observers. It will continue running updates insofar
   * it detects changes.
   *
   * @returns {void}
   */


  ResizeObserverController.prototype.refresh = function () {
    var changesDetected = this.updateObservers_(); // Continue running updates if changes have been detected as there might
    // be future ones caused by CSS transitions.

    if (changesDetected) {
      this.refresh();
    }
  };
  /**
   * Updates every observer from observers list and notifies them of queued
   * entries.
   *
   * @private
   * @returns {boolean} Returns "true" if any observer has detected changes in
   *      dimensions of it's elements.
   */


  ResizeObserverController.prototype.updateObservers_ = function () {
    // Collect observers that have active observations.
    var activeObservers = this.observers_.filter(function (observer) {
      return observer.gatherActive(), observer.hasActive();
    }); // Deliver notifications in a separate cycle in order to avoid any
    // collisions between observers, e.g. when multiple instances of
    // ResizeObserver are tracking the same element and the callback of one
    // of them changes content dimensions of the observed target. Sometimes
    // this may result in notifications being blocked for the rest of observers.

    activeObservers.forEach(function (observer) {
      return observer.broadcastActive();
    });
    return activeObservers.length > 0;
  };
  /**
   * Initializes DOM listeners.
   *
   * @private
   * @returns {void}
   */


  ResizeObserverController.prototype.connect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already added.
    if (!isBrowser$3 || this.connected_) {
      return;
    } // Subscription to the "Transitionend" event is used as a workaround for
    // delayed transitions. This way it's possible to capture at least the
    // final state of an element.


    document.addEventListener('transitionend', this.onTransitionEnd_);
    window.addEventListener('resize', this.refresh);

    if (mutationObserverSupported) {
      this.mutationsObserver_ = new MutationObserver(this.refresh);
      this.mutationsObserver_.observe(document, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    } else {
      document.addEventListener('DOMSubtreeModified', this.refresh);
      this.mutationEventsAdded_ = true;
    }

    this.connected_ = true;
  };
  /**
   * Removes DOM listeners.
   *
   * @private
   * @returns {void}
   */


  ResizeObserverController.prototype.disconnect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already removed.
    if (!isBrowser$3 || !this.connected_) {
      return;
    }

    document.removeEventListener('transitionend', this.onTransitionEnd_);
    window.removeEventListener('resize', this.refresh);

    if (this.mutationsObserver_) {
      this.mutationsObserver_.disconnect();
    }

    if (this.mutationEventsAdded_) {
      document.removeEventListener('DOMSubtreeModified', this.refresh);
    }

    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
  };
  /**
   * "Transitionend" event handler.
   *
   * @private
   * @param {TransitionEvent} event
   * @returns {void}
   */


  ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
    var _b = _a.propertyName,
        propertyName = _b === void 0 ? '' : _b; // Detect whether transition may affect dimensions of an element.

    var isReflowProperty = transitionKeys.some(function (key) {
      return !!~propertyName.indexOf(key);
    });

    if (isReflowProperty) {
      this.refresh();
    }
  };
  /**
   * Returns instance of the ResizeObserverController.
   *
   * @returns {ResizeObserverController}
   */


  ResizeObserverController.getInstance = function () {
    if (!this.instance_) {
      this.instance_ = new ResizeObserverController();
    }

    return this.instance_;
  };
  /**
   * Holds reference to the controller's instance.
   *
   * @private {ResizeObserverController}
   */


  ResizeObserverController.instance_ = null;
  return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */


var defineConfigurable = function defineConfigurable(target, props) {
  for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
    var key = _a[_i];
    Object.defineProperty(target, key, {
      value: props[key],
      enumerable: false,
      writable: false,
      configurable: true
    });
  }

  return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */


var getWindowOf = function getWindowOf(target) {
  // Assume that the element is an instance of Node, which means that it
  // has the "ownerDocument" property from which we can retrieve a
  // corresponding global object.
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView; // Return the local global object if it's not possible extract one from
  // provided element.

  return ownerGlobal || global$1;
}; // Placeholder of an empty content rectangle.


var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */

function toFloat(value) {
  return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */


function getBordersSize(styles) {
  var positions = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    positions[_i - 1] = arguments[_i];
  }

  return positions.reduce(function (size, position) {
    var value = styles['border-' + position + '-width'];
    return size + toFloat(value);
  }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */


function getPaddings(styles) {
  var positions = ['top', 'right', 'bottom', 'left'];
  var paddings = {};

  for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
    var position = positions_1[_i];
    var value = styles['padding-' + position];
    paddings[position] = toFloat(value);
  }

  return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */


function getSVGContentRect(target) {
  var bbox = target.getBBox();
  return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */


function getHTMLElementContentRect(target) {
  // Client width & height properties can't be
  // used exclusively as they provide rounded values.
  var clientWidth = target.clientWidth,
      clientHeight = target.clientHeight; // By this condition we can catch all non-replaced inline, hidden and
  // detached elements. Though elements with width & height properties less
  // than 0.5 will be discarded as well.
  //
  // Without it we would need to implement separate methods for each of
  // those cases and it's not possible to perform a precise and performance
  // effective test for hidden elements. E.g. even jQuery's ':visible' filter
  // gives wrong results for elements with width & height less than 0.5.

  if (!clientWidth && !clientHeight) {
    return emptyRect;
  }

  var styles = getWindowOf(target).getComputedStyle(target);
  var paddings = getPaddings(styles);
  var horizPad = paddings.left + paddings.right;
  var vertPad = paddings.top + paddings.bottom; // Computed styles of width & height are being used because they are the
  // only dimensions available to JS that contain non-rounded values. It could
  // be possible to utilize the getBoundingClientRect if only it's data wasn't
  // affected by CSS transformations let alone paddings, borders and scroll bars.

  var width = toFloat(styles.width),
      height = toFloat(styles.height); // Width & height include paddings and borders when the 'border-box' box
  // model is applied (except for IE).

  if (styles.boxSizing === 'border-box') {
    // Following conditions are required to handle Internet Explorer which
    // doesn't include paddings and borders to computed CSS dimensions.
    //
    // We can say that if CSS dimensions + paddings are equal to the "client"
    // properties then it's either IE, and thus we don't need to subtract
    // anything, or an element merely doesn't have paddings/borders styles.
    if (Math.round(width + horizPad) !== clientWidth) {
      width -= getBordersSize(styles, 'left', 'right') + horizPad;
    }

    if (Math.round(height + vertPad) !== clientHeight) {
      height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
  } // Following steps can't be applied to the document's root element as its
  // client[Width/Height] properties represent viewport area of the window.
  // Besides, it's as well not necessary as the <html> itself neither has
  // rendered scroll bars nor it can be clipped.


  if (!isDocumentElement(target)) {
    // In some browsers (only in Firefox, actually) CSS width & height
    // include scroll bars size which can be removed at this step as scroll
    // bars are the only difference between rounded dimensions + paddings
    // and "client" properties, though that is not always true in Chrome.
    var vertScrollbar = Math.round(width + horizPad) - clientWidth;
    var horizScrollbar = Math.round(height + vertPad) - clientHeight; // Chrome has a rather weird rounding of "client" properties.
    // E.g. for an element with content width of 314.2px it sometimes gives
    // the client width of 315px and for the width of 314.7px it may give
    // 314px. And it doesn't happen all the time. So just ignore this delta
    // as a non-relevant.

    if (Math.abs(vertScrollbar) !== 1) {
      width -= vertScrollbar;
    }

    if (Math.abs(horizScrollbar) !== 1) {
      height -= horizScrollbar;
    }
  }

  return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */


var isSVGGraphicsElement = function () {
  // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
  // interface.
  if (typeof SVGGraphicsElement !== 'undefined') {
    return function (target) {
      return target instanceof getWindowOf(target).SVGGraphicsElement;
    };
  } // If it's so, then check that element is at least an instance of the
  // SVGElement and that it has the "getBBox" method.
  // eslint-disable-next-line no-extra-parens


  return function (target) {
    return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
  };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */


function isDocumentElement(target) {
  return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */


function getContentRect(target) {
  if (!isBrowser$3) {
    return emptyRect;
  }

  if (isSVGGraphicsElement(target)) {
    return getSVGContentRect(target);
  }

  return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */


function createReadOnlyRect(_a) {
  var x = _a.x,
      y = _a.y,
      width = _a.width,
      height = _a.height; // If DOMRectReadOnly is available use it as a prototype for the rectangle.

  var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
  var rect = Object.create(Constr.prototype); // Rectangle's properties are not writable and non-enumerable.

  defineConfigurable(rect, {
    x: x,
    y: y,
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: height + y,
    left: x
  });
  return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */


function createRectInit(x, y, width, height) {
  return {
    x: x,
    y: y,
    width: width,
    height: height
  };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */


var ResizeObservation =
/** @class */
function () {
  /**
   * Creates an instance of ResizeObservation.
   *
   * @param {Element} target - Element to be observed.
   */
  function ResizeObservation(target) {
    /**
     * Broadcasted width of content rectangle.
     *
     * @type {number}
     */
    this.broadcastWidth = 0;
    /**
     * Broadcasted height of content rectangle.
     *
     * @type {number}
     */

    this.broadcastHeight = 0;
    /**
     * Reference to the last observed content rectangle.
     *
     * @private {DOMRectInit}
     */

    this.contentRect_ = createRectInit(0, 0, 0, 0);
    this.target = target;
  }
  /**
   * Updates content rectangle and tells whether it's width or height properties
   * have changed since the last broadcast.
   *
   * @returns {boolean}
   */


  ResizeObservation.prototype.isActive = function () {
    var rect = getContentRect(this.target);
    this.contentRect_ = rect;
    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
  };
  /**
   * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
   * from the corresponding properties of the last observed content rectangle.
   *
   * @returns {DOMRectInit} Last observed content rectangle.
   */


  ResizeObservation.prototype.broadcastRect = function () {
    var rect = this.contentRect_;
    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;
    return rect;
  };

  return ResizeObservation;
}();

var ResizeObserverEntry =
/** @class */
function () {
  /**
   * Creates an instance of ResizeObserverEntry.
   *
   * @param {Element} target - Element that is being observed.
   * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
   */
  function ResizeObserverEntry(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit); // According to the specification following properties are not writable
    // and are also not enumerable in the native implementation.
    //
    // Property accessors are not being used as they'd require to define a
    // private WeakMap storage which may cause memory leaks in browsers that
    // don't support this type of collections.

    defineConfigurable(this, {
      target: target,
      contentRect: contentRect
    });
  }

  return ResizeObserverEntry;
}();

var ResizeObserverSPI =
/** @class */
function () {
  /**
   * Creates a new instance of ResizeObserver.
   *
   * @param {ResizeObserverCallback} callback - Callback function that is invoked
   *      when one of the observed elements changes it's content dimensions.
   * @param {ResizeObserverController} controller - Controller instance which
   *      is responsible for the updates of observer.
   * @param {ResizeObserver} callbackCtx - Reference to the public
   *      ResizeObserver instance which will be passed to callback function.
   */
  function ResizeObserverSPI(callback, controller, callbackCtx) {
    /**
     * Collection of resize observations that have detected changes in dimensions
     * of elements.
     *
     * @private {Array<ResizeObservation>}
     */
    this.activeObservations_ = [];
    /**
     * Registry of the ResizeObservation instances.
     *
     * @private {Map<Element, ResizeObservation>}
     */

    this.observations_ = new MapShim();

    if (typeof callback !== 'function') {
      throw new TypeError('The callback provided as parameter 1 is not a function.');
    }

    this.callback_ = callback;
    this.controller_ = controller;
    this.callbackCtx_ = callbackCtx;
  }
  /**
   * Starts observing provided element.
   *
   * @param {Element} target - Element to be observed.
   * @returns {void}
   */


  ResizeObserverSPI.prototype.observe = function (target) {
    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    } // Do nothing if current environment doesn't have the Element interface.


    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
      return;
    }

    if (!(target instanceof getWindowOf(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_; // Do nothing if element is already being observed.

    if (observations.has(target)) {
      return;
    }

    observations.set(target, new ResizeObservation(target));
    this.controller_.addObserver(this); // Force the update of observations.

    this.controller_.refresh();
  };
  /**
   * Stops observing provided element.
   *
   * @param {Element} target - Element to stop observing.
   * @returns {void}
   */


  ResizeObserverSPI.prototype.unobserve = function (target) {
    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    } // Do nothing if current environment doesn't have the Element interface.


    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
      return;
    }

    if (!(target instanceof getWindowOf(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_; // Do nothing if element is not being observed.

    if (!observations.has(target)) {
      return;
    }

    observations["delete"](target);

    if (!observations.size) {
      this.controller_.removeObserver(this);
    }
  };
  /**
   * Stops observing all elements.
   *
   * @returns {void}
   */


  ResizeObserverSPI.prototype.disconnect = function () {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
  };
  /**
   * Collects observation instances the associated element of which has changed
   * it's content rectangle.
   *
   * @returns {void}
   */


  ResizeObserverSPI.prototype.gatherActive = function () {
    var _this = this;

    this.clearActive();
    this.observations_.forEach(function (observation) {
      if (observation.isActive()) {
        _this.activeObservations_.push(observation);
      }
    });
  };
  /**
   * Invokes initial callback function with a list of ResizeObserverEntry
   * instances collected from active resize observations.
   *
   * @returns {void}
   */


  ResizeObserverSPI.prototype.broadcastActive = function () {
    // Do nothing if observer doesn't have active observations.
    if (!this.hasActive()) {
      return;
    }

    var ctx = this.callbackCtx_; // Create ResizeObserverEntry instance for every active observation.

    var entries = this.activeObservations_.map(function (observation) {
      return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });
    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
  };
  /**
   * Clears the collection of active observations.
   *
   * @returns {void}
   */


  ResizeObserverSPI.prototype.clearActive = function () {
    this.activeObservations_.splice(0);
  };
  /**
   * Tells whether observer has active observations.
   *
   * @returns {boolean}
   */


  ResizeObserverSPI.prototype.hasActive = function () {
    return this.activeObservations_.length > 0;
  };

  return ResizeObserverSPI;
}(); // Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.


var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */

var ResizeObserver =
/** @class */
function () {
  /**
   * Creates a new instance of ResizeObserver.
   *
   * @param {ResizeObserverCallback} callback - Callback that is invoked when
   *      dimensions of the observed elements change.
   */
  function ResizeObserver(callback) {
    if (!(this instanceof ResizeObserver)) {
      throw new TypeError('Cannot call a class as a function.');
    }

    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    }

    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback, controller, this);
    observers.set(this, observer);
  }

  return ResizeObserver;
}(); // Expose public methods of ResizeObserver.


['observe', 'unobserve', 'disconnect'].forEach(function (method) {
  ResizeObserver.prototype[method] = function () {
    var _a;

    return (_a = observers.get(this))[method].apply(_a, arguments);
  };
});

var index = function () {
  // Export existing implementation if available.
  if (typeof global$1.ResizeObserver !== 'undefined') {
    return global$1.ResizeObserver;
  }

  return ResizeObserver;
}();

var _templateObject$n = taggedTemplateLiteral(["\n    width: ", ";\n    ul {\n      ", "\n      flex: 1 0 auto;\n      line-height: 1.3;\n      width: ", ";\n      box-shadow: ", ";\n      border: ", ";\n      border-radius: ", ";\n      color: ", ";\n      background: ", ";\n      list-style: none;\n      margin: 0;\n      padding: ", " 0;\n      /* padding: 0; */\n      > div {\n        padding: 0 ", " ", ";\n        padding-right: 1.4em;\n        word-break: break-word;\n      }\n      li {\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        cursor: pointer;\n        padding: ", " ", ";\n        padding-right: 1.4em;\n        p {\n          font-size: ", ";\n          color: ", ";\n        }\n        &.active {\n          background: ", ";\n          p {\n            color: ", ";\n          }\n        }\n      }\n    }\n  "], ["\n    width: ", ";\n    ul {\n      ", "\n      flex: 1 0 auto;\n      line-height: 1.3;\n      width: ", ";\n      box-shadow: ", ";\n      border: ", ";\n      border-radius: ", ";\n      color: ", ";\n      background: ", ";\n      list-style: none;\n      margin: 0;\n      padding: ", " 0;\n      /* padding: 0; */\n      > div {\n        padding: 0 ", " ", ";\n        padding-right: 1.4em;\n        word-break: break-word;\n      }\n      li {\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        cursor: pointer;\n        padding: ", " ", ";\n        padding-right: 1.4em;\n        p {\n          font-size: ", ";\n          color: ", ";\n        }\n        &.active {\n          background: ", ";\n          p {\n            color: ", ";\n          }\n        }\n      }\n    }\n  "]),
    _templateObject2$g = taggedTemplateLiteral(["\n            max-height: ", ";\n            overflow: scroll;\n            scroll-behavior: smooth;\n          "], ["\n            max-height: ", ";\n            overflow: scroll;\n            scroll-behavior: smooth;\n          "]);

var DropDown = function DropDown(props) {
  var config = useConfig();
  var _config$dropdown = config.dropdown,
      configOffset = _config$dropdown.offset,
      configAnchor = _config$dropdown.anchor,
      preferX = _config$dropdown.preferX,
      textColor = _config$dropdown.textColor,
      activeColor = _config$dropdown.activeColor,
      iconPadding = _config$dropdown.iconPadding,
      rowIconSizeConfig = _config$dropdown.rowIconSize,
      rowImageSizeConfig = _config$dropdown.rowImageSize,
      rowImageCornerRadiusConfig = _config$dropdown.rowImageCornerRadius,
      headerPadding = _config$dropdown.headerPadding,
      detailsSize = _config$dropdown.detailsSize,
      detailsColor = _config$dropdown.detailsColor;
  var children = props.children,
      show = props.show,
      width = props.width,
      fullWidth = props.fullWidth,
      _props$offset = props.offset,
      offset = _props$offset === undefined ? configOffset : _props$offset,
      _props$anchor = props.anchor,
      anchor = _props$anchor === undefined ? configAnchor : _props$anchor,
      _props$scrollable = props.scrollable,
      scrollable = _props$scrollable === undefined ? false : _props$scrollable,
      header = props.header,
      _props$options = props.options,
      options = _props$options === undefined ? [] : _props$options,
      _props$optionsDetails = props.optionsDetails,
      optionsDetails = _props$optionsDetails === undefined ? [] : _props$optionsDetails,
      optionsNames = props.optionsNames,
      optionsIcons = props.optionsIcons,
      optionsImages = props.optionsImages,
      selectedOption = props.selectedOption,
      setSelectedOption = props.setSelectedOption,
      _props$optionsIconsSi = props.optionsIconsSize,
      optionsIconsSize = _props$optionsIconsSi === undefined ? rowIconSizeConfig : _props$optionsIconsSi,
      _props$optionsImagesS = props.optionsImagesSize,
      optionsImagesSize = _props$optionsImagesS === undefined ? rowImageSizeConfig : _props$optionsImagesS,
      _props$rowImageCorner = props.rowImageCornerRadius,
      rowImageCornerRadius = _props$rowImageCorner === undefined ? rowImageCornerRadiusConfig : _props$rowImageCorner,
      onClickOutside = props.onClickOutside;

  var _useState = useState(selectedOption || null),
      _useState2 = slicedToArray(_useState, 2),
      highlightedOption = _useState2[0],
      setHighlightedOption = _useState2[1];

  useEffect(function () {
    setHighlightedOption(selectedOption || 0);
  }, [selectedOption]);
  var innerListRef = useRef(null);
  useClickOutside(innerListRef, function (event) {
    return onClickOutside && onClickOutside(event);
  });

  function handleKeyDown(event) {
    if (!show) return;
    var keyDown = event.key;

    if (keyDown === "ArrowUp") {
      if (highlightedOption > 0) {
        setHighlightedOption(highlightedOption - 1);
      } else {
        setHighlightedOption(options.length - 1);
      }
    }

    if (keyDown === "ArrowDown") {
      if (highlightedOption < options.length - 1) {
        setHighlightedOption(highlightedOption + 1);
      } else {
        setHighlightedOption(0);
      }
    }

    if (keyDown === "Enter") {
      setSelectedOption(highlightedOption);
    }

    if (keyDown === "ArrowUp" || keyDown === "ArrowDown") {
      scrollDOMOption();
    }
  }

  var optionsFormActive = options && options.length > 0;
  var childRef = useRef(null);

  function scrollDOMOption() {
    var containerDiv = childRef.current.firstElementChild.firstElementChild;

    if (typeof containerDiv !== "undefined" && scrollable && containerDiv.children[highlightedOption || 0]) {
      containerDiv.children[highlightedOption || 0].scrollIntoView({
        block: "center"
      });
    }
  }

  var window = useWindow();
  useEffect(function () {
    if (!optionsFormActive) return;
    window.addEventListener("keydown", handleKeyDown);
    return function () {
      return window.removeEventListener("keydown", handleKeyDown);
    };
  }); // the content of the DropDown

  var renderLayer = function renderLayer(renderLayerProps) {
    var triggerRect = renderLayerProps.triggerRect,
        layerProps = renderLayerProps.layerProps;
    return show && options && options.length > 0 && jsx("div", {
      ref: composeRefs(layerProps.ref, childRef),
      style: _extends({}, layerProps.style, {
        zIndex: 10
      })
    }, jsx("div", {
      css: optionsWrapperCSS(props, config, triggerRect),
      onMouseLeave: function onMouseLeave() {
        return setHighlightedOption(null);
      }
    }, jsx("ul", {
      ref: innerListRef
    }, header && jsx("div", {
      style: {
        paddingTop: headerPadding,
        paddingBottom: headerPadding
      }
    }, header), options.map(function (s, i) {
      var isHighlighted = highlightedOption === i;
      return jsx("li", {
        key: i,
        className: isHighlighted ? "active" : "",
        onClick: function onClick() {
          setHighlightedOption(i);
          setSelectedOption(i);
        },
        onMouseEnter: function onMouseEnter() {
          return setHighlightedOption(i);
        }
      }, optionsImages && optionsImages[i] && jsx("img", {
        width: optionsImagesSize,
        height: optionsImagesSize,
        src: optionsImages[i],
        alt: "" + i,
        style: {
          flex: "0 0 " + optionsImagesSize,
          width: optionsImagesSize,
          height: optionsImagesSize,
          borderRadius: rowImageCornerRadius,
          marginRight: iconPadding
        }
      }), optionsIcons && optionsIcons[i] && jsx(Icon, {
        size: optionsIconsSize,
        name: optionsIcons[i],
        color: isHighlighted ? activeColor : textColor,
        style: {
          flex: "0 0 " + optionsImagesSize,
          marginRight: iconPadding
        }
      }), jsx(VStack, {
        gap: 0,
        style: {
          minWidth: width || fullWidth ? 0 : "auto"
        }
      }, jsx(HStack, {
        gap: 0,
        noWrap: true,
        style: {
          width: "100%"
        }
      }, jsx(P2, {
        noMargin: true,
        key: i
      }, optionsNames ? optionsNames[i] : s)), optionsDetails[i] && jsx(HStack, {
        gap: 0,
        noWrap: true,
        style: {
          width: "100%"
        }
      }, jsx(P2, {
        style: {
          fontSize: detailsSize,
          color: isHighlighted ? activeColor : detailsColor,
          margin: "-.3em 0 0"
        }
      }, optionsDetails[i]))));
    }))));
  };

  var renderTrigger = function renderTrigger(renderTriggerProps) {
    return jsx("div", {
      style: {
        cursor: "pointer"
      },
      ref: renderTriggerProps.triggerRef,
      onClick: renderTriggerProps.toggle
    }, children);
  };

  return jsx(ToggleLayer, {
    closeOnOutsideClick: true,
    ResizeObserver: index,
    renderLayer: renderLayer,
    placement: {
      anchor: anchor,
      autoAdjust: true,
      snapToAnchor: false,
      triggerOffset: offset,
      scrollOffset: 16,
      preferX: preferX
    }
  }, renderTrigger);
};

var optionsWrapperCSS = function optionsWrapperCSS(props, config, triggerRect) {
  var _config$dropdown2 = config.dropdown,
      background = _config$dropdown2.background,
      border = _config$dropdown2.border,
      shadow = _config$dropdown2.shadow,
      radius = _config$dropdown2.radius,
      textColor = _config$dropdown2.textColor,
      activeColor = _config$dropdown2.activeColor,
      rowSizeConfig = _config$dropdown2.rowSize,
      rowPadding = _config$dropdown2.rowPadding,
      lateralPadding = _config$dropdown2.lateralPadding,
      verticalPadding = _config$dropdown2.verticalPadding,
      scrollableHeight = _config$dropdown2.scrollableHeight;
  var scrollable = props.scrollable,
      width = props.width,
      fullWidth = props.fullWidth,
      _props$rowSize = props.rowSize,
      rowSize = _props$rowSize === undefined ? rowSizeConfig : _props$rowSize;
  var triggerWidth = triggerRect.width;
  var activeColorTransparent = tinycolor(activeColor).setAlpha(0.2).toString();

  var computedWidth = function () {
    if (width) return width;
    if (fullWidth) return triggerWidth + "px";
    return "auto";
  }();

  return css(_templateObject$n, computedWidth, scrollable ? css(_templateObject2$g, scrollableHeight) : "", computedWidth, shadow, border, radius, textColor, background, verticalPadding, lateralPadding, verticalPadding, rowPadding, lateralPadding, rowSize, textColor, activeColorTransparent, activeColor);
};

var _templateObject$o = taggedTemplateLiteral(["\n    /* flex: 1 1 auto; */\n    ", "\n    max-width: ", ";\n    /* max-width: 100%; */\n    /* flex-grow: 999 !important; */\n  "], ["\n    /* flex: 1 1 auto; */\n    ", "\n    max-width: ", ";\n    /* max-width: 100%; */\n    /* flex-grow: 999 !important; */\n  "]),
    _templateObject2$h = taggedTemplateLiteral(["\n    ", "\n    ", ";\n    height: ", ";\n  "], ["\n    ", "\n    ", ";\n    height: ", ";\n  "]),
    _templateObject3$c = taggedTemplateLiteral(["\n    ", "\n    ", "\n    width: 100%;\n    resize: none;\n    ", "\n    ", " :disabled {\n      opacity: 0.5;\n    }\n    ::placeholder {\n      ", "\n      color: ", ";\n    }\n  "], ["\n    ", "\n    ", "\n    width: 100%;\n    resize: none;\n    ", "\n    ", " :disabled {\n      opacity: 0.5;\n    }\n    ::placeholder {\n      ", "\n      color: ", ";\n    }\n  "]),
    _templateObject4$6 = taggedTemplateLiteral(["\n    ", "\n  "], ["\n    ", "\n  "]),
    _templateObject5$5 = taggedTemplateLiteral(["\n            ", "\n            margin: 0 0 .2em;\n          "], ["\n            ", "\n            margin: 0 0 .2em;\n          "]);

var Input = function Input(props) {
  var _useState = useState(false),
      _useState2 = slicedToArray(_useState, 2),
      focus = _useState2[0],
      setFocus = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = slicedToArray(_useState3, 2),
      selectedSuggestion = _useState4[0],
      setSelectedSuggestion = _useState4[1];

  var config = useConfig();
  var _config$inputs = config.inputs,
      widthConfig = _config$inputs.width,
      color = _config$inputs.color,
      colorFocus = _config$inputs.colorFocus,
      colorError = _config$inputs.colorError,
      outlineAlpha = _config$inputs.outlineAlpha,
      outlineWidth = _config$inputs.outlineWidth,
      colorSuccess = _config$inputs.colorSuccess,
      placeholderColor = _config$inputs.placeholderColor,
      borderWidth = _config$inputs.borderWidth,
      iconColorConfig = _config$inputs.iconColor,
      iconStrokeWidth = _config$inputs.iconStrokeWidth,
      labelColor = _config$inputs.labelColor; // when adding props, also update the nativeInputProps below

  var _props$component = props.component,
      Component$$1 = _props$component === undefined ? "input" : _props$component,
      icon = props.icon,
      height = props.height,
      loading = props.loading,
      _props$width = props.width,
      width = _props$width === undefined ? widthConfig : _props$width,
      _props$maxWidth = props.maxWidth,
      maxWidth = _props$maxWidth === undefined ? "100%" : _props$maxWidth,
      suggestions = props.suggestions,
      suggestionsNames = props.suggestionsNames,
      suggestionsDetails = props.suggestionsDetails,
      suggestionsIcons = props.suggestionsIcons,
      suggestionsImages = props.suggestionsImages,
      suggestionsIconsSize = props.suggestionsIconsSize,
      suggestionsImagesSize = props.suggestionsImagesSize,
      onSuggestionClick = props.onSuggestionClick,
      onSubmit = props.onSubmit,
      providedOnBlur = props.onBlur,
      providedStyle = props.style,
      wrapperStyle = props.wrapperStyle,
      _props$error = props.error,
      error = _props$error === undefined ? false : _props$error,
      success = props.success,
      required = props.required,
      label = props.label,
      fixedSpaceForErrors = props.fixedSpaceForErrors;
  var nativeInputProps = cleanedProps(props, ["component", "icon", "loading", "width", "maxWidth", "suggestions", "suggestionsNames", "suggestionsDetails", "suggestionsIcons", "suggestionsImages", "suggestionsIconsSize", "suggestionsImagesSize", "onSuggestionClick", "fixedSpaceForErrors", "onSubmit", "style", "wrapperStyle", "error", "success", "required", "label"]);
  var colorFocusAlpha = tinycolor(colorFocus).setAlpha(outlineAlpha).toString();
  var colorErrorAlpha = tinycolor(colorError).setAlpha(outlineAlpha).toString();

  var inputStyle = function () {
    if (error && focus) return "\n      box-shadow:\n        inset 0 0 0 " + borderWidth + " " + colorError + ",\n        0 0 0 " + outlineWidth + "px " + colorErrorAlpha + ";\n      ";
    if (error) return "\n      box-shadow:\n        inset 0 0 0 " + borderWidth + " " + colorError + ",\n        0 0 0 0px " + colorErrorAlpha + ";\n      ";
    if (focus) return "\n      box-shadow:\n          inset 0 0 0 " + borderWidth + " " + colorFocus + ",\n          0 0 0 " + outlineWidth + "px " + colorFocusAlpha + ";\n      ";
    return "\n      box-shadow:\n        inset 0 0 0 " + borderWidth + " " + color + ",\n        0 0 0 0px " + colorFocusAlpha + ";\n      ";
  }();

  var iconColor = function () {
    if (error) return colorError;
    if (focus) return colorFocus;
    return iconColorConfig;
  }();

  var style = _extends({}, config.Input.style, providedStyle);

  var outerWrapperCSS = css(_templateObject$o, width ? "width: " + width + ";" : "", maxWidth);
  var inputWrapperCSS = css(_templateObject2$h, inputWrapperGeneralStyle(config), inputStyle, height);
  var inputCSS = css(_templateObject3$c, inputComponentGeneralStyle(config), height ? "padding-top: " + config.inputs.padding + "; padding-bottom: " + config.inputs.padding + ";" : "", getFontSize("Input", config), icon ? "padding-right: 2em;" : "", getFontSize("Input", config), placeholderColor);
  var iconWrapperCSS = css(_templateObject4$6, iconWrapperStyle(config));
  var inputRef = useRef(null);
  useEffect(function () {
    if (!inputRef.current) return;
    inputRef.current.addEventListener("keydown", function () {});
  }, [inputRef]);

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === "Enter") {
      onSubmit && onSubmit();
    }
  };

  return jsx("div", {
    css: outerWrapperCSS
  }, label && jsx(P1, {
    CSS: css(_templateObject5$5, getFontSize("Input", config)),
    color: labelColor
  }, label, required ? jsx("span", {
    style: {
      color: "red"
    }
  }, " *") : ""), jsx(DropDown, {
    fullWidth: true,
    show: focus,
    scrollable: true,
    options: suggestions,
    optionsNames: suggestionsNames,
    optionsDetails: suggestionsDetails,
    optionsIcons: suggestionsIcons,
    optionsImages: suggestionsImages,
    optionsIconsSize: suggestionsIconsSize,
    optionsImagesSize: suggestionsImagesSize,
    selectedOption: selectedSuggestion,
    setSelectedOption: function setSelectedOption(suggestionIndex) {
      setSelectedSuggestion(suggestionIndex);

      if (suggestionsDetails) {
        onSuggestionClick(suggestions[suggestionIndex], suggestionIndex, suggestionsDetails[suggestionIndex]);
      } else {
        onSuggestionClick(suggestions[suggestionIndex], suggestionIndex);
      }

      inputRef.current && inputRef.current.blur();
    }
  }, jsx("div", {
    css: inputWrapperCSS,
    style: wrapperStyle
  }, jsx(Component$$1, _extends({
    ref: inputRef,
    onFocus: function onFocus() {
      return setFocus(true);
    },
    css: inputCSS,
    style: style,
    onKeyDown: handleKeyDown
  }, nativeInputProps, {
    onBlur: function onBlur(e) {
      providedOnBlur && providedOnBlur(e);
      setTimeout(function () {
        return setFocus(false);
      }, 200);
    }
  })), jsx("div", {
    css: iconWrapperCSS
  }, jsx(Spinner, {
    size: 14,
    stroke: 1.5,
    show: loading
  }), icon && !loading && jsx(Icon, {
    name: icon,
    size: "1em",
    color: iconColor,
    strokeWidth: iconStrokeWidth
  })))), function () {
    if (error && typeof error === "string") {
      return jsx(SmallText, {
        CSS: messageCSS(),
        color: colorError
      }, error);
    }

    if (success && typeof success === "string") {
      return jsx(SmallText, {
        CSS: messageCSS(),
        color: colorSuccess
      }, success);
    }

    if (fixedSpaceForErrors) {
      return jsx(SmallText, {
        CSS: messageCSS(),
        color: colorError
      }, "\u2063");
    }
  }());
};

var SliderWithInput = function SliderWithInput(props) {
  var min = props.min,
      max = props.max,
      value = props.value,
      _onChange = props.onChange,
      style = props.style,
      error = props.error,
      success = props.success,
      messageOnTopAt = props.messageOnTopAt;
  var config = useConfig();
  var _config$colors = config.colors,
      successColor = _config$colors.success,
      errorColor = _config$colors.error;
  return React.createElement("div", {
    style: {
      position: "relative"
    }
  }, React.createElement(Grid, {
    style: style,
    vAlign: "center",
    columns: "1fr 4em"
  }, React.createElement(Slider, {
    min: min,
    max: max,
    value: value,
    onChange: _onChange
  }), React.createElement(Input, {
    type: "number",
    min: min,
    max: max,
    value: value,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    }
  })), error && typeof error === "string" && React.createElement(SmallText, {
    CSS: messageCSS(messageOnTopAt),
    color: errorColor
  }, error), success && typeof success === "string" && React.createElement(SmallText, {
    CSS: messageCSS(messageOnTopAt),
    color: successColor
  }, success));
};

var _templateObject$p = taggedTemplateLiteral(["\n    ", "\n    ", "\n    :not(.last) {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n    &.last {\n      flex: 1 0 auto;\n    }\n  "], ["\n    ", "\n    ", "\n    :not(.last) {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n    &.last {\n      flex: 1 0 auto;\n    }\n  "]);

var Breadcrumb = function Breadcrumb(props) {
  var crumbs = props.crumbs,
      _props$maxCrumbs = props.maxCrumbs,
      providedMaxCrumbs = _props$maxCrumbs === undefined ? 99 : _props$maxCrumbs,
      breakPoint = props.breakPoint,
      onCrumbClick = props.onCrumbClick,
      externalCSS = props.CSS;

  var _useWindowSize = useWindowSize(),
      windowWidth = _useWindowSize.width;

  var maxCrumbs = breakPoint ? windowWidth < parseInt(breakPoint) ? 2 : providedMaxCrumbs : providedMaxCrumbs;
  var config = useConfig();
  var spacing = config.breadcrumbs.spacing;

  var _useState = useState(false),
      _useState2 = slicedToArray(_useState, 2),
      dropDownShown = _useState2[0],
      setDropDownShown = _useState2[1];

  if (!crumbs || crumbs.length === 0) return null;
  var hiddenCrumbs = crumbs.length <= maxCrumbs ? [] : crumbs.slice(1, crumbs.length - maxCrumbs + 1);
  var visibleCrumbs = crumbs.length <= maxCrumbs ? crumbs.slice(1, crumbs.length) : crumbs.slice(crumbs.length - maxCrumbs + 1, crumbs.length);

  var handleCrumbClick = function handleCrumbClick(crumb) {
    onCrumbClick && onCrumbClick(crumb);
  };

  return jsx(HStack, {
    maxWidth: "100%",
    css: externalCSS,
    noWrap: true,
    gap: spacing
  }, jsx(Crumb, {
    crumb: crumbs[0],
    onClick: function onClick() {
      return handleCrumbClick(crumbs[0]);
    }
  }), crumbs.length > 1 && jsx(Separator, null), hiddenCrumbs.length > 0 && jsx(Fragment, null, jsx(DropDown, {
    show: dropDownShown,
    onClickOutside: function onClickOutside() {
      return setDropDownShown(false);
    },
    scrollable: false,
    options: hiddenCrumbs.map(function (c) {
      return c.title;
    }),
    optionsNames: hiddenCrumbs.map(function (c) {
      return c.title;
    }),
    selectedOption: null,
    setSelectedOption: function setSelectedOption(index) {
      handleCrumbClick(hiddenCrumbs[index]);
      setDropDownShown(false);
    }
  }, jsx(Crumb, {
    crumb: {
      title: "..."
    },
    onClick: function onClick() {
      return setDropDownShown(!dropDownShown);
    }
  })), jsx(Separator, null)), visibleCrumbs.map(function (crumb, i) {
    var separatorPresent = i < visibleCrumbs.length - 1 ? "..." : null;
    return jsx(Fragment, {
      key: i
    }, jsx(Crumb, {
      crumb: crumb,
      last: i === visibleCrumbs.length - 1,
      onClick: function onClick() {
        return handleCrumbClick(crumb);
      }
    }), separatorPresent && jsx(Separator, null));
  }));
};

var Crumb = function Crumb(_ref) {
  var crumb = _ref.crumb,
      last = _ref.last,
      _onClick = _ref.onClick;
  var config = useConfig();
  var _config$breadcrumbs = config.breadcrumbs,
      crumbStyle = _config$breadcrumbs.crumbStyle,
      lastCrumbStyle = _config$breadcrumbs.lastCrumbStyle,
      emphasizedCrumbStyle = _config$breadcrumbs.emphasizedCrumbStyle;

  var style = _extends({}, crumbStyle, last ? lastCrumbStyle : undefined, crumb.emphasized ? emphasizedCrumbStyle : undefined, crumb.style);

  var crumbCSS = css(_templateObject$p, getFontSize("Button", config), getFontWeight("Button", config));
  return jsx("span", {
    className: last && "last",
    style: style,
    css: crumbCSS,
    onClick: function onClick() {
      return _onClick && _onClick(crumb);
    }
  }, crumb.title);
};

var Separator = function Separator() {
  var config = useConfig();
  var separator = config.breadcrumbs.separator;
  return jsx(Icon, {
    style: {
      flex: "1 0 " + separator.size
    },
    name: separator.icon,
    color: separator.color,
    size: separator.size,
    strokeWidth: separator.strokeWidth
  });
};

Breadcrumb.propTypes = {
  crumbs: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    emphasized: PropTypes.bool
  })).isRequired,
  maxCrumbs: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  breakPoint: PropTypes.string,
  // Example: 640px
  onCrumbClick: PropTypes.func
};

var Accordion = function Accordion(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === undefined ? 150 : _ref$height,
      shadowColor = _ref.shadowColor,
      shadowHeight = _ref.shadowHeight,
      speed = _ref.speed,
      children = _ref.children,
      noToggle = _ref.noToggle,
      providedIsOpen = _ref.isOpen,
      providedSetIsOpen = _ref.setIsOpen;
  var config = useConfig();
  var toggleSpacing = config.accordion.toggleSpacing;
  /**
   *  - height: desired collapsed height
   *  - contentsHeight: height of the actual content
   *  - currentHeight: the active state between those 2 ( contentsHeight | height )
   */

  var _useClientRect = useClientRect(),
      _useClientRect2 = slicedToArray(_useClientRect, 2),
      rect = _useClientRect2[0],
      contentContainerRef = _useClientRect2[1];

  var _useState = useState(height),
      _useState2 = slicedToArray(_useState, 2),
      currentHeight = _useState2[0],
      setCurrentHeight = _useState2[1];

  var contentsHeight = rect ? rect.height : 0;

  var _useState3 = useState(false),
      _useState4 = slicedToArray(_useState3, 2),
      animationEnabled = _useState4[0],
      setAnimationEnabled = _useState4[1];

  useEffect(function () {
    var enableAnimation = setTimeout(function () {
      return setAnimationEnabled(true);
    }, 100);
    return function () {
      return clearTimeout(enableAnimation);
    };
  }, []);

  var _useState5 = useState(false),
      _useState6 = slicedToArray(_useState5, 2),
      _isOpen = _useState6[0],
      _setIsOpen = _useState6[1]; // control with external hooks if provided, otherwise use _isOpen internal hook


  var _ref2 = providedIsOpen !== undefined && providedSetIsOpen !== undefined ? [providedIsOpen, providedSetIsOpen] : [_isOpen, _setIsOpen],
      _ref3 = slicedToArray(_ref2, 2),
      isOpen = _ref3[0],
      setIsOpen = _ref3[1];

  var shouldShowShadow = contentsHeight !== height && height < contentsHeight && height !== 0 && !isOpen;
  /**
   * Effects
   */
  // adjust content height when initially open

  useEffect(function () {
    if (isOpen) setCurrentHeight(contentsHeight);
    if (!isOpen) setCurrentHeight(height);
  }, [contentsHeight, height, isOpen]);
  /**
   * Toggle between the maximum height (height of the content)
   */

  var handleToggleHeight = function handleToggleHeight() {
    if (currentHeight === height) {
      setCurrentHeight(contentsHeight);
      setIsOpen(true);
    } else {
      setCurrentHeight(height);
      setIsOpen(false);
    }
  };

  return React.createElement(Fragment, null, React.createElement("div", {
    style: {
      position: "relative",
      overflow: "hidden",
      marginBottom: !isOpen && !noToggle ? toggleSpacing : "0em"
    }
  }, shouldShowShadow && React.createElement(ShadowOverlay, {
    color: shadowColor,
    height: shadowHeight
  }), React.createElement(MainContent, {
    height: currentHeight,
    animationSpeed: animationEnabled ? speed : 0,
    isOpen: isOpen
  }, children), React.createElement("div", {
    ref: contentContainerRef,
    style: {
      opacity: 0,
      position: "absolute",
      top: 0
    },
    "aria-hidden": "true"
  }, children)), !noToggle && React.createElement(HStack, {
    align: "center",
    width: "100%" // style={{ transition: ".1s", marginTop: isOpen ? "0em" : "-1.6em" }}

  }, React.createElement(Button, {
    color: config.colors.c3,
    icon: isOpen ? "chevronUp" : "chevronDown",
    small: true,
    onClick: handleToggleHeight
  }, isOpen ? "Hide" : "Show All")));
};

var MainContent = function MainContent(_ref4) {
  var height = _ref4.height,
      _ref4$animationSpeed = _ref4.animationSpeed,
      animationSpeed = _ref4$animationSpeed === undefined ? 500 : _ref4$animationSpeed,
      isOpen = _ref4.isOpen,
      children = _ref4.children;
  var config = useConfig();
  var toggleSpacing = config.accordion.toggleSpacing;
  return React.createElement("div", {
    style: {
      position: "relative",
      maxHeight: height + "px",
      transition: "max-height " + animationSpeed + "ms cubic-bezier(.3, 0, .2, 1)",
      paddingBottom: isOpen ? toggleSpacing : "0em"
    }
  }, children);
};

var ShadowOverlay = function ShadowOverlay(_ref5) {
  var _ref5$color = _ref5.color,
      color = _ref5$color === undefined ? "#fff" : _ref5$color,
      _ref5$height = _ref5.height,
      height = _ref5$height === undefined ? 40 : _ref5$height;
  var startingColor = transparent(color, 0);
  return React.createElement("div", {
    style: {
      zIndex: 3,
      backgroundImage: "linear-gradient(" + startingColor + " 0%, " + color + " 90%)",
      opacity: 0.4,
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%",
      height: height
    }
  });
};

var useClientRect = function useClientRect() {
  var _useState7 = useState(null),
      _useState8 = slicedToArray(_useState7, 2),
      rect = _useState8[0],
      setRect = _useState8[1];

  var ref = useCallback(function (node) {
    if (node !== null) {
      setRect(node.getBoundingClientRect());
    }
  }, []);
  return [rect, ref];
};

var _templateObject$q = taggedTemplateLiteral(["\n    display: grid;\n    width: 100%;\n    align-items: ", ";\n    ", "\n    ", ";\n    grid-gap: ", ";\n    @media (max-width: ", ") {\n      grid-template-columns: 1fr;\n    }\n    ", "\n  "], ["\n    display: grid;\n    width: 100%;\n    align-items: ", ";\n    ", "\n    ", ";\n    grid-gap: ", ";\n    @media (max-width: ", ") {\n      grid-template-columns: 1fr;\n    }\n    ", "\n  "]);

var AutoGrid = function AutoGrid(props) {
  var config = useConfig();
  var gridGap = config.layout.gridGap;
  var children = props.children,
      _props$direction = props.direction,
      direction = _props$direction === undefined ? "horizontal" : _props$direction,
      align = props.align,
      _props$vAlign = props.vAlign,
      vAlign = _props$vAlign === undefined ? "stretch" : _props$vAlign,
      _props$width = props.width,
      width = _props$width === undefined ? "6em" : _props$width,
      _props$gap = props.gap,
      gap = _props$gap === undefined ? gridGap : _props$gap,
      _props$breakAt = props.breakAt,
      breakAt = _props$breakAt === undefined ? "0px" : _props$breakAt,
      id = props.id;

  var style = _extends({}, config.Grid.style, props.style);

  var alignItems = getVAlign(vAlign);
  var justifyItems = getHAlign(align);
  var mainCSS = css(_templateObject$q, alignItems, align ? "justify-items: " + justifyItems + ";" : "", (direction === "horizontal" ? "grid-template-columns: repeat(\n      auto-fit,\n      minmax(" + width + ", 1fr)\n    )" : "") || "grid-template-rows: repeat(\n      auto-fit,\n      minmax(" + width + ", 1fr)\n    )", gap, breakAt, showHideCss(props));
  return jsx("div", {
    style: style,
    id: id,
    css: mainCSS
  }, children);
};

var _templateObject$r = taggedTemplateLiteral(["\n    z-index: 0;\n    box-sizing: border-box;\n    position: relative;\n    flex: 1 1 auto;\n    min-height: ", ";\n    ", "\n    :first-child:not(style) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n      flex: 0 1 auto;\n    }\n    :last-child:not(style) {\n      flex: 0 1 auto;\n    }\n    display: flex;\n    box-sizing: border-box;\n\n    > div {\n      width: ", ";\n      max-width: 100%;\n      margin: 0 auto;\n      box-sizing: border-box;\n      ", "\n    }\n  "], ["\n    z-index: 0;\n    box-sizing: border-box;\n    position: relative;\n    flex: 1 1 auto;\n    min-height: ", ";\n    ", "\n    :first-child:not(style) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {\n      flex: 0 1 auto;\n    }\n    :last-child:not(style) {\n      flex: 0 1 auto;\n    }\n    display: flex;\n    box-sizing: border-box;\n\n    > div {\n      width: ", ";\n      max-width: 100%;\n      margin: 0 auto;\n      box-sizing: border-box;\n      ", "\n    }\n  "]),
    _templateObject2$i = taggedTemplateLiteral(["\n          display: flex;\n          flex-direction: column;\n          align-items: ", ";\n          justify-content: ", ";\n        "], ["\n          display: flex;\n          flex-direction: column;\n          align-items: ", ";\n          justify-content: ", ";\n        "]);

var Block = function Block(props) {
  var config = useConfig();
  var children = props.children,
      _props$center = props.center,
      center = _props$center === undefined ? false : _props$center,
      providedAlign = props.align,
      providedVAlign = props.vAlign,
      _props$minHeight = props.minHeight,
      minHeight = _props$minHeight === undefined ? 0 : _props$minHeight,
      _props$width = props.width,
      width = _props$width === undefined ? "auto" : _props$width,
      id = props.id;
  var align = center ? "center" : getHAlign(providedAlign);
  var vAlign = center ? "center" : getVAlign(providedVAlign);

  var style = _extends({}, config.Block.style, props.style);

  var mainCSS = css(_templateObject$r, minHeight, center ? "margin-left: auto; margin-right: auto;" : "", width, (align || vAlign) && css(_templateObject2$i, align, vAlign));
  return jsx("div", _extends({
    style: style,
    id: id,
    css: mainCSS
  }, defaultProps(props)), jsx("div", null, children));
};

var _templateObject$s = taggedTemplateLiteral(["\n    position: fixed;\n    ", "\n    left: 0;\n    right: 0;\n    bottom: 0;\n    transform: translateZ(0px);\n    overflow: scroll;\n    -webkit-overflow-scrolling: touch;\n    flex: 1 1 100%;\n    display: flex;\n    flex-direction: column;\n    > div {\n      flex: 1 1 auto;\n      display: flex;\n      flex-direction: column;\n    }\n  "], ["\n    position: fixed;\n    ", "\n    left: 0;\n    right: 0;\n    bottom: 0;\n    transform: translateZ(0px);\n    overflow: scroll;\n    -webkit-overflow-scrolling: touch;\n    flex: 1 1 100%;\n    display: flex;\n    flex-direction: column;\n    > div {\n      flex: 1 1 auto;\n      display: flex;\n      flex-direction: column;\n    }\n  "]),
    _templateObject2$j = taggedTemplateLiteral(["\n          body {\n            height: 99vh;\n            overflow: hidden;\n          }\n        "], ["\n          body {\n            height: 99vh;\n            overflow: hidden;\n          }\n        "]);

var Body = function Body(props) {
  var config$$1 = useConfig();
  var _config$sidebar = config$$1.sidebar,
      fullScreenAt = _config$sidebar.fullScreenAt,
      floatingAt = _config$sidebar.floatingAt,
      width = _config$sidebar.width,
      handle = _config$sidebar.handle;
  var handleShown = handle.show,
      configHandleWidth = handle.width;
  var configHeaderHeight = config$$1.header.height;
  var medium = config$$1.animations.springs.medium;
  var id = props.id,
      children = props.children,
      sidebarOpen = props.sidebarOpen,
      withHeader = props.withHeader,
      _props$headerHeight = props.headerHeight,
      headerHeight = _props$headerHeight === undefined ? configHeaderHeight : _props$headerHeight,
      headerHeightBreakPoint = props.headerHeightBreakPoint,
      style = props.style;
  var handleWidth = handleShown ? configHandleWidth : 0;

  if (typeof sidebarOpen === "undefined") {
    if (process.env.NODE_ENV === "development") {
      throw new Error("You need to pass the state of the sidebar to the Body element as a \"sidebarOpen\" boolean prop.");
    }
  } // const style = { ...config.Body.style, ...props.style };


  var mainCSS = css(_templateObject$s, responsive("top", withHeader ? headerHeight : "0px", {
    breakPoint: headerHeightBreakPoint
  }));
  var sidebarState = useMedia(["(max-width: " + fullScreenAt + ")", "(max-width: " + floatingAt + ")"], ["fullscreen", "floating"], "default");
  var paddingLeft = getSidebarValue({
    openCloseValues: [[parseInt(width) + parseInt(handleWidth), parseInt(handleWidth), "default"], [0, 0, "floating"], [0, 0, "fullscreen"]],
    sidebarState: sidebarState,
    sidebarOpen: sidebarOpen
  });
  var animatedBody = useSpring({
    to: {
      paddingLeft: paddingLeft
    },
    config: _extends({}, medium)
  });
  return jsx(extendedAnimated.div, {
    id: id,
    style: _extends({}, animatedBody, style),
    css: mainCSS
  }, jsx(Global, {
    styles: css(_templateObject2$j)
  }), jsx("div", null, children));
};

var _templateObject$t = taggedTemplateLiteral(["\n    flex: 999 1 auto;\n    background: ", ";\n    padding: ", ";\n    margin: ", ";\n    border-top: ", "px solid ", ";\n    border-radius: 0 0 ", " ", ";\n    ", "\n  "], ["\n    flex: 999 1 auto;\n    background: ", ";\n    padding: ", ";\n    margin: ", ";\n    border-top: ", "px solid ", ";\n    border-radius: 0 0 ", " ", ";\n    ", "\n  "]),
    _templateObject2$k = taggedTemplateLiteral(["\n        display: flex;\n        flex-direction: column;\n        align-items: ", ";\n        justify-content: ", ";\n      "], ["\n        display: flex;\n        flex-direction: column;\n        align-items: ", ";\n        justify-content: ", ";\n      "]);

var CardFooter = function CardFooter(props) {
  var config = useConfig();
  var bg2 = config.colors.bg2;
  var _config$appearance = config.appearance,
      bigRadius = _config$appearance.bigRadius,
      smallRadius = _config$appearance.smallRadius;
  var _config$cards = config.cards,
      bigPadding = _config$cards.bigPadding,
      smallPadding = _config$cards.smallPadding,
      footerBorderWidth = _config$cards.footerBorderWidth,
      footerBorderColor = _config$cards.footerBorderColor;
  var inline = props.inline,
      children = props.children,
      _props$border = props.border,
      border = _props$border === undefined ? footerBorderColor : _props$border,
      _props$background = props.background,
      background = _props$background === undefined ? bg2 : _props$background,
      id = props.id,
      _props$center = props.center,
      center = _props$center === undefined ? false : _props$center,
      providedAlign = props.align,
      providedVAlign = props.vAlign;
  var radius = inline ? smallRadius : bigRadius;
  var padding = inline ? smallPadding : bigPadding;
  var paddings = padding.split(" ");
  var reversePadding = paddings[0] + " -" + paddings[1] + " -" + paddings[0];
  var align = center ? "center" : getHAlign(providedAlign);
  var vAlign = center ? "center" : getHAlign(providedVAlign);

  var style = _extends({}, config.CardFooter.style, props.style);

  var mainCSS = css(_templateObject$t, background, padding, reversePadding, footerBorderWidth, border, radius, radius, (align || vAlign) && css(_templateObject2$k, align, vAlign));
  return jsx("div", {
    style: style,
    id: id,
    css: mainCSS
  }, children);
};

var _templateObject$u = taggedTemplateLiteral(["\n    ", "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    width: ", ";\n    margin: 0 auto;\n    ", "\n  "], ["\n    ", "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    width: ", ";\n    margin: 0 auto;\n    ", "\n  "]);

var Center = function Center(props) {
  var children = props.children,
      _props$width = props.width,
      width = _props$width === undefined ? "100%" : _props$width,
      id = props.id,
      at = props.at,
      externalCSS = props.CSS;
  var config = useConfig();

  var style = _extends({}, config.Center.style, props.style);

  var mainCSS = css(_templateObject$u, at && "@media (max-width: " + at + ") {", width, at && "}");
  return jsx("div", _extends({
    style: style,
    id: id,
    css: [mainCSS, externalCSS]
  }, defaultProps(props)), children);
};

var _templateObject$v = taggedTemplateLiteral(["\n    position: relative;\n    background: ", ";\n\n    min-height: ", ";\n    max-width: 100%;\n\n    display: flex;\n    flex-direction: column;\n    align-items: \"stretch\";\n    box-sizing: border-box;\n\n    ", "\n  "], ["\n    position: relative;\n    background: ", ";\n\n    min-height: ", ";\n    max-width: 100%;\n\n    display: flex;\n    flex-direction: column;\n    align-items: \"stretch\";\n    box-sizing: border-box;\n\n    ", "\n  "]);

var ContainerContext = React.createContext(null);

var Container = function Container(props) {
  var config = useConfig();
  var _config$colors = config.colors,
      bg1 = _config$colors.bg1,
      bg3 = _config$colors.bg3;
  var children = props.children,
      _props$background = props.background,
      background = _props$background === undefined ? bg1 : _props$background,
      id = props.id,
      withSidebar = props.withSidebar;

  var style = _extends({}, config.Container.style, props.style);

  var _useState = useState({
    width: "100vw",
    height: "100vh"
  }),
      _useState2 = slicedToArray(_useState, 2),
      viewportSize = _useState2[0],
      setViewportSize = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = slicedToArray(_useState3, 2),
      documentScroll = _useState4[0],
      setDocumentScroll = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = slicedToArray(_useState5, 2),
      documentScrolled = _useState6[0],
      setDocumentScrolled = _useState6[1];

  function getDocumentScroll() {
    setDocumentScroll((window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0));
    setDocumentScrolled(function (documentScrolled) {
      return !documentScrolled;
    });
  }

  function getViewportSize() {
    setViewportSize({
      width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0) + "px",
      height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0) + "px"
    });
  }

  useEffect(function () {
    function handleKeyDown(event) {
      var keyDown = event.key;

      if (keyDown === "=" || keyDown === "+" || keyDown === "-" || keyDown === "0") {
        setTimeout(function () {
          return getViewportSize();
        }, 100);
      }
    }

    getViewportSize();
    window.addEventListener("resize", getViewportSize);
    window.addEventListener("keydown", handleKeyDown);
    document.addEventListener("scroll", getDocumentScroll, true);
    return function () {
      window.removeEventListener("resize", getViewportSize);
      window.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("scroll", getDocumentScroll, true);
    };
  }, []);
  var mainCSS = css(_templateObject$v, background ? typeof background === "string" ? background : bg3 : bg1, viewportSize.height, withSidebar ? "\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      width: 100%;\n      flex-direction: row;\n      overflow: hidden;\n    " : "");
  return jsx(ContainerContext.Provider, {
    value: {
      viewportSize: viewportSize,
      documentScroll: documentScroll,
      documentScrolled: documentScrolled
    }
  }, jsx("div", {
    style: style,
    id: id,
    css: mainCSS
  }, children));
};

var _templateObject$w = taggedTemplateLiteral(["\n    margin: ", " auto !important;\n    width: 100%;\n    border-bottom: 1px solid ", ";\n    max-width: ", ";\n    flex: 0 0 auto;\n    ", "\n  "], ["\n    margin: ", " auto !important;\n    width: 100%;\n    border-bottom: 1px solid ", ";\n    max-width: ", ";\n    flex: 0 0 auto;\n    ", "\n  "]);

var Divider = function Divider(props) {
  var config = useConfig();
  var color = config.divider.color;
  var children = props.children,
      externalCSS = props.CSS,
      _props$size = props.size,
      providedSize = _props$size === undefined ? "xl" : _props$size,
      _props$width = props.width,
      width = _props$width === undefined ? "medium" : _props$width,
      id = props.id;
  var size = config.sizes[providedSize];

  if (typeof size === "undefined") {
    if (process.env.NODE_ENV === "development") {
      throw new Error("Size \"" + providedSize + "\" is not valid for Spacer.");
    }
  }

  var widths = {
    small: "25%",
    medium: "50%",
    big: "75%",
    full: "100%"
  };

  var style = _extends({}, props.style);

  var mainCSS = css(_templateObject$w, size, color, widths[width], showHideCss(props));
  return jsx("div", _extends({
    style: style,
    id: id,
    css: [mainCSS, externalCSS]
  }, defaultProps(props)), children);
};

var _templateObject$x = taggedTemplateLiteral(["\n    display: none;\n    @media (max-width: ", ") {\n      display: block;\n      z-index: 4;\n      position: fixed;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background: ", ";\n      opacity: ", ";\n      pointer-events: ", ";\n      transition: 0.3s opacity ", ";\n    }\n  "], ["\n    display: none;\n    @media (max-width: ", ") {\n      display: block;\n      z-index: 4;\n      position: fixed;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background: ", ";\n      opacity: ", ";\n      pointer-events: ", ";\n      transition: 0.3s opacity ", ";\n    }\n  "]),
    _templateObject2$l = taggedTemplateLiteral(["\n      ", "\n    ", "\n    background: ", ";\n    position: fixed;\n    z-index: 1;\n    ", "\n    border-right: ", ";\n    bottom: 0px;\n    max-width: 100%;\n    /* overflow-x: hidden; */\n    overflow-y: scroll;\n    box-sizing: border-box;\n    -webkit-overflow-scrolling: touch;\n    ", "\n    ", "\n    ", "\n    ", "\n    width: ", ";\n    @media (max-width: ", ") {\n      position: fixed;\n      z-index: 5;\n    }\n    @media (max-width: ", ") {\n      width: 100%;\n    }\n  "], ["\n      ", "\n    ", "\n    background: ", ";\n    position: fixed;\n    z-index: 1;\n    ", "\n    border-right: ", ";\n    bottom: 0px;\n    max-width: 100%;\n    /* overflow-x: hidden; */\n    overflow-y: scroll;\n    box-sizing: border-box;\n    -webkit-overflow-scrolling: touch;\n    ", "\n    ", "\n    ", "\n    ", "\n    width: ", ";\n    @media (max-width: ", ") {\n      position: fixed;\n      z-index: 5;\n    }\n    @media (max-width: ", ") {\n      width: 100%;\n    }\n  "]),
    _templateObject3$d = taggedTemplateLiteral(["\n              display: flex;\n              align-items: ", ";\n              justify-content: ", ";\n            "], ["\n              display: flex;\n              align-items: ", ";\n              justify-content: ", ";\n            "]),
    _templateObject4$7 = taggedTemplateLiteral(["\n            display: flex;\n          "], ["\n            display: flex;\n          "]),
    _templateObject5$6 = taggedTemplateLiteral(["\n    position: fixed;\n    top: 0px;\n    bottom: 0px;\n    width: ", ";\n    opacity: 0.7;\n    display: flex;\n    z-index: 6;\n    pointer-events: none;\n    :hover {\n      opacity: 1;\n    }\n    > div {\n      pointer-events: auto;\n      margin: auto;\n      width: ", ";\n      height: ", ";\n      background: ", ";\n      border-radius: 1em;\n      position: relative;\n      cursor: pointer;\n      @media (max-width: ", ") and (min-width: ", ") {\n        background: ", ";\n      }\n    }\n    @media (max-width: ", ") {\n      display: none !important;\n    }\n  "], ["\n    position: fixed;\n    top: 0px;\n    bottom: 0px;\n    width: ", ";\n    opacity: 0.7;\n    display: flex;\n    z-index: 6;\n    pointer-events: none;\n    :hover {\n      opacity: 1;\n    }\n    > div {\n      pointer-events: auto;\n      margin: auto;\n      width: ", ";\n      height: ", ";\n      background: ", ";\n      border-radius: 1em;\n      position: relative;\n      cursor: pointer;\n      @media (max-width: ", ") and (min-width: ", ") {\n        background: ", ";\n      }\n    }\n    @media (max-width: ", ") {\n      display: none !important;\n    }\n  "]);

var Sidebar = function Sidebar(props) {
  var config$$1 = useConfig();
  var _config$sidebar = config$$1.sidebar,
      padding = _config$sidebar.padding,
      configWidth = _config$sidebar.width,
      floatingAtConfig = _config$sidebar.floatingAt,
      fullScreenAt = _config$sidebar.fullScreenAt,
      configBackground = _config$sidebar.background,
      backgroundOverlayColor = _config$sidebar.backgroundOverlayColor,
      configBorder = _config$sidebar.border,
      handleConfig = _config$sidebar.handle;
  var configHeaderHeight = config$$1.header.height;
  var animationCurveIn = config$$1.animations.animationCurveIn;
  var medium = config$$1.animations.springs.medium;

  var _useState = useState(false),
      _useState2 = slicedToArray(_useState, 2),
      resizingWindow = _useState2[0],
      setResizingWindow = _useState2[1];

  var _useState3 = useState({
    width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
    height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
  }),
      _useState4 = slicedToArray(_useState3, 2),
      viewportSize = _useState4[0],
      setViewportSize = _useState4[1];

  var children = props.children,
      noPadding = props.noPadding,
      open = props.open,
      setOpen = props.setOpen,
      _props$handle = props.handle,
      handle = _props$handle === undefined ? handleConfig.show : _props$handle,
      _props$hideHandleAt = props.hideHandleAt,
      hideHandleAt = _props$hideHandleAt === undefined ? handleConfig.hideAt : _props$hideHandleAt,
      _props$background = props.background,
      background = _props$background === undefined ? configBackground : _props$background,
      _props$border = props.border,
      border = _props$border === undefined ? configBorder : _props$border,
      _props$width = props.width,
      width = _props$width === undefined ? configWidth : _props$width,
      _props$floatingAt = props.floatingAt,
      floatingAt = _props$floatingAt === undefined ? floatingAtConfig : _props$floatingAt,
      _props$fullScreen = props.fullScreen,
      fullScreen = _props$fullScreen === undefined ? fullScreenAt : _props$fullScreen,
      withHeader = props.withHeader,
      _props$headerHeight = props.headerHeight,
      headerHeight = _props$headerHeight === undefined ? configHeaderHeight : _props$headerHeight,
      headerHeightBreakPoint = props.headerHeightBreakPoint,
      center = props.center,
      full = props.full,
      align = props.align,
      vAlign = props.vAlign;
  var alignItems = center ? "center" : getHAlign(align);
  var justifyContent = center ? "center" : getHAlign(vAlign);
  useEffect(function () {
    function getViewportSize() {
      setResizingWindow(true);
      setViewportSize({
        width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
        height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
      });
      setResizingWindow(false);
    }

    window.addEventListener("resize", getViewportSize);
    return function () {
      window.removeEventListener("resize", getViewportSize);
    };
  }, []);
  var backgroundCSS = css(_templateObject$x, floatingAt, backgroundOverlayColor, open ? 1 : 0, open ? "auto" : "none", animationCurveIn);

  var rightPadding = function () {
    if (!handle) {
      return responsive("padding-right", padding.lateral);
    } else {
      return responsive("padding-right", padding.lateral, false);
    }
  }();

  var mainCSS = css(_templateObject2$l, (align || vAlign || center) && !full ? css(_templateObject3$d, alignItems, justifyContent) : "", full ? css(_templateObject4$7) : "", background, responsive("top", withHeader ? headerHeight : "0px", {
    breakPoint: headerHeightBreakPoint
  }), border, !noPadding ? responsive("padding-top", padding.vertical) : "", !noPadding ? responsive("padding-bottom", padding.vertical) : "", responsive("padding-left", padding.lateral), rightPadding, width, floatingAt, fullScreen);
  var handleCSS = css(_templateObject5$6, parseInt(handleConfig.width) + 1 + "px", handleConfig.innerWidth, handleConfig.height, handleConfig.color, floatingAt, fullScreen, open ? handleConfig.colorFixed : handleConfig.color, hideHandleAt);
  var sidebarState = useMedia(["(max-width: " + fullScreenAt + ")", "(max-width: " + floatingAt + ")"], ["fullscreen", "floating"], "default");
  /**
   * SIDEBAR LEFT
   */

  var sidebarLeftNoHandle = getSidebarValue({
    openCloseValues: [[0, -parseInt(width), "default"], [0, -viewportSize.width, "fullscreen"]],
    sidebarState: sidebarState,
    sidebarOpen: open
  });
  var sidebarLeftHandle = getSidebarValue({
    openCloseValues: [[0, -parseInt(width), "default"], [0, -viewportSize.width, "fullscreen"]],
    sidebarState: sidebarState,
    sidebarOpen: open
  });
  var sidebarLeft = handleConfig ? sidebarLeftHandle : sidebarLeftNoHandle;
  /**
   * HANDLE LEFT
   */

  var handleLeft = getSidebarValue({
    openCloseValues: [[parseInt(width), 0, "default"], [viewportSize.width - parseInt(handleConfig.width), 0, "fullscreen"]],
    sidebarState: sidebarState,
    sidebarOpen: open
  });
  /** SIDEBAR SHADOW */

  var boxShadow = "0px 0px 80px rgba(0, 0, 0, 0.2)";
  var sidebarShadow = open ? boxShadow : "none";
  /** ANIMATE ELEMENTS */

  var animatedMainDiv = useSpring({
    boxShadow: sidebarShadow,
    to: {
      left: sidebarLeft || 0
    },
    immediate: resizingWindow,
    config: _extends({}, medium)
  });
  var animatedHandle = useSpring({
    to: {
      left: handleLeft || 0
    },
    immediate: resizingWindow,
    config: _extends({}, medium)
  });
  return jsx(Fragment, null, jsx(extendedAnimated.div, {
    className: "sidebar",
    css: mainCSS,
    style: animatedMainDiv
  }, children), handleConfig.show && jsx(extendedAnimated.div, {
    css: handleCSS,
    style: animatedHandle
  }, jsx("div", {
    onClick: function onClick() {
      return setOpen(!open);
    }
  })), jsx("div", {
    css: backgroundCSS,
    onClick: function onClick() {
      return setOpen(false);
    }
  }));
};

var _templateObject$y = taggedTemplateLiteral(["\n    position: ", ";\n    width: 100%;\n    top: 0;\n    border-top: 1px solid transparent;\n    border-right: 1px solid transparent;\n    z-index: 2;\n    box-sizing: border-box;\n    ", "\n  "], ["\n    position: ", ";\n    width: 100%;\n    top: 0;\n    border-top: 1px solid transparent;\n    border-right: 1px solid transparent;\n    z-index: 2;\n    box-sizing: border-box;\n    ", "\n  "]),
    _templateObject2$m = taggedTemplateLiteral(["\n    background: ", ";\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    border-bottom: ", ";\n    box-sizing: border-box;\n    position: relative;\n    top: -1px;\n    ", "\n    /* ", " */\n  "], ["\n    background: ", ";\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    border-bottom: ", ";\n    box-sizing: border-box;\n    position: relative;\n    top: -1px;\n    ", "\n    /* ", " */\n  "]),
    _templateObject3$e = taggedTemplateLiteral(["\n        display: flex;\n        flex-direction: column;\n        align-items: ", ";\n        justify-content: ", ";\n      "], ["\n        display: flex;\n        flex-direction: column;\n        align-items: ", ";\n        justify-content: ", ";\n      "]),
    _templateObject4$8 = taggedTemplateLiteral(["\n        box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.05);\n      "], ["\n        box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.05);\n      "]);

var SidebarHeader = function SidebarHeader(props) {
  var config = useConfig();
  var _config$sidebar = config.sidebar,
      padding = _config$sidebar.padding,
      configBackground = _config$sidebar.headerFooterBackground,
      innerBorders = _config$sidebar.innerBorders,
      headerSticky = _config$sidebar.headerSticky;
  var children = props.children,
      _props$background = props.background,
      background = _props$background === undefined ? configBackground : _props$background,
      noPadding = props.noPadding,
      _props$center = props.center,
      center = _props$center === undefined ? false : _props$center,
      providedAlign = props.align,
      providedVAlign = props.vAlign,
      _props$headerBorder = props.headerBorder,
      headerBorder = _props$headerBorder === undefined ? innerBorders : _props$headerBorder,
      _props$sticky = props.sticky,
      sticky = _props$sticky === undefined ? headerSticky : _props$sticky;
  var align = center ? "center" : getHAlign(providedAlign);
  var vAlign = center ? "center" : getHAlign(providedVAlign);

  var style = _extends({}, config.SidebarHeader.style, props.style);

  var wrapperCSS = css(_templateObject$y, sticky ? "sticky" : "relative", !noPadding ? responsive("margin-bottom", padding.vertical) : "");
  var mainCSS = css(_templateObject2$m, background, responsive("padding-top", padding.header), responsive("padding-bottom", padding.header), responsive("padding-left", padding.lateral), responsive("padding-right", padding.lateral), responsive("margin-left", padding.lateral, {
    negative: true
  }), responsive("margin-right", padding.lateral, {
    negative: true,
    operation: " - 1px"
  }), responsive("margin-top", padding.vertical, {
    negative: true
  }), headerBorder, (align || vAlign) && css(_templateObject3$e, align, vAlign), sticky && css(_templateObject4$8));
  return jsx("div", {
    style: style,
    css: wrapperCSS
  }, jsx("div", {
    css: mainCSS
  }, children));
};

var _templateObject$z = taggedTemplateLiteral(["\n    width: 100%;\n    height: ", ";\n    ", "\n    ", "\n    ", "\n  "], ["\n    width: 100%;\n    height: ", ";\n    ", "\n    ", "\n    ", "\n  "]),
    _templateObject2$n = taggedTemplateLiteral(["\n    position: ", ";\n    width: ", ";\n    max-width: 100%;\n    /* left: 0; */\n    bottom: 0;\n    border-right: 1px solid transparent;\n    z-index: 4;\n    box-sizing: border-box;\n    @media (max-width: ", ") {\n      width: 100%;\n    }\n  "], ["\n    position: ", ";\n    width: ", ";\n    max-width: 100%;\n    /* left: 0; */\n    bottom: 0;\n    border-right: 1px solid transparent;\n    z-index: 4;\n    box-sizing: border-box;\n    @media (max-width: ", ") {\n      width: 100%;\n    }\n  "]),
    _templateObject3$f = taggedTemplateLiteral(["\n    background: ", ";\n    ", "\n    ", "\n    ", "\n    ", "\n    border-top: ", ";\n    box-sizing: border-box;\n    position: relative;\n    top: 1px;\n    ", "\n    ", "\n    /* ", " */\n  "], ["\n    background: ", ";\n    ", "\n    ", "\n    ", "\n    ", "\n    border-top: ", ";\n    box-sizing: border-box;\n    position: relative;\n    top: 1px;\n    ", "\n    ", "\n    /* ", " */\n  "]),
    _templateObject4$9 = taggedTemplateLiteral(["\n        display: flex;\n        flex-direction: column;\n        align-items: ", ";\n        justify-content: ", ";\n      "], ["\n        display: flex;\n        flex-direction: column;\n        align-items: ", ";\n        justify-content: ", ";\n      "]),
    _templateObject5$7 = taggedTemplateLiteral(["\n        box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.05);\n      "], ["\n        box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.05);\n      "]);

var SidebarFooter = function SidebarFooter(props) {
  var config = useConfig();
  var _config$sidebar = config.sidebar,
      padding = _config$sidebar.padding,
      footerPlaceholderHeight = _config$sidebar.footerPlaceholderHeight,
      configBackground = _config$sidebar.headerFooterBackground,
      innerBorders = _config$sidebar.innerBorders,
      footerSticky = _config$sidebar.footerSticky,
      fullScreenAt = _config$sidebar.fullScreenAt,
      sidebarWidth = _config$sidebar.width;
  var children = props.children,
      _props$placeholderHei = props.placeholderHeight,
      placeholderHeight = _props$placeholderHei === undefined ? footerPlaceholderHeight : _props$placeholderHei,
      _props$background = props.background,
      background = _props$background === undefined ? configBackground : _props$background,
      _props$center = props.center,
      center = _props$center === undefined ? false : _props$center,
      providedAlign = props.align,
      providedVAlign = props.vAlign,
      _props$headerBorder = props.headerBorder,
      headerBorder = _props$headerBorder === undefined ? innerBorders : _props$headerBorder,
      _props$sticky = props.sticky,
      sticky = _props$sticky === undefined ? footerSticky : _props$sticky,
      _props$fullScreen = props.fullScreen,
      fullScreen = _props$fullScreen === undefined ? fullScreenAt : _props$fullScreen,
      externalCSS = props.CSS;
  var align = center ? "center" : getHAlign(providedAlign);
  var vAlign = center ? "center" : getHAlign(providedVAlign);

  var style = _extends({}, config.SidebarFooter.style, props.style);

  var placeholderCSS = css(_templateObject$z, placeholderHeight, responsive("margin-top", padding.vertical), responsive("padding-top", padding.header), responsive("padding-bottom", padding.header));
  var wrapperCSS = css(_templateObject2$n, sticky ? "fixed" : "relative", sidebarWidth, fullScreen);
  var innerCSS = css(_templateObject3$f, background, responsive("padding-top", padding.header), responsive("padding-bottom", padding.header), responsive("padding-left", padding.lateral), responsive("padding-right", padding.lateral), headerBorder, responsive("left", padding.lateral, {
    negative: true
  }), (align || vAlign) && css(_templateObject4$9, align, vAlign), sticky && css(_templateObject5$7));
  return jsx(Fragment, null, jsx("div", {
    css: placeholderCSS
  }), jsx("div", {
    css: wrapperCSS
  }, jsx("div", {
    style: style,
    css: [innerCSS, externalCSS]
  }, children)));
};

var _templateObject$A = taggedTemplateLiteral(["\n    width: 100%;\n    top: 0;\n    border-right: 1px solid transparent;\n    margin-bottom: -1px;\n    box-sizing: border-box;\n  "], ["\n    width: 100%;\n    top: 0;\n    border-right: 1px solid transparent;\n    margin-bottom: -1px;\n    box-sizing: border-box;\n  "]),
    _templateObject2$o = taggedTemplateLiteral(["\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    border-top: ", ";\n    border-bottom: ", ";\n    box-sizing: border-box;\n    position: relative;\n    top: -1px;\n    ", "\n  "], ["\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    border-top: ", ";\n    border-bottom: ", ";\n    box-sizing: border-box;\n    position: relative;\n    top: -1px;\n    ", "\n  "]),
    _templateObject3$g = taggedTemplateLiteral(["\n        display: flex;\n        flex-direction: column;\n        align-items: ", ";\n        justify-content: ", ";\n      "], ["\n        display: flex;\n        flex-direction: column;\n        align-items: ", ";\n        justify-content: ", ";\n      "]);

var SidebarSection = function SidebarSection(props) {
  var config = useConfig();
  var _config$sidebar = config.sidebar,
      padding = _config$sidebar.padding,
      innerBorders = _config$sidebar.innerBorders;
  var children = props.children,
      _props$center = props.center,
      center = _props$center === undefined ? false : _props$center,
      providedAlign = props.align,
      providedVAlign = props.vAlign,
      _props$headerBorder = props.headerBorder,
      headerBorder = _props$headerBorder === undefined ? innerBorders : _props$headerBorder,
      onClick = props.onClick,
      style = props.style,
      externalCSS = props.CSS;
  var align = center ? "center" : getHAlign(providedAlign);
  var vAlign = center ? "center" : getHAlign(providedVAlign);
  var wrapperCSS = css(_templateObject$A);
  var mainCSS = css(_templateObject2$o, responsive("padding-top", padding.vertical), responsive("padding-bottom", padding.vertical), responsive("padding-left", padding.lateral), responsive("padding-right", padding.lateral), responsive("margin-left", padding.lateral, {
    negative: true
  }), responsive("margin-right", padding.lateral, {
    negative: true,
    operation: " - 1px"
  }), headerBorder, headerBorder, (align || vAlign) && css(_templateObject3$g, align, vAlign));
  return jsx("div", {
    style: props.style,
    css: wrapperCSS,
    onClick: onClick
  }, jsx("div", {
    css: [mainCSS, externalCSS],
    style: style
  }, children));
};

var _templateObject$B = taggedTemplateLiteral(["\n    cursor: pointer;\n    :hover {\n      background: ", ";\n    }\n  "], ["\n    cursor: pointer;\n    :hover {\n      background: ", ";\n    }\n  "]),
    _templateObject2$p = taggedTemplateLiteral(["\n    ", "\n  "], ["\n    ", "\n  "]);

var SidebarSectionNav = function SidebarSectionNav(props) {
  var config = useConfig();
  var _config$sidebar = config.sidebar,
      padding = _config$sidebar.padding,
      section = _config$sidebar.section;
  var chevron = section.chevron;
  var children = props.children,
      onClick = props.onClick;
  var sectionCSS = css(_templateObject$B, section.hoverColor);
  var gridCSS = css(_templateObject2$p, responsive("margin-right", padding.lateral, {
    negative: true,
    operation: " - 1px"
  }));
  return jsx(SidebarSection, _extends({}, props, {
    onClick: onClick,
    CSS: sectionCSS
  }), jsx(Grid, {
    columns: "1fr " + chevron.width,
    CSS: gridCSS
  }, jsx("div", null, children), jsx(Center, null, jsx(Icon, {
    size: chevron.size,
    strokeWidth: chevron.strokeWidth,
    color: chevron.color,
    name: chevron.icon
  }))));
};

var _templateObject$C = taggedTemplateLiteral(["\n    color: ", ";\n    background: ", ";\n    box-sizing: border-box;\n    padding: ", ";\n    border-radius: ", ";\n    min-height: ", ";\n    max-width: ", ";\n    ", ";\n  "], ["\n    color: ", ";\n    background: ", ";\n    box-sizing: border-box;\n    padding: ", ";\n    border-radius: ", ";\n    min-height: ", ";\n    max-width: ", ";\n    ", ";\n  "]);

var SubtleCard = function SubtleCard(props) {
  var config = useConfig();
  var accent1 = config.colors.accent1;
  var subtleBackground = config.cards.subtleBackground;
  var smallRadius = config.appearance.smallRadius;
  var smallPadding = config.cards.smallPadding;
  var color = props.color,
      children = props.children,
      _props$padding = props.padding,
      padding = _props$padding === undefined ? smallPadding : _props$padding,
      _props$maxWidth = props.maxWidth,
      maxWidth = _props$maxWidth === undefined ? "unset" : _props$maxWidth,
      _props$center = props.center,
      center = _props$center === undefined ? false : _props$center,
      _props$minHeight = props.minHeight,
      minHeight = _props$minHeight === undefined ? "0" : _props$minHeight,
      id = props.id;
  var bgColor = tinycolor(color || subtleBackground).setAlpha(0.09).toString();

  var style = _extends({}, config.SubtleCard.style, props.style);

  var mainCSS = css(_templateObject$C, accent1, bgColor, padding, smallRadius, minHeight, maxWidth, center ? "\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    " : "");
  return jsx("div", _extends({
    style: style,
    id: id,
    css: mainCSS
  }, defaultProps(props)), children);
};

var _templateObject$D = taggedTemplateLiteral(["\n        height: env(safe-area-inset-bottom);\n      "], ["\n        height: env(safe-area-inset-bottom);\n      "]);

var SafeAreaInsetBottom = function SafeAreaInsetBottom(props) {
  return jsx("div", {
    css: css(_templateObject$D)
  });
};

var CustomSelect = function CustomSelect(props) {
  var config = useConfig();
  var buttonColor = config.dropdown.buttonColor;
  var options = props.options,
      optionsNames = props.optionsNames,
      optionsIcons = props.optionsIcons,
      selectedOption = props.selectedOption,
      onSelect = props.onSelect;

  var _useState = useState(null),
      _useState2 = slicedToArray(_useState, 2),
      selectedOptionIndex = _useState2[0],
      setSelectedOptionIndex = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = slicedToArray(_useState3, 2),
      show = _useState4[0],
      setShow = _useState4[1];

  React.useEffect(function () {
    var index = options.indexOf(selectedOption);
    setSelectedOptionIndex(index);
  }, [show, options, selectedOption, setSelectedOptionIndex]);
  return React.createElement("div", {
    style: {
      position: "relative",
      width: "16em"
    }
  }, React.createElement(Button, {
    icon: optionsIcons[selectedOptionIndex],
    color: buttonColor,
    onClick: function onClick() {
      return setShow(!show);
    }
  }, optionsNames ? optionsNames[selectedOptionIndex] : selectedOption), React.createElement(DropDown, {
    fullWidth: true,
    show: show,
    scrollable: false,
    options: options,
    optionsNames: optionsNames,
    optionsIcons: optionsIcons,
    selectedOption: selectedOptionIndex,
    setSelectedOption: function setSelectedOption(index) {
      setSelectedOptionIndex(index);
      onSelect(options[index]);
      setShow(false);
    }
  }));
};

var DropDownMenu = function DropDownMenu(props) {
  var config = useConfig();
  var _config$dropdown = config.dropdown,
      buttonColor = _config$dropdown.buttonColor,
      textColor = _config$dropdown.textColor;
  var children = props.children,
      width = props.width,
      fullWidth = props.fullWidth,
      header = props.header,
      label = props.label,
      _props$scrollable = props.scrollable,
      scrollable = _props$scrollable === undefined ? false : _props$scrollable,
      icon = props.icon,
      innerIcon = props.innerIcon,
      iconColor = props.iconColor,
      iconSide = props.iconSide,
      options = props.options,
      optionsDetails = props.optionsDetails,
      optionsNames = props.optionsNames,
      optionsIcons = props.optionsIcons,
      selectedOption = props.selectedOption,
      onSelect = props.onSelect,
      rowSize = props.rowSize,
      rowIconSize = props.rowIconSize,
      anchor = props.anchor,
      offset = props.offset,
      buttonWidth = props.buttonWidth,
      style = props.style;

  var _useState = useState(null),
      _useState2 = slicedToArray(_useState, 2),
      selectedOptionIndex = _useState2[0],
      setSelectedOptionIndex = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = slicedToArray(_useState3, 2),
      show = _useState4[0],
      setShow = _useState4[1];

  useEffect(function () {
    var index = options.indexOf(selectedOption);
    setSelectedOptionIndex(index);
  }, [show, options, selectedOption, setSelectedOptionIndex]);
  return React.createElement(DropDown, {
    header: header,
    width: width,
    fullWidth: fullWidth,
    show: show,
    anchor: anchor,
    offset: offset,
    onClickOutside: function onClickOutside() {
      return setShow(false);
    },
    scrollable: scrollable,
    options: options,
    optionsDetails: optionsDetails,
    optionsNames: optionsNames,
    optionsIcons: optionsIcons,
    selectedOption: selectedOptionIndex,
    setSelectedOption: function setSelectedOption(index) {
      setSelectedOptionIndex(index);
      onSelect(options[index], index);
      setShow(false);
    },
    rowSize: rowSize,
    rowIconSize: rowIconSize
  }, children && React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    onClick: function onClick() {
      return setShow(!show);
    }
  }, children), label && React.createElement(Button, {
    style: style,
    width: buttonWidth,
    icon: innerIcon,
    iconSide: iconSide,
    color: buttonColor,
    onClick: function onClick() {
      return setShow(!show);
    }
  }, label), icon && React.createElement(Icon, {
    name: icon,
    color: iconColor ? iconColor : textColor,
    onClick: function onClick() {
      return setShow(!show);
    }
  }));
};

var _templateObject$E = taggedTemplateLiteral(["\n    position: relative;\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", "px;\n    background: ", ";\n    border: 1px solid ", ";\n    display: flex;\n    box-shadow: ", " ", ";\n    ", "\n    input {\n      position: absolute;\n      opacity: 0;\n      cursor: pointer;\n      height: 0;\n      width: 0;\n    }\n  "], ["\n    position: relative;\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", "px;\n    background: ", ";\n    border: 1px solid ", ";\n    display: flex;\n    box-shadow: ", " ", ";\n    ", "\n    input {\n      position: absolute;\n      opacity: 0;\n      cursor: pointer;\n      height: 0;\n      width: 0;\n    }\n  "]),
    _templateObject2$q = taggedTemplateLiteral(["\n          span {\n            margin: auto;\n            width: ", "px;\n            height: ", "px;\n            border-radius: ", "px;\n            background: ", ";\n          }\n        "], ["\n          span {\n            margin: auto;\n            width: ", "px;\n            height: ", "px;\n            border-radius: ", "px;\n            background: ", ";\n          }\n        "]);

var Radio = function Radio(props) {
  var checked = props.checked,
      name = props.name,
      value = props.value;
  var config = useConfig();
  var _config$radio = config.radio,
      borderColor = _config$radio.borderColor,
      colorNormal = _config$radio.colorNormal,
      colorChecked = _config$radio.colorChecked,
      shadowSize = _config$radio.shadowSize,
      shadowAlpha = _config$radio.shadowAlpha,
      colorDot = _config$radio.colorDot,
      size = _config$radio.size,
      dotSize = _config$radio.dotSize;
  var shadowColor = checked ? tinycolor(colorChecked).setAlpha(shadowAlpha).toString() : tinycolor(borderColor).setAlpha(shadowAlpha).toString();
  var radioWrapper = css(_templateObject$E, size, size, size, checked ? colorChecked : colorNormal, checked ? colorChecked : borderColor, shadowSize, shadowColor, checked ? css(_templateObject2$q, dotSize, dotSize, dotSize, colorDot) : "");
  return jsx("div", {
    css: radioWrapper
  }, jsx("input", {
    type: "radio",
    value: value,
    name: name,
    checked: checked,
    onChange: function onChange() {}
  }), jsx("span", null));
};
/** @jsx jsx */


var RadioGroup = function RadioGroup(props) {
  var config = useConfig();
  var gap = config.radio.gap;
  var _props$groupName = props.groupName,
      groupName = _props$groupName === undefined ? "radioGroup" : _props$groupName,
      options = props.options,
      optionsNames = props.optionsNames,
      selectedOption = props.selectedOption,
      onSelect = props.onSelect,
      fontSize = props.fontSize,
      style = props.style;
  return jsx(VStack, {
    gap: gap,
    style: style
  }, options.map(function (option, index) {
    var selected = option === selectedOption;
    return jsx(HStack, {
      key: index,
      onClick: function onClick() {
        return onSelect(option);
      },
      style: {
        cursor: "pointer"
      }
    }, jsx(Radio, {
      checked: selected,
      value: option,
      name: groupName
    }), jsx(P1, {
      style: fontSize ? {
        fontSize: fontSize
      } : {}
    }, optionsNames ? optionsNames[index] : option));
  }));
};

var _templateObject$F = taggedTemplateLiteral(["\n    position: relative;\n    width: ", "px;\n    height: ", "px;\n    cursor: pointer;\n    z-index: 1;\n    box-sizing: border-box;\n    svg {\n      position: absolute;\n      top: ", "%;\n      left: ", "%;\n      width: ", "%;\n      height: ", "%;\n      transition: 0.1s;\n    }\n  "], ["\n    position: relative;\n    width: ", "px;\n    height: ", "px;\n    cursor: pointer;\n    z-index: 1;\n    box-sizing: border-box;\n    svg {\n      position: absolute;\n      top: ", "%;\n      left: ", "%;\n      width: ", "%;\n      height: ", "%;\n      transition: 0.1s;\n    }\n  "]),
    _templateObject2$r = taggedTemplateLiteral(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", ";\n    background: ", ";\n    border: ", " ", ";\n    box-sizing: border-box;\n    box-shadow: ", " ", ";\n    ", "\n  "], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", ";\n    background: ", ";\n    border: ", " ", ";\n    box-sizing: border-box;\n    box-shadow: ", " ", ";\n    ", "\n  "]),
    _templateObject3$h = taggedTemplateLiteral(["\n        background: ", ";\n        border-color: ", ";\n      "], ["\n        background: ", ";\n        border-color: ", ";\n      "]);

var Checkbox = function Checkbox(props) {
  var config = useConfig();
  var id = props.id,
      _props$checked = props.checked,
      checked = _props$checked === undefined ? false : _props$checked,
      onClick = props.onClick,
      style = props.style;
  var _config$checkbox = config.checkbox,
      size = _config$checkbox.size,
      colorNormal = _config$checkbox.colorNormal,
      activeColor = _config$checkbox.activeColor,
      borderColor = _config$checkbox.borderColor,
      borderSize = _config$checkbox.borderSize,
      shadowSize = _config$checkbox.shadowSize,
      shadowAlpha = _config$checkbox.shadowAlpha,
      radius = _config$checkbox.radius,
      configGlyphSize = _config$checkbox.glyphSize,
      strokeWidth = _config$checkbox.strokeWidth;
  var glyphSize = checked ? parseInt(configGlyphSize) : parseInt(configGlyphSize) - 20;
  var shadowColor = checked ? tinycolor(activeColor).setAlpha(shadowAlpha).toString() : tinycolor(borderColor).setAlpha(shadowAlpha).toString();
  var wrapperCSS = css(_templateObject$F, size, size, parseInt(100 - glyphSize) / 2, parseInt(100 - glyphSize) / 2, glyphSize, glyphSize);
  var styledInputCSS = css(_templateObject2$r, size, size, radius, colorNormal, borderSize, borderColor, shadowSize, shadowColor, checked && css(_templateObject3$h, activeColor, activeColor));
  return jsx("div", {
    css: wrapperCSS,
    onClick: onClick,
    style: style
  }, jsx("input", {
    type: "checkbox",
    id: id,
    css: htmlInputResets,
    checked: checked,
    onChange: function onChange() {} // We control with an external hook, but without the onChange

  }), checked && jsx(Icon, {
    strokeWidth: strokeWidth,
    name: "checkmark",
    color: "white",
    style: {
      zIndex: 1
    }
  }), jsx("div", {
    css: styledInputCSS
  }));
};
/** @jsx jsx */


var CheckboxGroup = function CheckboxGroup(props) {
  var config = useConfig();
  var gap = config.checkbox.gap;
  var options = props.options,
      optionsNames = props.optionsNames,
      selectedOptions = props.selectedOptions,
      onSelect = props.onSelect,
      fontSize = props.fontSize,
      style = props.style;
  return jsx(VStack, {
    gap: gap,
    style: style
  }, options.map(function (option, index) {
    var selected = selectedOptions.find(function (o) {
      return o === option;
    });
    return jsx(HStack, {
      key: index,
      onClick: function onClick() {
        if (selected) onSelect(selectedOptions.filter(function (e) {
          return e !== option;
        }));
        if (!selected) onSelect([].concat(toConsumableArray(selectedOptions), [option]));
      },
      style: {
        cursor: "pointer"
      }
    }, jsx(Checkbox, {
      checked: selected
    }), jsx(P1, {
      style: fontSize ? {
        fontSize: fontSize
      } : {}
    }, optionsNames ? optionsNames[index] : option));
  }));
};

var _templateObject$G = taggedTemplateLiteral(["\n    ", ";\n    max-width: 100%;\n  "], ["\n    ", ";\n    max-width: 100%;\n  "]),
    _templateObject2$s = taggedTemplateLiteral(["\n    ", "\n    ", ";\n  "], ["\n    ", "\n    ", ";\n  "]),
    _templateObject3$i = taggedTemplateLiteral(["\n    ", "\n    appearance: none;\n    ::placeholder {\n      color: ", ";\n    }\n  "], ["\n    ", "\n    appearance: none;\n    ::placeholder {\n      color: ", ";\n    }\n  "]),
    _templateObject4$a = taggedTemplateLiteral(["\n    ", "\n  "], ["\n    ", "\n  "]);

var Select = function Select(props) {
  var _useState = useState(false),
      _useState2 = slicedToArray(_useState, 2),
      focus = _useState2[0],
      setFocus = _useState2[1];

  var config = useConfig();
  var _config$inputs = config.inputs,
      widthConfig = _config$inputs.width,
      color = _config$inputs.color,
      colorFocus = _config$inputs.colorFocus,
      colorError = _config$inputs.colorError,
      placeholderColor = _config$inputs.placeholderColor,
      borderWidth = _config$inputs.borderWidth,
      iconColorConfig = _config$inputs.iconColor,
      iconStrokeWidth = _config$inputs.iconStrokeWidth,
      labelColor = _config$inputs.labelColor;
  var fontSize = config.fonts.sizes.Input;
  var _props$icon = props.icon,
      icon = _props$icon === undefined ? "select" : _props$icon,
      _props$width = props.width,
      width = _props$width === undefined ? widthConfig : _props$width,
      options = props.options,
      optionNames = props.optionNames,
      selectedOption = props.selectedOption,
      onSelect = props.onSelect,
      _onChange = props.onChange,
      providedStyle = props.style,
      _props$error = props.error,
      error = _props$error === undefined ? false : _props$error,
      required = props.required,
      placeholder = props.placeholder,
      label = props.label;

  var inputColor = function () {
    if (error) return colorError;
    if (focus) return colorFocus;
    return color;
  }();

  var inputStyle = "box-shadow: inset 0 0 0 " + borderWidth + " " + inputColor + ";";

  var iconColor = function () {
    if (error) return colorError;
    if (focus) return colorFocus;
    return iconColorConfig;
  }();

  var nativeInputProps = cleanedProps(props, ["options", "optionsNames", "placeholder", "style", "selectedOption", "optionNames", "onSelect"]);
  var outerWrapperCSS = css(_templateObject$G, width ? "width: " + width + ";" : "");
  var inputWrapperCSS = css(_templateObject2$s, inputWrapperGeneralStyle(config), inputStyle);
  var selectCSS = css(_templateObject3$i, inputComponentGeneralStyle(config), placeholderColor);
  var iconWrapperCSS = css(_templateObject4$a, iconWrapperStyle(config));
  var NO_VALUE = "";
  return jsx("div", {
    css: outerWrapperCSS
  }, label && jsx(P1, {
    style: {
      fontSize: fontSize,
      margin: "0 0 .2em"
    },
    color: labelColor
  }, label, required ? jsx("span", {
    style: {
      color: "red"
    }
  }, " *") : ""), jsx("div", {
    css: inputWrapperCSS
  }, jsx("select", _extends({
    value: placeholder && !selectedOption ? NO_VALUE : selectedOption,
    onFocus: function onFocus() {
      return setFocus(true);
    },
    onBlur: function onBlur() {
      return setTimeout(function () {
        return setFocus(false);
      }, 200);
    },
    onChange: function onChange(e) {
      if (onSelect) {
        if (e.target.value === NO_VALUE) {
          onSelect(null);
        } else {
          onSelect(e.target.value);
        }
      }

      _onChange && _onChange(e);
    },
    css: selectCSS,
    style: providedStyle
  }, nativeInputProps), placeholder && jsx("option", {
    disabled: true,
    value: NO_VALUE
  }, placeholder), options.map(function (option, index) {
    return jsx("option", {
      key: index,
      value: option
    }, optionNames ? optionNames[index] : option);
  })), icon && jsx("div", {
    css: iconWrapperCSS
  }, jsx(Icon, {
    name: icon,
    size: "1em",
    color: iconColor,
    strokeWidth: iconStrokeWidth
  })), error && typeof error === "string" && jsx(SmallText, {
    css: messageCSS(),
    color: colorError
  }, error)));
};

var _templateObject$H = taggedTemplateLiteral(["\n    0% {\n      box-shadow: 0px 0px 0px 3px ", ";\n      ;\n    }\n    100% {\n      box-shadow: 0px 0px 0px 8px ", ";\n      ;\n    }\n  "], ["\n    0% {\n      box-shadow: 0px 0px 0px 3px ", ";\n      ;\n    }\n    100% {\n      box-shadow: 0px 0px 0px 8px ", ";\n      ;\n    }\n  "]),
    _templateObject2$t = taggedTemplateLiteral(["\n    width: ", ";\n    height: ", ";\n    display: flex;\n    padding: 0;\n    align-items: center;\n    justify-content: center;\n    z-index: 8;\n    border: none;\n    border-radius: 50%;\n    background: ", ";\n    outline: none;\n    box-shadow: ", ";\n    cursor: pointer;\n    transition: ", ";\n    :hover {\n      background: ", ";\n    }\n    :active {\n      background: ", ";\n    }\n    svg {\n      margin: 0;\n      opacity: ", ";\n    }\n    ", "\n    ", "\n    :disabled {\n      opacity: 0.5;\n      :hover {\n        transform: none !important;\n      }\n      cursor: not-allowed;\n    }\n    ", "\n    ", "\n  "], ["\n    width: ", ";\n    height: ", ";\n    display: flex;\n    padding: 0;\n    align-items: center;\n    justify-content: center;\n    z-index: 8;\n    border: none;\n    border-radius: 50%;\n    background: ", ";\n    outline: none;\n    box-shadow: ", ";\n    cursor: pointer;\n    transition: ", ";\n    :hover {\n      background: ", ";\n    }\n    :active {\n      background: ", ";\n    }\n    svg {\n      margin: 0;\n      opacity: ", ";\n    }\n    ", "\n    ", "\n    :disabled {\n      opacity: 0.5;\n      :hover {\n        transform: none !important;\n      }\n      cursor: not-allowed;\n    }\n    ", "\n    ", "\n  "]),
    _templateObject3$j = taggedTemplateLiteral(["\n          animation: ", " 0.8s ease-in-out infinite alternate;\n        "], ["\n          animation: ", " 0.8s ease-in-out infinite alternate;\n        "]);

var CircleButton = function CircleButton(props) {
  var config = useConfig();
  var _config$buttons = config.buttons,
      hoverLighten = _config$buttons.hoverLighten,
      activeLighten = _config$buttons.activeLighten,
      transition = _config$buttons.transition;
  var _config$circleButton = config.circleButton,
      configColor = _config$circleButton.color,
      colorInverted = _config$circleButton.colorInverted,
      configSize = _config$circleButton.size,
      configIconSize = _config$circleButton.iconSize,
      configBackground = _config$circleButton.background,
      shadowSize = _config$circleButton.shadowSize;
  var whiteButtonsEffectConfig = config.buttons.whiteButtonsEffect;
  var onClick = props.onClick,
      _props$icon = props.icon,
      icon = _props$icon === undefined ? "writeSquare" : _props$icon,
      _props$loading = props.loading,
      loading = _props$loading === undefined ? false : _props$loading,
      _props$size = props.size,
      size = _props$size === undefined ? configSize : _props$size,
      _props$iconSize = props.iconSize,
      iconSize = _props$iconSize === undefined ? configIconSize : _props$iconSize,
      strokeWidth = props.strokeWidth,
      shadow = props.shadow,
      _props$color = props.color,
      providedColor = _props$color === undefined ? configColor : _props$color,
      _props$background = props.background,
      background = _props$background === undefined ? configBackground : _props$background,
      className = props.className,
      submit = props.submit,
      glow = props.glow,
      disabled = props.disabled,
      CSS = props.CSS;
  var color = getColorBasedOnLuminance(background, providedColor, colorInverted, "primary");
  var shadowColor = getShadowColor(background, color);
  var hoverBackgroundColor = lighten(background, hoverLighten);
  var activeBackgroundColor = lighten(background, activeLighten);
  var glowColorOn = transparent(background, 0.3);
  var glowColorOff = transparent(background, 0.1);
  var animatedGlow = keyframes(_templateObject$H, glowColorOff, glowColorOn);
  var whiteButtonEffect = background === "white" ? whiteButtonsEffectConfig : "";

  var style = _extends({}, config.CircleButton.style, props.style);

  var mainCSS = css(_templateObject2$t, size, size, background, shadow || shadowSize + " " + shadowColor, transition, hoverBackgroundColor, activeBackgroundColor, loading ? 0 : 1, loading ? "color: transparent !important;" : "", color ? "color: " + color + ";" : "", whiteButtonEffect, glow ? css(_templateObject3$j, animatedGlow) : "");
  return jsx("button", {
    onClick: onClick,
    className: className,
    style: style,
    css: [mainCSS, CSS],
    type: submit ? "submit" : undefined,
    disabled: disabled
  }, jsx(Icon, {
    strokeWidth: strokeWidth,
    name: icon,
    size: iconSize,
    color: color
  }), jsx(Spinner, {
    center: true,
    size: 20,
    stroke: 2,
    color1: "white",
    color2: "rgba(255,255,255,.3)",
    show: loading
  }));
};

var _templateObject$I = taggedTemplateLiteral(["\n    ", "\n  "], ["\n    ", "\n  "]),
    _templateObject2$u = taggedTemplateLiteral(["\n    position: fixed;\n    ", "\n    ", "\n    ", "\n    ", "\n  "], ["\n    position: fixed;\n    ", "\n    ", "\n    ", "\n    ", "\n  "]);

var FloatingButton = function FloatingButton(props) {
  var config = useConfig();
  var _config$floatingButto = config.floatingButton,
      configColor = _config$floatingButto.color,
      configSize = _config$floatingButto.size,
      configBackground = _config$floatingButto.background,
      configPosition = _config$floatingButto.position;
  var onClick = props.onClick,
      className = props.className,
      _props$icon = props.icon,
      icon = _props$icon === undefined ? "writeSquare" : _props$icon,
      _props$loading = props.loading,
      loading = _props$loading === undefined ? false : _props$loading,
      _props$size = props.size,
      size = _props$size === undefined ? configSize : _props$size,
      iconSize = props.iconSize,
      strokeWidth = props.strokeWidth,
      _props$position = props.position,
      position = _props$position === undefined ? configPosition : _props$position,
      _props$color = props.color,
      color = _props$color === undefined ? configColor : _props$color,
      _props$background = props.background,
      background = _props$background === undefined ? configBackground : _props$background,
      glow = props.glow,
      submit = props.submit,
      disabled = props.disabled,
      externalCSS = props.CSS;
  var mainCSS = css(_templateObject$I, showHideCss(props));
  var positionCSS = css(_templateObject2$u, position.top ? responsive("top", position.top) : "", position.right ? responsive("right", position.right) : "", position.bottom ? responsive("bottom", position.bottom) : "", position.left ? responsive("left", position.left) : "");

  var style = _extends({}, config.FloatingButton.style, props.style);

  return jsx(CircleButton, {
    onClick: onClick,
    className: className,
    icon: icon,
    iconSize: iconSize,
    loading: loading,
    size: size,
    strokeWidth: strokeWidth,
    color: color,
    glow: glow,
    background: background,
    submit: submit,
    CSS: [mainCSS, externalCSS, positionCSS],
    style: style,
    disabled: disabled
  });
};

var _templateObject$J = taggedTemplateLiteral(["\n    /* padding: 0.2em; */\n    background: ", ";\n    flex: 0 0 auto !important;\n\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", "px;\n    position: relative;\n    box-sizing: border-box;\n\n    transition: 0.2s;\n\n    cursor: pointer;\n\n    div {\n      position: absolute;\n      left: ", ";\n      top: ", "px;\n      width: ", "px;\n      height: ", "px;\n      border-radius: 50%;\n      transition: 0.2s;\n      background: ", ";\n      box-sizing: border-box;\n      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);\n    }\n  "], ["\n    /* padding: 0.2em; */\n    background: ", ";\n    flex: 0 0 auto !important;\n\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", "px;\n    position: relative;\n    box-sizing: border-box;\n\n    transition: 0.2s;\n\n    cursor: pointer;\n\n    div {\n      position: absolute;\n      left: ", ";\n      top: ", "px;\n      width: ", "px;\n      height: ", "px;\n      border-radius: 50%;\n      transition: 0.2s;\n      background: ", ";\n      box-sizing: border-box;\n      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);\n    }\n  "]);

var Switch = function Switch(props) {
  var config = useConfig();
  var _config$switch = config["switch"],
      colorOnConfig = _config$switch.colorOn,
      colorOffConfig = _config$switch.colorOff,
      colorForegroundConfig = _config$switch.colorForeground,
      normalProps = _config$switch.normal,
      smallProps = _config$switch.small;
  var small = props.small,
      _props$on = props.on,
      on = _props$on === undefined ? false : _props$on,
      onClick = props.onClick,
      _props$colorOn = props.colorOn,
      colorOn = _props$colorOn === undefined ? colorOnConfig : _props$colorOn,
      _props$colorOff = props.colorOff,
      colorOff = _props$colorOff === undefined ? colorOffConfig : _props$colorOff,
      _props$colorForegroun = props.colorForeground,
      colorForeground = _props$colorForegroun === undefined ? colorForegroundConfig : _props$colorForegroun,
      CSS = props.CSS;

  var _ref = small ? smallProps : normalProps,
      width = _ref.width,
      height = _ref.height,
      padding = _ref.padding;

  var nobHeight = height - padding * 2;
  var nobMoved = width - nobHeight - padding;
  var mainCSS = css(_templateObject$J, on ? colorOn : colorOff, width, height, height, on ? nobMoved + "px" : padding + "px", padding, nobHeight, nobHeight, colorForeground);
  return jsx("div", {
    style: props.style,
    css: [mainCSS, CSS],
    onClick: onClick
  }, jsx("div", null));
};

var _templateObject$K = taggedTemplateLiteral(["\n      position: relative;\n      width: ", ";\n      ", "\n      ", "\n      display: inline-flex !important;\n      svg {\n        opacity: ", ";\n      }\n\n      align-items: center;\n      justify-content: center;\n      ", "\n      :disabled {\n        opacity: 0.5;\n        :hover {\n          transform: none !important;\n        }\n\n        cursor: not-allowed;\n      }\n\n      ", "\n    "], ["\n      position: relative;\n      width: ", ";\n      ", "\n      ", "\n      display: inline-flex !important;\n      svg {\n        opacity: ", ";\n      }\n\n      align-items: center;\n      justify-content: center;\n      ", "\n      :disabled {\n        opacity: 0.5;\n        :hover {\n          transform: none !important;\n        }\n\n        cursor: not-allowed;\n      }\n\n      ", "\n    "]);

function styleLink(Component$$1) {
  return function (props) {
    // type: primary, secondary, link
    var config = useConfig();
    var _config$buttons = config.buttons,
        configTextColor = _config$buttons.textColor,
        textColorInverted = _config$buttons.textColorInverted,
        configIconSide = _config$buttons.iconSide,
        configIconGap = _config$buttons.iconGap;
    var _props$type = props.type,
        type = _props$type === undefined ? "link" : _props$type,
        glow = props.glow,
        icon = props.icon,
        _props$iconSide = props.iconSide,
        iconSide = _props$iconSide === undefined ? configIconSide : _props$iconSide,
        _props$iconGap = props.iconGap,
        iconGap = _props$iconGap === undefined ? configIconGap : _props$iconGap,
        small = props.small,
        width = props.width,
        noStretch = props.noStretch,
        stretch = props.stretch,
        providedBgColor = props.color,
        loading = props.loading,
        CSS = props.CSS,
        children = props.children;
    var componentProps = cleanedProps(props, ["CSS", "type", "children", "iconSide", "iconGap", "loading", "width", "noStretch", "stretch", "small"]);
    var _config$icon = config.icon,
        sizeInButtons = _config$icon.sizeInButtons,
        strokeInButtons = _config$icon.strokeInButtons;
    var textColor = getColorBasedOnLuminance(providedBgColor, configTextColor, textColorInverted, type);

    var typeStyle = _styleForType(type, config, small, textColor, providedBgColor, glow);

    var mainCSS = css(_templateObject$K, width, noStretch ? "flex: 0 0 auto;" : "", stretch ? "flex: 1 1 auto;" : "", loading ? 0 : 1, loading ? "color: transparent !important;" : "", textColor ? "color: " + textColor + ";" : "");
    return jsx(Component$$1, _extends({
      css: [mainCSS, typeStyle, CSS]
    }, componentProps), jsx(HStack, {
      noWrap: true,
      align: "center",
      vAlign: "center",
      gap: iconGap
    }, icon && iconSide === "left" && jsx(Icon, {
      name: icon,
      color: textColor,
      size: small ? ".8em" : sizeInButtons
    }), children && jsx("span", {
      style: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        position: "relative"
      }
    }, children), icon && iconSide === "right" && jsx(Icon, {
      name: icon,
      color: textColor,
      size: small ? ".8em" : sizeInButtons
    })), jsx(Spinner, {
      center: true,
      size: 20,
      stroke: strokeInButtons,
      color: textColor,
      show: loading
    }));
  };
}

export { UIContextProvider, Callout, Modal, ExitModal, Header, FloatingFooter, TabSet, Spinner, TopLoader, Notification, SegmentedControl, MultiSegmentedControl, SliderWithInput, cleanedProps, IconBadge, Breadcrumb, Accordion, AutoGrid, Block, Body, Card, CardFooter, Center, Container, Divider, Grid, HStack, Section, Sidebar, SidebarHeader, SidebarFooter, SidebarSection, SidebarSectionNav, Spacer, SubtleCard, VStack, SafeAreaInsetBottom, CustomSelect, DropDownMenu, Input, Radio, RadioGroup, Checkbox, CheckboxGroup, Slider, Select, Button, FloatingButton, CircleButton, Switch, styleLink, globals, typeStyle, H1, H2, H3, H4, H5, P1, P2, SmallText, Badge, Table, Tr, Th, Td, useNotification, useDarkMode, useLocalStorage, useMedia, usePrefersDarkMode, useWindow, useWindowSize, useClickOutside, useResponsiveValue, useBrowserStorage, useConfigSetup, useConfig, useUpdateConfig, useResetConfig, Icon, getAllIconNames };